import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: string;
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: string;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: string;
  /** The day, does not include a time. */
  Date: string;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: unknown;
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: string;
};

export type AccountingInvoice = Node & {
  __typename?: 'AccountingInvoice';
  accountingSystem: AccountingSystem;
  createdAt: Scalars['Datetime'];
  /** Reads a single `GatewayPayoutReport` that is related to this `AccountingInvoice`. */
  gatewayPayoutReportByPayoutReportId?: Maybe<GatewayPayoutReport>;
  invoiceId: Scalars['String'];
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceType: InvoiceType;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  paidDate?: Maybe<Scalars['Date']>;
  /** Reads a single `Payment` that is related to this `AccountingInvoice`. */
  paymentByPaymentId?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['BigInt']>;
  payoutReportId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `AccountingInvoice` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AccountingInvoiceCondition = {
  /** Checks for equality with the object’s `accountingSystem` field. */
  accountingSystem?: InputMaybe<AccountingSystem>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `invoiceId` field. */
  invoiceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `invoiceNumber` field. */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `invoiceType` field. */
  invoiceType?: InputMaybe<InvoiceType>;
  /** Checks for equality with the object’s `paidDate` field. */
  paidDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `paymentId` field. */
  paymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `payoutReportId` field. */
  payoutReportId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `AccountingInvoice` values. */
export type AccountingInvoicesConnection = {
  __typename?: 'AccountingInvoicesConnection';
  /** A list of edges which contains the `AccountingInvoice` and cursor to aid in pagination. */
  edges: Array<AccountingInvoicesEdge>;
  /** A list of `AccountingInvoice` objects. */
  nodes: Array<Maybe<AccountingInvoice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountingInvoice` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AccountingInvoice` edge in the connection. */
export type AccountingInvoicesEdge = {
  __typename?: 'AccountingInvoicesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AccountingInvoice` at the end of the edge. */
  node?: Maybe<AccountingInvoice>;
};

/** Methods to use when ordering `AccountingInvoice`. */
export enum AccountingInvoicesOrderBy {
  AccountingSystemAsc = 'ACCOUNTING_SYSTEM_ASC',
  AccountingSystemDesc = 'ACCOUNTING_SYSTEM_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  InvoiceIdAsc = 'INVOICE_ID_ASC',
  InvoiceIdDesc = 'INVOICE_ID_DESC',
  InvoiceNumberAsc = 'INVOICE_NUMBER_ASC',
  InvoiceNumberDesc = 'INVOICE_NUMBER_DESC',
  InvoiceTypeAsc = 'INVOICE_TYPE_ASC',
  InvoiceTypeDesc = 'INVOICE_TYPE_DESC',
  Natural = 'NATURAL',
  PaidDateAsc = 'PAID_DATE_ASC',
  PaidDateDesc = 'PAID_DATE_DESC',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PayoutReportIdAsc = 'PAYOUT_REPORT_ID_ASC',
  PayoutReportIdDesc = 'PAYOUT_REPORT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum AccountingSystem {
  Xero = 'XERO'
}

export type Acquisition = Node & {
  __typename?: 'Acquisition';
  campaign?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['BigInt'];
  medium?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Person` that is related to this `Acquisition`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  source: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `Acquisition` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AcquisitionCondition = {
  /** Checks for equality with the object’s `campaign` field. */
  campaign?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `medium` field. */
  medium?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `source` field. */
  source?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Acquisition` values. */
export type AcquisitionsConnection = {
  __typename?: 'AcquisitionsConnection';
  /** A list of edges which contains the `Acquisition` and cursor to aid in pagination. */
  edges: Array<AcquisitionsEdge>;
  /** A list of `Acquisition` objects. */
  nodes: Array<Maybe<Acquisition>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Acquisition` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Acquisition` edge in the connection. */
export type AcquisitionsEdge = {
  __typename?: 'AcquisitionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Acquisition` at the end of the edge. */
  node?: Maybe<Acquisition>;
};

/** Methods to use when ordering `Acquisition`. */
export enum AcquisitionsOrderBy {
  CampaignAsc = 'CAMPAIGN_ASC',
  CampaignDesc = 'CAMPAIGN_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MediumAsc = 'MEDIUM_ASC',
  MediumDesc = 'MEDIUM_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A connection to a list of `ActiveExtendedLottery` values. */
export type ActiveExtendedLotteriesConnection = {
  __typename?: 'ActiveExtendedLotteriesConnection';
  /** A list of edges which contains the `ActiveExtendedLottery` and cursor to aid in pagination. */
  edges: Array<ActiveExtendedLotteriesEdge>;
  /** A list of `ActiveExtendedLottery` objects. */
  nodes: Array<Maybe<ActiveExtendedLottery>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActiveExtendedLottery` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ActiveExtendedLottery` edge in the connection. */
export type ActiveExtendedLotteriesEdge = {
  __typename?: 'ActiveExtendedLotteriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ActiveExtendedLottery` at the end of the edge. */
  node?: Maybe<ActiveExtendedLottery>;
};

/** Methods to use when ordering `ActiveExtendedLottery`. */
export enum ActiveExtendedLotteriesOrderBy {
  BlockSizeAsc = 'BLOCK_SIZE_ASC',
  BlockSizeDesc = 'BLOCK_SIZE_DESC',
  CloseTimestampAsc = 'CLOSE_TIMESTAMP_ASC',
  CloseTimestampDesc = 'CLOSE_TIMESTAMP_DESC',
  DrawEpochAsc = 'DRAW_EPOCH_ASC',
  DrawEpochDesc = 'DRAW_EPOCH_DESC',
  DrawTimestampAsc = 'DRAW_TIMESTAMP_ASC',
  DrawTimestampDesc = 'DRAW_TIMESTAMP_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LockTimestampAsc = 'LOCK_TIMESTAMP_ASC',
  LockTimestampDesc = 'LOCK_TIMESTAMP_DESC',
  Natural = 'NATURAL',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  WinningNumberAsc = 'WINNING_NUMBER_ASC',
  WinningNumberDesc = 'WINNING_NUMBER_DESC'
}

export type ActiveExtendedLottery = {
  __typename?: 'ActiveExtendedLottery';
  blockSize?: Maybe<Scalars['BigFloat']>;
  closeTimestamp?: Maybe<Scalars['Datetime']>;
  drawEpoch?: Maybe<Scalars['Int']>;
  drawTimestamp?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['BigInt']>;
  lockTimestamp?: Maybe<Scalars['Datetime']>;
  status?: Maybe<Scalars['String']>;
  winningNumber?: Maybe<Scalars['BigInt']>;
};

/**
 * A condition to be used against `ActiveExtendedLottery` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ActiveExtendedLotteryCondition = {
  /** Checks for equality with the object’s `blockSize` field. */
  blockSize?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `closeTimestamp` field. */
  closeTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `drawEpoch` field. */
  drawEpoch?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `drawTimestamp` field. */
  drawTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `lockTimestamp` field. */
  lockTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `winningNumber` field. */
  winningNumber?: InputMaybe<Scalars['BigInt']>;
};

/** All input for the `addWinningNumber` mutation. */
export type AddWinningNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  randomHex?: InputMaybe<Scalars['String']>;
};

/** The output of our `addWinningNumber` mutation. */
export type AddWinningNumberPayload = {
  __typename?: 'AddWinningNumberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  lottery?: Maybe<Lottery>;
  /** An edge for our `Lottery`. May be used by Relay 1. */
  lotteryEdge?: Maybe<LotteriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `addWinningNumber` mutation. */
export type AddWinningNumberPayloadLotteryEdgeArgs = {
  orderBy?: InputMaybe<Array<LotteriesOrderBy>>;
};

export type Address = Node & {
  __typename?: 'Address';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressType?: Maybe<AddressType>;
  city?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `ContactPreference`. */
  contactPreferencesByCurrentAddressId: ContactPreferencesConnection;
  /** Reads and enables pagination through a set of `ContactPreference`. */
  contactPreferencesByCurrentAddressIdList: Array<ContactPreference>;
  /** Reads and enables pagination through a set of `ContactPreference`. */
  contactPreferencesByPersonIdAndCurrentAddressId: ContactPreferencesConnection;
  /** Reads and enables pagination through a set of `ContactPreference`. */
  contactPreferencesByPersonIdAndCurrentAddressIdList: Array<ContactPreference>;
  coordinates?: Maybe<Scalars['String']>;
  /** Reads a single `Country` that is related to this `Address`. */
  countryByCountryCode?: Maybe<Country>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  firstName?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `GiftAidClaim`. */
  giftAidClaimsByAddressIdAndPersonId: GiftAidClaimsConnection;
  /** Reads and enables pagination through a set of `GiftAidClaim`. */
  giftAidClaimsByAddressIdAndPersonIdList: Array<GiftAidClaim>;
  googlePlaceId?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  lastName?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByBillingAddressId: PaymentsConnection;
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByBillingAddressIdList: Array<Payment>;
  /** Reads a single `Person` that is related to this `Address`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  postalCode?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `RecurringPayment`. */
  recurringPaymentsByBillingAddressId: RecurringPaymentsConnection;
  /** Reads and enables pagination through a set of `RecurringPayment`. */
  recurringPaymentsByBillingAddressIdList: Array<RecurringPayment>;
  region?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};


export type AddressContactPreferencesByCurrentAddressIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContactPreferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactPreferencesOrderBy>>;
};


export type AddressContactPreferencesByCurrentAddressIdListArgs = {
  condition?: InputMaybe<ContactPreferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactPreferencesOrderBy>>;
};


export type AddressContactPreferencesByPersonIdAndCurrentAddressIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContactPreferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactPreferencesOrderBy>>;
};


export type AddressContactPreferencesByPersonIdAndCurrentAddressIdListArgs = {
  condition?: InputMaybe<ContactPreferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactPreferencesOrderBy>>;
};


export type AddressGiftAidClaimsByAddressIdAndPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GiftAidClaimCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimsOrderBy>>;
};


export type AddressGiftAidClaimsByAddressIdAndPersonIdListArgs = {
  condition?: InputMaybe<GiftAidClaimCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimsOrderBy>>;
};


export type AddressPaymentsByBillingAddressIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type AddressPaymentsByBillingAddressIdListArgs = {
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type AddressRecurringPaymentsByBillingAddressIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};


export type AddressRecurringPaymentsByBillingAddressIdListArgs = {
  condition?: InputMaybe<RecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};

export type AddressBackup = Node & {
  __typename?: 'AddressBackup';
  city?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  /** Reads a single `Country` that is related to this `AddressBackup`. */
  countryByCountryCode?: Maybe<Country>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  formattedAddress?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Person` that is related to this `AddressBackup`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  region?: Maybe<Scalars['String']>;
  route?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `AddressBackup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AddressBackupCondition = {
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `coordinates` field. */
  coordinates?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `countryCode` field. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `formattedAddress` field. */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `googlePlaceId` field. */
  googlePlaceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `region` field. */
  region?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `route` field. */
  route?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `AddressBackup` values. */
export type AddressBackupsConnection = {
  __typename?: 'AddressBackupsConnection';
  /** A list of edges which contains the `AddressBackup` and cursor to aid in pagination. */
  edges: Array<AddressBackupsEdge>;
  /** A list of `AddressBackup` objects. */
  nodes: Array<Maybe<AddressBackup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AddressBackup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AddressBackup` edge in the connection. */
export type AddressBackupsEdge = {
  __typename?: 'AddressBackupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AddressBackup` at the end of the edge. */
  node?: Maybe<AddressBackup>;
};

/** Methods to use when ordering `AddressBackup`. */
export enum AddressBackupsOrderBy {
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CoordinatesAsc = 'COORDINATES_ASC',
  CoordinatesDesc = 'COORDINATES_DESC',
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FormattedAddressAsc = 'FORMATTED_ADDRESS_ASC',
  FormattedAddressDesc = 'FORMATTED_ADDRESS_DESC',
  GooglePlaceIdAsc = 'GOOGLE_PLACE_ID_ASC',
  GooglePlaceIdDesc = 'GOOGLE_PLACE_ID_DESC',
  HouseNumberAsc = 'HOUSE_NUMBER_ASC',
  HouseNumberDesc = 'HOUSE_NUMBER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RegionAsc = 'REGION_ASC',
  RegionDesc = 'REGION_DESC',
  RouteAsc = 'ROUTE_ASC',
  RouteDesc = 'ROUTE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A condition to be used against `Address` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AddressCondition = {
  /** Checks for equality with the object’s `addressLine1` field. */
  addressLine1?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `addressLine2` field. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `addressType` field. */
  addressType?: InputMaybe<AddressType>;
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `coordinates` field. */
  coordinates?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `countryCode` field. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `googlePlaceId` field. */
  googlePlaceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `postalCode` field. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `region` field. */
  region?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum AddressType {
  Billing = 'BILLING'
}

/** A connection to a list of `Address` values. */
export type AddressesConnection = {
  __typename?: 'AddressesConnection';
  /** A list of edges which contains the `Address` and cursor to aid in pagination. */
  edges: Array<AddressesEdge>;
  /** A list of `Address` objects. */
  nodes: Array<Maybe<Address>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Address` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Address` edge in the connection. */
export type AddressesEdge = {
  __typename?: 'AddressesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Address` at the end of the edge. */
  node?: Maybe<Address>;
};

/** Methods to use when ordering `Address`. */
export enum AddressesOrderBy {
  AddressLine_1Asc = 'ADDRESS_LINE_1_ASC',
  AddressLine_1Desc = 'ADDRESS_LINE_1_DESC',
  AddressLine_2Asc = 'ADDRESS_LINE_2_ASC',
  AddressLine_2Desc = 'ADDRESS_LINE_2_DESC',
  AddressTypeAsc = 'ADDRESS_TYPE_ASC',
  AddressTypeDesc = 'ADDRESS_TYPE_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CoordinatesAsc = 'COORDINATES_ASC',
  CoordinatesDesc = 'COORDINATES_DESC',
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  GooglePlaceIdAsc = 'GOOGLE_PLACE_ID_ASC',
  GooglePlaceIdDesc = 'GOOGLE_PLACE_ID_DESC',
  HouseNumberAsc = 'HOUSE_NUMBER_ASC',
  HouseNumberDesc = 'HOUSE_NUMBER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PostalCodeAsc = 'POSTAL_CODE_ASC',
  PostalCodeDesc = 'POSTAL_CODE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RegionAsc = 'REGION_ASC',
  RegionDesc = 'REGION_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type AllPledge = {
  __typename?: 'AllPledge';
  anonymous?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  inactive?: Maybe<Scalars['Boolean']>;
  period?: Maybe<DateRange>;
  personId?: Maybe<Scalars['BigInt']>;
  pledgeEnd?: Maybe<Scalars['Date']>;
  pledgePercentage?: Maybe<Scalars['BigFloat']>;
  pledgeStart?: Maybe<Scalars['Date']>;
  pledgeType?: Maybe<PledgeType>;
  rankByPledgeType?: Maybe<Scalars['BigInt']>;
  withdrawn?: Maybe<Scalars['Boolean']>;
};

/**
 * A condition to be used against `AllPledge` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AllPledgeCondition = {
  /** Checks for equality with the object’s `anonymous` field. */
  anonymous?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `fullName` field. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `inactive` field. */
  inactive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `period` field. */
  period?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pledgeEnd` field. */
  pledgeEnd?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `pledgePercentage` field. */
  pledgePercentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `pledgeStart` field. */
  pledgeStart?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `pledgeType` field. */
  pledgeType?: InputMaybe<PledgeType>;
  /** Checks for equality with the object’s `rankByPledgeType` field. */
  rankByPledgeType?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `withdrawn` field. */
  withdrawn?: InputMaybe<Scalars['Boolean']>;
};

/** A connection to a list of `AllPledge` values. */
export type AllPledgesConnection = {
  __typename?: 'AllPledgesConnection';
  /** A list of edges which contains the `AllPledge` and cursor to aid in pagination. */
  edges: Array<AllPledgesEdge>;
  /** A list of `AllPledge` objects. */
  nodes: Array<Maybe<AllPledge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllPledge` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllPledge` edge in the connection. */
export type AllPledgesEdge = {
  __typename?: 'AllPledgesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllPledge` at the end of the edge. */
  node?: Maybe<AllPledge>;
};

/** Methods to use when ordering `AllPledge`. */
export enum AllPledgesOrderBy {
  AnonymousAsc = 'ANONYMOUS_ASC',
  AnonymousDesc = 'ANONYMOUS_DESC',
  FullNameAsc = 'FULL_NAME_ASC',
  FullNameDesc = 'FULL_NAME_DESC',
  InactiveAsc = 'INACTIVE_ASC',
  InactiveDesc = 'INACTIVE_DESC',
  Natural = 'NATURAL',
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PledgeEndAsc = 'PLEDGE_END_ASC',
  PledgeEndDesc = 'PLEDGE_END_DESC',
  PledgePercentageAsc = 'PLEDGE_PERCENTAGE_ASC',
  PledgePercentageDesc = 'PLEDGE_PERCENTAGE_DESC',
  PledgeStartAsc = 'PLEDGE_START_ASC',
  PledgeStartDesc = 'PLEDGE_START_DESC',
  PledgeTypeAsc = 'PLEDGE_TYPE_ASC',
  PledgeTypeDesc = 'PLEDGE_TYPE_DESC',
  RankByPledgeTypeAsc = 'RANK_BY_PLEDGE_TYPE_ASC',
  RankByPledgeTypeDesc = 'RANK_BY_PLEDGE_TYPE_DESC',
  WithdrawnAsc = 'WITHDRAWN_ASC',
  WithdrawnDesc = 'WITHDRAWN_DESC'
}

export type AllPledgesPublic = {
  __typename?: 'AllPledgesPublic';
  anonymous?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  inactive?: Maybe<Scalars['Boolean']>;
  period?: Maybe<DateRange>;
  pledgeEnd?: Maybe<Scalars['Date']>;
  pledgePercentage?: Maybe<Scalars['BigFloat']>;
  pledgeStart?: Maybe<Scalars['Date']>;
  pledgeType?: Maybe<PledgeType>;
  rankByPledgeType?: Maybe<Scalars['BigInt']>;
  withdrawn?: Maybe<Scalars['Boolean']>;
};

/**
 * A condition to be used against `AllPledgesPublic` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AllPledgesPublicCondition = {
  /** Checks for equality with the object’s `anonymous` field. */
  anonymous?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `fullName` field. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `inactive` field. */
  inactive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `period` field. */
  period?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `pledgeEnd` field. */
  pledgeEnd?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `pledgePercentage` field. */
  pledgePercentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `pledgeStart` field. */
  pledgeStart?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `pledgeType` field. */
  pledgeType?: InputMaybe<PledgeType>;
  /** Checks for equality with the object’s `rankByPledgeType` field. */
  rankByPledgeType?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `withdrawn` field. */
  withdrawn?: InputMaybe<Scalars['Boolean']>;
};

/** A connection to a list of `AllPledgesPublic` values. */
export type AllPledgesPublicsConnection = {
  __typename?: 'AllPledgesPublicsConnection';
  /** A list of edges which contains the `AllPledgesPublic` and cursor to aid in pagination. */
  edges: Array<AllPledgesPublicsEdge>;
  /** A list of `AllPledgesPublic` objects. */
  nodes: Array<Maybe<AllPledgesPublic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllPledgesPublic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllPledgesPublic` edge in the connection. */
export type AllPledgesPublicsEdge = {
  __typename?: 'AllPledgesPublicsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllPledgesPublic` at the end of the edge. */
  node?: Maybe<AllPledgesPublic>;
};

/** Methods to use when ordering `AllPledgesPublic`. */
export enum AllPledgesPublicsOrderBy {
  AnonymousAsc = 'ANONYMOUS_ASC',
  AnonymousDesc = 'ANONYMOUS_DESC',
  FullNameAsc = 'FULL_NAME_ASC',
  FullNameDesc = 'FULL_NAME_DESC',
  InactiveAsc = 'INACTIVE_ASC',
  InactiveDesc = 'INACTIVE_DESC',
  Natural = 'NATURAL',
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC',
  PledgeEndAsc = 'PLEDGE_END_ASC',
  PledgeEndDesc = 'PLEDGE_END_DESC',
  PledgePercentageAsc = 'PLEDGE_PERCENTAGE_ASC',
  PledgePercentageDesc = 'PLEDGE_PERCENTAGE_DESC',
  PledgeStartAsc = 'PLEDGE_START_ASC',
  PledgeStartDesc = 'PLEDGE_START_DESC',
  PledgeTypeAsc = 'PLEDGE_TYPE_ASC',
  PledgeTypeDesc = 'PLEDGE_TYPE_DESC',
  RankByPledgeTypeAsc = 'RANK_BY_PLEDGE_TYPE_ASC',
  RankByPledgeTypeDesc = 'RANK_BY_PLEDGE_TYPE_DESC',
  WithdrawnAsc = 'WITHDRAWN_ASC',
  WithdrawnDesc = 'WITHDRAWN_DESC'
}

export type Allocation = Node & {
  __typename?: 'Allocation';
  allocation: Scalars['JSON'];
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Person` that is related to this `Allocation`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `Allocation` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AllocationCondition = {
  /** Checks for equality with the object’s `allocation` field. */
  allocation?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Allocation` values. */
export type AllocationsConnection = {
  __typename?: 'AllocationsConnection';
  /** A list of edges which contains the `Allocation` and cursor to aid in pagination. */
  edges: Array<AllocationsEdge>;
  /** A list of `Allocation` objects. */
  nodes: Array<Maybe<Allocation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Allocation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Allocation` edge in the connection. */
export type AllocationsEdge = {
  __typename?: 'AllocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Allocation` at the end of the edge. */
  node?: Maybe<Allocation>;
};

/** Methods to use when ordering `Allocation`. */
export enum AllocationsOrderBy {
  AllocationAsc = 'ALLOCATION_ASC',
  AllocationDesc = 'ALLOCATION_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** All input for the `anonymizePerson` mutation. */
export type AnonymizePersonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `anonymizePerson` mutation. */
export type AnonymizePersonPayload = {
  __typename?: 'AnonymizePersonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EmailAddress` that is related to this `Person`. */
  emailAddressByIdAndEmail?: Maybe<EmailAddress>;
  person?: Maybe<Person>;
  /** An edge for our `Person`. May be used by Relay 1. */
  personEdge?: Maybe<PeopleEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `anonymizePerson` mutation. */
export type AnonymizePersonPayloadPersonEdgeArgs = {
  orderBy?: InputMaybe<Array<PeopleOrderBy>>;
};

export type BalanceSheetReport = Node & {
  __typename?: 'BalanceSheetReport';
  accountingSystem: AccountingSystem;
  amount: Scalars['BigFloat'];
  amountNormalized: Scalars['BigFloat'];
  /** Reads a single `Currency` that is related to this `BalanceSheetReport`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  currencyCode?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  recipient: Scalars['String'];
  reference: Scalars['String'];
  reportDate: Scalars['Date'];
  /** Reads a single `XeroTracking` that is related to this `BalanceSheetReport`. */
  xeroTrackingByReferenceAndRecipientAndXeroTrackingCategoryName?: Maybe<XeroTracking>;
  xeroTrackingCategoryName?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `BalanceSheetReport` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BalanceSheetReportCondition = {
  /** Checks for equality with the object’s `accountingSystem` field. */
  accountingSystem?: InputMaybe<AccountingSystem>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reportDate` field. */
  reportDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `xeroTrackingCategoryName` field. */
  xeroTrackingCategoryName?: InputMaybe<Scalars['String']>;
};

export type BalanceSheetReportMonthlyTotal = {
  __typename?: 'BalanceSheetReportMonthlyTotal';
  amount?: Maybe<Scalars['BigFloat']>;
  reference?: Maybe<Scalars['String']>;
  reportDate?: Maybe<Scalars['Date']>;
};

/**
 * A condition to be used against `BalanceSheetReportMonthlyTotal` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type BalanceSheetReportMonthlyTotalCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reportDate` field. */
  reportDate?: InputMaybe<Scalars['Date']>;
};

/** A connection to a list of `BalanceSheetReportMonthlyTotal` values. */
export type BalanceSheetReportMonthlyTotalsConnection = {
  __typename?: 'BalanceSheetReportMonthlyTotalsConnection';
  /** A list of edges which contains the `BalanceSheetReportMonthlyTotal` and cursor to aid in pagination. */
  edges: Array<BalanceSheetReportMonthlyTotalsEdge>;
  /** A list of `BalanceSheetReportMonthlyTotal` objects. */
  nodes: Array<Maybe<BalanceSheetReportMonthlyTotal>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BalanceSheetReportMonthlyTotal` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BalanceSheetReportMonthlyTotal` edge in the connection. */
export type BalanceSheetReportMonthlyTotalsEdge = {
  __typename?: 'BalanceSheetReportMonthlyTotalsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BalanceSheetReportMonthlyTotal` at the end of the edge. */
  node?: Maybe<BalanceSheetReportMonthlyTotal>;
};

/** Methods to use when ordering `BalanceSheetReportMonthlyTotal`. */
export enum BalanceSheetReportMonthlyTotalsOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  Natural = 'NATURAL',
  ReferenceAsc = 'REFERENCE_ASC',
  ReferenceDesc = 'REFERENCE_DESC',
  ReportDateAsc = 'REPORT_DATE_ASC',
  ReportDateDesc = 'REPORT_DATE_DESC'
}

export type BalanceSheetReportPublic = {
  __typename?: 'BalanceSheetReportPublic';
  amount?: Maybe<Scalars['BigFloat']>;
  amountNormalized?: Maybe<Scalars['BigFloat']>;
  currencyCode?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  reportDate?: Maybe<Scalars['Date']>;
};

/**
 * A condition to be used against `BalanceSheetReportPublic` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type BalanceSheetReportPublicCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reportDate` field. */
  reportDate?: InputMaybe<Scalars['Date']>;
};

/** A connection to a list of `BalanceSheetReportPublic` values. */
export type BalanceSheetReportPublicsConnection = {
  __typename?: 'BalanceSheetReportPublicsConnection';
  /** A list of edges which contains the `BalanceSheetReportPublic` and cursor to aid in pagination. */
  edges: Array<BalanceSheetReportPublicsEdge>;
  /** A list of `BalanceSheetReportPublic` objects. */
  nodes: Array<Maybe<BalanceSheetReportPublic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BalanceSheetReportPublic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BalanceSheetReportPublic` edge in the connection. */
export type BalanceSheetReportPublicsEdge = {
  __typename?: 'BalanceSheetReportPublicsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BalanceSheetReportPublic` at the end of the edge. */
  node?: Maybe<BalanceSheetReportPublic>;
};

/** Methods to use when ordering `BalanceSheetReportPublic`. */
export enum BalanceSheetReportPublicsOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  Natural = 'NATURAL',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  ReferenceAsc = 'REFERENCE_ASC',
  ReferenceDesc = 'REFERENCE_DESC',
  ReportDateAsc = 'REPORT_DATE_ASC',
  ReportDateDesc = 'REPORT_DATE_DESC'
}

/** A connection to a list of `BalanceSheetReport` values. */
export type BalanceSheetReportsConnection = {
  __typename?: 'BalanceSheetReportsConnection';
  /** A list of edges which contains the `BalanceSheetReport` and cursor to aid in pagination. */
  edges: Array<BalanceSheetReportsEdge>;
  /** A list of `BalanceSheetReport` objects. */
  nodes: Array<Maybe<BalanceSheetReport>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BalanceSheetReport` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BalanceSheetReport` edge in the connection. */
export type BalanceSheetReportsEdge = {
  __typename?: 'BalanceSheetReportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BalanceSheetReport` at the end of the edge. */
  node?: Maybe<BalanceSheetReport>;
};

/** Methods to use when ordering `BalanceSheetReport`. */
export enum BalanceSheetReportsOrderBy {
  AccountingSystemAsc = 'ACCOUNTING_SYSTEM_ASC',
  AccountingSystemDesc = 'ACCOUNTING_SYSTEM_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  ReferenceAsc = 'REFERENCE_ASC',
  ReferenceDesc = 'REFERENCE_DESC',
  ReportDateAsc = 'REPORT_DATE_ASC',
  ReportDateDesc = 'REPORT_DATE_DESC',
  XeroTrackingCategoryNameAsc = 'XERO_TRACKING_CATEGORY_NAME_ASC',
  XeroTrackingCategoryNameDesc = 'XERO_TRACKING_CATEGORY_NAME_DESC'
}

/** A range of `BigInt`. */
export type BigIntRange = {
  __typename?: 'BigIntRange';
  /** The ending bound of our range. */
  end?: Maybe<BigIntRangeBound>;
  /** The starting bound of our range. */
  start?: Maybe<BigIntRangeBound>;
};

/** The value at one end of a range. A range can either include this value, or not. */
export type BigIntRangeBound = {
  __typename?: 'BigIntRangeBound';
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean'];
  /** The value at one end of our range. */
  value: Scalars['BigInt'];
};

/** The value at one end of a range. A range can either include this value, or not. */
export type BigIntRangeBoundInput = {
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean'];
  /** The value at one end of our range. */
  value: Scalars['BigInt'];
};

/** A range of `BigInt`. */
export type BigIntRangeInput = {
  /** The ending bound of our range. */
  end?: InputMaybe<BigIntRangeBoundInput>;
  /** The starting bound of our range. */
  start?: InputMaybe<BigIntRangeBoundInput>;
};

/** All input for the `cancelRecurringPayment` mutation. */
export type CancelRecurringPaymentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  recurringPaymentId: Scalars['BigInt'];
};

/** The output of our `cancelRecurringPayment` mutation. */
export type CancelRecurringPaymentPayload = {
  __typename?: 'CancelRecurringPaymentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `cancelRecurringReportedDonation` mutation. */
export type CancelRecurringReportedDonationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  recurringReportedDonationId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `cancelRecurringReportedDonation` mutation. */
export type CancelRecurringReportedDonationPayload = {
  __typename?: 'CancelRecurringReportedDonationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `RecurringReportedDonation`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `ExternalOrganization` that is related to this `RecurringReportedDonation`. */
  externalOrganizationByOrganizationId?: Maybe<ExternalOrganization>;
  /** Reads a single `Person` that is related to this `RecurringReportedDonation`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  recurringReportedDonation?: Maybe<RecurringReportedDonation>;
  /** An edge for our `RecurringReportedDonation`. May be used by Relay 1. */
  recurringReportedDonationEdge?: Maybe<RecurringReportedDonationsEdge>;
};


/** The output of our `cancelRecurringReportedDonation` mutation. */
export type CancelRecurringReportedDonationPayloadRecurringReportedDonationEdgeArgs = {
  orderBy?: InputMaybe<Array<RecurringReportedDonationsOrderBy>>;
};

export type Changelog = Node & {
  __typename?: 'Changelog';
  createdAt: Scalars['Datetime'];
  event: ChangelogEvent;
  id: Scalars['BigInt'];
  itemId: Scalars['BigInt'];
  itemType: ChangelogItemType;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  object?: Maybe<Scalars['JSON']>;
  objectChanges?: Maybe<Scalars['JSON']>;
  reason?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  whodunnit?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `Changelog` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ChangelogCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `event` field. */
  event?: InputMaybe<ChangelogEvent>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `itemId` field. */
  itemId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `itemType` field. */
  itemType?: InputMaybe<ChangelogItemType>;
  /** Checks for equality with the object’s `object` field. */
  object?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `objectChanges` field. */
  objectChanges?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `reason` field. */
  reason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `whodunnit` field. */
  whodunnit?: InputMaybe<Scalars['String']>;
};

export enum ChangelogEvent {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE'
}

export enum ChangelogItemType {
  Payment = 'PAYMENT',
  Person = 'PERSON',
  Pledge = 'PLEDGE',
  RecurringPayment = 'RECURRING_PAYMENT'
}

/** A connection to a list of `Changelog` values. */
export type ChangelogsConnection = {
  __typename?: 'ChangelogsConnection';
  /** A list of edges which contains the `Changelog` and cursor to aid in pagination. */
  edges: Array<ChangelogsEdge>;
  /** A list of `Changelog` objects. */
  nodes: Array<Maybe<Changelog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Changelog` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Changelog` edge in the connection. */
export type ChangelogsEdge = {
  __typename?: 'ChangelogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Changelog` at the end of the edge. */
  node?: Maybe<Changelog>;
};

/** Methods to use when ordering `Changelog`. */
export enum ChangelogsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EventAsc = 'EVENT_ASC',
  EventDesc = 'EVENT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ItemIdAsc = 'ITEM_ID_ASC',
  ItemIdDesc = 'ITEM_ID_DESC',
  ItemTypeAsc = 'ITEM_TYPE_ASC',
  ItemTypeDesc = 'ITEM_TYPE_DESC',
  Natural = 'NATURAL',
  ObjectAsc = 'OBJECT_ASC',
  ObjectChangesAsc = 'OBJECT_CHANGES_ASC',
  ObjectChangesDesc = 'OBJECT_CHANGES_DESC',
  ObjectDesc = 'OBJECT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReasonAsc = 'REASON_ASC',
  ReasonDesc = 'REASON_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WhodunnitAsc = 'WHODUNNIT_ASC',
  WhodunnitDesc = 'WHODUNNIT_DESC'
}

export type Color = {
  __typename?: 'Color';
  name?: Maybe<Scalars['String']>;
};

/** A condition to be used against `Color` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ColorCondition = {
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Color` values. */
export type ColorsConnection = {
  __typename?: 'ColorsConnection';
  /** A list of edges which contains the `Color` and cursor to aid in pagination. */
  edges: Array<ColorsEdge>;
  /** A list of `Color` objects. */
  nodes: Array<Maybe<Color>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Color` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Color` edge in the connection. */
export type ColorsEdge = {
  __typename?: 'ColorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Color` at the end of the edge. */
  node?: Maybe<Color>;
};

/** Methods to use when ordering `Color`. */
export enum ColorsOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL'
}

export type CommonNoun = {
  __typename?: 'CommonNoun';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `CommonNoun` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CommonNounCondition = {
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `CommonNoun` values. */
export type CommonNounsConnection = {
  __typename?: 'CommonNounsConnection';
  /** A list of edges which contains the `CommonNoun` and cursor to aid in pagination. */
  edges: Array<CommonNounsEdge>;
  /** A list of `CommonNoun` objects. */
  nodes: Array<Maybe<CommonNoun>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CommonNoun` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CommonNoun` edge in the connection. */
export type CommonNounsEdge = {
  __typename?: 'CommonNounsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CommonNoun` at the end of the edge. */
  node?: Maybe<CommonNoun>;
};

/** Methods to use when ordering `CommonNoun`. */
export enum CommonNounsOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export type CompletionPayment = {
  __typename?: 'CompletionPayment';
  allocation?: Maybe<Scalars['JSON']>;
  amount: Scalars['BigFloat'];
  amountNormalized?: Maybe<Scalars['BigFloat']>;
  currencyCode: Scalars['String'];
  donationDate: Scalars['Date'];
  /** Reads a single `ExternalOrganization` that is related to this `CompletionPayment`. */
  externalOrganizationByOrganizationId?: Maybe<ExternalOrganization>;
  /** Reads a single `Income` that is related to this `CompletionPayment`. */
  incomeByIncomeId?: Maybe<Income>;
  incomeId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `Liability` that is related to this `CompletionPayment`. */
  liabilityByPledgeIdAndIncomeId?: Maybe<Liability>;
  objectId: Scalars['BigInt'];
  objectType: CompletionPaymentObjectType;
  organizationId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `Payment` that is related to this `CompletionPayment`. */
  paymentByPaymentId?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['BigInt']>;
  personId?: Maybe<Scalars['BigInt']>;
  pledgeId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `ReportedDonation` that is related to this `CompletionPayment`. */
  reportedDonationByReportedDonationId?: Maybe<ReportedDonation>;
  reportedDonationId?: Maybe<Scalars['BigInt']>;
};

/**
 * A condition to be used against `CompletionPayment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CompletionPaymentCondition = {
  /** Checks for equality with the object’s `allocation` field. */
  allocation?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `donationDate` field. */
  donationDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `incomeId` field. */
  incomeId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `objectType` field. */
  objectType?: InputMaybe<CompletionPaymentObjectType>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `paymentId` field. */
  paymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pledgeId` field. */
  pledgeId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `reportedDonationId` field. */
  reportedDonationId?: InputMaybe<Scalars['BigInt']>;
};

/** An input for mutations affecting `CompletionPayment` */
export type CompletionPaymentInput = {
  allocation?: InputMaybe<Scalars['JSON']>;
  amount: Scalars['BigFloat'];
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  currencyCode: Scalars['String'];
  donationDate: Scalars['Date'];
  incomeId?: InputMaybe<Scalars['BigInt']>;
  objectId: Scalars['BigInt'];
  objectType: CompletionPaymentObjectType;
  organizationId?: InputMaybe<Scalars['BigInt']>;
  paymentId?: InputMaybe<Scalars['BigInt']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  pledgeId?: InputMaybe<Scalars['BigInt']>;
  reportedDonationId?: InputMaybe<Scalars['BigInt']>;
};

export enum CompletionPaymentObjectType {
  Payment = 'PAYMENT',
  ReportedDonation = 'REPORTED_DONATION'
}

/** A connection to a list of `CompletionPayment` values. */
export type CompletionPaymentsConnection = {
  __typename?: 'CompletionPaymentsConnection';
  /** A list of edges which contains the `CompletionPayment` and cursor to aid in pagination. */
  edges: Array<CompletionPaymentsEdge>;
  /** A list of `CompletionPayment` objects. */
  nodes: Array<Maybe<CompletionPayment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompletionPayment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CompletionPayment` edge in the connection. */
export type CompletionPaymentsEdge = {
  __typename?: 'CompletionPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompletionPayment` at the end of the edge. */
  node?: Maybe<CompletionPayment>;
};

/** Methods to use when ordering `CompletionPayment`. */
export enum CompletionPaymentsOrderBy {
  AllocationAsc = 'ALLOCATION_ASC',
  AllocationDesc = 'ALLOCATION_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DonationDateAsc = 'DONATION_DATE_ASC',
  DonationDateDesc = 'DONATION_DATE_DESC',
  IncomeIdAsc = 'INCOME_ID_ASC',
  IncomeIdDesc = 'INCOME_ID_DESC',
  Natural = 'NATURAL',
  ObjectIdAsc = 'OBJECT_ID_ASC',
  ObjectIdDesc = 'OBJECT_ID_DESC',
  ObjectTypeAsc = 'OBJECT_TYPE_ASC',
  ObjectTypeDesc = 'OBJECT_TYPE_DESC',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PledgeIdAsc = 'PLEDGE_ID_ASC',
  PledgeIdDesc = 'PLEDGE_ID_DESC',
  ReportedDonationIdAsc = 'REPORTED_DONATION_ID_ASC',
  ReportedDonationIdDesc = 'REPORTED_DONATION_ID_DESC'
}

export type ContactPreference = Node & {
  __typename?: 'ContactPreference';
  /** Reads a single `Address` that is related to this `ContactPreference`. */
  addressByCurrentAddressId?: Maybe<Address>;
  /** Reads a single `Address` that is related to this `ContactPreference`. */
  addressByPersonIdAndCurrentAddressId?: Maybe<Address>;
  createdAt: Scalars['Datetime'];
  currentAddressId?: Maybe<Scalars['BigInt']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Person` that is related to this `ContactPreference`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ContactPreference` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ContactPreferenceCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currentAddressId` field. */
  currentAddressId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `ContactPreference` values. */
export type ContactPreferencesConnection = {
  __typename?: 'ContactPreferencesConnection';
  /** A list of edges which contains the `ContactPreference` and cursor to aid in pagination. */
  edges: Array<ContactPreferencesEdge>;
  /** A list of `ContactPreference` objects. */
  nodes: Array<Maybe<ContactPreference>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContactPreference` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ContactPreference` edge in the connection. */
export type ContactPreferencesEdge = {
  __typename?: 'ContactPreferencesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ContactPreference` at the end of the edge. */
  node?: Maybe<ContactPreference>;
};

/** Methods to use when ordering `ContactPreference`. */
export enum ContactPreferencesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrentAddressIdAsc = 'CURRENT_ADDRESS_ID_ASC',
  CurrentAddressIdDesc = 'CURRENT_ADDRESS_ID_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A connection to a list of `Country` values. */
export type CountriesConnection = {
  __typename?: 'CountriesConnection';
  /** A list of edges which contains the `Country` and cursor to aid in pagination. */
  edges: Array<CountriesEdge>;
  /** A list of `Country` objects. */
  nodes: Array<Maybe<Country>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Country` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Country` edge in the connection. */
export type CountriesEdge = {
  __typename?: 'CountriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Country` at the end of the edge. */
  node?: Maybe<Country>;
};

/** Methods to use when ordering `Country`. */
export enum CountriesOrderBy {
  IsoAlpha_2Asc = 'ISO_ALPHA_2_ASC',
  IsoAlpha_2Desc = 'ISO_ALPHA_2_DESC',
  IsoAlpha_3Asc = 'ISO_ALPHA_3_ASC',
  IsoAlpha_3Desc = 'ISO_ALPHA_3_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Country = Node & {
  __typename?: 'Country';
  /** Reads and enables pagination through a set of `AddressBackup`. */
  addressBackupsByCountryCode: AddressBackupsConnection;
  /** Reads and enables pagination through a set of `AddressBackup`. */
  addressBackupsByCountryCodeList: Array<AddressBackup>;
  /** Reads and enables pagination through a set of `Address`. */
  addressesByCountryCode: AddressesConnection;
  /** Reads and enables pagination through a set of `Address`. */
  addressesByCountryCodeList: Array<Address>;
  /** Reads and enables pagination through a set of `CurrencyByCountry`. */
  currencyByCountriesByCountryCode: CurrencyByCountriesConnection;
  /** Reads and enables pagination through a set of `CurrencyByCountry`. */
  currencyByCountriesByCountryCodeList: Array<CurrencyByCountry>;
  isoAlpha2: Scalars['String'];
  isoAlpha3: Scalars['String'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PaymentRecipient`. */
  paymentRecipientsByCountryCode: PaymentRecipientsConnection;
  /** Reads and enables pagination through a set of `PaymentRecipient`. */
  paymentRecipientsByCountryCodeList: Array<PaymentRecipient>;
};


export type CountryAddressBackupsByCountryCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AddressBackupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressBackupsOrderBy>>;
};


export type CountryAddressBackupsByCountryCodeListArgs = {
  condition?: InputMaybe<AddressBackupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressBackupsOrderBy>>;
};


export type CountryAddressesByCountryCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};


export type CountryAddressesByCountryCodeListArgs = {
  condition?: InputMaybe<AddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};


export type CountryCurrencyByCountriesByCountryCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CurrencyByCountryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrencyByCountriesOrderBy>>;
};


export type CountryCurrencyByCountriesByCountryCodeListArgs = {
  condition?: InputMaybe<CurrencyByCountryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrencyByCountriesOrderBy>>;
};


export type CountryPaymentRecipientsByCountryCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecipientsOrderBy>>;
};


export type CountryPaymentRecipientsByCountryCodeListArgs = {
  condition?: InputMaybe<PaymentRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecipientsOrderBy>>;
};

/** A condition to be used against `Country` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CountryCondition = {
  /** Checks for equality with the object’s `isoAlpha2` field. */
  isoAlpha2?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `isoAlpha3` field. */
  isoAlpha3?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

export type CountryCount = {
  __typename?: 'CountryCount';
  count?: Maybe<Scalars['Int']>;
  countryCode?: Maybe<Scalars['String']>;
};

/** A connection to a list of `CountryCount` values. */
export type CountryCountsConnection = {
  __typename?: 'CountryCountsConnection';
  /** A list of edges which contains the `CountryCount` and cursor to aid in pagination. */
  edges: Array<CountryCountsEdge>;
  /** A list of `CountryCount` objects. */
  nodes: Array<Maybe<CountryCount>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CountryCount` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CountryCount` edge in the connection. */
export type CountryCountsEdge = {
  __typename?: 'CountryCountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CountryCount` at the end of the edge. */
  node?: Maybe<CountryCount>;
};

export type CountryPaymentMethod = Node & {
  __typename?: 'CountryPaymentMethod';
  countryCode: Scalars['String'];
  createdAt: Scalars['Datetime'];
  gateway: PaymentGateway;
  /** Reads a single `GatewayPaymentMethod` that is related to this `CountryPaymentMethod`. */
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  paymentMethod: PaymentMethod;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `CountryPaymentMethod` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CountryPaymentMethodCondition = {
  /** Checks for equality with the object’s `countryCode` field. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `gateway` field. */
  gateway?: InputMaybe<PaymentGateway>;
  /** Checks for equality with the object’s `paymentMethod` field. */
  paymentMethod?: InputMaybe<PaymentMethod>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `CountryPaymentMethod` values. */
export type CountryPaymentMethodsConnection = {
  __typename?: 'CountryPaymentMethodsConnection';
  /** A list of edges which contains the `CountryPaymentMethod` and cursor to aid in pagination. */
  edges: Array<CountryPaymentMethodsEdge>;
  /** A list of `CountryPaymentMethod` objects. */
  nodes: Array<Maybe<CountryPaymentMethod>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CountryPaymentMethod` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CountryPaymentMethod` edge in the connection. */
export type CountryPaymentMethodsEdge = {
  __typename?: 'CountryPaymentMethodsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CountryPaymentMethod` at the end of the edge. */
  node?: Maybe<CountryPaymentMethod>;
};

/** Methods to use when ordering `CountryPaymentMethod`. */
export enum CountryPaymentMethodsOrderBy {
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GatewayAsc = 'GATEWAY_ASC',
  GatewayDesc = 'GATEWAY_DESC',
  Natural = 'NATURAL',
  PaymentMethodAsc = 'PAYMENT_METHOD_ASC',
  PaymentMethodDesc = 'PAYMENT_METHOD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** All input for the `createAcquisition` mutation. */
export type CreateAcquisitionInput = {
  campaign?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Int']>;
  medium?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<Scalars['String']>;
};

/** The output of our `createAcquisition` mutation. */
export type CreateAcquisitionPayload = {
  __typename?: 'CreateAcquisitionPayload';
  acquisition?: Maybe<Acquisition>;
  /** An edge for our `Acquisition`. May be used by Relay 1. */
  acquisitionEdge?: Maybe<AcquisitionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Person` that is related to this `Acquisition`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createAcquisition` mutation. */
export type CreateAcquisitionPayloadAcquisitionEdgeArgs = {
  orderBy?: InputMaybe<Array<AcquisitionsOrderBy>>;
};

/** All input for the `createAddressByPersonId` mutation. */
export type CreateAddressByPersonIdInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<AddressType>;
  city?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

/** The output of our `createAddressByPersonId` mutation. */
export type CreateAddressByPersonIdPayload = {
  __typename?: 'CreateAddressByPersonIdPayload';
  address?: Maybe<Address>;
  /** An edge for our `Address`. May be used by Relay 1. */
  addressEdge?: Maybe<AddressesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Country` that is related to this `Address`. */
  countryByCountryCode?: Maybe<Country>;
  /** Reads a single `Person` that is related to this `Address`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createAddressByPersonId` mutation. */
export type CreateAddressByPersonIdPayloadAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};

/** All input for the `createAddressByPersonOrTemporaryPerson` mutation. */
export type CreateAddressByPersonOrTemporaryPersonInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<AddressType>;
  city?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `createAddressByPersonOrTemporaryPerson` mutation. */
export type CreateAddressByPersonOrTemporaryPersonPayload = {
  __typename?: 'CreateAddressByPersonOrTemporaryPersonPayload';
  address?: Maybe<Address>;
  /** An edge for our `Address`. May be used by Relay 1. */
  addressEdge?: Maybe<AddressesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Country` that is related to this `Address`. */
  countryByCountryCode?: Maybe<Country>;
  /** Reads a single `Person` that is related to this `Address`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createAddressByPersonOrTemporaryPerson` mutation. */
export type CreateAddressByPersonOrTemporaryPersonPayloadAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};

/** All input for the `createAddressByTemporaryPerson` mutation. */
export type CreateAddressByTemporaryPersonInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<AddressType>;
  city?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `createAddressByTemporaryPerson` mutation. */
export type CreateAddressByTemporaryPersonPayload = {
  __typename?: 'CreateAddressByTemporaryPersonPayload';
  address?: Maybe<Address>;
  /** An edge for our `Address`. May be used by Relay 1. */
  addressEdge?: Maybe<AddressesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Country` that is related to this `Address`. */
  countryByCountryCode?: Maybe<Country>;
  /** Reads a single `Person` that is related to this `Address`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createAddressByTemporaryPerson` mutation. */
export type CreateAddressByTemporaryPersonPayloadAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};

/** All input for the `createExternalOrganization` mutation. */
export type CreateExternalOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  organizationSlug?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** The output of our `createExternalOrganization` mutation. */
export type CreateExternalOrganizationPayload = {
  __typename?: 'CreateExternalOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  externalOrganization?: Maybe<ExternalOrganization>;
  /** An edge for our `ExternalOrganization`. May be used by Relay 1. */
  externalOrganizationEdge?: Maybe<ExternalOrganizationsEdge>;
  /** Reads a single `Organization` that is related to this `ExternalOrganization`. */
  organizationByOrganizationSlug?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createExternalOrganization` mutation. */
export type CreateExternalOrganizationPayloadExternalOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalOrganizationsOrderBy>>;
};

/** All input for the `createGiftAidClaimFromPayment` mutation. */
export type CreateGiftAidClaimFromPaymentInput = {
  addressId?: InputMaybe<Scalars['BigInt']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `createGiftAidClaimFromPayment` mutation. */
export type CreateGiftAidClaimFromPaymentPayload = {
  __typename?: 'CreateGiftAidClaimFromPaymentPayload';
  /** Reads a single `Address` that is related to this `GiftAidClaim`. */
  addressByAddressIdAndPersonId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  giftAidClaim?: Maybe<GiftAidClaim>;
  /** An edge for our `GiftAidClaim`. May be used by Relay 1. */
  giftAidClaimEdge?: Maybe<GiftAidClaimsEdge>;
  /** Reads a single `Payment` that is related to this `GiftAidClaim`. */
  paymentByGiftAidPaymentId?: Maybe<Payment>;
  /** Reads a single `Payment` that is related to this `GiftAidClaim`. */
  paymentByPaymentIdAndPersonId?: Maybe<Payment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createGiftAidClaimFromPayment` mutation. */
export type CreateGiftAidClaimFromPaymentPayloadGiftAidClaimEdgeArgs = {
  orderBy?: InputMaybe<Array<GiftAidClaimsOrderBy>>;
};

/** All input for the `createGiftAidClaim` mutation. */
export type CreateGiftAidClaimInput = {
  addressId: Scalars['BigInt'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['BigInt'];
  personId: Scalars['BigInt'];
};

/** The output of our `createGiftAidClaim` mutation. */
export type CreateGiftAidClaimPayload = {
  __typename?: 'CreateGiftAidClaimPayload';
  /** Reads a single `Address` that is related to this `GiftAidClaim`. */
  addressByAddressIdAndPersonId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  giftAidClaim?: Maybe<GiftAidClaim>;
  /** An edge for our `GiftAidClaim`. May be used by Relay 1. */
  giftAidClaimEdge?: Maybe<GiftAidClaimsEdge>;
  /** Reads a single `Payment` that is related to this `GiftAidClaim`. */
  paymentByGiftAidPaymentId?: Maybe<Payment>;
  /** Reads a single `Payment` that is related to this `GiftAidClaim`. */
  paymentByPaymentIdAndPersonId?: Maybe<Payment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createGiftAidClaim` mutation. */
export type CreateGiftAidClaimPayloadGiftAidClaimEdgeArgs = {
  orderBy?: InputMaybe<Array<GiftAidClaimsOrderBy>>;
};

/** All input for the `createGiftAidFromPayment` mutation. */
export type CreateGiftAidFromPaymentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `createGiftAidFromPayment` mutation. */
export type CreateGiftAidFromPaymentPayload = {
  __typename?: 'CreateGiftAidFromPaymentPayload';
  /** Reads a single `Address` that is related to this `Payment`. */
  addressByBillingAddressId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByChargeCurrencyCode?: Maybe<Currency>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `GatewayPaymentMethod` that is related to this `Payment`. */
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  payment?: Maybe<Payment>;
  /** An edge for our `Payment`. May be used by Relay 1. */
  paymentEdge?: Maybe<PaymentsEdge>;
  /** Reads a single `PaymentRecipient` that is related to this `Payment`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Reads a single `Person` that is related to this `Payment`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createGiftAidFromPayment` mutation. */
export type CreateGiftAidFromPaymentPayloadPaymentEdgeArgs = {
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};

/** All input for the `createGocardlessRedirectFlowByPersonOrTemporaryPerson` mutation. */
export type CreateGocardlessRedirectFlowByPersonOrTemporaryPersonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `createGocardlessRedirectFlowByPersonOrTemporaryPerson` mutation. */
export type CreateGocardlessRedirectFlowByPersonOrTemporaryPersonPayload = {
  __typename?: 'CreateGocardlessRedirectFlowByPersonOrTemporaryPersonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  gocardlessRedirectFlow?: Maybe<GocardlessRedirectFlow>;
  /** An edge for our `GocardlessRedirectFlow`. May be used by Relay 1. */
  gocardlessRedirectFlowEdge?: Maybe<GocardlessRedirectFlowsEdge>;
  /** Reads a single `Person` that is related to this `GocardlessRedirectFlow`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createGocardlessRedirectFlowByPersonOrTemporaryPerson` mutation. */
export type CreateGocardlessRedirectFlowByPersonOrTemporaryPersonPayloadGocardlessRedirectFlowEdgeArgs = {
  orderBy?: InputMaybe<Array<GocardlessRedirectFlowsOrderBy>>;
};

/** All input for the `createGocardlessRedirectFlowByTemporaryPerson` mutation. */
export type CreateGocardlessRedirectFlowByTemporaryPersonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sessionToken: Scalars['UUID'];
};

/** The output of our `createGocardlessRedirectFlowByTemporaryPerson` mutation. */
export type CreateGocardlessRedirectFlowByTemporaryPersonPayload = {
  __typename?: 'CreateGocardlessRedirectFlowByTemporaryPersonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  gocardlessRedirectFlow?: Maybe<GocardlessRedirectFlow>;
  /** An edge for our `GocardlessRedirectFlow`. May be used by Relay 1. */
  gocardlessRedirectFlowEdge?: Maybe<GocardlessRedirectFlowsEdge>;
  /** Reads a single `Person` that is related to this `GocardlessRedirectFlow`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createGocardlessRedirectFlowByTemporaryPerson` mutation. */
export type CreateGocardlessRedirectFlowByTemporaryPersonPayloadGocardlessRedirectFlowEdgeArgs = {
  orderBy?: InputMaybe<Array<GocardlessRedirectFlowsOrderBy>>;
};

/** All input for the `createGocardlessRedirectFlow` mutation. */
export type CreateGocardlessRedirectFlowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  personId: Scalars['BigInt'];
};

/** The output of our `createGocardlessRedirectFlow` mutation. */
export type CreateGocardlessRedirectFlowPayload = {
  __typename?: 'CreateGocardlessRedirectFlowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  gocardlessRedirectFlow?: Maybe<GocardlessRedirectFlow>;
  /** An edge for our `GocardlessRedirectFlow`. May be used by Relay 1. */
  gocardlessRedirectFlowEdge?: Maybe<GocardlessRedirectFlowsEdge>;
  /** Reads a single `Person` that is related to this `GocardlessRedirectFlow`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createGocardlessRedirectFlow` mutation. */
export type CreateGocardlessRedirectFlowPayloadGocardlessRedirectFlowEdgeArgs = {
  orderBy?: InputMaybe<Array<GocardlessRedirectFlowsOrderBy>>;
};

/** All input for the `createIncome` mutation. */
export type CreateIncomeInput = {
  amount: Scalars['BigFloat'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  currencyCode: Scalars['String'];
  donationsTaxDeductible: Scalars['Boolean'];
  employmentStatus: IncomeEmploymentStatus;
  period: DateRangeInput;
  personId: Scalars['BigInt'];
};

/** The output of our `createIncome` mutation. */
export type CreateIncomePayload = {
  __typename?: 'CreateIncomePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `Income`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  income?: Maybe<Income>;
  /** An edge for our `Income`. May be used by Relay 1. */
  incomeEdge?: Maybe<IncomesEdge>;
  /** Reads a single `Person` that is related to this `Income`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createIncome` mutation. */
export type CreateIncomePayloadIncomeEdgeArgs = {
  orderBy?: InputMaybe<Array<IncomesOrderBy>>;
};

/** All input for the `createLotteryEntry` mutation. */
export type CreateLotteryEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  paymentId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `createLotteryEntry` mutation. */
export type CreateLotteryEntryPayload = {
  __typename?: 'CreateLotteryEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `createPaymentBatch` mutation. */
export type CreatePaymentBatchInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  payments: Array<InputMaybe<PaymentInput>>;
};

/** The output of our `createPaymentBatch` mutation. */
export type CreatePaymentBatchPayload = {
  __typename?: 'CreatePaymentBatchPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `createPaymentByPersonId` mutation. */
export type CreatePaymentByPersonIdInput = {
  allocation?: InputMaybe<Scalars['JSON']>;
  amount?: InputMaybe<Scalars['BigFloat']>;
  billingAddressId?: InputMaybe<Scalars['BigInt']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  gateway?: InputMaybe<PaymentGateway>;
  gatewayData?: InputMaybe<Scalars['JSON']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  personId?: InputMaybe<Scalars['BigInt']>;
  recipient?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PaymentStatus>;
};

/** The output of our `createPaymentByPersonId` mutation. */
export type CreatePaymentByPersonIdPayload = {
  __typename?: 'CreatePaymentByPersonIdPayload';
  /** Reads a single `Address` that is related to this `Payment`. */
  addressByBillingAddressId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByChargeCurrencyCode?: Maybe<Currency>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `GatewayPaymentMethod` that is related to this `Payment`. */
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  payment?: Maybe<Payment>;
  /** An edge for our `Payment`. May be used by Relay 1. */
  paymentEdge?: Maybe<PaymentsEdge>;
  /** Reads a single `PaymentRecipient` that is related to this `Payment`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Reads a single `Person` that is related to this `Payment`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createPaymentByPersonId` mutation. */
export type CreatePaymentByPersonIdPayloadPaymentEdgeArgs = {
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};

/** All input for the `createPaymentByTemporaryPerson` mutation. */
export type CreatePaymentByTemporaryPersonInput = {
  allocation?: InputMaybe<Scalars['JSON']>;
  amount?: InputMaybe<Scalars['BigFloat']>;
  billingAddressId?: InputMaybe<Scalars['BigInt']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  gateway?: InputMaybe<PaymentGateway>;
  gatewayData?: InputMaybe<Scalars['JSON']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  recipient?: InputMaybe<Scalars['String']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `createPaymentByTemporaryPerson` mutation. */
export type CreatePaymentByTemporaryPersonPayload = {
  __typename?: 'CreatePaymentByTemporaryPersonPayload';
  /** Reads a single `Address` that is related to this `Payment`. */
  addressByBillingAddressId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByChargeCurrencyCode?: Maybe<Currency>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `GatewayPaymentMethod` that is related to this `Payment`. */
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  payment?: Maybe<Payment>;
  /** An edge for our `Payment`. May be used by Relay 1. */
  paymentEdge?: Maybe<PaymentsEdge>;
  /** Reads a single `PaymentRecipient` that is related to this `Payment`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Reads a single `Person` that is related to this `Payment`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createPaymentByTemporaryPerson` mutation. */
export type CreatePaymentByTemporaryPersonPayloadPaymentEdgeArgs = {
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};

/** All input for the `createPayrollGivingProviderCustomerBatch` mutation. */
export type CreatePayrollGivingProviderCustomerBatchInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  payrollGivingProviderCustomers: Array<InputMaybe<PayrollGivingProviderCustomerInput>>;
};

/** The output of our `createPayrollGivingProviderCustomerBatch` mutation. */
export type CreatePayrollGivingProviderCustomerBatchPayload = {
  __typename?: 'CreatePayrollGivingProviderCustomerBatchPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  payrollGivingProviderCustomers?: Maybe<Array<Maybe<PayrollGivingProviderCustomer>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `createPerson` mutation. */
export type CreatePersonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

/** The output of our `createPerson` mutation. */
export type CreatePersonPayload = {
  __typename?: 'CreatePersonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EmailAddress` that is related to this `Person`. */
  emailAddressByIdAndEmail?: Maybe<EmailAddress>;
  person?: Maybe<Person>;
  /** An edge for our `Person`. May be used by Relay 1. */
  personEdge?: Maybe<PeopleEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createPerson` mutation. */
export type CreatePersonPayloadPersonEdgeArgs = {
  orderBy?: InputMaybe<Array<PeopleOrderBy>>;
};

/** All input for the `createPledge` mutation. */
export type CreatePledgeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  motivation?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<DateRangeInput>;
  personId?: InputMaybe<Scalars['BigInt']>;
  pledgePercentage?: InputMaybe<Scalars['BigFloat']>;
  pledgeType?: InputMaybe<PledgeType>;
};

/** The output of our `createPledge` mutation. */
export type CreatePledgePayload = {
  __typename?: 'CreatePledgePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Person` that is related to this `Pledge`. */
  personByPersonId?: Maybe<Person>;
  pledge?: Maybe<Pledge>;
  /** An edge for our `Pledge`. May be used by Relay 1. */
  pledgeEdge?: Maybe<PledgesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createPledge` mutation. */
export type CreatePledgePayloadPledgeEdgeArgs = {
  orderBy?: InputMaybe<Array<PledgesOrderBy>>;
};

/** All input for the `createPollOptionVote` mutation. */
export type CreatePollOptionVoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  context: Scalars['String'];
  personId: Scalars['BigInt'];
  pollOptionId: Scalars['BigInt'];
};

/** The output of our `createPollOptionVote` mutation. */
export type CreatePollOptionVotePayload = {
  __typename?: 'CreatePollOptionVotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Person` that is related to this `PollOptionVote`. */
  personByPersonId?: Maybe<Person>;
  /** Reads a single `PollOptionPublic` that is related to this `PollOptionVote`. */
  pollOptionPublicByPollOptionId?: Maybe<PollOptionPublic>;
  pollOptionVote?: Maybe<PollOptionVote>;
  /** An edge for our `PollOptionVote`. May be used by Relay 1. */
  pollOptionVoteEdge?: Maybe<PollOptionVotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createPollOptionVote` mutation. */
export type CreatePollOptionVotePayloadPollOptionVoteEdgeArgs = {
  orderBy?: InputMaybe<Array<PollOptionVotesOrderBy>>;
};

/** All input for the `createRecurringPaymentByTemporaryPerson` mutation. */
export type CreateRecurringPaymentByTemporaryPersonInput = {
  allocation?: InputMaybe<Scalars['JSON']>;
  amount?: InputMaybe<Scalars['BigFloat']>;
  billingAddressId?: InputMaybe<Scalars['BigInt']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  gateway?: InputMaybe<PaymentGateway>;
  gatewayData?: InputMaybe<Scalars['JSON']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  period?: InputMaybe<RecurrencePeriod>;
  periodIndex?: InputMaybe<Scalars['Int']>;
  recipient?: InputMaybe<Scalars['String']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `createRecurringPaymentByTemporaryPerson` mutation. */
export type CreateRecurringPaymentByTemporaryPersonPayload = {
  __typename?: 'CreateRecurringPaymentByTemporaryPersonPayload';
  /** Reads a single `Address` that is related to this `RecurringPayment`. */
  addressByBillingAddressId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `RecurringPayment`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `GatewayPaymentMethod` that is related to this `RecurringPayment`. */
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  /** Reads a single `PaymentRecipient` that is related to this `RecurringPayment`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Reads a single `Person` that is related to this `RecurringPayment`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  recurringPayment?: Maybe<RecurringPayment>;
  /** An edge for our `RecurringPayment`. May be used by Relay 1. */
  recurringPaymentEdge?: Maybe<RecurringPaymentsEdge>;
};


/** The output of our `createRecurringPaymentByTemporaryPerson` mutation. */
export type CreateRecurringPaymentByTemporaryPersonPayloadRecurringPaymentEdgeArgs = {
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};

/** All input for the `createRecurringPayment` mutation. */
export type CreateRecurringPaymentInput = {
  allocation?: InputMaybe<Scalars['JSON']>;
  amount?: InputMaybe<Scalars['BigFloat']>;
  billingAddressId?: InputMaybe<Scalars['BigInt']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  gateway?: InputMaybe<PaymentGateway>;
  gatewayData?: InputMaybe<Scalars['JSON']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  period?: InputMaybe<RecurrencePeriod>;
  periodIndex?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  recipient?: InputMaybe<Scalars['String']>;
};

/** The output of our `createRecurringPayment` mutation. */
export type CreateRecurringPaymentPayload = {
  __typename?: 'CreateRecurringPaymentPayload';
  /** Reads a single `Address` that is related to this `RecurringPayment`. */
  addressByBillingAddressId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `RecurringPayment`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `GatewayPaymentMethod` that is related to this `RecurringPayment`. */
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  /** Reads a single `PaymentRecipient` that is related to this `RecurringPayment`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Reads a single `Person` that is related to this `RecurringPayment`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  recurringPayment?: Maybe<RecurringPayment>;
  /** An edge for our `RecurringPayment`. May be used by Relay 1. */
  recurringPaymentEdge?: Maybe<RecurringPaymentsEdge>;
};


/** The output of our `createRecurringPayment` mutation. */
export type CreateRecurringPaymentPayloadRecurringPaymentEdgeArgs = {
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};

/** All input for the `createRecurringReportedDonation` mutation. */
export type CreateRecurringReportedDonationInput = {
  amount?: InputMaybe<Scalars['BigFloat']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['BigInt']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  recurrenceInterval?: InputMaybe<IntervalInput>;
  startDate?: InputMaybe<Scalars['Date']>;
};

/** The output of our `createRecurringReportedDonation` mutation. */
export type CreateRecurringReportedDonationPayload = {
  __typename?: 'CreateRecurringReportedDonationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `RecurringReportedDonation`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `ExternalOrganization` that is related to this `RecurringReportedDonation`. */
  externalOrganizationByOrganizationId?: Maybe<ExternalOrganization>;
  /** Reads a single `Person` that is related to this `RecurringReportedDonation`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  recurringReportedDonation?: Maybe<RecurringReportedDonation>;
  /** An edge for our `RecurringReportedDonation`. May be used by Relay 1. */
  recurringReportedDonationEdge?: Maybe<RecurringReportedDonationsEdge>;
};


/** The output of our `createRecurringReportedDonation` mutation. */
export type CreateRecurringReportedDonationPayloadRecurringReportedDonationEdgeArgs = {
  orderBy?: InputMaybe<Array<RecurringReportedDonationsOrderBy>>;
};

/** All input for the `createReportedDonationByPersonId` mutation. */
export type CreateReportedDonationByPersonIdInput = {
  amount?: InputMaybe<Scalars['BigFloat']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  donationDate?: InputMaybe<Scalars['Date']>;
  incomeId?: InputMaybe<Scalars['BigInt']>;
  organizationId?: InputMaybe<Scalars['BigInt']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  pledgeId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `createReportedDonationByPersonId` mutation. */
export type CreateReportedDonationByPersonIdPayload = {
  __typename?: 'CreateReportedDonationByPersonIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `ReportedDonation`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `ExternalOrganization` that is related to this `ReportedDonation`. */
  externalOrganizationByOrganizationId?: Maybe<ExternalOrganization>;
  /** Reads a single `Person` that is related to this `ReportedDonation`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  reportedDonation?: Maybe<ReportedDonation>;
  /** An edge for our `ReportedDonation`. May be used by Relay 1. */
  reportedDonationEdge?: Maybe<ReportedDonationsEdge>;
};


/** The output of our `createReportedDonationByPersonId` mutation. */
export type CreateReportedDonationByPersonIdPayloadReportedDonationEdgeArgs = {
  orderBy?: InputMaybe<Array<ReportedDonationsOrderBy>>;
};

/** All input for the `createTemporaryPersonByEmail` mutation. */
export type CreateTemporaryPersonByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  recaptchaToken: Scalars['String'];
};

/** The output of our `createTemporaryPersonByEmail` mutation. */
export type CreateTemporaryPersonByEmailPayload = {
  __typename?: 'CreateTemporaryPersonByEmailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EmailAddress` that is related to this `TemporaryPerson`. */
  emailAddressByEmail?: Maybe<EmailAddress>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  temporaryPerson?: Maybe<TemporaryPerson>;
  /** An edge for our `TemporaryPerson`. May be used by Relay 1. */
  temporaryPersonEdge?: Maybe<TemporaryPeopleEdge>;
};


/** The output of our `createTemporaryPersonByEmail` mutation. */
export type CreateTemporaryPersonByEmailPayloadTemporaryPersonEdgeArgs = {
  orderBy?: InputMaybe<Array<TemporaryPeopleOrderBy>>;
};

/** All input for the `createdDueReportedDonationsByRecurringReportedDonation` mutation. */
export type CreatedDueReportedDonationsByRecurringReportedDonationInput = {
  _recurringReportedDonation?: InputMaybe<RecurringReportedDonationInput>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `createdDueReportedDonationsByRecurringReportedDonation` mutation. */
export type CreatedDueReportedDonationsByRecurringReportedDonationPayload = {
  __typename?: 'CreatedDueReportedDonationsByRecurringReportedDonationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  reportedDonations?: Maybe<Array<Maybe<ReportedDonation>>>;
};

/** A connection to a list of `Currency` values. */
export type CurrenciesConnection = {
  __typename?: 'CurrenciesConnection';
  /** A list of edges which contains the `Currency` and cursor to aid in pagination. */
  edges: Array<CurrenciesEdge>;
  /** A list of `Currency` objects. */
  nodes: Array<Maybe<Currency>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Currency` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Currency` edge in the connection. */
export type CurrenciesEdge = {
  __typename?: 'CurrenciesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Currency` at the end of the edge. */
  node?: Maybe<Currency>;
};

/** Methods to use when ordering `Currency`. */
export enum CurrenciesOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  CurrencyTypeAsc = 'CURRENCY_TYPE_ASC',
  CurrencyTypeDesc = 'CURRENCY_TYPE_DESC',
  DecimalsAsc = 'DECIMALS_ASC',
  DecimalsDesc = 'DECIMALS_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SymbolAsc = 'SYMBOL_ASC',
  SymbolDesc = 'SYMBOL_DESC'
}

export type Currency = Node & {
  __typename?: 'Currency';
  /** Reads and enables pagination through a set of `BalanceSheetReport`. */
  balanceSheetReportsByCurrencyCode: BalanceSheetReportsConnection;
  /** Reads and enables pagination through a set of `BalanceSheetReport`. */
  balanceSheetReportsByCurrencyCodeList: Array<BalanceSheetReport>;
  code: Scalars['String'];
  /** Reads and enables pagination through a set of `CurrencyByCountry`. */
  currencyByCountriesByCurrencyCode: CurrencyByCountriesConnection;
  /** Reads and enables pagination through a set of `CurrencyByCountry`. */
  currencyByCountriesByCurrencyCodeList: Array<CurrencyByCountry>;
  currencyType: CurrencyType;
  decimals: Scalars['Int'];
  /** Reads and enables pagination through a set of `ExchangeRate`. */
  exchangeRatesByCurrencyCode: ExchangeRatesConnection;
  /** Reads and enables pagination through a set of `ExchangeRate`. */
  exchangeRatesByCurrencyCodeList: Array<ExchangeRate>;
  /** Reads and enables pagination through a set of `FtxCoin`. */
  ftxCoinsByCode: FtxCoinsConnection;
  /** Reads and enables pagination through a set of `FtxCoin`. */
  ftxCoinsByCodeList: Array<FtxCoin>;
  /** Reads and enables pagination through a set of `FtxConversion`. */
  ftxConversionsByFromCurrencyCode: FtxConversionsConnection;
  /** Reads and enables pagination through a set of `FtxConversion`. */
  ftxConversionsByFromCurrencyCodeList: Array<FtxConversion>;
  /** Reads and enables pagination through a set of `FtxConversion`. */
  ftxConversionsByToCurrencyCode: FtxConversionsConnection;
  /** Reads and enables pagination through a set of `FtxConversion`. */
  ftxConversionsByToCurrencyCodeList: Array<FtxConversion>;
  /** Reads and enables pagination through a set of `GatewayPayoutReportEntry`. */
  gatewayPayoutReportEntriesByCurrencyCode: GatewayPayoutReportEntriesConnection;
  /** Reads and enables pagination through a set of `GatewayPayoutReportEntry`. */
  gatewayPayoutReportEntriesByCurrencyCodeList: Array<GatewayPayoutReportEntry>;
  /** Reads and enables pagination through a set of `GatewayPayoutReport`. */
  gatewayPayoutReportsByCurrencyCode: GatewayPayoutReportsConnection;
  /** Reads and enables pagination through a set of `GatewayPayoutReport`. */
  gatewayPayoutReportsByCurrencyCodeList: Array<GatewayPayoutReport>;
  /** Reads and enables pagination through a set of `Income`. */
  incomesByCurrencyCode: IncomesConnection;
  /** Reads and enables pagination through a set of `Income`. */
  incomesByCurrencyCodeList: Array<Income>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PaymentRecipient`. */
  paymentRecipientsByCurrencyCode: PaymentRecipientsConnection;
  /** Reads and enables pagination through a set of `PaymentRecipient`. */
  paymentRecipientsByCurrencyCodeList: Array<PaymentRecipient>;
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByChargeCurrencyCode: PaymentsConnection;
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByChargeCurrencyCodeList: Array<Payment>;
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByCurrencyCode: PaymentsConnection;
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByCurrencyCodeList: Array<Payment>;
  /** Reads and enables pagination through a set of `RecurringPayment`. */
  recurringPaymentsByCurrencyCode: RecurringPaymentsConnection;
  /** Reads and enables pagination through a set of `RecurringPayment`. */
  recurringPaymentsByCurrencyCodeList: Array<RecurringPayment>;
  /** Reads and enables pagination through a set of `RecurringReportedDonation`. */
  recurringReportedDonationsByCurrencyCode: RecurringReportedDonationsConnection;
  /** Reads and enables pagination through a set of `RecurringReportedDonation`. */
  recurringReportedDonationsByCurrencyCodeList: Array<RecurringReportedDonation>;
  /** Reads and enables pagination through a set of `ReportedDonation`. */
  reportedDonationsByCurrencyCode: ReportedDonationsConnection;
  /** Reads and enables pagination through a set of `ReportedDonation`. */
  reportedDonationsByCurrencyCodeList: Array<ReportedDonation>;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomersByCurrencyCode: StripeCustomersConnection;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomersByCurrencyCodeList: Array<StripeCustomer>;
  symbol?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `WorldIncome`. */
  worldIncomesByCurrencyCode: WorldIncomesConnection;
  /** Reads and enables pagination through a set of `WorldIncome`. */
  worldIncomesByCurrencyCodeList: Array<WorldIncome>;
};


export type CurrencyBalanceSheetReportsByCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BalanceSheetReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BalanceSheetReportsOrderBy>>;
};


export type CurrencyBalanceSheetReportsByCurrencyCodeListArgs = {
  condition?: InputMaybe<BalanceSheetReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BalanceSheetReportsOrderBy>>;
};


export type CurrencyCurrencyByCountriesByCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CurrencyByCountryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrencyByCountriesOrderBy>>;
};


export type CurrencyCurrencyByCountriesByCurrencyCodeListArgs = {
  condition?: InputMaybe<CurrencyByCountryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrencyByCountriesOrderBy>>;
};


export type CurrencyExchangeRatesByCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExchangeRateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExchangeRatesOrderBy>>;
};


export type CurrencyExchangeRatesByCurrencyCodeListArgs = {
  condition?: InputMaybe<ExchangeRateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExchangeRatesOrderBy>>;
};


export type CurrencyFtxCoinsByCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FtxCoinCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxCoinsOrderBy>>;
};


export type CurrencyFtxCoinsByCodeListArgs = {
  condition?: InputMaybe<FtxCoinCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxCoinsOrderBy>>;
};


export type CurrencyFtxConversionsByFromCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FtxConversionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxConversionsOrderBy>>;
};


export type CurrencyFtxConversionsByFromCurrencyCodeListArgs = {
  condition?: InputMaybe<FtxConversionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxConversionsOrderBy>>;
};


export type CurrencyFtxConversionsByToCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FtxConversionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxConversionsOrderBy>>;
};


export type CurrencyFtxConversionsByToCurrencyCodeListArgs = {
  condition?: InputMaybe<FtxConversionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxConversionsOrderBy>>;
};


export type CurrencyGatewayPayoutReportEntriesByCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GatewayPayoutReportEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportEntriesOrderBy>>;
};


export type CurrencyGatewayPayoutReportEntriesByCurrencyCodeListArgs = {
  condition?: InputMaybe<GatewayPayoutReportEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportEntriesOrderBy>>;
};


export type CurrencyGatewayPayoutReportsByCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GatewayPayoutReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportsOrderBy>>;
};


export type CurrencyGatewayPayoutReportsByCurrencyCodeListArgs = {
  condition?: InputMaybe<GatewayPayoutReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportsOrderBy>>;
};


export type CurrencyIncomesByCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IncomeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IncomesOrderBy>>;
};


export type CurrencyIncomesByCurrencyCodeListArgs = {
  condition?: InputMaybe<IncomeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IncomesOrderBy>>;
};


export type CurrencyPaymentRecipientsByCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecipientsOrderBy>>;
};


export type CurrencyPaymentRecipientsByCurrencyCodeListArgs = {
  condition?: InputMaybe<PaymentRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecipientsOrderBy>>;
};


export type CurrencyPaymentsByChargeCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type CurrencyPaymentsByChargeCurrencyCodeListArgs = {
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type CurrencyPaymentsByCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type CurrencyPaymentsByCurrencyCodeListArgs = {
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type CurrencyRecurringPaymentsByCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};


export type CurrencyRecurringPaymentsByCurrencyCodeListArgs = {
  condition?: InputMaybe<RecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};


export type CurrencyRecurringReportedDonationsByCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecurringReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringReportedDonationsOrderBy>>;
};


export type CurrencyRecurringReportedDonationsByCurrencyCodeListArgs = {
  condition?: InputMaybe<RecurringReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringReportedDonationsOrderBy>>;
};


export type CurrencyReportedDonationsByCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportedDonationsOrderBy>>;
};


export type CurrencyReportedDonationsByCurrencyCodeListArgs = {
  condition?: InputMaybe<ReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportedDonationsOrderBy>>;
};


export type CurrencyStripeCustomersByCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StripeCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};


export type CurrencyStripeCustomersByCurrencyCodeListArgs = {
  condition?: InputMaybe<StripeCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};


export type CurrencyWorldIncomesByCurrencyCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WorldIncomeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WorldIncomesOrderBy>>;
};


export type CurrencyWorldIncomesByCurrencyCodeListArgs = {
  condition?: InputMaybe<WorldIncomeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WorldIncomesOrderBy>>;
};

/** A connection to a list of `CurrencyByCountry` values. */
export type CurrencyByCountriesConnection = {
  __typename?: 'CurrencyByCountriesConnection';
  /** A list of edges which contains the `CurrencyByCountry` and cursor to aid in pagination. */
  edges: Array<CurrencyByCountriesEdge>;
  /** A list of `CurrencyByCountry` objects. */
  nodes: Array<Maybe<CurrencyByCountry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CurrencyByCountry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CurrencyByCountry` edge in the connection. */
export type CurrencyByCountriesEdge = {
  __typename?: 'CurrencyByCountriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CurrencyByCountry` at the end of the edge. */
  node?: Maybe<CurrencyByCountry>;
};

/** Methods to use when ordering `CurrencyByCountry`. */
export enum CurrencyByCountriesOrderBy {
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  Natural = 'NATURAL',
  PrecedenceAsc = 'PRECEDENCE_ASC',
  PrecedenceDesc = 'PRECEDENCE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type CurrencyByCountry = Node & {
  __typename?: 'CurrencyByCountry';
  /** Reads a single `Country` that is related to this `CurrencyByCountry`. */
  countryByCountryCode?: Maybe<Country>;
  countryCode: Scalars['String'];
  /** Reads a single `Currency` that is related to this `CurrencyByCountry`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  currencyCode: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  precedence: Scalars['Int'];
};

/**
 * A condition to be used against `CurrencyByCountry` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CurrencyByCountryCondition = {
  /** Checks for equality with the object’s `countryCode` field. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `precedence` field. */
  precedence?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `Currency` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CurrencyCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `currencyType` field. */
  currencyType?: InputMaybe<CurrencyType>;
  /** Checks for equality with the object’s `decimals` field. */
  decimals?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `symbol` field. */
  symbol?: InputMaybe<Scalars['String']>;
};

export enum CurrencyType {
  Crypto = 'CRYPTO',
  Fiat = 'FIAT'
}

/** A range of `Date`. */
export type DateRange = {
  __typename?: 'DateRange';
  /** The ending bound of our range. */
  end?: Maybe<DateRangeBound>;
  /** The starting bound of our range. */
  start?: Maybe<DateRangeBound>;
};

/** The value at one end of a range. A range can either include this value, or not. */
export type DateRangeBound = {
  __typename?: 'DateRangeBound';
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean'];
  /** The value at one end of our range. */
  value: Scalars['Date'];
};

/** The value at one end of a range. A range can either include this value, or not. */
export type DateRangeBoundInput = {
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean'];
  /** The value at one end of our range. */
  value: Scalars['Date'];
};

/** A range of `Date`. */
export type DateRangeInput = {
  /** The ending bound of our range. */
  end?: InputMaybe<DateRangeBoundInput>;
  /** The starting bound of our range. */
  start?: InputMaybe<DateRangeBoundInput>;
};

/** All input for the `deleteGiftAidClaimFromPayment` mutation. */
export type DeleteGiftAidClaimFromPaymentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `deleteGiftAidClaimFromPayment` mutation. */
export type DeleteGiftAidClaimFromPaymentPayload = {
  __typename?: 'DeleteGiftAidClaimFromPaymentPayload';
  /** Reads a single `Address` that is related to this `GiftAidClaim`. */
  addressByAddressIdAndPersonId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  giftAidClaim?: Maybe<GiftAidClaim>;
  /** An edge for our `GiftAidClaim`. May be used by Relay 1. */
  giftAidClaimEdge?: Maybe<GiftAidClaimsEdge>;
  /** Reads a single `Payment` that is related to this `GiftAidClaim`. */
  paymentByGiftAidPaymentId?: Maybe<Payment>;
  /** Reads a single `Payment` that is related to this `GiftAidClaim`. */
  paymentByPaymentIdAndPersonId?: Maybe<Payment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `deleteGiftAidClaimFromPayment` mutation. */
export type DeleteGiftAidClaimFromPaymentPayloadGiftAidClaimEdgeArgs = {
  orderBy?: InputMaybe<Array<GiftAidClaimsOrderBy>>;
};

/** All input for the `deleteIncome` mutation. */
export type DeleteIncomeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `deleteIncome` mutation. */
export type DeleteIncomePayload = {
  __typename?: 'DeleteIncomePayload';
  bigInt?: Maybe<Scalars['BigInt']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteReportedDonation` mutation. */
export type DeleteReportedDonationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `deleteReportedDonation` mutation. */
export type DeleteReportedDonationPayload = {
  __typename?: 'DeleteReportedDonationPayload';
  bigInt?: Maybe<Scalars['BigInt']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Disbursement = Node & {
  __typename?: 'Disbursement';
  createdAt: Scalars['Datetime'];
  disbursementDate?: Maybe<Scalars['Date']>;
  /** Reads and enables pagination through a set of `DisbursementEntry`. */
  disbursementEntriesByDisbursementName: DisbursementEntriesConnection;
  /** Reads and enables pagination through a set of `DisbursementEntry`. */
  disbursementEntriesByDisbursementNameList: Array<DisbursementEntry>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  recipient: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};


export type DisbursementDisbursementEntriesByDisbursementNameArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DisbursementEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisbursementEntriesOrderBy>>;
};


export type DisbursementDisbursementEntriesByDisbursementNameListArgs = {
  condition?: InputMaybe<DisbursementEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisbursementEntriesOrderBy>>;
};

/**
 * A condition to be used against `Disbursement` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DisbursementCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `disbursementDate` field. */
  disbursementDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `DisbursementEntry` values. */
export type DisbursementEntriesConnection = {
  __typename?: 'DisbursementEntriesConnection';
  /** A list of edges which contains the `DisbursementEntry` and cursor to aid in pagination. */
  edges: Array<DisbursementEntriesEdge>;
  /** A list of `DisbursementEntry` objects. */
  nodes: Array<Maybe<DisbursementEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DisbursementEntry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DisbursementEntry` edge in the connection. */
export type DisbursementEntriesEdge = {
  __typename?: 'DisbursementEntriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DisbursementEntry` at the end of the edge. */
  node?: Maybe<DisbursementEntry>;
};

/** Methods to use when ordering `DisbursementEntry`. */
export enum DisbursementEntriesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DisbursementNameAsc = 'DISBURSEMENT_NAME_ASC',
  DisbursementNameDesc = 'DISBURSEMENT_NAME_DESC',
  Natural = 'NATURAL',
  OrganizationSlugAsc = 'ORGANIZATION_SLUG_ASC',
  OrganizationSlugDesc = 'ORGANIZATION_SLUG_DESC',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type DisbursementEntry = Node & {
  __typename?: 'DisbursementEntry';
  createdAt: Scalars['Datetime'];
  /** Reads a single `Disbursement` that is related to this `DisbursementEntry`. */
  disbursementByDisbursementName?: Maybe<Disbursement>;
  disbursementName: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `DisbursementEntry`. */
  organizationByOrganizationSlug?: Maybe<Organization>;
  organizationSlug: Scalars['String'];
  /** Reads a single `Payment` that is related to this `DisbursementEntry`. */
  paymentByPaymentId?: Maybe<Payment>;
  paymentId: Scalars['BigInt'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `DisbursementEntry` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DisbursementEntryCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `disbursementName` field. */
  disbursementName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `organizationSlug` field. */
  organizationSlug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `paymentId` field. */
  paymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Disbursement` values. */
export type DisbursementsConnection = {
  __typename?: 'DisbursementsConnection';
  /** A list of edges which contains the `Disbursement` and cursor to aid in pagination. */
  edges: Array<DisbursementsEdge>;
  /** A list of `Disbursement` objects. */
  nodes: Array<Maybe<Disbursement>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Disbursement` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Disbursement` edge in the connection. */
export type DisbursementsEdge = {
  __typename?: 'DisbursementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Disbursement` at the end of the edge. */
  node?: Maybe<Disbursement>;
};

/** Methods to use when ordering `Disbursement`. */
export enum DisbursementsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DisbursementDateAsc = 'DISBURSEMENT_DATE_ASC',
  DisbursementDateDesc = 'DISBURSEMENT_DATE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type EmailAddress = Node & {
  __typename?: 'EmailAddress';
  createdAt: Scalars['Datetime'];
  email: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Person`. */
  peopleByIdAndEmail: PeopleConnection;
  /** Reads and enables pagination through a set of `Person`. */
  peopleByIdAndEmailList: Array<Person>;
  /** Reads a single `Person` that is related to this `EmailAddress`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  /**
   * Reads and enables pagination through a set of `TemporaryPerson`.
   * @deprecated Please use temporaryPersonByEmail instead
   */
  temporaryPeopleByEmail: TemporaryPeopleConnection;
  /** Reads a single `TemporaryPerson` that is related to this `EmailAddress`. */
  temporaryPersonByEmail?: Maybe<TemporaryPerson>;
  updatedAt: Scalars['Datetime'];
};


export type EmailAddressPeopleByIdAndEmailArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PersonCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PeopleOrderBy>>;
};


export type EmailAddressPeopleByIdAndEmailListArgs = {
  condition?: InputMaybe<PersonCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PeopleOrderBy>>;
};


export type EmailAddressTemporaryPeopleByEmailArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TemporaryPersonCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TemporaryPeopleOrderBy>>;
};

/**
 * A condition to be used against `EmailAddress` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EmailAddressCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `EmailAddress` values. */
export type EmailAddressesConnection = {
  __typename?: 'EmailAddressesConnection';
  /** A list of edges which contains the `EmailAddress` and cursor to aid in pagination. */
  edges: Array<EmailAddressesEdge>;
  /** A list of `EmailAddress` objects. */
  nodes: Array<Maybe<EmailAddress>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmailAddress` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EmailAddress` edge in the connection. */
export type EmailAddressesEdge = {
  __typename?: 'EmailAddressesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EmailAddress` at the end of the edge. */
  node?: Maybe<EmailAddress>;
};

/** Methods to use when ordering `EmailAddress`. */
export enum EmailAddressesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type EoyTaxReceipt = Node & {
  __typename?: 'EoyTaxReceipt';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `PaymentRecipient` that is related to this `EoyTaxReceipt`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  period: DateRange;
  /** Reads a single `Person` that is related to this `EoyTaxReceipt`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  recipient: Scalars['String'];
  sentTimestamp?: Maybe<Scalars['Datetime']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `EoyTaxReceipt` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EoyTaxReceiptCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `period` field. */
  period?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sentTimestamp` field. */
  sentTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type EoyTaxReceiptExtended = {
  __typename?: 'EoyTaxReceiptExtended';
  aggregatePayments?: Maybe<Scalars['JSON']>;
  allPayments?: Maybe<Scalars['JSON']>;
  email?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  period?: Maybe<DateRange>;
  personId?: Maybe<Scalars['BigInt']>;
  recipient?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  summaryPayments?: Maybe<Scalars['JSON']>;
};

/**
 * A condition to be used against `EoyTaxReceiptExtended` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type EoyTaxReceiptExtendedCondition = {
  /** Checks for equality with the object’s `aggregatePayments` field. */
  aggregatePayments?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `allPayments` field. */
  allPayments?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fullName` field. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `period` field. */
  period?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `summaryPayments` field. */
  summaryPayments?: InputMaybe<Scalars['JSON']>;
};

/** A connection to a list of `EoyTaxReceiptExtended` values. */
export type EoyTaxReceiptExtendedsConnection = {
  __typename?: 'EoyTaxReceiptExtendedsConnection';
  /** A list of edges which contains the `EoyTaxReceiptExtended` and cursor to aid in pagination. */
  edges: Array<EoyTaxReceiptExtendedsEdge>;
  /** A list of `EoyTaxReceiptExtended` objects. */
  nodes: Array<Maybe<EoyTaxReceiptExtended>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EoyTaxReceiptExtended` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EoyTaxReceiptExtended` edge in the connection. */
export type EoyTaxReceiptExtendedsEdge = {
  __typename?: 'EoyTaxReceiptExtendedsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EoyTaxReceiptExtended` at the end of the edge. */
  node?: Maybe<EoyTaxReceiptExtended>;
};

/** Methods to use when ordering `EoyTaxReceiptExtended`. */
export enum EoyTaxReceiptExtendedsOrderBy {
  AggregatePaymentsAsc = 'AGGREGATE_PAYMENTS_ASC',
  AggregatePaymentsDesc = 'AGGREGATE_PAYMENTS_DESC',
  AllPaymentsAsc = 'ALL_PAYMENTS_ASC',
  AllPaymentsDesc = 'ALL_PAYMENTS_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  FullNameAsc = 'FULL_NAME_ASC',
  FullNameDesc = 'FULL_NAME_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  SummaryPaymentsAsc = 'SUMMARY_PAYMENTS_ASC',
  SummaryPaymentsDesc = 'SUMMARY_PAYMENTS_DESC'
}

/** A connection to a list of `EoyTaxReceipt` values. */
export type EoyTaxReceiptsConnection = {
  __typename?: 'EoyTaxReceiptsConnection';
  /** A list of edges which contains the `EoyTaxReceipt` and cursor to aid in pagination. */
  edges: Array<EoyTaxReceiptsEdge>;
  /** A list of `EoyTaxReceipt` objects. */
  nodes: Array<Maybe<EoyTaxReceipt>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EoyTaxReceipt` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EoyTaxReceipt` edge in the connection. */
export type EoyTaxReceiptsEdge = {
  __typename?: 'EoyTaxReceiptsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EoyTaxReceipt` at the end of the edge. */
  node?: Maybe<EoyTaxReceipt>;
};

/** Methods to use when ordering `EoyTaxReceipt`. */
export enum EoyTaxReceiptsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  SentTimestampAsc = 'SENT_TIMESTAMP_ASC',
  SentTimestampDesc = 'SENT_TIMESTAMP_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ExchangeRate = Node & {
  __typename?: 'ExchangeRate';
  /** Reads a single `Currency` that is related to this `ExchangeRate`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  currencyCode: Scalars['String'];
  date: Scalars['Date'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  rate?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `ExchangeRate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ExchangeRateCondition = {
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `rate` field. */
  rate?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `ExchangeRate` values. */
export type ExchangeRatesConnection = {
  __typename?: 'ExchangeRatesConnection';
  /** A list of edges which contains the `ExchangeRate` and cursor to aid in pagination. */
  edges: Array<ExchangeRatesEdge>;
  /** A list of `ExchangeRate` objects. */
  nodes: Array<Maybe<ExchangeRate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExchangeRate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExchangeRate` edge in the connection. */
export type ExchangeRatesEdge = {
  __typename?: 'ExchangeRatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExchangeRate` at the end of the edge. */
  node?: Maybe<ExchangeRate>;
};

/** Methods to use when ordering `ExchangeRate`. */
export enum ExchangeRatesOrderBy {
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RateAsc = 'RATE_ASC',
  RateDesc = 'RATE_DESC'
}

/** A connection to a list of `ExtendedLottery` values. */
export type ExtendedLotteriesConnection = {
  __typename?: 'ExtendedLotteriesConnection';
  /** A list of edges which contains the `ExtendedLottery` and cursor to aid in pagination. */
  edges: Array<ExtendedLotteriesEdge>;
  /** A list of `ExtendedLottery` objects. */
  nodes: Array<Maybe<ExtendedLottery>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExtendedLottery` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExtendedLottery` edge in the connection. */
export type ExtendedLotteriesEdge = {
  __typename?: 'ExtendedLotteriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExtendedLottery` at the end of the edge. */
  node?: Maybe<ExtendedLottery>;
};

/** Methods to use when ordering `ExtendedLottery`. */
export enum ExtendedLotteriesOrderBy {
  BlockSizeAsc = 'BLOCK_SIZE_ASC',
  BlockSizeDesc = 'BLOCK_SIZE_DESC',
  CloseTimestampAsc = 'CLOSE_TIMESTAMP_ASC',
  CloseTimestampDesc = 'CLOSE_TIMESTAMP_DESC',
  DrawEpochAsc = 'DRAW_EPOCH_ASC',
  DrawEpochDesc = 'DRAW_EPOCH_DESC',
  DrawTimestampAsc = 'DRAW_TIMESTAMP_ASC',
  DrawTimestampDesc = 'DRAW_TIMESTAMP_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LockTimestampAsc = 'LOCK_TIMESTAMP_ASC',
  LockTimestampDesc = 'LOCK_TIMESTAMP_DESC',
  Natural = 'NATURAL',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  WinningNumberAsc = 'WINNING_NUMBER_ASC',
  WinningNumberDesc = 'WINNING_NUMBER_DESC'
}

export type ExtendedLottery = {
  __typename?: 'ExtendedLottery';
  blockSize?: Maybe<Scalars['BigFloat']>;
  closeTimestamp?: Maybe<Scalars['Datetime']>;
  drawEpoch?: Maybe<Scalars['Int']>;
  drawTimestamp?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['BigInt']>;
  lockTimestamp?: Maybe<Scalars['Datetime']>;
  status?: Maybe<Scalars['String']>;
  winningNumber?: Maybe<Scalars['BigInt']>;
};

/**
 * A condition to be used against `ExtendedLottery` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ExtendedLotteryCondition = {
  /** Checks for equality with the object’s `blockSize` field. */
  blockSize?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `closeTimestamp` field. */
  closeTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `drawEpoch` field. */
  drawEpoch?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `drawTimestamp` field. */
  drawTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `lockTimestamp` field. */
  lockTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `winningNumber` field. */
  winningNumber?: InputMaybe<Scalars['BigInt']>;
};

export type ExternalOrganization = Node & {
  __typename?: 'ExternalOrganization';
  /** Reads and enables pagination through a set of `CompletionPayment`. */
  completionPaymentsByOrganizationId: CompletionPaymentsConnection;
  /** Reads and enables pagination through a set of `CompletionPayment`. */
  completionPaymentsByOrganizationIdList: Array<CompletionPayment>;
  createdAt: Scalars['Datetime'];
  id: Scalars['BigInt'];
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `ExternalOrganization`. */
  organizationByOrganizationSlug?: Maybe<Organization>;
  organizationSlug?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `RecurringReportedDonation`. */
  recurringReportedDonationsByOrganizationId: RecurringReportedDonationsConnection;
  /** Reads and enables pagination through a set of `RecurringReportedDonation`. */
  recurringReportedDonationsByOrganizationIdList: Array<RecurringReportedDonation>;
  /** Reads and enables pagination through a set of `ReportedDonation`. */
  reportedDonationsByOrganizationId: ReportedDonationsConnection;
  /** Reads and enables pagination through a set of `ReportedDonation`. */
  reportedDonationsByOrganizationIdList: Array<ReportedDonation>;
  updatedAt: Scalars['Datetime'];
  url?: Maybe<Scalars['String']>;
};


export type ExternalOrganizationCompletionPaymentsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompletionPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompletionPaymentsOrderBy>>;
};


export type ExternalOrganizationCompletionPaymentsByOrganizationIdListArgs = {
  condition?: InputMaybe<CompletionPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompletionPaymentsOrderBy>>;
};


export type ExternalOrganizationRecurringReportedDonationsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecurringReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringReportedDonationsOrderBy>>;
};


export type ExternalOrganizationRecurringReportedDonationsByOrganizationIdListArgs = {
  condition?: InputMaybe<RecurringReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringReportedDonationsOrderBy>>;
};


export type ExternalOrganizationReportedDonationsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportedDonationsOrderBy>>;
};


export type ExternalOrganizationReportedDonationsByOrganizationIdListArgs = {
  condition?: InputMaybe<ReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportedDonationsOrderBy>>;
};

/**
 * A condition to be used against `ExternalOrganization` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ExternalOrganizationCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `keywords` field. */
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `organizationSlug` field. */
  organizationSlug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `ExternalOrganization` values. */
export type ExternalOrganizationsConnection = {
  __typename?: 'ExternalOrganizationsConnection';
  /** A list of edges which contains the `ExternalOrganization` and cursor to aid in pagination. */
  edges: Array<ExternalOrganizationsEdge>;
  /** A list of `ExternalOrganization` objects. */
  nodes: Array<Maybe<ExternalOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExternalOrganization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExternalOrganization` edge in the connection. */
export type ExternalOrganizationsEdge = {
  __typename?: 'ExternalOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExternalOrganization` at the end of the edge. */
  node?: Maybe<ExternalOrganization>;
};

/** Methods to use when ordering `ExternalOrganization`. */
export enum ExternalOrganizationsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeywordsAsc = 'KEYWORDS_ASC',
  KeywordsDesc = 'KEYWORDS_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrganizationSlugAsc = 'ORGANIZATION_SLUG_ASC',
  OrganizationSlugDesc = 'ORGANIZATION_SLUG_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UrlAsc = 'URL_ASC',
  UrlDesc = 'URL_DESC'
}

export type FailedPayment = {
  __typename?: 'FailedPayment';
  allocation?: Maybe<Scalars['JSON']>;
  amount?: Maybe<Scalars['BigFloat']>;
  amountNormalized?: Maybe<Scalars['BigFloat']>;
  chargeAmount?: Maybe<Scalars['BigFloat']>;
  chargeCurrencyCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  currencyCode?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['BigFloat']>;
  gateway?: Maybe<PaymentGateway>;
  gatewayData?: Maybe<Scalars['JSON']>;
  gatewayTransactionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  metadata?: Maybe<Scalars['JSON']>;
  net?: Maybe<Scalars['BigFloat']>;
  personId?: Maybe<Scalars['BigInt']>;
  recipient?: Maybe<Scalars['String']>;
  recurrence?: Maybe<PaymentRecurrence>;
  reference?: Maybe<Scalars['String']>;
  status?: Maybe<PaymentStatus>;
  statusData?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `FailedPayment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FailedPaymentCondition = {
  /** Checks for equality with the object’s `allocation` field. */
  allocation?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `chargeAmount` field. */
  chargeAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `chargeCurrencyCode` field. */
  chargeCurrencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `gateway` field. */
  gateway?: InputMaybe<PaymentGateway>;
  /** Checks for equality with the object’s `gatewayData` field. */
  gatewayData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `gatewayTransactionId` field. */
  gatewayTransactionId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `net` field. */
  net?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `recurrence` field. */
  recurrence?: InputMaybe<PaymentRecurrence>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<PaymentStatus>;
  /** Checks for equality with the object’s `statusData` field. */
  statusData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `FailedPayment` values. */
export type FailedPaymentsConnection = {
  __typename?: 'FailedPaymentsConnection';
  /** A list of edges which contains the `FailedPayment` and cursor to aid in pagination. */
  edges: Array<FailedPaymentsEdge>;
  /** A list of `FailedPayment` objects. */
  nodes: Array<Maybe<FailedPayment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FailedPayment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FailedPayment` edge in the connection. */
export type FailedPaymentsEdge = {
  __typename?: 'FailedPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FailedPayment` at the end of the edge. */
  node?: Maybe<FailedPayment>;
};

/** Methods to use when ordering `FailedPayment`. */
export enum FailedPaymentsOrderBy {
  AllocationAsc = 'ALLOCATION_ASC',
  AllocationDesc = 'ALLOCATION_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  ChargeAmountAsc = 'CHARGE_AMOUNT_ASC',
  ChargeAmountDesc = 'CHARGE_AMOUNT_DESC',
  ChargeCurrencyCodeAsc = 'CHARGE_CURRENCY_CODE_ASC',
  ChargeCurrencyCodeDesc = 'CHARGE_CURRENCY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  FeeAsc = 'FEE_ASC',
  FeeDesc = 'FEE_DESC',
  GatewayAsc = 'GATEWAY_ASC',
  GatewayDataAsc = 'GATEWAY_DATA_ASC',
  GatewayDataDesc = 'GATEWAY_DATA_DESC',
  GatewayDesc = 'GATEWAY_DESC',
  GatewayTransactionIdAsc = 'GATEWAY_TRANSACTION_ID_ASC',
  GatewayTransactionIdDesc = 'GATEWAY_TRANSACTION_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MetadataAsc = 'METADATA_ASC',
  MetadataDesc = 'METADATA_DESC',
  Natural = 'NATURAL',
  NetAsc = 'NET_ASC',
  NetDesc = 'NET_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  RecurrenceAsc = 'RECURRENCE_ASC',
  RecurrenceDesc = 'RECURRENCE_DESC',
  ReferenceAsc = 'REFERENCE_ASC',
  ReferenceDesc = 'REFERENCE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDataAsc = 'STATUS_DATA_ASC',
  StatusDataDesc = 'STATUS_DATA_DESC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type FailedRecurringPayment = Node & {
  __typename?: 'FailedRecurringPayment';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Person` that is related to this `FailedRecurringPayment`. */
  personByPersonId?: Maybe<Person>;
  personId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `RecurringPayment` that is related to this `FailedRecurringPayment`. */
  recurringPaymentByRecurringPaymentId?: Maybe<RecurringPayment>;
  recurringPaymentId: Scalars['BigInt'];
  resolved?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `FailedRecurringPayment` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type FailedRecurringPaymentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recurringPaymentId` field. */
  recurringPaymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `resolved` field. */
  resolved?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `FailedRecurringPayment` values. */
export type FailedRecurringPaymentsConnection = {
  __typename?: 'FailedRecurringPaymentsConnection';
  /** A list of edges which contains the `FailedRecurringPayment` and cursor to aid in pagination. */
  edges: Array<FailedRecurringPaymentsEdge>;
  /** A list of `FailedRecurringPayment` objects. */
  nodes: Array<Maybe<FailedRecurringPayment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FailedRecurringPayment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FailedRecurringPayment` edge in the connection. */
export type FailedRecurringPaymentsEdge = {
  __typename?: 'FailedRecurringPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FailedRecurringPayment` at the end of the edge. */
  node?: Maybe<FailedRecurringPayment>;
};

/** Methods to use when ordering `FailedRecurringPayment`. */
export enum FailedRecurringPaymentsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecurringPaymentIdAsc = 'RECURRING_PAYMENT_ID_ASC',
  RecurringPaymentIdDesc = 'RECURRING_PAYMENT_ID_DESC',
  ResolvedAsc = 'RESOLVED_ASC',
  ResolvedDesc = 'RESOLVED_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** All input for the `findOrRegisterPersonShadow` mutation. */
export type FindOrRegisterPersonShadowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  registrationMethod?: InputMaybe<RegistrationMethod>;
};

/** The output of our `findOrRegisterPersonShadow` mutation. */
export type FindOrRegisterPersonShadowPayload = {
  __typename?: 'FindOrRegisterPersonShadowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  findOrRegisterPersonShadowResult?: Maybe<FindOrRegisterPersonShadowResult>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type FindOrRegisterPersonShadowResult = {
  __typename?: 'FindOrRegisterPersonShadowResult';
  newRegistration?: Maybe<Scalars['Boolean']>;
  personId?: Maybe<Scalars['BigInt']>;
};

export type FtxCoin = Node & {
  __typename?: 'FtxCoin';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  /** Reads a single `Currency` that is related to this `FtxCoin`. */
  currencyByCode?: Maybe<Currency>;
  depositAddress?: Maybe<Scalars['String']>;
  method: Scalars['String'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `PaymentRecipient` that is related to this `FtxCoin`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  recipient: Scalars['String'];
  sortOrder: Scalars['Int'];
  tag?: Maybe<Scalars['String']>;
};

/** A condition to be used against `FtxCoin` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type FtxCoinCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `depositAddress` field. */
  depositAddress?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `method` field. */
  method?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `tag` field. */
  tag?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `FtxCoin` values. */
export type FtxCoinsConnection = {
  __typename?: 'FtxCoinsConnection';
  /** A list of edges which contains the `FtxCoin` and cursor to aid in pagination. */
  edges: Array<FtxCoinsEdge>;
  /** A list of `FtxCoin` objects. */
  nodes: Array<Maybe<FtxCoin>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FtxCoin` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FtxCoin` edge in the connection. */
export type FtxCoinsEdge = {
  __typename?: 'FtxCoinsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FtxCoin` at the end of the edge. */
  node?: Maybe<FtxCoin>;
};

/** Methods to use when ordering `FtxCoin`. */
export enum FtxCoinsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  DepositAddressAsc = 'DEPOSIT_ADDRESS_ASC',
  DepositAddressDesc = 'DEPOSIT_ADDRESS_DESC',
  MethodAsc = 'METHOD_ASC',
  MethodDesc = 'METHOD_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC',
  TagAsc = 'TAG_ASC',
  TagDesc = 'TAG_DESC'
}

export type FtxConversion = Node & {
  __typename?: 'FtxConversion';
  createdAt: Scalars['Datetime'];
  /** Reads a single `Currency` that is related to this `FtxConversion`. */
  currencyByFromCurrencyCode?: Maybe<Currency>;
  /** Reads a single `Currency` that is related to this `FtxConversion`. */
  currencyByToCurrencyCode?: Maybe<Currency>;
  fromAmount: Scalars['BigFloat'];
  fromCurrencyCode: Scalars['String'];
  gatewayTransactionId: Scalars['String'];
  id: Scalars['BigInt'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `PaymentRecipient` that is related to this `FtxConversion`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  payoutReportId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['BigFloat']>;
  recipient?: Maybe<Scalars['String']>;
  status: FtxConversionStatus;
  statusData?: Maybe<Scalars['JSON']>;
  toAmount?: Maybe<Scalars['BigFloat']>;
  toCurrencyCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `FtxConversion` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FtxConversionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `fromAmount` field. */
  fromAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `fromCurrencyCode` field. */
  fromCurrencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `gatewayTransactionId` field. */
  gatewayTransactionId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `payoutReportId` field. */
  payoutReportId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<FtxConversionStatus>;
  /** Checks for equality with the object’s `statusData` field. */
  statusData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `toAmount` field. */
  toAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `toCurrencyCode` field. */
  toCurrencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum FtxConversionStatus {
  Failed = 'FAILED',
  Succeeded = 'SUCCEEDED'
}

/** A connection to a list of `FtxConversion` values. */
export type FtxConversionsConnection = {
  __typename?: 'FtxConversionsConnection';
  /** A list of edges which contains the `FtxConversion` and cursor to aid in pagination. */
  edges: Array<FtxConversionsEdge>;
  /** A list of `FtxConversion` objects. */
  nodes: Array<Maybe<FtxConversion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FtxConversion` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FtxConversion` edge in the connection. */
export type FtxConversionsEdge = {
  __typename?: 'FtxConversionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FtxConversion` at the end of the edge. */
  node?: Maybe<FtxConversion>;
};

/** Methods to use when ordering `FtxConversion`. */
export enum FtxConversionsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FromAmountAsc = 'FROM_AMOUNT_ASC',
  FromAmountDesc = 'FROM_AMOUNT_DESC',
  FromCurrencyCodeAsc = 'FROM_CURRENCY_CODE_ASC',
  FromCurrencyCodeDesc = 'FROM_CURRENCY_CODE_DESC',
  GatewayTransactionIdAsc = 'GATEWAY_TRANSACTION_ID_ASC',
  GatewayTransactionIdDesc = 'GATEWAY_TRANSACTION_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PayoutReportIdAsc = 'PAYOUT_REPORT_ID_ASC',
  PayoutReportIdDesc = 'PAYOUT_REPORT_ID_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDataAsc = 'STATUS_DATA_ASC',
  StatusDataDesc = 'STATUS_DATA_DESC',
  StatusDesc = 'STATUS_DESC',
  ToAmountAsc = 'TO_AMOUNT_ASC',
  ToAmountDesc = 'TO_AMOUNT_DESC',
  ToCurrencyCodeAsc = 'TO_CURRENCY_CODE_ASC',
  ToCurrencyCodeDesc = 'TO_CURRENCY_CODE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type Fund = {
  __typename?: 'Fund';
  createdAt?: Maybe<Scalars['Datetime']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/** A condition to be used against `Fund` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type FundCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type FundraiserStat = {
  __typename?: 'FundraiserStat';
  amountRaisedNormalized?: Maybe<Scalars['BigFloat']>;
  fundraiserId?: Maybe<Scalars['String']>;
  numDonors?: Maybe<Scalars['BigInt']>;
};

/** A connection to a list of `FundraiserStat` values. */
export type FundraiserStatsConnection = {
  __typename?: 'FundraiserStatsConnection';
  /** A list of edges which contains the `FundraiserStat` and cursor to aid in pagination. */
  edges: Array<FundraiserStatsEdge>;
  /** A list of `FundraiserStat` objects. */
  nodes: Array<Maybe<FundraiserStat>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FundraiserStat` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FundraiserStat` edge in the connection. */
export type FundraiserStatsEdge = {
  __typename?: 'FundraiserStatsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FundraiserStat` at the end of the edge. */
  node?: Maybe<FundraiserStat>;
};

/** A connection to a list of `Fund` values. */
export type FundsConnection = {
  __typename?: 'FundsConnection';
  /** A list of edges which contains the `Fund` and cursor to aid in pagination. */
  edges: Array<FundsEdge>;
  /** A list of `Fund` objects. */
  nodes: Array<Maybe<Fund>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Fund` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Fund` edge in the connection. */
export type FundsEdge = {
  __typename?: 'FundsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Fund` at the end of the edge. */
  node?: Maybe<Fund>;
};

/** Methods to use when ordering `Fund`. */
export enum FundsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GatewayPaymentMethod = Node & {
  __typename?: 'GatewayPaymentMethod';
  /** Reads and enables pagination through a set of `CountryPaymentMethod`. */
  countryPaymentMethodsByGatewayAndPaymentMethod: CountryPaymentMethodsConnection;
  /** Reads and enables pagination through a set of `CountryPaymentMethod`. */
  countryPaymentMethodsByGatewayAndPaymentMethodList: Array<CountryPaymentMethod>;
  gateway: PaymentGateway;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  paymentMethod: PaymentMethod;
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByGatewayAndPaymentMethod: PaymentsConnection;
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByGatewayAndPaymentMethodList: Array<Payment>;
  /** Reads and enables pagination through a set of `RecurringPayment`. */
  recurringPaymentsByGatewayAndPaymentMethod: RecurringPaymentsConnection;
  /** Reads and enables pagination through a set of `RecurringPayment`. */
  recurringPaymentsByGatewayAndPaymentMethodList: Array<RecurringPayment>;
};


export type GatewayPaymentMethodCountryPaymentMethodsByGatewayAndPaymentMethodArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CountryPaymentMethodCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountryPaymentMethodsOrderBy>>;
};


export type GatewayPaymentMethodCountryPaymentMethodsByGatewayAndPaymentMethodListArgs = {
  condition?: InputMaybe<CountryPaymentMethodCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountryPaymentMethodsOrderBy>>;
};


export type GatewayPaymentMethodPaymentsByGatewayAndPaymentMethodArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type GatewayPaymentMethodPaymentsByGatewayAndPaymentMethodListArgs = {
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type GatewayPaymentMethodRecurringPaymentsByGatewayAndPaymentMethodArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};


export type GatewayPaymentMethodRecurringPaymentsByGatewayAndPaymentMethodListArgs = {
  condition?: InputMaybe<RecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};

/**
 * A condition to be used against `GatewayPaymentMethod` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GatewayPaymentMethodCondition = {
  /** Checks for equality with the object’s `gateway` field. */
  gateway?: InputMaybe<PaymentGateway>;
  /** Checks for equality with the object’s `paymentMethod` field. */
  paymentMethod?: InputMaybe<PaymentMethod>;
};

/** A connection to a list of `GatewayPaymentMethod` values. */
export type GatewayPaymentMethodsConnection = {
  __typename?: 'GatewayPaymentMethodsConnection';
  /** A list of edges which contains the `GatewayPaymentMethod` and cursor to aid in pagination. */
  edges: Array<GatewayPaymentMethodsEdge>;
  /** A list of `GatewayPaymentMethod` objects. */
  nodes: Array<Maybe<GatewayPaymentMethod>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GatewayPaymentMethod` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GatewayPaymentMethod` edge in the connection. */
export type GatewayPaymentMethodsEdge = {
  __typename?: 'GatewayPaymentMethodsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GatewayPaymentMethod` at the end of the edge. */
  node?: Maybe<GatewayPaymentMethod>;
};

/** Methods to use when ordering `GatewayPaymentMethod`. */
export enum GatewayPaymentMethodsOrderBy {
  GatewayAsc = 'GATEWAY_ASC',
  GatewayDesc = 'GATEWAY_DESC',
  Natural = 'NATURAL',
  PaymentMethodAsc = 'PAYMENT_METHOD_ASC',
  PaymentMethodDesc = 'PAYMENT_METHOD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type GatewayPayoutReport = Node & {
  __typename?: 'GatewayPayoutReport';
  /** Reads and enables pagination through a set of `AccountingInvoice`. */
  accountingInvoicesByPayoutReportId: AccountingInvoicesConnection;
  /** Reads and enables pagination through a set of `AccountingInvoice`. */
  accountingInvoicesByPayoutReportIdList: Array<AccountingInvoice>;
  amount: Scalars['BigFloat'];
  amountNormalized: Scalars['BigFloat'];
  arrivalDate: Scalars['Date'];
  createdAt: Scalars['Datetime'];
  /** Reads a single `Currency` that is related to this `GatewayPayoutReport`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  currencyCode: Scalars['String'];
  gateway: PaymentGateway;
  /** Reads and enables pagination through a set of `GatewayPayoutReportEntry`. */
  gatewayPayoutReportEntriesByPayoutId: GatewayPayoutReportEntriesConnection;
  /** Reads and enables pagination through a set of `GatewayPayoutReportEntry`. */
  gatewayPayoutReportEntriesByPayoutIdList: Array<GatewayPayoutReportEntry>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  paidDate?: Maybe<Scalars['Date']>;
  /** Reads a single `PaymentRecipient` that is related to this `GatewayPayoutReport`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  payoutId: Scalars['String'];
  recipient: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};


export type GatewayPayoutReportAccountingInvoicesByPayoutReportIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountingInvoiceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountingInvoicesOrderBy>>;
};


export type GatewayPayoutReportAccountingInvoicesByPayoutReportIdListArgs = {
  condition?: InputMaybe<AccountingInvoiceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountingInvoicesOrderBy>>;
};


export type GatewayPayoutReportGatewayPayoutReportEntriesByPayoutIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GatewayPayoutReportEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportEntriesOrderBy>>;
};


export type GatewayPayoutReportGatewayPayoutReportEntriesByPayoutIdListArgs = {
  condition?: InputMaybe<GatewayPayoutReportEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportEntriesOrderBy>>;
};

export type GatewayPayoutReportAllocation = {
  __typename?: 'GatewayPayoutReportAllocation';
  amount?: Maybe<Scalars['BigFloat']>;
  currencyCode?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['BigFloat']>;
  net?: Maybe<Scalars['BigFloat']>;
  organizationSlug?: Maybe<Scalars['String']>;
  payoutId?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `GatewayPayoutReportAllocation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type GatewayPayoutReportAllocationCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `net` field. */
  net?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `organizationSlug` field. */
  organizationSlug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `payoutId` field. */
  payoutId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `percentage` field. */
  percentage?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `GatewayPayoutReportAllocation` values. */
export type GatewayPayoutReportAllocationsConnection = {
  __typename?: 'GatewayPayoutReportAllocationsConnection';
  /** A list of edges which contains the `GatewayPayoutReportAllocation` and cursor to aid in pagination. */
  edges: Array<GatewayPayoutReportAllocationsEdge>;
  /** A list of `GatewayPayoutReportAllocation` objects. */
  nodes: Array<Maybe<GatewayPayoutReportAllocation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GatewayPayoutReportAllocation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GatewayPayoutReportAllocation` edge in the connection. */
export type GatewayPayoutReportAllocationsEdge = {
  __typename?: 'GatewayPayoutReportAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GatewayPayoutReportAllocation` at the end of the edge. */
  node?: Maybe<GatewayPayoutReportAllocation>;
};

/** Methods to use when ordering `GatewayPayoutReportAllocation`. */
export enum GatewayPayoutReportAllocationsOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  FeeAsc = 'FEE_ASC',
  FeeDesc = 'FEE_DESC',
  Natural = 'NATURAL',
  NetAsc = 'NET_ASC',
  NetDesc = 'NET_DESC',
  OrganizationSlugAsc = 'ORGANIZATION_SLUG_ASC',
  OrganizationSlugDesc = 'ORGANIZATION_SLUG_DESC',
  PayoutIdAsc = 'PAYOUT_ID_ASC',
  PayoutIdDesc = 'PAYOUT_ID_DESC',
  PercentageAsc = 'PERCENTAGE_ASC',
  PercentageDesc = 'PERCENTAGE_DESC'
}

/**
 * A condition to be used against `GatewayPayoutReport` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GatewayPayoutReportCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `arrivalDate` field. */
  arrivalDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `gateway` field. */
  gateway?: InputMaybe<PaymentGateway>;
  /** Checks for equality with the object’s `paidDate` field. */
  paidDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `payoutId` field. */
  payoutId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `GatewayPayoutReportEntry` values. */
export type GatewayPayoutReportEntriesConnection = {
  __typename?: 'GatewayPayoutReportEntriesConnection';
  /** A list of edges which contains the `GatewayPayoutReportEntry` and cursor to aid in pagination. */
  edges: Array<GatewayPayoutReportEntriesEdge>;
  /** A list of `GatewayPayoutReportEntry` objects. */
  nodes: Array<Maybe<GatewayPayoutReportEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GatewayPayoutReportEntry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GatewayPayoutReportEntry` edge in the connection. */
export type GatewayPayoutReportEntriesEdge = {
  __typename?: 'GatewayPayoutReportEntriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GatewayPayoutReportEntry` at the end of the edge. */
  node?: Maybe<GatewayPayoutReportEntry>;
};

/** Methods to use when ordering `GatewayPayoutReportEntry`. */
export enum GatewayPayoutReportEntriesOrderBy {
  AllocationAsc = 'ALLOCATION_ASC',
  AllocationDesc = 'ALLOCATION_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  EntryTimestampAsc = 'ENTRY_TIMESTAMP_ASC',
  EntryTimestampDesc = 'ENTRY_TIMESTAMP_DESC',
  EntryTypeAsc = 'ENTRY_TYPE_ASC',
  EntryTypeDesc = 'ENTRY_TYPE_DESC',
  FeeAsc = 'FEE_ASC',
  FeeDesc = 'FEE_DESC',
  GatewayTransactionIdAsc = 'GATEWAY_TRANSACTION_ID_ASC',
  GatewayTransactionIdDesc = 'GATEWAY_TRANSACTION_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NetAsc = 'NET_ASC',
  NetDesc = 'NET_DESC',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PayoutIdAsc = 'PAYOUT_ID_ASC',
  PayoutIdDesc = 'PAYOUT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type GatewayPayoutReportEntry = Node & {
  __typename?: 'GatewayPayoutReportEntry';
  allocation: Scalars['JSON'];
  amount: Scalars['BigFloat'];
  /** Reads a single `Currency` that is related to this `GatewayPayoutReportEntry`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  currencyCode: Scalars['String'];
  entryTimestamp: Scalars['Datetime'];
  entryType: Scalars['String'];
  fee: Scalars['BigFloat'];
  /** Reads a single `GatewayPayoutReport` that is related to this `GatewayPayoutReportEntry`. */
  gatewayPayoutReportByPayoutId?: Maybe<GatewayPayoutReport>;
  gatewayTransactionId: Scalars['String'];
  id: Scalars['BigInt'];
  net: Scalars['BigFloat'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Payment` that is related to this `GatewayPayoutReportEntry`. */
  paymentByPaymentId?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['BigInt']>;
  payoutId: Scalars['String'];
};

/**
 * A condition to be used against `GatewayPayoutReportEntry` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type GatewayPayoutReportEntryCondition = {
  /** Checks for equality with the object’s `allocation` field. */
  allocation?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `entryTimestamp` field. */
  entryTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `entryType` field. */
  entryType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `gatewayTransactionId` field. */
  gatewayTransactionId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `net` field. */
  net?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `paymentId` field. */
  paymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `payoutId` field. */
  payoutId?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `GatewayPayoutReportSummary` values. */
export type GatewayPayoutReportSummariesConnection = {
  __typename?: 'GatewayPayoutReportSummariesConnection';
  /** A list of edges which contains the `GatewayPayoutReportSummary` and cursor to aid in pagination. */
  edges: Array<GatewayPayoutReportSummariesEdge>;
  /** A list of `GatewayPayoutReportSummary` objects. */
  nodes: Array<Maybe<GatewayPayoutReportSummary>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GatewayPayoutReportSummary` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GatewayPayoutReportSummary` edge in the connection. */
export type GatewayPayoutReportSummariesEdge = {
  __typename?: 'GatewayPayoutReportSummariesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GatewayPayoutReportSummary` at the end of the edge. */
  node?: Maybe<GatewayPayoutReportSummary>;
};

/** Methods to use when ordering `GatewayPayoutReportSummary`. */
export enum GatewayPayoutReportSummariesOrderBy {
  AmountsMatchAsc = 'AMOUNTS_MATCH_ASC',
  AmountsMatchDesc = 'AMOUNTS_MATCH_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  ArrivalDateAsc = 'ARRIVAL_DATE_ASC',
  ArrivalDateDesc = 'ARRIVAL_DATE_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DateRangeAsc = 'DATE_RANGE_ASC',
  DateRangeDesc = 'DATE_RANGE_DESC',
  EntriesAmountAsc = 'ENTRIES_AMOUNT_ASC',
  EntriesAmountDesc = 'ENTRIES_AMOUNT_DESC',
  EntriesFeeAsc = 'ENTRIES_FEE_ASC',
  EntriesFeeDesc = 'ENTRIES_FEE_DESC',
  EntriesNetAsc = 'ENTRIES_NET_ASC',
  EntriesNetDesc = 'ENTRIES_NET_DESC',
  GatewayAsc = 'GATEWAY_ASC',
  GatewayDesc = 'GATEWAY_DESC',
  Natural = 'NATURAL',
  PayoutIdAsc = 'PAYOUT_ID_ASC',
  PayoutIdDesc = 'PAYOUT_ID_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC'
}

export type GatewayPayoutReportSummary = {
  __typename?: 'GatewayPayoutReportSummary';
  amount?: Maybe<Scalars['BigFloat']>;
  amountsMatch?: Maybe<Scalars['Boolean']>;
  arrivalDate?: Maybe<Scalars['Date']>;
  currencyCode?: Maybe<Scalars['String']>;
  dateRange?: Maybe<DateRange>;
  entriesAmount?: Maybe<Scalars['BigFloat']>;
  entriesFee?: Maybe<Scalars['BigFloat']>;
  entriesNet?: Maybe<Scalars['BigFloat']>;
  gateway?: Maybe<PaymentGateway>;
  payoutId?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `GatewayPayoutReportSummary` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type GatewayPayoutReportSummaryCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountsMatch` field. */
  amountsMatch?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `arrivalDate` field. */
  arrivalDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `dateRange` field. */
  dateRange?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `entriesAmount` field. */
  entriesAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `entriesFee` field. */
  entriesFee?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `entriesNet` field. */
  entriesNet?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `gateway` field. */
  gateway?: InputMaybe<PaymentGateway>;
  /** Checks for equality with the object’s `payoutId` field. */
  payoutId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `GatewayPayoutReport` values. */
export type GatewayPayoutReportsConnection = {
  __typename?: 'GatewayPayoutReportsConnection';
  /** A list of edges which contains the `GatewayPayoutReport` and cursor to aid in pagination. */
  edges: Array<GatewayPayoutReportsEdge>;
  /** A list of `GatewayPayoutReport` objects. */
  nodes: Array<Maybe<GatewayPayoutReport>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GatewayPayoutReport` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GatewayPayoutReport` edge in the connection. */
export type GatewayPayoutReportsEdge = {
  __typename?: 'GatewayPayoutReportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GatewayPayoutReport` at the end of the edge. */
  node?: Maybe<GatewayPayoutReport>;
};

/** Methods to use when ordering `GatewayPayoutReport`. */
export enum GatewayPayoutReportsOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  ArrivalDateAsc = 'ARRIVAL_DATE_ASC',
  ArrivalDateDesc = 'ARRIVAL_DATE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  GatewayAsc = 'GATEWAY_ASC',
  GatewayDesc = 'GATEWAY_DESC',
  Natural = 'NATURAL',
  PaidDateAsc = 'PAID_DATE_ASC',
  PaidDateDesc = 'PAID_DATE_DESC',
  PayoutIdAsc = 'PAYOUT_ID_ASC',
  PayoutIdDesc = 'PAYOUT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** All input for the `generateEoyTaxReceipts` mutation. */
export type GenerateEoyTaxReceiptsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  period: DateRangeInput;
  recipient: Scalars['String'];
};

/** The output of our `generateEoyTaxReceipts` mutation. */
export type GenerateEoyTaxReceiptsPayload = {
  __typename?: 'GenerateEoyTaxReceiptsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  eoyTaxReceipts?: Maybe<Array<Maybe<EoyTaxReceipt>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `generateGiftAidClaimReports` mutation. */
export type GenerateGiftAidClaimReportsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput>;
  maxLinesPerReport?: InputMaybe<Scalars['Int']>;
};

/** The output of our `generateGiftAidClaimReports` mutation. */
export type GenerateGiftAidClaimReportsPayload = {
  __typename?: 'GenerateGiftAidClaimReportsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  giftAidClaimReports?: Maybe<Array<Maybe<GiftAidClaimReport>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `generateLiability` mutation. */
export type GenerateLiabilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  income?: InputMaybe<IncomeInput>;
  pledge?: InputMaybe<PledgeInput>;
};

/** The output of our `generateLiability` mutation. */
export type GenerateLiabilityPayload = {
  __typename?: 'GenerateLiabilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Income` that is related to this `Liability`. */
  incomeByIncomeId?: Maybe<Income>;
  liability?: Maybe<Liability>;
  /** An edge for our `Liability`. May be used by Relay 1. */
  liabilityEdge?: Maybe<LiabilitiesEdge>;
  /** Reads a single `Person` that is related to this `Liability`. */
  personByPersonId?: Maybe<Person>;
  /** Reads a single `Pledge` that is related to this `Liability`. */
  pledgeByPledgeId?: Maybe<Pledge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `generateLiability` mutation. */
export type GenerateLiabilityPayloadLiabilityEdgeArgs = {
  orderBy?: InputMaybe<Array<LiabilitiesOrderBy>>;
};

/** All input for the `generateLiabilityPaymentFromCompletionPayment` mutation. */
export type GenerateLiabilityPaymentFromCompletionPaymentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  completionPayment?: InputMaybe<CompletionPaymentInput>;
};

/** The output of our `generateLiabilityPaymentFromCompletionPayment` mutation. */
export type GenerateLiabilityPaymentFromCompletionPaymentPayload = {
  __typename?: 'GenerateLiabilityPaymentFromCompletionPaymentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Income` that is related to this `LiabilityPayment`. */
  incomeByIncomeId?: Maybe<Income>;
  liabilityPayment?: Maybe<LiabilityPayment>;
  /** An edge for our `LiabilityPayment`. May be used by Relay 1. */
  liabilityPaymentEdge?: Maybe<LiabilityPaymentsEdge>;
  /** Reads a single `Payment` that is related to this `LiabilityPayment`. */
  paymentByPaymentId?: Maybe<Payment>;
  /** Reads a single `Person` that is related to this `LiabilityPayment`. */
  personByPersonId?: Maybe<Person>;
  /** Reads a single `Pledge` that is related to this `LiabilityPayment`. */
  pledgeByPledgeId?: Maybe<Pledge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ReportedDonation` that is related to this `LiabilityPayment`. */
  reportedDonationByReportedDonationId?: Maybe<ReportedDonation>;
};


/** The output of our `generateLiabilityPaymentFromCompletionPayment` mutation. */
export type GenerateLiabilityPaymentFromCompletionPaymentPayloadLiabilityPaymentEdgeArgs = {
  orderBy?: InputMaybe<Array<LiabilityPaymentsOrderBy>>;
};

/** All input for the `generateLotteryTickets` mutation. */
export type GenerateLotteryTicketsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lotteryId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `generateLotteryTickets` mutation. */
export type GenerateLotteryTicketsPayload = {
  __typename?: 'GenerateLotteryTicketsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  lotteryTickets?: Maybe<Array<Maybe<LotteryTicket>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `getCurrentPersonId` mutation. */
export type GetCurrentPersonIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `getCurrentPersonId` mutation. */
export type GetCurrentPersonIdPayload = {
  __typename?: 'GetCurrentPersonIdPayload';
  bigInt?: Maybe<Scalars['BigInt']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `getDaterangeOverlap` mutation. */
export type GetDaterangeOverlapInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fullPeriod?: InputMaybe<DateRangeInput>;
  overlappingPeriod?: InputMaybe<DateRangeInput>;
};

/** The output of our `getDaterangeOverlap` mutation. */
export type GetDaterangeOverlapPayload = {
  __typename?: 'GetDaterangeOverlapPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  float?: Maybe<Scalars['Float']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type GetGivingSeasonStatsT = {
  __typename?: 'GetGivingSeasonStatsT';
  amountNormalized?: Maybe<Scalars['BigFloat']>;
  numCountries?: Maybe<Scalars['BigInt']>;
  numDonations?: Maybe<Scalars['BigInt']>;
  numPeople?: Maybe<Scalars['BigInt']>;
  slug?: Maybe<Scalars['String']>;
};

/** A connection to a list of `GetGivingSeasonStatsT` values. */
export type GetGivingSeasonStatsTsConnection = {
  __typename?: 'GetGivingSeasonStatsTsConnection';
  /** A list of edges which contains the `GetGivingSeasonStatsT` and cursor to aid in pagination. */
  edges: Array<GetGivingSeasonStatsTsEdge>;
  /** A list of `GetGivingSeasonStatsT` objects. */
  nodes: Array<Maybe<GetGivingSeasonStatsT>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GetGivingSeasonStatsT` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GetGivingSeasonStatsT` edge in the connection. */
export type GetGivingSeasonStatsTsEdge = {
  __typename?: 'GetGivingSeasonStatsTsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GetGivingSeasonStatsT` at the end of the edge. */
  node?: Maybe<GetGivingSeasonStatsT>;
};

/** An input for mutations affecting `GetPayrollGivingProviderCustomerBatchArg` */
export type GetPayrollGivingProviderCustomerBatchArgInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<PayrollGivingProvider>;
  providerCustomerId?: InputMaybe<Scalars['String']>;
};

/** All input for the `getPayrollGivingProviderCustomerBatch` mutation. */
export type GetPayrollGivingProviderCustomerBatchInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  payrollGivingProviderCustomers?: InputMaybe<Array<InputMaybe<GetPayrollGivingProviderCustomerBatchArgInput>>>;
};

/** The output of our `getPayrollGivingProviderCustomerBatch` mutation. */
export type GetPayrollGivingProviderCustomerBatchPayload = {
  __typename?: 'GetPayrollGivingProviderCustomerBatchPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  payrollGivingProviderCustomers?: Maybe<Array<Maybe<PayrollGivingProviderCustomer>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type GetTotalProjectedDonationsT = {
  __typename?: 'GetTotalProjectedDonationsT';
  numPledges?: Maybe<Scalars['Int']>;
  projectedDonationsTotal?: Maybe<Scalars['BigFloat']>;
  projectedIncomeTotal?: Maybe<Scalars['BigFloat']>;
};

export type GiftAidClaim = Node & {
  __typename?: 'GiftAidClaim';
  /** Reads a single `Address` that is related to this `GiftAidClaim`. */
  addressByAddressIdAndPersonId?: Maybe<Address>;
  addressId: Scalars['BigInt'];
  createdAt: Scalars['Datetime'];
  giftAidPaymentId?: Maybe<Scalars['BigInt']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Payment` that is related to this `GiftAidClaim`. */
  paymentByGiftAidPaymentId?: Maybe<Payment>;
  /** Reads a single `Payment` that is related to this `GiftAidClaim`. */
  paymentByPaymentIdAndPersonId?: Maybe<Payment>;
  paymentId: Scalars['BigInt'];
  personId: Scalars['BigInt'];
  reportId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
};

export type GiftAidClaimBackup = Node & {
  __typename?: 'GiftAidClaimBackup';
  addressId: Scalars['BigInt'];
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  paymentId: Scalars['BigInt'];
  personId: Scalars['BigInt'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `GiftAidClaimBackup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GiftAidClaimBackupCondition = {
  /** Checks for equality with the object’s `addressId` field. */
  addressId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `paymentId` field. */
  paymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `GiftAidClaimBackup` values. */
export type GiftAidClaimBackupsConnection = {
  __typename?: 'GiftAidClaimBackupsConnection';
  /** A list of edges which contains the `GiftAidClaimBackup` and cursor to aid in pagination. */
  edges: Array<GiftAidClaimBackupsEdge>;
  /** A list of `GiftAidClaimBackup` objects. */
  nodes: Array<Maybe<GiftAidClaimBackup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GiftAidClaimBackup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GiftAidClaimBackup` edge in the connection. */
export type GiftAidClaimBackupsEdge = {
  __typename?: 'GiftAidClaimBackupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GiftAidClaimBackup` at the end of the edge. */
  node?: Maybe<GiftAidClaimBackup>;
};

/** Methods to use when ordering `GiftAidClaimBackup`. */
export enum GiftAidClaimBackupsOrderBy {
  AddressIdAsc = 'ADDRESS_ID_ASC',
  AddressIdDesc = 'ADDRESS_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/**
 * A condition to be used against `GiftAidClaim` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GiftAidClaimCondition = {
  /** Checks for equality with the object’s `addressId` field. */
  addressId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `giftAidPaymentId` field. */
  giftAidPaymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `paymentId` field. */
  paymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `reportId` field. */
  reportId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type GiftAidClaimReport = {
  __typename?: 'GiftAidClaimReport';
  aggregatedDonations?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['BigFloat']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  firstName?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  reportId?: Maybe<Scalars['Int']>;
  sponsoredEvent?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type GiftAidClaimReportAllocation = {
  __typename?: 'GiftAidClaimReportAllocation';
  amount?: Maybe<Scalars['BigFloat']>;
  organizationName?: Maybe<Scalars['String']>;
  organizationSlug?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['BigFloat']>;
  reportId?: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `GiftAidClaimReportAllocation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type GiftAidClaimReportAllocationCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `organizationName` field. */
  organizationName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `organizationSlug` field. */
  organizationSlug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `percentage` field. */
  percentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `reportId` field. */
  reportId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `GiftAidClaimReportAllocation` values. */
export type GiftAidClaimReportAllocationsConnection = {
  __typename?: 'GiftAidClaimReportAllocationsConnection';
  /** A list of edges which contains the `GiftAidClaimReportAllocation` and cursor to aid in pagination. */
  edges: Array<GiftAidClaimReportAllocationsEdge>;
  /** A list of `GiftAidClaimReportAllocation` objects. */
  nodes: Array<Maybe<GiftAidClaimReportAllocation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GiftAidClaimReportAllocation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GiftAidClaimReportAllocation` edge in the connection. */
export type GiftAidClaimReportAllocationsEdge = {
  __typename?: 'GiftAidClaimReportAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GiftAidClaimReportAllocation` at the end of the edge. */
  node?: Maybe<GiftAidClaimReportAllocation>;
};

/** Methods to use when ordering `GiftAidClaimReportAllocation`. */
export enum GiftAidClaimReportAllocationsOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  Natural = 'NATURAL',
  OrganizationNameAsc = 'ORGANIZATION_NAME_ASC',
  OrganizationNameDesc = 'ORGANIZATION_NAME_DESC',
  OrganizationSlugAsc = 'ORGANIZATION_SLUG_ASC',
  OrganizationSlugDesc = 'ORGANIZATION_SLUG_DESC',
  PercentageAsc = 'PERCENTAGE_ASC',
  PercentageDesc = 'PERCENTAGE_DESC',
  ReportIdAsc = 'REPORT_ID_ASC',
  ReportIdDesc = 'REPORT_ID_DESC'
}

/**
 * A condition to be used against `GiftAidClaimReport` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GiftAidClaimReportCondition = {
  /** Checks for equality with the object’s `aggregatedDonations` field. */
  aggregatedDonations?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `postalCode` field. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reportId` field. */
  reportId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `sponsoredEvent` field. */
  sponsoredEvent?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
};

export type GiftAidClaimReportExtended = {
  __typename?: 'GiftAidClaimReportExtended';
  addressId?: Maybe<Scalars['BigInt']>;
  aggregatedDonations?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['BigFloat']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  firstName?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['BigInt']>;
  personId?: Maybe<Scalars['BigInt']>;
  postalCode?: Maybe<Scalars['String']>;
  reportId?: Maybe<Scalars['Int']>;
  sponsoredEvent?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `GiftAidClaimReportExtended` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type GiftAidClaimReportExtendedCondition = {
  /** Checks for equality with the object’s `addressId` field. */
  addressId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `aggregatedDonations` field. */
  aggregatedDonations?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `paymentId` field. */
  paymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `postalCode` field. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reportId` field. */
  reportId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `sponsoredEvent` field. */
  sponsoredEvent?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `GiftAidClaimReportExtended` values. */
export type GiftAidClaimReportExtendedsConnection = {
  __typename?: 'GiftAidClaimReportExtendedsConnection';
  /** A list of edges which contains the `GiftAidClaimReportExtended` and cursor to aid in pagination. */
  edges: Array<GiftAidClaimReportExtendedsEdge>;
  /** A list of `GiftAidClaimReportExtended` objects. */
  nodes: Array<Maybe<GiftAidClaimReportExtended>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GiftAidClaimReportExtended` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GiftAidClaimReportExtended` edge in the connection. */
export type GiftAidClaimReportExtendedsEdge = {
  __typename?: 'GiftAidClaimReportExtendedsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GiftAidClaimReportExtended` at the end of the edge. */
  node?: Maybe<GiftAidClaimReportExtended>;
};

/** Methods to use when ordering `GiftAidClaimReportExtended`. */
export enum GiftAidClaimReportExtendedsOrderBy {
  AddressIdAsc = 'ADDRESS_ID_ASC',
  AddressIdDesc = 'ADDRESS_ID_DESC',
  AggregatedDonationsAsc = 'AGGREGATED_DONATIONS_ASC',
  AggregatedDonationsDesc = 'AGGREGATED_DONATIONS_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  HouseNumberAsc = 'HOUSE_NUMBER_ASC',
  HouseNumberDesc = 'HOUSE_NUMBER_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PostalCodeAsc = 'POSTAL_CODE_ASC',
  PostalCodeDesc = 'POSTAL_CODE_DESC',
  ReportIdAsc = 'REPORT_ID_ASC',
  ReportIdDesc = 'REPORT_ID_DESC',
  SponsoredEventAsc = 'SPONSORED_EVENT_ASC',
  SponsoredEventDesc = 'SPONSORED_EVENT_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** A connection to a list of `GiftAidClaimReportSummary` values. */
export type GiftAidClaimReportSummariesConnection = {
  __typename?: 'GiftAidClaimReportSummariesConnection';
  /** A list of edges which contains the `GiftAidClaimReportSummary` and cursor to aid in pagination. */
  edges: Array<GiftAidClaimReportSummariesEdge>;
  /** A list of `GiftAidClaimReportSummary` objects. */
  nodes: Array<Maybe<GiftAidClaimReportSummary>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GiftAidClaimReportSummary` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GiftAidClaimReportSummary` edge in the connection. */
export type GiftAidClaimReportSummariesEdge = {
  __typename?: 'GiftAidClaimReportSummariesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GiftAidClaimReportSummary` at the end of the edge. */
  node?: Maybe<GiftAidClaimReportSummary>;
};

/** Methods to use when ordering `GiftAidClaimReportSummary`. */
export enum GiftAidClaimReportSummariesOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CountAsc = 'COUNT_ASC',
  CountDesc = 'COUNT_DESC',
  DateRangeAsc = 'DATE_RANGE_ASC',
  DateRangeDesc = 'DATE_RANGE_DESC',
  Natural = 'NATURAL',
  ReportIdAsc = 'REPORT_ID_ASC',
  ReportIdDesc = 'REPORT_ID_DESC'
}

export type GiftAidClaimReportSummary = {
  __typename?: 'GiftAidClaimReportSummary';
  amount?: Maybe<Scalars['BigFloat']>;
  count?: Maybe<Scalars['BigInt']>;
  dateRange?: Maybe<DateRange>;
  reportId?: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `GiftAidClaimReportSummary` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type GiftAidClaimReportSummaryCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `count` field. */
  count?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `dateRange` field. */
  dateRange?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `reportId` field. */
  reportId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `GiftAidClaimReport` values. */
export type GiftAidClaimReportsConnection = {
  __typename?: 'GiftAidClaimReportsConnection';
  /** A list of edges which contains the `GiftAidClaimReport` and cursor to aid in pagination. */
  edges: Array<GiftAidClaimReportsEdge>;
  /** A list of `GiftAidClaimReport` objects. */
  nodes: Array<Maybe<GiftAidClaimReport>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GiftAidClaimReport` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GiftAidClaimReport` edge in the connection. */
export type GiftAidClaimReportsEdge = {
  __typename?: 'GiftAidClaimReportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GiftAidClaimReport` at the end of the edge. */
  node?: Maybe<GiftAidClaimReport>;
};

/** Methods to use when ordering `GiftAidClaimReport`. */
export enum GiftAidClaimReportsOrderBy {
  AggregatedDonationsAsc = 'AGGREGATED_DONATIONS_ASC',
  AggregatedDonationsDesc = 'AGGREGATED_DONATIONS_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  HouseNumberAsc = 'HOUSE_NUMBER_ASC',
  HouseNumberDesc = 'HOUSE_NUMBER_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PostalCodeAsc = 'POSTAL_CODE_ASC',
  PostalCodeDesc = 'POSTAL_CODE_DESC',
  ReportIdAsc = 'REPORT_ID_ASC',
  ReportIdDesc = 'REPORT_ID_DESC',
  SponsoredEventAsc = 'SPONSORED_EVENT_ASC',
  SponsoredEventDesc = 'SPONSORED_EVENT_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** A connection to a list of `GiftAidClaim` values. */
export type GiftAidClaimsConnection = {
  __typename?: 'GiftAidClaimsConnection';
  /** A list of edges which contains the `GiftAidClaim` and cursor to aid in pagination. */
  edges: Array<GiftAidClaimsEdge>;
  /** A list of `GiftAidClaim` objects. */
  nodes: Array<Maybe<GiftAidClaim>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GiftAidClaim` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GiftAidClaim` edge in the connection. */
export type GiftAidClaimsEdge = {
  __typename?: 'GiftAidClaimsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GiftAidClaim` at the end of the edge. */
  node?: Maybe<GiftAidClaim>;
};

/** Methods to use when ordering `GiftAidClaim`. */
export enum GiftAidClaimsOrderBy {
  AddressIdAsc = 'ADDRESS_ID_ASC',
  AddressIdDesc = 'ADDRESS_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GiftAidPaymentIdAsc = 'GIFT_AID_PAYMENT_ID_ASC',
  GiftAidPaymentIdDesc = 'GIFT_AID_PAYMENT_ID_DESC',
  Natural = 'NATURAL',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReportIdAsc = 'REPORT_ID_ASC',
  ReportIdDesc = 'REPORT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GivingWhatWeCanSurvey = Node & {
  __typename?: 'GivingWhatWeCanSurvey';
  counterfactualDonationPercentage?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Datetime'];
  gwwcDonationInfluence?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  otherComments?: Maybe<Scalars['String']>;
  /** Reads a single `Person` that is related to this `GivingWhatWeCanSurvey`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  referrer?: Maybe<Array<Maybe<Scalars['String']>>>;
  referrerNotes?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  wherePlanningToGive?: Maybe<Array<Maybe<Scalars['String']>>>;
  wherePlanningToGiveNotes?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `GivingWhatWeCanSurvey` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GivingWhatWeCanSurveyCondition = {
  /** Checks for equality with the object’s `counterfactualDonationPercentage` field. */
  counterfactualDonationPercentage?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `gwwcDonationInfluence` field. */
  gwwcDonationInfluence?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `otherComments` field. */
  otherComments?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `referrer` field. */
  referrer?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `referrerNotes` field. */
  referrerNotes?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `wherePlanningToGive` field. */
  wherePlanningToGive?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `wherePlanningToGiveNotes` field. */
  wherePlanningToGiveNotes?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `GivingWhatWeCanSurvey` values. */
export type GivingWhatWeCanSurveysConnection = {
  __typename?: 'GivingWhatWeCanSurveysConnection';
  /** A list of edges which contains the `GivingWhatWeCanSurvey` and cursor to aid in pagination. */
  edges: Array<GivingWhatWeCanSurveysEdge>;
  /** A list of `GivingWhatWeCanSurvey` objects. */
  nodes: Array<Maybe<GivingWhatWeCanSurvey>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GivingWhatWeCanSurvey` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GivingWhatWeCanSurvey` edge in the connection. */
export type GivingWhatWeCanSurveysEdge = {
  __typename?: 'GivingWhatWeCanSurveysEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GivingWhatWeCanSurvey` at the end of the edge. */
  node?: Maybe<GivingWhatWeCanSurvey>;
};

/** Methods to use when ordering `GivingWhatWeCanSurvey`. */
export enum GivingWhatWeCanSurveysOrderBy {
  CounterfactualDonationPercentageAsc = 'COUNTERFACTUAL_DONATION_PERCENTAGE_ASC',
  CounterfactualDonationPercentageDesc = 'COUNTERFACTUAL_DONATION_PERCENTAGE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GwwcDonationInfluenceAsc = 'GWWC_DONATION_INFLUENCE_ASC',
  GwwcDonationInfluenceDesc = 'GWWC_DONATION_INFLUENCE_DESC',
  Natural = 'NATURAL',
  OtherCommentsAsc = 'OTHER_COMMENTS_ASC',
  OtherCommentsDesc = 'OTHER_COMMENTS_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferrerAsc = 'REFERRER_ASC',
  ReferrerDesc = 'REFERRER_DESC',
  ReferrerNotesAsc = 'REFERRER_NOTES_ASC',
  ReferrerNotesDesc = 'REFERRER_NOTES_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WherePlanningToGiveAsc = 'WHERE_PLANNING_TO_GIVE_ASC',
  WherePlanningToGiveDesc = 'WHERE_PLANNING_TO_GIVE_DESC',
  WherePlanningToGiveNotesAsc = 'WHERE_PLANNING_TO_GIVE_NOTES_ASC',
  WherePlanningToGiveNotesDesc = 'WHERE_PLANNING_TO_GIVE_NOTES_DESC'
}

export type GlobalStat = {
  __typename?: 'GlobalStat';
  activeTryGivingPledgesTotal?: Maybe<Scalars['Int']>;
  gwwcPledgesTotal?: Maybe<Scalars['Int']>;
  pledgersCountriesTotal?: Maybe<Scalars['Int']>;
  pledgesDonationsTotal?: Maybe<Scalars['BigFloat']>;
  projectedDonationsTotal?: Maybe<Scalars['BigFloat']>;
  tryGivingCompletedTotal?: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `GlobalStat` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GlobalStatCondition = {
  /** Checks for equality with the object’s `activeTryGivingPledgesTotal` field. */
  activeTryGivingPledgesTotal?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `gwwcPledgesTotal` field. */
  gwwcPledgesTotal?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `pledgersCountriesTotal` field. */
  pledgersCountriesTotal?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `pledgesDonationsTotal` field. */
  pledgesDonationsTotal?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `projectedDonationsTotal` field. */
  projectedDonationsTotal?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `tryGivingCompletedTotal` field. */
  tryGivingCompletedTotal?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `GlobalStat` values. */
export type GlobalStatsConnection = {
  __typename?: 'GlobalStatsConnection';
  /** A list of edges which contains the `GlobalStat` and cursor to aid in pagination. */
  edges: Array<GlobalStatsEdge>;
  /** A list of `GlobalStat` objects. */
  nodes: Array<Maybe<GlobalStat>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GlobalStat` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GlobalStat` edge in the connection. */
export type GlobalStatsEdge = {
  __typename?: 'GlobalStatsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GlobalStat` at the end of the edge. */
  node?: Maybe<GlobalStat>;
};

/** Methods to use when ordering `GlobalStat`. */
export enum GlobalStatsOrderBy {
  ActiveTryGivingPledgesTotalAsc = 'ACTIVE_TRY_GIVING_PLEDGES_TOTAL_ASC',
  ActiveTryGivingPledgesTotalDesc = 'ACTIVE_TRY_GIVING_PLEDGES_TOTAL_DESC',
  GwwcPledgesTotalAsc = 'GWWC_PLEDGES_TOTAL_ASC',
  GwwcPledgesTotalDesc = 'GWWC_PLEDGES_TOTAL_DESC',
  Natural = 'NATURAL',
  PledgersCountriesTotalAsc = 'PLEDGERS_COUNTRIES_TOTAL_ASC',
  PledgersCountriesTotalDesc = 'PLEDGERS_COUNTRIES_TOTAL_DESC',
  PledgesDonationsTotalAsc = 'PLEDGES_DONATIONS_TOTAL_ASC',
  PledgesDonationsTotalDesc = 'PLEDGES_DONATIONS_TOTAL_DESC',
  ProjectedDonationsTotalAsc = 'PROJECTED_DONATIONS_TOTAL_ASC',
  ProjectedDonationsTotalDesc = 'PROJECTED_DONATIONS_TOTAL_DESC',
  TryGivingCompletedTotalAsc = 'TRY_GIVING_COMPLETED_TOTAL_ASC',
  TryGivingCompletedTotalDesc = 'TRY_GIVING_COMPLETED_TOTAL_DESC'
}

export type GocardlessCustomer = {
  __typename?: 'GocardlessCustomer';
  createdAt: Scalars['Datetime'];
  gocardlessCustomerId: Scalars['String'];
  /** Reads and enables pagination through a set of `GocardlessMandate`. */
  gocardlessMandatesByGocardlessCustomerId: GocardlessMandatesConnection;
  /** Reads and enables pagination through a set of `GocardlessMandate`. */
  gocardlessMandatesByGocardlessCustomerIdList: Array<GocardlessMandate>;
  /** Reads and enables pagination through a set of `GocardlessMandate`. */
  gocardlessMandatesByPersonIdAndGocardlessCustomerId: GocardlessMandatesConnection;
  /** Reads and enables pagination through a set of `GocardlessMandate`. */
  gocardlessMandatesByPersonIdAndGocardlessCustomerIdList: Array<GocardlessMandate>;
  /** Reads a single `PaymentRecipient` that is related to this `GocardlessCustomer`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Reads a single `Person` that is related to this `GocardlessCustomer`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  recipient: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};


export type GocardlessCustomerGocardlessMandatesByGocardlessCustomerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GocardlessMandateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessMandatesOrderBy>>;
};


export type GocardlessCustomerGocardlessMandatesByGocardlessCustomerIdListArgs = {
  condition?: InputMaybe<GocardlessMandateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessMandatesOrderBy>>;
};


export type GocardlessCustomerGocardlessMandatesByPersonIdAndGocardlessCustomerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GocardlessMandateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessMandatesOrderBy>>;
};


export type GocardlessCustomerGocardlessMandatesByPersonIdAndGocardlessCustomerIdListArgs = {
  condition?: InputMaybe<GocardlessMandateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessMandatesOrderBy>>;
};

/**
 * A condition to be used against `GocardlessCustomer` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GocardlessCustomerCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `gocardlessCustomerId` field. */
  gocardlessCustomerId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `GocardlessCustomer` values. */
export type GocardlessCustomersConnection = {
  __typename?: 'GocardlessCustomersConnection';
  /** A list of edges which contains the `GocardlessCustomer` and cursor to aid in pagination. */
  edges: Array<GocardlessCustomersEdge>;
  /** A list of `GocardlessCustomer` objects. */
  nodes: Array<Maybe<GocardlessCustomer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GocardlessCustomer` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GocardlessCustomer` edge in the connection. */
export type GocardlessCustomersEdge = {
  __typename?: 'GocardlessCustomersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GocardlessCustomer` at the end of the edge. */
  node?: Maybe<GocardlessCustomer>;
};

/** Methods to use when ordering `GocardlessCustomer`. */
export enum GocardlessCustomersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GocardlessCustomerIdAsc = 'GOCARDLESS_CUSTOMER_ID_ASC',
  GocardlessCustomerIdDesc = 'GOCARDLESS_CUSTOMER_ID_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GocardlessMandate = {
  __typename?: 'GocardlessMandate';
  createdAt: Scalars['Datetime'];
  gocardlessBankAccountBankName?: Maybe<Scalars['String']>;
  gocardlessBankAccountHolderName?: Maybe<Scalars['String']>;
  gocardlessBankAccountId?: Maybe<Scalars['String']>;
  gocardlessBankAccountNumberEnding?: Maybe<Scalars['Int']>;
  /** Reads a single `GocardlessCustomer` that is related to this `GocardlessMandate`. */
  gocardlessCustomerByGocardlessCustomerId?: Maybe<GocardlessCustomer>;
  /** Reads a single `GocardlessCustomer` that is related to this `GocardlessMandate`. */
  gocardlessCustomerByPersonIdAndGocardlessCustomerId?: Maybe<GocardlessCustomer>;
  gocardlessCustomerId: Scalars['String'];
  gocardlessMandateId: Scalars['String'];
  /** Reads a single `Person` that is related to this `GocardlessMandate`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  status: GocardlessMandateStatus;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `GocardlessMandate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GocardlessMandateCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `gocardlessBankAccountBankName` field. */
  gocardlessBankAccountBankName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `gocardlessBankAccountHolderName` field. */
  gocardlessBankAccountHolderName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `gocardlessBankAccountId` field. */
  gocardlessBankAccountId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `gocardlessBankAccountNumberEnding` field. */
  gocardlessBankAccountNumberEnding?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `gocardlessCustomerId` field. */
  gocardlessCustomerId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `gocardlessMandateId` field. */
  gocardlessMandateId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<GocardlessMandateStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum GocardlessMandateStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  PendingCustomerApproval = 'PENDING_CUSTOMER_APPROVAL',
  PendingSubmission = 'PENDING_SUBMISSION',
  Submitted = 'SUBMITTED'
}

/** A connection to a list of `GocardlessMandate` values. */
export type GocardlessMandatesConnection = {
  __typename?: 'GocardlessMandatesConnection';
  /** A list of edges which contains the `GocardlessMandate` and cursor to aid in pagination. */
  edges: Array<GocardlessMandatesEdge>;
  /** A list of `GocardlessMandate` objects. */
  nodes: Array<Maybe<GocardlessMandate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GocardlessMandate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GocardlessMandate` edge in the connection. */
export type GocardlessMandatesEdge = {
  __typename?: 'GocardlessMandatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GocardlessMandate` at the end of the edge. */
  node?: Maybe<GocardlessMandate>;
};

/** Methods to use when ordering `GocardlessMandate`. */
export enum GocardlessMandatesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GocardlessBankAccountBankNameAsc = 'GOCARDLESS_BANK_ACCOUNT_BANK_NAME_ASC',
  GocardlessBankAccountBankNameDesc = 'GOCARDLESS_BANK_ACCOUNT_BANK_NAME_DESC',
  GocardlessBankAccountHolderNameAsc = 'GOCARDLESS_BANK_ACCOUNT_HOLDER_NAME_ASC',
  GocardlessBankAccountHolderNameDesc = 'GOCARDLESS_BANK_ACCOUNT_HOLDER_NAME_DESC',
  GocardlessBankAccountIdAsc = 'GOCARDLESS_BANK_ACCOUNT_ID_ASC',
  GocardlessBankAccountIdDesc = 'GOCARDLESS_BANK_ACCOUNT_ID_DESC',
  GocardlessBankAccountNumberEndingAsc = 'GOCARDLESS_BANK_ACCOUNT_NUMBER_ENDING_ASC',
  GocardlessBankAccountNumberEndingDesc = 'GOCARDLESS_BANK_ACCOUNT_NUMBER_ENDING_DESC',
  GocardlessCustomerIdAsc = 'GOCARDLESS_CUSTOMER_ID_ASC',
  GocardlessCustomerIdDesc = 'GOCARDLESS_CUSTOMER_ID_DESC',
  GocardlessMandateIdAsc = 'GOCARDLESS_MANDATE_ID_ASC',
  GocardlessMandateIdDesc = 'GOCARDLESS_MANDATE_ID_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GocardlessRedirectFlow = Node & {
  __typename?: 'GocardlessRedirectFlow';
  createdAt: Scalars['Datetime'];
  expires: Scalars['Datetime'];
  gocardlessRedirectFlowId?: Maybe<Scalars['String']>;
  gocardlessRedirectFlowUrl?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Person` that is related to this `GocardlessRedirectFlow`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  sessionToken: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `GocardlessRedirectFlow` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GocardlessRedirectFlowCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `expires` field. */
  expires?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `gocardlessRedirectFlowId` field. */
  gocardlessRedirectFlowId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `gocardlessRedirectFlowUrl` field. */
  gocardlessRedirectFlowUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `sessionToken` field. */
  sessionToken?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `GocardlessRedirectFlow` values. */
export type GocardlessRedirectFlowsConnection = {
  __typename?: 'GocardlessRedirectFlowsConnection';
  /** A list of edges which contains the `GocardlessRedirectFlow` and cursor to aid in pagination. */
  edges: Array<GocardlessRedirectFlowsEdge>;
  /** A list of `GocardlessRedirectFlow` objects. */
  nodes: Array<Maybe<GocardlessRedirectFlow>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GocardlessRedirectFlow` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GocardlessRedirectFlow` edge in the connection. */
export type GocardlessRedirectFlowsEdge = {
  __typename?: 'GocardlessRedirectFlowsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GocardlessRedirectFlow` at the end of the edge. */
  node?: Maybe<GocardlessRedirectFlow>;
};

/** Methods to use when ordering `GocardlessRedirectFlow`. */
export enum GocardlessRedirectFlowsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExpiresAsc = 'EXPIRES_ASC',
  ExpiresDesc = 'EXPIRES_DESC',
  GocardlessRedirectFlowIdAsc = 'GOCARDLESS_REDIRECT_FLOW_ID_ASC',
  GocardlessRedirectFlowIdDesc = 'GOCARDLESS_REDIRECT_FLOW_ID_DESC',
  GocardlessRedirectFlowUrlAsc = 'GOCARDLESS_REDIRECT_FLOW_URL_ASC',
  GocardlessRedirectFlowUrlDesc = 'GOCARDLESS_REDIRECT_FLOW_URL_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SessionTokenAsc = 'SESSION_TOKEN_ASC',
  SessionTokenDesc = 'SESSION_TOKEN_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GwwcCompliance = {
  __typename?: 'GwwcCompliance';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastCompletionPaymentAmount?: Maybe<Scalars['BigFloat']>;
  lastCompletionPaymentCurrencyCode?: Maybe<Scalars['String']>;
  lastCompletionPaymentDonationDate?: Maybe<Scalars['Date']>;
  lastCompletionPaymentType?: Maybe<CompletionPaymentObjectType>;
  lastIncomeAmount?: Maybe<Scalars['BigFloat']>;
  lastIncomeCurrencyCode?: Maybe<Scalars['String']>;
  lastIncomeEndDate?: Maybe<Scalars['Date']>;
  lastIncomeIsCurrent?: Maybe<Scalars['Boolean']>;
  lastIncomeStartDate?: Maybe<Scalars['Date']>;
  lastName?: Maybe<Scalars['String']>;
  personId?: Maybe<Scalars['BigInt']>;
  pledgeCompletionPercentage?: Maybe<Scalars['BigFloat']>;
  pledgeEndDate?: Maybe<Scalars['Date']>;
  pledgeId?: Maybe<Scalars['BigInt']>;
  pledgePercentage?: Maybe<Scalars['BigFloat']>;
  pledgeStartDate?: Maybe<Scalars['Date']>;
  pledgeType?: Maybe<PledgeType>;
};

/**
 * A condition to be used against `GwwcCompliance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GwwcComplianceCondition = {
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastCompletionPaymentAmount` field. */
  lastCompletionPaymentAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `lastCompletionPaymentCurrencyCode` field. */
  lastCompletionPaymentCurrencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastCompletionPaymentDonationDate` field. */
  lastCompletionPaymentDonationDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `lastCompletionPaymentType` field. */
  lastCompletionPaymentType?: InputMaybe<CompletionPaymentObjectType>;
  /** Checks for equality with the object’s `lastIncomeAmount` field. */
  lastIncomeAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `lastIncomeCurrencyCode` field. */
  lastIncomeCurrencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastIncomeEndDate` field. */
  lastIncomeEndDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `lastIncomeIsCurrent` field. */
  lastIncomeIsCurrent?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `lastIncomeStartDate` field. */
  lastIncomeStartDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pledgeCompletionPercentage` field. */
  pledgeCompletionPercentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `pledgeEndDate` field. */
  pledgeEndDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `pledgeId` field. */
  pledgeId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pledgePercentage` field. */
  pledgePercentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `pledgeStartDate` field. */
  pledgeStartDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `pledgeType` field. */
  pledgeType?: InputMaybe<PledgeType>;
};

/** A connection to a list of `GwwcCompliance` values. */
export type GwwcCompliancesConnection = {
  __typename?: 'GwwcCompliancesConnection';
  /** A list of edges which contains the `GwwcCompliance` and cursor to aid in pagination. */
  edges: Array<GwwcCompliancesEdge>;
  /** A list of `GwwcCompliance` objects. */
  nodes: Array<Maybe<GwwcCompliance>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GwwcCompliance` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GwwcCompliance` edge in the connection. */
export type GwwcCompliancesEdge = {
  __typename?: 'GwwcCompliancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GwwcCompliance` at the end of the edge. */
  node?: Maybe<GwwcCompliance>;
};

/** Methods to use when ordering `GwwcCompliance`. */
export enum GwwcCompliancesOrderBy {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  LastCompletionPaymentAmountAsc = 'LAST_COMPLETION_PAYMENT_AMOUNT_ASC',
  LastCompletionPaymentAmountDesc = 'LAST_COMPLETION_PAYMENT_AMOUNT_DESC',
  LastCompletionPaymentCurrencyCodeAsc = 'LAST_COMPLETION_PAYMENT_CURRENCY_CODE_ASC',
  LastCompletionPaymentCurrencyCodeDesc = 'LAST_COMPLETION_PAYMENT_CURRENCY_CODE_DESC',
  LastCompletionPaymentDonationDateAsc = 'LAST_COMPLETION_PAYMENT_DONATION_DATE_ASC',
  LastCompletionPaymentDonationDateDesc = 'LAST_COMPLETION_PAYMENT_DONATION_DATE_DESC',
  LastCompletionPaymentTypeAsc = 'LAST_COMPLETION_PAYMENT_TYPE_ASC',
  LastCompletionPaymentTypeDesc = 'LAST_COMPLETION_PAYMENT_TYPE_DESC',
  LastIncomeAmountAsc = 'LAST_INCOME_AMOUNT_ASC',
  LastIncomeAmountDesc = 'LAST_INCOME_AMOUNT_DESC',
  LastIncomeCurrencyCodeAsc = 'LAST_INCOME_CURRENCY_CODE_ASC',
  LastIncomeCurrencyCodeDesc = 'LAST_INCOME_CURRENCY_CODE_DESC',
  LastIncomeEndDateAsc = 'LAST_INCOME_END_DATE_ASC',
  LastIncomeEndDateDesc = 'LAST_INCOME_END_DATE_DESC',
  LastIncomeIsCurrentAsc = 'LAST_INCOME_IS_CURRENT_ASC',
  LastIncomeIsCurrentDesc = 'LAST_INCOME_IS_CURRENT_DESC',
  LastIncomeStartDateAsc = 'LAST_INCOME_START_DATE_ASC',
  LastIncomeStartDateDesc = 'LAST_INCOME_START_DATE_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PledgeCompletionPercentageAsc = 'PLEDGE_COMPLETION_PERCENTAGE_ASC',
  PledgeCompletionPercentageDesc = 'PLEDGE_COMPLETION_PERCENTAGE_DESC',
  PledgeEndDateAsc = 'PLEDGE_END_DATE_ASC',
  PledgeEndDateDesc = 'PLEDGE_END_DATE_DESC',
  PledgeIdAsc = 'PLEDGE_ID_ASC',
  PledgeIdDesc = 'PLEDGE_ID_DESC',
  PledgePercentageAsc = 'PLEDGE_PERCENTAGE_ASC',
  PledgePercentageDesc = 'PLEDGE_PERCENTAGE_DESC',
  PledgeStartDateAsc = 'PLEDGE_START_DATE_ASC',
  PledgeStartDateDesc = 'PLEDGE_START_DATE_DESC',
  PledgeTypeAsc = 'PLEDGE_TYPE_ASC',
  PledgeTypeDesc = 'PLEDGE_TYPE_DESC'
}

/** A connection to a list of `GwwcMembersByCountry` values. */
export type GwwcMembersByCountriesConnection = {
  __typename?: 'GwwcMembersByCountriesConnection';
  /** A list of edges which contains the `GwwcMembersByCountry` and cursor to aid in pagination. */
  edges: Array<GwwcMembersByCountriesEdge>;
  /** A list of `GwwcMembersByCountry` objects. */
  nodes: Array<Maybe<GwwcMembersByCountry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GwwcMembersByCountry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GwwcMembersByCountry` edge in the connection. */
export type GwwcMembersByCountriesEdge = {
  __typename?: 'GwwcMembersByCountriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GwwcMembersByCountry` at the end of the edge. */
  node?: Maybe<GwwcMembersByCountry>;
};

/** Methods to use when ordering `GwwcMembersByCountry`. */
export enum GwwcMembersByCountriesOrderBy {
  GivingWhatWeCanMembersAsc = 'GIVING_WHAT_WE_CAN_MEMBERS_ASC',
  GivingWhatWeCanMembersDesc = 'GIVING_WHAT_WE_CAN_MEMBERS_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  TotalMembersAsc = 'TOTAL_MEMBERS_ASC',
  TotalMembersDesc = 'TOTAL_MEMBERS_DESC',
  TryGiversAsc = 'TRY_GIVERS_ASC',
  TryGiversDesc = 'TRY_GIVERS_DESC'
}

export type GwwcMembersByCountry = {
  __typename?: 'GwwcMembersByCountry';
  givingWhatWeCanMembers?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  totalMembers?: Maybe<Scalars['BigInt']>;
  tryGivers?: Maybe<Scalars['BigInt']>;
};

/**
 * A condition to be used against `GwwcMembersByCountry` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GwwcMembersByCountryCondition = {
  /** Checks for equality with the object’s `givingWhatWeCanMembers` field. */
  givingWhatWeCanMembers?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `totalMembers` field. */
  totalMembers?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `tryGivers` field. */
  tryGivers?: InputMaybe<Scalars['BigInt']>;
};

export type GwwcMembershipEmailExport = {
  __typename?: 'GwwcMembershipEmailExport';
  countryCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  pledgeEnd?: Maybe<Scalars['Date']>;
  pledgeStart?: Maybe<Scalars['Date']>;
  pledgeType?: Maybe<PledgeType>;
};

/**
 * A condition to be used against `GwwcMembershipEmailExport` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type GwwcMembershipEmailExportCondition = {
  /** Checks for equality with the object’s `countryCode` field. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `pledgeEnd` field. */
  pledgeEnd?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `pledgeStart` field. */
  pledgeStart?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `pledgeType` field. */
  pledgeType?: InputMaybe<PledgeType>;
};

/** A connection to a list of `GwwcMembershipEmailExport` values. */
export type GwwcMembershipEmailExportsConnection = {
  __typename?: 'GwwcMembershipEmailExportsConnection';
  /** A list of edges which contains the `GwwcMembershipEmailExport` and cursor to aid in pagination. */
  edges: Array<GwwcMembershipEmailExportsEdge>;
  /** A list of `GwwcMembershipEmailExport` objects. */
  nodes: Array<Maybe<GwwcMembershipEmailExport>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GwwcMembershipEmailExport` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GwwcMembershipEmailExport` edge in the connection. */
export type GwwcMembershipEmailExportsEdge = {
  __typename?: 'GwwcMembershipEmailExportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GwwcMembershipEmailExport` at the end of the edge. */
  node?: Maybe<GwwcMembershipEmailExport>;
};

/** Methods to use when ordering `GwwcMembershipEmailExport`. */
export enum GwwcMembershipEmailExportsOrderBy {
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PledgeEndAsc = 'PLEDGE_END_ASC',
  PledgeEndDesc = 'PLEDGE_END_DESC',
  PledgeStartAsc = 'PLEDGE_START_ASC',
  PledgeStartDesc = 'PLEDGE_START_DESC',
  PledgeTypeAsc = 'PLEDGE_TYPE_ASC',
  PledgeTypeDesc = 'PLEDGE_TYPE_DESC'
}

export type GwwcNewMemberInfo = {
  __typename?: 'GwwcNewMemberInfo';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  period?: Maybe<DateRange>;
  pledgePercentage?: Maybe<Scalars['BigFloat']>;
  pledgeType?: Maybe<PledgeType>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `GwwcNewMemberInfo` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GwwcNewMemberInfoCondition = {
  /** Checks for equality with the object’s `addressLine1` field. */
  addressLine1?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `addressLine2` field. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `countryCode` field. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `period` field. */
  period?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `pledgePercentage` field. */
  pledgePercentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `pledgeType` field. */
  pledgeType?: InputMaybe<PledgeType>;
  /** Checks for equality with the object’s `postalCode` field. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `region` field. */
  region?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `GwwcNewMemberInfo` values. */
export type GwwcNewMemberInfosConnection = {
  __typename?: 'GwwcNewMemberInfosConnection';
  /** A list of edges which contains the `GwwcNewMemberInfo` and cursor to aid in pagination. */
  edges: Array<GwwcNewMemberInfosEdge>;
  /** A list of `GwwcNewMemberInfo` objects. */
  nodes: Array<Maybe<GwwcNewMemberInfo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GwwcNewMemberInfo` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GwwcNewMemberInfo` edge in the connection. */
export type GwwcNewMemberInfosEdge = {
  __typename?: 'GwwcNewMemberInfosEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GwwcNewMemberInfo` at the end of the edge. */
  node?: Maybe<GwwcNewMemberInfo>;
};

/** Methods to use when ordering `GwwcNewMemberInfo`. */
export enum GwwcNewMemberInfosOrderBy {
  AddressLine_1Asc = 'ADDRESS_LINE_1_ASC',
  AddressLine_1Desc = 'ADDRESS_LINE_1_DESC',
  AddressLine_2Asc = 'ADDRESS_LINE_2_ASC',
  AddressLine_2Desc = 'ADDRESS_LINE_2_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  HouseNumberAsc = 'HOUSE_NUMBER_ASC',
  HouseNumberDesc = 'HOUSE_NUMBER_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC',
  PledgePercentageAsc = 'PLEDGE_PERCENTAGE_ASC',
  PledgePercentageDesc = 'PLEDGE_PERCENTAGE_DESC',
  PledgeTypeAsc = 'PLEDGE_TYPE_ASC',
  PledgeTypeDesc = 'PLEDGE_TYPE_DESC',
  PostalCodeAsc = 'POSTAL_CODE_ASC',
  PostalCodeDesc = 'POSTAL_CODE_DESC',
  RegionAsc = 'REGION_ASC',
  RegionDesc = 'REGION_DESC'
}

export type GwwcRecurringReportedDonationExtended = {
  __typename?: 'GwwcRecurringReportedDonationExtended';
  amount?: Maybe<Scalars['BigFloat']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  currencyCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  nextDate?: Maybe<Scalars['Date']>;
  organizationId?: Maybe<Scalars['BigInt']>;
  organizationName?: Maybe<Scalars['String']>;
  personId?: Maybe<Scalars['BigInt']>;
  recurrenceInterval?: Maybe<Interval>;
  startDate?: Maybe<Scalars['Date']>;
  status?: Maybe<RecurringPaymentStatus>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `GwwcRecurringReportedDonationExtended` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type GwwcRecurringReportedDonationExtendedCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `nextDate` field. */
  nextDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `organizationName` field. */
  organizationName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recurrenceInterval` field. */
  recurrenceInterval?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<RecurringPaymentStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `GwwcRecurringReportedDonationExtended` values. */
export type GwwcRecurringReportedDonationExtendedsConnection = {
  __typename?: 'GwwcRecurringReportedDonationExtendedsConnection';
  /** A list of edges which contains the `GwwcRecurringReportedDonationExtended` and cursor to aid in pagination. */
  edges: Array<GwwcRecurringReportedDonationExtendedsEdge>;
  /** A list of `GwwcRecurringReportedDonationExtended` objects. */
  nodes: Array<Maybe<GwwcRecurringReportedDonationExtended>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GwwcRecurringReportedDonationExtended` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GwwcRecurringReportedDonationExtended` edge in the connection. */
export type GwwcRecurringReportedDonationExtendedsEdge = {
  __typename?: 'GwwcRecurringReportedDonationExtendedsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GwwcRecurringReportedDonationExtended` at the end of the edge. */
  node?: Maybe<GwwcRecurringReportedDonationExtended>;
};

/** Methods to use when ordering `GwwcRecurringReportedDonationExtended`. */
export enum GwwcRecurringReportedDonationExtendedsOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NextDateAsc = 'NEXT_DATE_ASC',
  NextDateDesc = 'NEXT_DATE_DESC',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  OrganizationNameAsc = 'ORGANIZATION_NAME_ASC',
  OrganizationNameDesc = 'ORGANIZATION_NAME_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  RecurrenceIntervalAsc = 'RECURRENCE_INTERVAL_ASC',
  RecurrenceIntervalDesc = 'RECURRENCE_INTERVAL_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GwwcReportedDonationExtended = {
  __typename?: 'GwwcReportedDonationExtended';
  amount?: Maybe<Scalars['BigFloat']>;
  amountNormalized?: Maybe<Scalars['BigFloat']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  currencyCode?: Maybe<Scalars['String']>;
  donationDate?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['BigInt']>;
  personId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `GwwcReportedDonationExtended` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type GwwcReportedDonationExtendedCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `donationDate` field. */
  donationDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `GwwcReportedDonationExtended` values. */
export type GwwcReportedDonationExtendedsConnection = {
  __typename?: 'GwwcReportedDonationExtendedsConnection';
  /** A list of edges which contains the `GwwcReportedDonationExtended` and cursor to aid in pagination. */
  edges: Array<GwwcReportedDonationExtendedsEdge>;
  /** A list of `GwwcReportedDonationExtended` objects. */
  nodes: Array<Maybe<GwwcReportedDonationExtended>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GwwcReportedDonationExtended` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GwwcReportedDonationExtended` edge in the connection. */
export type GwwcReportedDonationExtendedsEdge = {
  __typename?: 'GwwcReportedDonationExtendedsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GwwcReportedDonationExtended` at the end of the edge. */
  node?: Maybe<GwwcReportedDonationExtended>;
};

/** Methods to use when ordering `GwwcReportedDonationExtended`. */
export enum GwwcReportedDonationExtendedsOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DonationDateAsc = 'DONATION_DATE_ASC',
  DonationDateDesc = 'DONATION_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GwwcSurveyReport = {
  __typename?: 'GwwcSurveyReport';
  birthDate?: Maybe<Scalars['Date']>;
  counterfactualDonationPercentage?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gwwcDonationInfluence?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  otherComments?: Maybe<Scalars['String']>;
  period?: Maybe<DateRange>;
  pledgePercentage?: Maybe<Scalars['BigFloat']>;
  pledgeType?: Maybe<PledgeType>;
  referrer?: Maybe<Array<Maybe<Scalars['String']>>>;
  referrerNotes?: Maybe<Scalars['String']>;
  wherePlanningToGive?: Maybe<Array<Maybe<Scalars['String']>>>;
  wherePlanningToGiveNotes?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `GwwcSurveyReport` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GwwcSurveyReportCondition = {
  /** Checks for equality with the object’s `birthDate` field. */
  birthDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `counterfactualDonationPercentage` field. */
  counterfactualDonationPercentage?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `gwwcDonationInfluence` field. */
  gwwcDonationInfluence?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `otherComments` field. */
  otherComments?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `period` field. */
  period?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `pledgePercentage` field. */
  pledgePercentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `pledgeType` field. */
  pledgeType?: InputMaybe<PledgeType>;
  /** Checks for equality with the object’s `referrer` field. */
  referrer?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `referrerNotes` field. */
  referrerNotes?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `wherePlanningToGive` field. */
  wherePlanningToGive?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `wherePlanningToGiveNotes` field. */
  wherePlanningToGiveNotes?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `GwwcSurveyReport` values. */
export type GwwcSurveyReportsConnection = {
  __typename?: 'GwwcSurveyReportsConnection';
  /** A list of edges which contains the `GwwcSurveyReport` and cursor to aid in pagination. */
  edges: Array<GwwcSurveyReportsEdge>;
  /** A list of `GwwcSurveyReport` objects. */
  nodes: Array<Maybe<GwwcSurveyReport>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GwwcSurveyReport` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GwwcSurveyReport` edge in the connection. */
export type GwwcSurveyReportsEdge = {
  __typename?: 'GwwcSurveyReportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GwwcSurveyReport` at the end of the edge. */
  node?: Maybe<GwwcSurveyReport>;
};

/** Methods to use when ordering `GwwcSurveyReport`. */
export enum GwwcSurveyReportsOrderBy {
  BirthDateAsc = 'BIRTH_DATE_ASC',
  BirthDateDesc = 'BIRTH_DATE_DESC',
  CounterfactualDonationPercentageAsc = 'COUNTERFACTUAL_DONATION_PERCENTAGE_ASC',
  CounterfactualDonationPercentageDesc = 'COUNTERFACTUAL_DONATION_PERCENTAGE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  GwwcDonationInfluenceAsc = 'GWWC_DONATION_INFLUENCE_ASC',
  GwwcDonationInfluenceDesc = 'GWWC_DONATION_INFLUENCE_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  OtherCommentsAsc = 'OTHER_COMMENTS_ASC',
  OtherCommentsDesc = 'OTHER_COMMENTS_DESC',
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC',
  PledgePercentageAsc = 'PLEDGE_PERCENTAGE_ASC',
  PledgePercentageDesc = 'PLEDGE_PERCENTAGE_DESC',
  PledgeTypeAsc = 'PLEDGE_TYPE_ASC',
  PledgeTypeDesc = 'PLEDGE_TYPE_DESC',
  ReferrerAsc = 'REFERRER_ASC',
  ReferrerDesc = 'REFERRER_DESC',
  ReferrerNotesAsc = 'REFERRER_NOTES_ASC',
  ReferrerNotesDesc = 'REFERRER_NOTES_DESC',
  WherePlanningToGiveAsc = 'WHERE_PLANNING_TO_GIVE_ASC',
  WherePlanningToGiveDesc = 'WHERE_PLANNING_TO_GIVE_DESC',
  WherePlanningToGiveNotesAsc = 'WHERE_PLANNING_TO_GIVE_NOTES_ASC',
  WherePlanningToGiveNotesDesc = 'WHERE_PLANNING_TO_GIVE_NOTES_DESC'
}

export type Income = Node & {
  __typename?: 'Income';
  amount: Scalars['BigFloat'];
  /** Reads and enables pagination through a set of `CompletionPayment`. */
  completionPaymentsByIncomeId: CompletionPaymentsConnection;
  /** Reads and enables pagination through a set of `CompletionPayment`. */
  completionPaymentsByIncomeIdList: Array<CompletionPayment>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `Currency` that is related to this `Income`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  currencyCode: Scalars['String'];
  donationsTaxDeductible?: Maybe<Scalars['Boolean']>;
  employmentStatus?: Maybe<IncomeEmploymentStatus>;
  id: Scalars['BigInt'];
  /** Reads and enables pagination through a set of `Liability`. */
  liabilitiesByIncomeId: LiabilitiesConnection;
  /** Reads and enables pagination through a set of `Liability`. */
  liabilitiesByIncomeIdList: Array<Liability>;
  /** Reads and enables pagination through a set of `LiabilityPayment`. */
  liabilityPaymentsByIncomeId: LiabilityPaymentsConnection;
  /** Reads and enables pagination through a set of `LiabilityPayment`. */
  liabilityPaymentsByIncomeIdList: Array<LiabilityPayment>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  period: DateRange;
  /** Reads a single `Person` that is related to this `Income`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  updatedAt: Scalars['Datetime'];
};


export type IncomeCompletionPaymentsByIncomeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompletionPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompletionPaymentsOrderBy>>;
};


export type IncomeCompletionPaymentsByIncomeIdListArgs = {
  condition?: InputMaybe<CompletionPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompletionPaymentsOrderBy>>;
};


export type IncomeLiabilitiesByIncomeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LiabilityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilitiesOrderBy>>;
};


export type IncomeLiabilitiesByIncomeIdListArgs = {
  condition?: InputMaybe<LiabilityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilitiesOrderBy>>;
};


export type IncomeLiabilityPaymentsByIncomeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LiabilityPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityPaymentsOrderBy>>;
};


export type IncomeLiabilityPaymentsByIncomeIdListArgs = {
  condition?: InputMaybe<LiabilityPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityPaymentsOrderBy>>;
};

/** A condition to be used against `Income` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type IncomeCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `donationsTaxDeductible` field. */
  donationsTaxDeductible?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `employmentStatus` field. */
  employmentStatus?: InputMaybe<IncomeEmploymentStatus>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `period` field. */
  period?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum IncomeEmploymentStatus {
  Employed = 'EMPLOYED',
  Retired = 'RETIRED',
  Student = 'STUDENT',
  Unemployed = 'UNEMPLOYED'
}

/** An input for mutations affecting `Income` */
export type IncomeInput = {
  amount: Scalars['BigFloat'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currencyCode: Scalars['String'];
  donationsTaxDeductible?: InputMaybe<Scalars['Boolean']>;
  employmentStatus?: InputMaybe<IncomeEmploymentStatus>;
  id?: InputMaybe<Scalars['BigInt']>;
  period: DateRangeInput;
  personId: Scalars['BigInt'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Income` values. */
export type IncomesConnection = {
  __typename?: 'IncomesConnection';
  /** A list of edges which contains the `Income` and cursor to aid in pagination. */
  edges: Array<IncomesEdge>;
  /** A list of `Income` objects. */
  nodes: Array<Maybe<Income>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Income` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Income` edge in the connection. */
export type IncomesEdge = {
  __typename?: 'IncomesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Income` at the end of the edge. */
  node?: Maybe<Income>;
};

/** Methods to use when ordering `Income`. */
export enum IncomesOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DonationsTaxDeductibleAsc = 'DONATIONS_TAX_DEDUCTIBLE_ASC',
  DonationsTaxDeductibleDesc = 'DONATIONS_TAX_DEDUCTIBLE_DESC',
  EmploymentStatusAsc = 'EMPLOYMENT_STATUS_ASC',
  EmploymentStatusDesc = 'EMPLOYMENT_STATUS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type IncompleteAddress = {
  __typename?: 'IncompleteAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  personId?: Maybe<Scalars['BigInt']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `IncompleteAddress` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type IncompleteAddressCondition = {
  /** Checks for equality with the object’s `addressLine1` field. */
  addressLine1?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `addressLine2` field. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `coordinates` field. */
  coordinates?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `countryCode` field. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `googlePlaceId` field. */
  googlePlaceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `postalCode` field. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `region` field. */
  region?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `IncompleteAddress` values. */
export type IncompleteAddressesConnection = {
  __typename?: 'IncompleteAddressesConnection';
  /** A list of edges which contains the `IncompleteAddress` and cursor to aid in pagination. */
  edges: Array<IncompleteAddressesEdge>;
  /** A list of `IncompleteAddress` objects. */
  nodes: Array<Maybe<IncompleteAddress>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IncompleteAddress` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `IncompleteAddress` edge in the connection. */
export type IncompleteAddressesEdge = {
  __typename?: 'IncompleteAddressesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `IncompleteAddress` at the end of the edge. */
  node?: Maybe<IncompleteAddress>;
};

/** Methods to use when ordering `IncompleteAddress`. */
export enum IncompleteAddressesOrderBy {
  AddressLine_1Asc = 'ADDRESS_LINE_1_ASC',
  AddressLine_1Desc = 'ADDRESS_LINE_1_DESC',
  AddressLine_2Asc = 'ADDRESS_LINE_2_ASC',
  AddressLine_2Desc = 'ADDRESS_LINE_2_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CoordinatesAsc = 'COORDINATES_ASC',
  CoordinatesDesc = 'COORDINATES_DESC',
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GooglePlaceIdAsc = 'GOOGLE_PLACE_ID_ASC',
  GooglePlaceIdDesc = 'GOOGLE_PLACE_ID_DESC',
  HouseNumberAsc = 'HOUSE_NUMBER_ASC',
  HouseNumberDesc = 'HOUSE_NUMBER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PostalCodeAsc = 'POSTAL_CODE_ASC',
  PostalCodeDesc = 'POSTAL_CODE_DESC',
  RegionAsc = 'REGION_ASC',
  RegionDesc = 'REGION_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** All input for the `insertGiftAidClaimReport` mutation. */
export type InsertGiftAidClaimReportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  reportId?: InputMaybe<Scalars['Int']>;
};

/** The output of our `insertGiftAidClaimReport` mutation. */
export type InsertGiftAidClaimReportPayload = {
  __typename?: 'InsertGiftAidClaimReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `GatewayPayoutReport`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  gatewayPayoutReport?: Maybe<GatewayPayoutReport>;
  /** An edge for our `GatewayPayoutReport`. May be used by Relay 1. */
  gatewayPayoutReportEdge?: Maybe<GatewayPayoutReportsEdge>;
  /** Reads a single `PaymentRecipient` that is related to this `GatewayPayoutReport`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `insertGiftAidClaimReport` mutation. */
export type InsertGiftAidClaimReportPayloadGatewayPayoutReportEdgeArgs = {
  orderBy?: InputMaybe<Array<GatewayPayoutReportsOrderBy>>;
};

/** All input for the `insertLotteryTicket` mutation. */
export type InsertLotteryTicketInput = {
  blockId?: InputMaybe<Scalars['Int']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  paymentId?: InputMaybe<Scalars['BigInt']>;
  winRange?: InputMaybe<BigIntRangeInput>;
};

/** The output of our `insertLotteryTicket` mutation. */
export type InsertLotteryTicketPayload = {
  __typename?: 'InsertLotteryTicketPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `LotteryEntry` that is related to this `LotteryTicket`. */
  lotteryEntryByLotteryIdAndPaymentId?: Maybe<LotteryEntry>;
  lotteryTicket?: Maybe<LotteryTicket>;
  /** An edge for our `LotteryTicket`. May be used by Relay 1. */
  lotteryTicketEdge?: Maybe<LotteryTicketsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `insertLotteryTicket` mutation. */
export type InsertLotteryTicketPayloadLotteryTicketEdgeArgs = {
  orderBy?: InputMaybe<Array<LotteryTicketsOrderBy>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename?: 'Interval';
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: InputMaybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: InputMaybe<Scalars['Int']>;
};

export enum InvoiceType {
  AccountsPayable = 'ACCOUNTS_PAYABLE',
  AccountsReceivable = 'ACCOUNTS_RECEIVABLE'
}

/** All input for the `isPaymentsManager` mutation. */
export type IsPaymentsManagerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `isPaymentsManager` mutation. */
export type IsPaymentsManagerPayload = {
  __typename?: 'IsPaymentsManagerPayload';
  boolean?: Maybe<Scalars['Boolean']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Jwt = {
  __typename?: 'Jwt';
  exp?: Maybe<Scalars['Int']>;
  personId?: Maybe<Scalars['BigInt']>;
  refreshToken?: Maybe<Scalars['UUID']>;
  role?: Maybe<Scalars['String']>;
};

/** A connection to a list of `Liability` values. */
export type LiabilitiesConnection = {
  __typename?: 'LiabilitiesConnection';
  /** A list of edges which contains the `Liability` and cursor to aid in pagination. */
  edges: Array<LiabilitiesEdge>;
  /** A list of `Liability` objects. */
  nodes: Array<Maybe<Liability>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Liability` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Liability` edge in the connection. */
export type LiabilitiesEdge = {
  __typename?: 'LiabilitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Liability` at the end of the edge. */
  node?: Maybe<Liability>;
};

/** Methods to use when ordering `Liability`. */
export enum LiabilitiesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  IncomeIdAsc = 'INCOME_ID_ASC',
  IncomeIdDesc = 'INCOME_ID_DESC',
  LiabilityAmountAsc = 'LIABILITY_AMOUNT_ASC',
  LiabilityAmountDesc = 'LIABILITY_AMOUNT_DESC',
  LiabilityNormalizedAsc = 'LIABILITY_NORMALIZED_ASC',
  LiabilityNormalizedDesc = 'LIABILITY_NORMALIZED_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PledgeIdAsc = 'PLEDGE_ID_ASC',
  PledgeIdDesc = 'PLEDGE_ID_DESC',
  PledgeIncomePeriodAsc = 'PLEDGE_INCOME_PERIOD_ASC',
  PledgeIncomePeriodDesc = 'PLEDGE_INCOME_PERIOD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type Liability = Node & {
  __typename?: 'Liability';
  /** Reads and enables pagination through a set of `CompletionPayment`. */
  completionPaymentsByPledgeIdAndIncomeId: CompletionPaymentsConnection;
  /** Reads and enables pagination through a set of `CompletionPayment`. */
  completionPaymentsByPledgeIdAndIncomeIdList: Array<CompletionPayment>;
  createdAt: Scalars['Datetime'];
  currencyCode: Scalars['String'];
  /** Reads a single `Income` that is related to this `Liability`. */
  incomeByIncomeId?: Maybe<Income>;
  incomeId: Scalars['BigInt'];
  liabilityAmount: Scalars['BigFloat'];
  liabilityNormalized: Scalars['BigFloat'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Person` that is related to this `Liability`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  /** Reads a single `Pledge` that is related to this `Liability`. */
  pledgeByPledgeId?: Maybe<Pledge>;
  pledgeId: Scalars['BigInt'];
  pledgeIncomePeriod: DateRange;
  updatedAt: Scalars['Datetime'];
};


export type LiabilityCompletionPaymentsByPledgeIdAndIncomeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompletionPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompletionPaymentsOrderBy>>;
};


export type LiabilityCompletionPaymentsByPledgeIdAndIncomeIdListArgs = {
  condition?: InputMaybe<CompletionPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompletionPaymentsOrderBy>>;
};

export type LiabilityCompletion = {
  __typename?: 'LiabilityCompletion';
  completionAmount?: Maybe<Scalars['BigFloat']>;
  completionAmountNormalized?: Maybe<Scalars['BigFloat']>;
  completionPercentage?: Maybe<Scalars['BigFloat']>;
  currencyCode?: Maybe<Scalars['String']>;
  incomeId?: Maybe<Scalars['BigInt']>;
  liabilityAmount?: Maybe<Scalars['BigFloat']>;
  period?: Maybe<DateRange>;
  personId?: Maybe<Scalars['BigInt']>;
  pledgeId?: Maybe<Scalars['BigInt']>;
};

/**
 * A condition to be used against `LiabilityCompletion` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LiabilityCompletionCondition = {
  /** Checks for equality with the object’s `completionAmount` field. */
  completionAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `completionAmountNormalized` field. */
  completionAmountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `completionPercentage` field. */
  completionPercentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `incomeId` field. */
  incomeId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `liabilityAmount` field. */
  liabilityAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `period` field. */
  period?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pledgeId` field. */
  pledgeId?: InputMaybe<Scalars['BigInt']>;
};

export type LiabilityCompletionT = {
  __typename?: 'LiabilityCompletionT';
  completionAmount?: Maybe<Scalars['BigFloat']>;
  completionAmountNormalized?: Maybe<Scalars['BigFloat']>;
  completionPercentage?: Maybe<Scalars['BigFloat']>;
  currencyCode?: Maybe<Scalars['String']>;
  incomeId?: Maybe<Scalars['BigInt']>;
  liabilityAmount?: Maybe<Scalars['BigFloat']>;
  period?: Maybe<DateRange>;
  personId?: Maybe<Scalars['BigInt']>;
  pledgeId?: Maybe<Scalars['BigInt']>;
};

/** A connection to a list of `LiabilityCompletionT` values. */
export type LiabilityCompletionTsConnection = {
  __typename?: 'LiabilityCompletionTsConnection';
  /** A list of edges which contains the `LiabilityCompletionT` and cursor to aid in pagination. */
  edges: Array<LiabilityCompletionTsEdge>;
  /** A list of `LiabilityCompletionT` objects. */
  nodes: Array<Maybe<LiabilityCompletionT>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiabilityCompletionT` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LiabilityCompletionT` edge in the connection. */
export type LiabilityCompletionTsEdge = {
  __typename?: 'LiabilityCompletionTsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LiabilityCompletionT` at the end of the edge. */
  node?: Maybe<LiabilityCompletionT>;
};

/** A connection to a list of `LiabilityCompletion` values. */
export type LiabilityCompletionsConnection = {
  __typename?: 'LiabilityCompletionsConnection';
  /** A list of edges which contains the `LiabilityCompletion` and cursor to aid in pagination. */
  edges: Array<LiabilityCompletionsEdge>;
  /** A list of `LiabilityCompletion` objects. */
  nodes: Array<Maybe<LiabilityCompletion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiabilityCompletion` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LiabilityCompletion` edge in the connection. */
export type LiabilityCompletionsEdge = {
  __typename?: 'LiabilityCompletionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LiabilityCompletion` at the end of the edge. */
  node?: Maybe<LiabilityCompletion>;
};

/** Methods to use when ordering `LiabilityCompletion`. */
export enum LiabilityCompletionsOrderBy {
  CompletionAmountAsc = 'COMPLETION_AMOUNT_ASC',
  CompletionAmountDesc = 'COMPLETION_AMOUNT_DESC',
  CompletionAmountNormalizedAsc = 'COMPLETION_AMOUNT_NORMALIZED_ASC',
  CompletionAmountNormalizedDesc = 'COMPLETION_AMOUNT_NORMALIZED_DESC',
  CompletionPercentageAsc = 'COMPLETION_PERCENTAGE_ASC',
  CompletionPercentageDesc = 'COMPLETION_PERCENTAGE_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  IncomeIdAsc = 'INCOME_ID_ASC',
  IncomeIdDesc = 'INCOME_ID_DESC',
  LiabilityAmountAsc = 'LIABILITY_AMOUNT_ASC',
  LiabilityAmountDesc = 'LIABILITY_AMOUNT_DESC',
  Natural = 'NATURAL',
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PledgeIdAsc = 'PLEDGE_ID_ASC',
  PledgeIdDesc = 'PLEDGE_ID_DESC'
}

/**
 * A condition to be used against `Liability` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LiabilityCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `incomeId` field. */
  incomeId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `liabilityAmount` field. */
  liabilityAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `liabilityNormalized` field. */
  liabilityNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pledgeId` field. */
  pledgeId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pledgeIncomePeriod` field. */
  pledgeIncomePeriod?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type LiabilityPayment = Node & {
  __typename?: 'LiabilityPayment';
  createdAt: Scalars['Datetime'];
  id: Scalars['BigInt'];
  /** Reads a single `Income` that is related to this `LiabilityPayment`. */
  incomeByIncomeId?: Maybe<Income>;
  incomeId: Scalars['BigInt'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Payment` that is related to this `LiabilityPayment`. */
  paymentByPaymentId?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `Person` that is related to this `LiabilityPayment`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  /** Reads a single `Pledge` that is related to this `LiabilityPayment`. */
  pledgeByPledgeId?: Maybe<Pledge>;
  pledgeId: Scalars['BigInt'];
  /** Reads a single `ReportedDonation` that is related to this `LiabilityPayment`. */
  reportedDonationByReportedDonationId?: Maybe<ReportedDonation>;
  reportedDonationId?: Maybe<Scalars['BigInt']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `LiabilityPayment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LiabilityPaymentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `incomeId` field. */
  incomeId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `paymentId` field. */
  paymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pledgeId` field. */
  pledgeId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `reportedDonationId` field. */
  reportedDonationId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `LiabilityPayment` values. */
export type LiabilityPaymentsConnection = {
  __typename?: 'LiabilityPaymentsConnection';
  /** A list of edges which contains the `LiabilityPayment` and cursor to aid in pagination. */
  edges: Array<LiabilityPaymentsEdge>;
  /** A list of `LiabilityPayment` objects. */
  nodes: Array<Maybe<LiabilityPayment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiabilityPayment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LiabilityPayment` edge in the connection. */
export type LiabilityPaymentsEdge = {
  __typename?: 'LiabilityPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LiabilityPayment` at the end of the edge. */
  node?: Maybe<LiabilityPayment>;
};

/** Methods to use when ordering `LiabilityPayment`. */
export enum LiabilityPaymentsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IncomeIdAsc = 'INCOME_ID_ASC',
  IncomeIdDesc = 'INCOME_ID_DESC',
  Natural = 'NATURAL',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PledgeIdAsc = 'PLEDGE_ID_ASC',
  PledgeIdDesc = 'PLEDGE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReportedDonationIdAsc = 'REPORTED_DONATION_ID_ASC',
  ReportedDonationIdDesc = 'REPORTED_DONATION_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type LiabilityTotalCompletion = {
  __typename?: 'LiabilityTotalCompletion';
  completionAmount?: Maybe<Scalars['BigFloat']>;
  completionAmountNormalized?: Maybe<Scalars['BigFloat']>;
  completionPercentage?: Maybe<Scalars['BigFloat']>;
  currencyCode?: Maybe<Scalars['String']>;
  currencySortOrder?: Maybe<Scalars['BigInt']>;
  liabilityAmount?: Maybe<Scalars['BigFloat']>;
  liabilityAmountNormalized?: Maybe<Scalars['BigFloat']>;
  pledgeId?: Maybe<Scalars['BigInt']>;
};

/**
 * A condition to be used against `LiabilityTotalCompletion` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type LiabilityTotalCompletionCondition = {
  /** Checks for equality with the object’s `completionAmount` field. */
  completionAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `completionAmountNormalized` field. */
  completionAmountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `completionPercentage` field. */
  completionPercentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `currencySortOrder` field. */
  currencySortOrder?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `liabilityAmount` field. */
  liabilityAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `liabilityAmountNormalized` field. */
  liabilityAmountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `pledgeId` field. */
  pledgeId?: InputMaybe<Scalars['BigInt']>;
};

export type LiabilityTotalCompletionT = {
  __typename?: 'LiabilityTotalCompletionT';
  completionAmount?: Maybe<Scalars['BigFloat']>;
  completionAmountNormalized?: Maybe<Scalars['BigFloat']>;
  completionPercentage?: Maybe<Scalars['BigFloat']>;
  currencyCode?: Maybe<Scalars['String']>;
  currencySortOrder?: Maybe<Scalars['BigInt']>;
  liabilityAmount?: Maybe<Scalars['BigFloat']>;
  liabilityAmountNormalized?: Maybe<Scalars['BigFloat']>;
  pledgeId?: Maybe<Scalars['BigInt']>;
};

/** A connection to a list of `LiabilityTotalCompletionT` values. */
export type LiabilityTotalCompletionTsConnection = {
  __typename?: 'LiabilityTotalCompletionTsConnection';
  /** A list of edges which contains the `LiabilityTotalCompletionT` and cursor to aid in pagination. */
  edges: Array<LiabilityTotalCompletionTsEdge>;
  /** A list of `LiabilityTotalCompletionT` objects. */
  nodes: Array<Maybe<LiabilityTotalCompletionT>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiabilityTotalCompletionT` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LiabilityTotalCompletionT` edge in the connection. */
export type LiabilityTotalCompletionTsEdge = {
  __typename?: 'LiabilityTotalCompletionTsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LiabilityTotalCompletionT` at the end of the edge. */
  node?: Maybe<LiabilityTotalCompletionT>;
};

/** A connection to a list of `LiabilityTotalCompletion` values. */
export type LiabilityTotalCompletionsConnection = {
  __typename?: 'LiabilityTotalCompletionsConnection';
  /** A list of edges which contains the `LiabilityTotalCompletion` and cursor to aid in pagination. */
  edges: Array<LiabilityTotalCompletionsEdge>;
  /** A list of `LiabilityTotalCompletion` objects. */
  nodes: Array<Maybe<LiabilityTotalCompletion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiabilityTotalCompletion` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LiabilityTotalCompletion` edge in the connection. */
export type LiabilityTotalCompletionsEdge = {
  __typename?: 'LiabilityTotalCompletionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LiabilityTotalCompletion` at the end of the edge. */
  node?: Maybe<LiabilityTotalCompletion>;
};

/** Methods to use when ordering `LiabilityTotalCompletion`. */
export enum LiabilityTotalCompletionsOrderBy {
  CompletionAmountAsc = 'COMPLETION_AMOUNT_ASC',
  CompletionAmountDesc = 'COMPLETION_AMOUNT_DESC',
  CompletionAmountNormalizedAsc = 'COMPLETION_AMOUNT_NORMALIZED_ASC',
  CompletionAmountNormalizedDesc = 'COMPLETION_AMOUNT_NORMALIZED_DESC',
  CompletionPercentageAsc = 'COMPLETION_PERCENTAGE_ASC',
  CompletionPercentageDesc = 'COMPLETION_PERCENTAGE_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  CurrencySortOrderAsc = 'CURRENCY_SORT_ORDER_ASC',
  CurrencySortOrderDesc = 'CURRENCY_SORT_ORDER_DESC',
  LiabilityAmountAsc = 'LIABILITY_AMOUNT_ASC',
  LiabilityAmountDesc = 'LIABILITY_AMOUNT_DESC',
  LiabilityAmountNormalizedAsc = 'LIABILITY_AMOUNT_NORMALIZED_ASC',
  LiabilityAmountNormalizedDesc = 'LIABILITY_AMOUNT_NORMALIZED_DESC',
  Natural = 'NATURAL',
  PledgeIdAsc = 'PLEDGE_ID_ASC',
  PledgeIdDesc = 'PLEDGE_ID_DESC'
}

/** A connection to a list of `Lottery` values. */
export type LotteriesConnection = {
  __typename?: 'LotteriesConnection';
  /** A list of edges which contains the `Lottery` and cursor to aid in pagination. */
  edges: Array<LotteriesEdge>;
  /** A list of `Lottery` objects. */
  nodes: Array<Maybe<Lottery>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Lottery` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Lottery` edge in the connection. */
export type LotteriesEdge = {
  __typename?: 'LotteriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Lottery` at the end of the edge. */
  node?: Maybe<Lottery>;
};

/** Methods to use when ordering `Lottery`. */
export enum LotteriesOrderBy {
  BlockSizeAsc = 'BLOCK_SIZE_ASC',
  BlockSizeDesc = 'BLOCK_SIZE_DESC',
  CloseTimestampAsc = 'CLOSE_TIMESTAMP_ASC',
  CloseTimestampDesc = 'CLOSE_TIMESTAMP_DESC',
  DrawTimestampAsc = 'DRAW_TIMESTAMP_ASC',
  DrawTimestampDesc = 'DRAW_TIMESTAMP_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LockTimestampAsc = 'LOCK_TIMESTAMP_ASC',
  LockTimestampDesc = 'LOCK_TIMESTAMP_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  WinningNumberAsc = 'WINNING_NUMBER_ASC',
  WinningNumberDesc = 'WINNING_NUMBER_DESC'
}

export type Lottery = Node & {
  __typename?: 'Lottery';
  blockSize: Scalars['BigFloat'];
  closeTimestamp: Scalars['Datetime'];
  drawTimestamp: Scalars['Datetime'];
  id: Scalars['BigInt'];
  lockTimestamp: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `LotteryEntry`. */
  lotteryEntriesByLotteryId: LotteryEntriesConnection;
  /** Reads and enables pagination through a set of `LotteryEntry`. */
  lotteryEntriesByLotteryIdList: Array<LotteryEntry>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  winningNumber?: Maybe<Scalars['BigInt']>;
};


export type LotteryLotteryEntriesByLotteryIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LotteryEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryEntriesOrderBy>>;
};


export type LotteryLotteryEntriesByLotteryIdListArgs = {
  condition?: InputMaybe<LotteryEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryEntriesOrderBy>>;
};

/** A condition to be used against `Lottery` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LotteryCondition = {
  /** Checks for equality with the object’s `blockSize` field. */
  blockSize?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `closeTimestamp` field. */
  closeTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `drawTimestamp` field. */
  drawTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `lockTimestamp` field. */
  lockTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `winningNumber` field. */
  winningNumber?: InputMaybe<Scalars['BigInt']>;
};

/** A connection to a list of `LotteryEntry` values. */
export type LotteryEntriesConnection = {
  __typename?: 'LotteryEntriesConnection';
  /** A list of edges which contains the `LotteryEntry` and cursor to aid in pagination. */
  edges: Array<LotteryEntriesEdge>;
  /** A list of `LotteryEntry` objects. */
  nodes: Array<Maybe<LotteryEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LotteryEntry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LotteryEntry` edge in the connection. */
export type LotteryEntriesEdge = {
  __typename?: 'LotteryEntriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LotteryEntry` at the end of the edge. */
  node?: Maybe<LotteryEntry>;
};

/** Methods to use when ordering `LotteryEntry`. */
export enum LotteryEntriesOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  AmountNormalizedNetFeeAsc = 'AMOUNT_NORMALIZED_NET_FEE_ASC',
  AmountNormalizedNetFeeDesc = 'AMOUNT_NORMALIZED_NET_FEE_DESC',
  AnonymousAsc = 'ANONYMOUS_ASC',
  AnonymousDesc = 'ANONYMOUS_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  FeeNormalizedAsc = 'FEE_NORMALIZED_ASC',
  FeeNormalizedDesc = 'FEE_NORMALIZED_DESC',
  GiftAidAsc = 'GIFT_AID_ASC',
  GiftAidDesc = 'GIFT_AID_DESC',
  LotteryIdAsc = 'LOTTERY_ID_ASC',
  LotteryIdDesc = 'LOTTERY_ID_DESC',
  Natural = 'NATURAL',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TotalAsc = 'TOTAL_ASC',
  TotalDesc = 'TOTAL_DESC'
}

export type LotteryEntry = Node & {
  __typename?: 'LotteryEntry';
  amount: Scalars['BigFloat'];
  amountNormalized: Scalars['BigFloat'];
  amountNormalizedNetFee?: Maybe<Scalars['BigFloat']>;
  anonymous: Scalars['Boolean'];
  currencyCode: Scalars['String'];
  feeNormalized?: Maybe<Scalars['BigFloat']>;
  giftAid: Scalars['BigFloat'];
  /** Reads a single `Lottery` that is related to this `LotteryEntry`. */
  lotteryByLotteryId?: Maybe<Lottery>;
  lotteryId: Scalars['BigInt'];
  /** Reads and enables pagination through a set of `LotteryTicket`. */
  lotteryTicketsByLotteryIdAndPaymentId: LotteryTicketsConnection;
  /** Reads and enables pagination through a set of `LotteryTicket`. */
  lotteryTicketsByLotteryIdAndPaymentIdList: Array<LotteryTicket>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Payment` that is related to this `LotteryEntry`. */
  paymentByPaymentId?: Maybe<Payment>;
  paymentId: Scalars['BigInt'];
  total?: Maybe<Scalars['BigFloat']>;
};


export type LotteryEntryLotteryTicketsByLotteryIdAndPaymentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LotteryTicketCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryTicketsOrderBy>>;
};


export type LotteryEntryLotteryTicketsByLotteryIdAndPaymentIdListArgs = {
  condition?: InputMaybe<LotteryTicketCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryTicketsOrderBy>>;
};

export type LotteryEntryComplete = {
  __typename?: 'LotteryEntryComplete';
  amountNormalized?: Maybe<Scalars['BigFloat']>;
  anonymous?: Maybe<Scalars['Boolean']>;
  benefactor?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  displayName?: Maybe<Scalars['String']>;
  lotteryId?: Maybe<Scalars['BigInt']>;
  paymentReference?: Maybe<Scalars['String']>;
  tickets?: Maybe<Scalars['JSON']>;
};

/**
 * A condition to be used against `LotteryEntryComplete` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LotteryEntryCompleteCondition = {
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `anonymous` field. */
  anonymous?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `benefactor` field. */
  benefactor?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `displayName` field. */
  displayName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lotteryId` field. */
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `paymentReference` field. */
  paymentReference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `tickets` field. */
  tickets?: InputMaybe<Scalars['JSON']>;
};

/** A connection to a list of `LotteryEntryComplete` values. */
export type LotteryEntryCompletesConnection = {
  __typename?: 'LotteryEntryCompletesConnection';
  /** A list of edges which contains the `LotteryEntryComplete` and cursor to aid in pagination. */
  edges: Array<LotteryEntryCompletesEdge>;
  /** A list of `LotteryEntryComplete` objects. */
  nodes: Array<Maybe<LotteryEntryComplete>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LotteryEntryComplete` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LotteryEntryComplete` edge in the connection. */
export type LotteryEntryCompletesEdge = {
  __typename?: 'LotteryEntryCompletesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LotteryEntryComplete` at the end of the edge. */
  node?: Maybe<LotteryEntryComplete>;
};

/** Methods to use when ordering `LotteryEntryComplete`. */
export enum LotteryEntryCompletesOrderBy {
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  AnonymousAsc = 'ANONYMOUS_ASC',
  AnonymousDesc = 'ANONYMOUS_DESC',
  BenefactorAsc = 'BENEFACTOR_ASC',
  BenefactorDesc = 'BENEFACTOR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DisplayNameAsc = 'DISPLAY_NAME_ASC',
  DisplayNameDesc = 'DISPLAY_NAME_DESC',
  LotteryIdAsc = 'LOTTERY_ID_ASC',
  LotteryIdDesc = 'LOTTERY_ID_DESC',
  Natural = 'NATURAL',
  PaymentReferenceAsc = 'PAYMENT_REFERENCE_ASC',
  PaymentReferenceDesc = 'PAYMENT_REFERENCE_DESC',
  TicketsAsc = 'TICKETS_ASC',
  TicketsDesc = 'TICKETS_DESC'
}

/**
 * A condition to be used against `LotteryEntry` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LotteryEntryCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalizedNetFee` field. */
  amountNormalizedNetFee?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `anonymous` field. */
  anonymous?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `feeNormalized` field. */
  feeNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `giftAid` field. */
  giftAid?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `lotteryId` field. */
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `paymentId` field. */
  paymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `total` field. */
  total?: InputMaybe<Scalars['BigFloat']>;
};

export type LotteryEntryPublic = {
  __typename?: 'LotteryEntryPublic';
  amount?: Maybe<Scalars['BigFloat']>;
  amountNormalized?: Maybe<Scalars['BigFloat']>;
  amountNormalizedNetFee?: Maybe<Scalars['BigFloat']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  currencyCode?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  feeNormalized?: Maybe<Scalars['BigFloat']>;
  giftAid?: Maybe<Scalars['BigFloat']>;
  lotteryId?: Maybe<Scalars['BigInt']>;
  paymentReference?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `LotteryEntryPublic` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LotteryEntryPublicCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalizedNetFee` field. */
  amountNormalizedNetFee?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `displayName` field. */
  displayName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `feeNormalized` field. */
  feeNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `giftAid` field. */
  giftAid?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `lotteryId` field. */
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `paymentReference` field. */
  paymentReference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `total` field. */
  total?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `LotteryEntryPublic` values. */
export type LotteryEntryPublicsConnection = {
  __typename?: 'LotteryEntryPublicsConnection';
  /** A list of edges which contains the `LotteryEntryPublic` and cursor to aid in pagination. */
  edges: Array<LotteryEntryPublicsEdge>;
  /** A list of `LotteryEntryPublic` objects. */
  nodes: Array<Maybe<LotteryEntryPublic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LotteryEntryPublic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LotteryEntryPublic` edge in the connection. */
export type LotteryEntryPublicsEdge = {
  __typename?: 'LotteryEntryPublicsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LotteryEntryPublic` at the end of the edge. */
  node?: Maybe<LotteryEntryPublic>;
};

/** Methods to use when ordering `LotteryEntryPublic`. */
export enum LotteryEntryPublicsOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  AmountNormalizedNetFeeAsc = 'AMOUNT_NORMALIZED_NET_FEE_ASC',
  AmountNormalizedNetFeeDesc = 'AMOUNT_NORMALIZED_NET_FEE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DisplayNameAsc = 'DISPLAY_NAME_ASC',
  DisplayNameDesc = 'DISPLAY_NAME_DESC',
  FeeNormalizedAsc = 'FEE_NORMALIZED_ASC',
  FeeNormalizedDesc = 'FEE_NORMALIZED_DESC',
  GiftAidAsc = 'GIFT_AID_ASC',
  GiftAidDesc = 'GIFT_AID_DESC',
  LotteryIdAsc = 'LOTTERY_ID_ASC',
  LotteryIdDesc = 'LOTTERY_ID_DESC',
  Natural = 'NATURAL',
  PaymentReferenceAsc = 'PAYMENT_REFERENCE_ASC',
  PaymentReferenceDesc = 'PAYMENT_REFERENCE_DESC',
  TotalAsc = 'TOTAL_ASC',
  TotalDesc = 'TOTAL_DESC'
}

/** A connection to a list of `LotterySummary` values. */
export type LotterySummariesConnection = {
  __typename?: 'LotterySummariesConnection';
  /** A list of edges which contains the `LotterySummary` and cursor to aid in pagination. */
  edges: Array<LotterySummariesEdge>;
  /** A list of `LotterySummary` objects. */
  nodes: Array<Maybe<LotterySummary>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LotterySummary` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LotterySummary` edge in the connection. */
export type LotterySummariesEdge = {
  __typename?: 'LotterySummariesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LotterySummary` at the end of the edge. */
  node?: Maybe<LotterySummary>;
};

/** Methods to use when ordering `LotterySummary`. */
export enum LotterySummariesOrderBy {
  BenefactorLiabilityAsc = 'BENEFACTOR_LIABILITY_ASC',
  BenefactorLiabilityDesc = 'BENEFACTOR_LIABILITY_DESC',
  BenefactorStartingTicketNumberAsc = 'BENEFACTOR_STARTING_TICKET_NUMBER_ASC',
  BenefactorStartingTicketNumberDesc = 'BENEFACTOR_STARTING_TICKET_NUMBER_DESC',
  BenefactorWinsLastBlockAsc = 'BENEFACTOR_WINS_LAST_BLOCK_ASC',
  BenefactorWinsLastBlockDesc = 'BENEFACTOR_WINS_LAST_BLOCK_DESC',
  BlockSizeAsc = 'BLOCK_SIZE_ASC',
  BlockSizeDesc = 'BLOCK_SIZE_DESC',
  CloseTimestampAsc = 'CLOSE_TIMESTAMP_ASC',
  CloseTimestampDesc = 'CLOSE_TIMESTAMP_DESC',
  DrawEpochAsc = 'DRAW_EPOCH_ASC',
  DrawEpochDesc = 'DRAW_EPOCH_DESC',
  DrawTimestampAsc = 'DRAW_TIMESTAMP_ASC',
  DrawTimestampDesc = 'DRAW_TIMESTAMP_DESC',
  EntriesTotalNormalizedAsc = 'ENTRIES_TOTAL_NORMALIZED_ASC',
  EntriesTotalNormalizedDesc = 'ENTRIES_TOTAL_NORMALIZED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LockTimestampAsc = 'LOCK_TIMESTAMP_ASC',
  LockTimestampDesc = 'LOCK_TIMESTAMP_DESC',
  MaxBlockIdAsc = 'MAX_BLOCK_ID_ASC',
  MaxBlockIdDesc = 'MAX_BLOCK_ID_DESC',
  Natural = 'NATURAL',
  NumEntriesAsc = 'NUM_ENTRIES_ASC',
  NumEntriesDesc = 'NUM_ENTRIES_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TicketsAssignedAsc = 'TICKETS_ASSIGNED_ASC',
  TicketsAssignedDesc = 'TICKETS_ASSIGNED_DESC',
  WinningNumberAsc = 'WINNING_NUMBER_ASC',
  WinningNumberDesc = 'WINNING_NUMBER_DESC',
  WinningNumberHexAsc = 'WINNING_NUMBER_HEX_ASC',
  WinningNumberHexDesc = 'WINNING_NUMBER_HEX_DESC',
  WinningTicketsAsc = 'WINNING_TICKETS_ASC',
  WinningTicketsDesc = 'WINNING_TICKETS_DESC'
}

export type LotterySummary = {
  __typename?: 'LotterySummary';
  benefactorLiability?: Maybe<Scalars['BigFloat']>;
  benefactorStartingTicketNumber?: Maybe<Scalars['BigInt']>;
  benefactorWinsLastBlock?: Maybe<Scalars['Boolean']>;
  blockSize?: Maybe<Scalars['BigFloat']>;
  closeTimestamp?: Maybe<Scalars['Datetime']>;
  drawEpoch?: Maybe<Scalars['BigInt']>;
  drawTimestamp?: Maybe<Scalars['Datetime']>;
  entriesTotalNormalized?: Maybe<Scalars['BigFloat']>;
  id?: Maybe<Scalars['BigInt']>;
  lockTimestamp?: Maybe<Scalars['Datetime']>;
  maxBlockId?: Maybe<Scalars['Int']>;
  numEntries?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  ticketsAssigned?: Maybe<Scalars['Boolean']>;
  winningNumber?: Maybe<Scalars['BigInt']>;
  winningNumberHex?: Maybe<Scalars['String']>;
  winningTickets?: Maybe<Scalars['JSON']>;
};

/**
 * A condition to be used against `LotterySummary` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LotterySummaryCondition = {
  /** Checks for equality with the object’s `benefactorLiability` field. */
  benefactorLiability?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `benefactorStartingTicketNumber` field. */
  benefactorStartingTicketNumber?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `benefactorWinsLastBlock` field. */
  benefactorWinsLastBlock?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `blockSize` field. */
  blockSize?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `closeTimestamp` field. */
  closeTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `drawEpoch` field. */
  drawEpoch?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `drawTimestamp` field. */
  drawTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `entriesTotalNormalized` field. */
  entriesTotalNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `lockTimestamp` field. */
  lockTimestamp?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `maxBlockId` field. */
  maxBlockId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `numEntries` field. */
  numEntries?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `ticketsAssigned` field. */
  ticketsAssigned?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `winningNumber` field. */
  winningNumber?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `winningNumberHex` field. */
  winningNumberHex?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `winningTickets` field. */
  winningTickets?: InputMaybe<Scalars['JSON']>;
};

export type LotteryTicket = Node & {
  __typename?: 'LotteryTicket';
  blockId: Scalars['Int'];
  /** Reads a single `LotteryEntry` that is related to this `LotteryTicket`. */
  lotteryEntryByLotteryIdAndPaymentId?: Maybe<LotteryEntry>;
  lotteryId: Scalars['BigInt'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  paymentId: Scalars['BigInt'];
  winRange: BigIntRange;
};

/**
 * A condition to be used against `LotteryTicket` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LotteryTicketCondition = {
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lotteryId` field. */
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `paymentId` field. */
  paymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `winRange` field. */
  winRange?: InputMaybe<BigIntRangeInput>;
};

export type LotteryTicketPublic = {
  __typename?: 'LotteryTicketPublic';
  benefactor?: Maybe<Scalars['Boolean']>;
  blockId?: Maybe<Scalars['Int']>;
  lotteryId?: Maybe<Scalars['BigInt']>;
  paymentReference?: Maybe<Scalars['String']>;
  winRange?: Maybe<BigIntRange>;
};

/**
 * A condition to be used against `LotteryTicketPublic` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LotteryTicketPublicCondition = {
  /** Checks for equality with the object’s `benefactor` field. */
  benefactor?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lotteryId` field. */
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `paymentReference` field. */
  paymentReference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `winRange` field. */
  winRange?: InputMaybe<BigIntRangeInput>;
};

/** A connection to a list of `LotteryTicketPublic` values. */
export type LotteryTicketPublicsConnection = {
  __typename?: 'LotteryTicketPublicsConnection';
  /** A list of edges which contains the `LotteryTicketPublic` and cursor to aid in pagination. */
  edges: Array<LotteryTicketPublicsEdge>;
  /** A list of `LotteryTicketPublic` objects. */
  nodes: Array<Maybe<LotteryTicketPublic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LotteryTicketPublic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LotteryTicketPublic` edge in the connection. */
export type LotteryTicketPublicsEdge = {
  __typename?: 'LotteryTicketPublicsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LotteryTicketPublic` at the end of the edge. */
  node?: Maybe<LotteryTicketPublic>;
};

/** Methods to use when ordering `LotteryTicketPublic`. */
export enum LotteryTicketPublicsOrderBy {
  BenefactorAsc = 'BENEFACTOR_ASC',
  BenefactorDesc = 'BENEFACTOR_DESC',
  BlockIdAsc = 'BLOCK_ID_ASC',
  BlockIdDesc = 'BLOCK_ID_DESC',
  LotteryIdAsc = 'LOTTERY_ID_ASC',
  LotteryIdDesc = 'LOTTERY_ID_DESC',
  Natural = 'NATURAL',
  PaymentReferenceAsc = 'PAYMENT_REFERENCE_ASC',
  PaymentReferenceDesc = 'PAYMENT_REFERENCE_DESC',
  WinRangeAsc = 'WIN_RANGE_ASC',
  WinRangeDesc = 'WIN_RANGE_DESC'
}

/** A connection to a list of `LotteryTicket` values. */
export type LotteryTicketsConnection = {
  __typename?: 'LotteryTicketsConnection';
  /** A list of edges which contains the `LotteryTicket` and cursor to aid in pagination. */
  edges: Array<LotteryTicketsEdge>;
  /** A list of `LotteryTicket` objects. */
  nodes: Array<Maybe<LotteryTicket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LotteryTicket` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LotteryTicket` edge in the connection. */
export type LotteryTicketsEdge = {
  __typename?: 'LotteryTicketsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LotteryTicket` at the end of the edge. */
  node?: Maybe<LotteryTicket>;
};

/** Methods to use when ordering `LotteryTicket`. */
export enum LotteryTicketsOrderBy {
  BlockIdAsc = 'BLOCK_ID_ASC',
  BlockIdDesc = 'BLOCK_ID_DESC',
  LotteryIdAsc = 'LOTTERY_ID_ASC',
  LotteryIdDesc = 'LOTTERY_ID_DESC',
  Natural = 'NATURAL',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  WinRangeAsc = 'WIN_RANGE_ASC',
  WinRangeDesc = 'WIN_RANGE_DESC'
}

export type LotteryWinner = {
  __typename?: 'LotteryWinner';
  benefactor?: Maybe<Scalars['Boolean']>;
  blockId?: Maybe<Scalars['Int']>;
  lotteryId?: Maybe<Scalars['BigInt']>;
  paymentReference?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `LotteryWinner` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LotteryWinnerCondition = {
  /** Checks for equality with the object’s `benefactor` field. */
  benefactor?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lotteryId` field. */
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `paymentReference` field. */
  paymentReference?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `LotteryWinner` values. */
export type LotteryWinnersConnection = {
  __typename?: 'LotteryWinnersConnection';
  /** A list of edges which contains the `LotteryWinner` and cursor to aid in pagination. */
  edges: Array<LotteryWinnersEdge>;
  /** A list of `LotteryWinner` objects. */
  nodes: Array<Maybe<LotteryWinner>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LotteryWinner` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LotteryWinner` edge in the connection. */
export type LotteryWinnersEdge = {
  __typename?: 'LotteryWinnersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LotteryWinner` at the end of the edge. */
  node?: Maybe<LotteryWinner>;
};

/** Methods to use when ordering `LotteryWinner`. */
export enum LotteryWinnersOrderBy {
  BenefactorAsc = 'BENEFACTOR_ASC',
  BenefactorDesc = 'BENEFACTOR_DESC',
  BlockIdAsc = 'BLOCK_ID_ASC',
  BlockIdDesc = 'BLOCK_ID_DESC',
  LotteryIdAsc = 'LOTTERY_ID_ASC',
  LotteryIdDesc = 'LOTTERY_ID_DESC',
  Natural = 'NATURAL',
  PaymentReferenceAsc = 'PAYMENT_REFERENCE_ASC',
  PaymentReferenceDesc = 'PAYMENT_REFERENCE_DESC'
}

/** All input for the `makeLotteryTicket` mutation. */
export type MakeLotteryTicketInput = {
  blockId?: InputMaybe<Scalars['Int']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  paymentId?: InputMaybe<Scalars['BigInt']>;
  previousHigh?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `makeLotteryTicket` mutation. */
export type MakeLotteryTicketPayload = {
  __typename?: 'MakeLotteryTicketPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  lotteryTickets?: Maybe<Array<Maybe<LotteryTicket>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  addWinningNumber?: Maybe<AddWinningNumberPayload>;
  anonymizePerson?: Maybe<AnonymizePersonPayload>;
  cancelRecurringPayment?: Maybe<CancelRecurringPaymentPayload>;
  cancelRecurringReportedDonation?: Maybe<CancelRecurringReportedDonationPayload>;
  createAcquisition?: Maybe<CreateAcquisitionPayload>;
  createAddressByPersonId?: Maybe<CreateAddressByPersonIdPayload>;
  createAddressByPersonOrTemporaryPerson?: Maybe<CreateAddressByPersonOrTemporaryPersonPayload>;
  createAddressByTemporaryPerson?: Maybe<CreateAddressByTemporaryPersonPayload>;
  createExternalOrganization?: Maybe<CreateExternalOrganizationPayload>;
  createGiftAidClaim?: Maybe<CreateGiftAidClaimPayload>;
  createGiftAidClaimFromPayment?: Maybe<CreateGiftAidClaimFromPaymentPayload>;
  createGiftAidFromPayment?: Maybe<CreateGiftAidFromPaymentPayload>;
  createGocardlessRedirectFlow?: Maybe<CreateGocardlessRedirectFlowPayload>;
  createGocardlessRedirectFlowByPersonOrTemporaryPerson?: Maybe<CreateGocardlessRedirectFlowByPersonOrTemporaryPersonPayload>;
  createGocardlessRedirectFlowByTemporaryPerson?: Maybe<CreateGocardlessRedirectFlowByTemporaryPersonPayload>;
  createIncome?: Maybe<CreateIncomePayload>;
  createLotteryEntry?: Maybe<CreateLotteryEntryPayload>;
  createPaymentBatch?: Maybe<CreatePaymentBatchPayload>;
  createPaymentByPersonId?: Maybe<CreatePaymentByPersonIdPayload>;
  createPaymentByTemporaryPerson?: Maybe<CreatePaymentByTemporaryPersonPayload>;
  createPayrollGivingProviderCustomerBatch?: Maybe<CreatePayrollGivingProviderCustomerBatchPayload>;
  createPerson?: Maybe<CreatePersonPayload>;
  createPledge?: Maybe<CreatePledgePayload>;
  createPollOptionVote?: Maybe<CreatePollOptionVotePayload>;
  createRecurringPayment?: Maybe<CreateRecurringPaymentPayload>;
  createRecurringPaymentByTemporaryPerson?: Maybe<CreateRecurringPaymentByTemporaryPersonPayload>;
  createRecurringReportedDonation?: Maybe<CreateRecurringReportedDonationPayload>;
  createReportedDonationByPersonId?: Maybe<CreateReportedDonationByPersonIdPayload>;
  createTemporaryPersonByEmail?: Maybe<CreateTemporaryPersonByEmailPayload>;
  createdDueReportedDonationsByRecurringReportedDonation?: Maybe<CreatedDueReportedDonationsByRecurringReportedDonationPayload>;
  deleteGiftAidClaimFromPayment?: Maybe<DeleteGiftAidClaimFromPaymentPayload>;
  deleteIncome?: Maybe<DeleteIncomePayload>;
  deleteReportedDonation?: Maybe<DeleteReportedDonationPayload>;
  findOrRegisterPersonShadow?: Maybe<FindOrRegisterPersonShadowPayload>;
  generateEoyTaxReceipts?: Maybe<GenerateEoyTaxReceiptsPayload>;
  generateGiftAidClaimReports?: Maybe<GenerateGiftAidClaimReportsPayload>;
  generateLiability?: Maybe<GenerateLiabilityPayload>;
  generateLiabilityPaymentFromCompletionPayment?: Maybe<GenerateLiabilityPaymentFromCompletionPaymentPayload>;
  generateLotteryTickets?: Maybe<GenerateLotteryTicketsPayload>;
  getCurrentPersonId?: Maybe<GetCurrentPersonIdPayload>;
  getDaterangeOverlap?: Maybe<GetDaterangeOverlapPayload>;
  getPayrollGivingProviderCustomerBatch?: Maybe<GetPayrollGivingProviderCustomerBatchPayload>;
  insertGiftAidClaimReport?: Maybe<InsertGiftAidClaimReportPayload>;
  insertLotteryTicket?: Maybe<InsertLotteryTicketPayload>;
  isPaymentsManager?: Maybe<IsPaymentsManagerPayload>;
  makeLotteryTicket?: Maybe<MakeLotteryTicketPayload>;
  notifyLotteryWinners?: Maybe<NotifyLotteryWinnersPayload>;
  refreshExpiredToken?: Maybe<RefreshExpiredTokenPayload>;
  registerShadow?: Maybe<RegisterShadowPayload>;
  signPledge?: Maybe<SignPledgePayload>;
  syncAuth0User?: Maybe<SyncAuth0UserPayload>;
  updateContactPreferenceByPersonId?: Maybe<UpdateContactPreferenceByPersonIdPayload>;
  updateCryptoPaymentGatewayTransactionId?: Maybe<UpdateCryptoPaymentGatewayTransactionIdPayload>;
  updateIncome?: Maybe<UpdateIncomePayload>;
  updatePaymentStatus?: Maybe<UpdatePaymentStatusPayload>;
  updatePersonByPersonId?: Maybe<UpdatePersonByPersonIdPayload>;
  updatePersonEmail?: Maybe<UpdatePersonEmailPayload>;
  updatePersonEmailAuth0?: Maybe<UpdatePersonEmailAuth0Payload>;
  updatePersonEmailByEmail?: Maybe<UpdatePersonEmailByEmailPayload>;
  updatePledge?: Maybe<UpdatePledgePayload>;
  updateRecurringPaymentAmount?: Maybe<UpdateRecurringPaymentAmountPayload>;
  updateReportedDonation?: Maybe<UpdateReportedDonationPayload>;
  updateReportedPayment?: Maybe<UpdateReportedPaymentPayload>;
  updateSettingsPrivacy?: Maybe<UpdateSettingsPrivacyPayload>;
  upsertGivingWhatWeCanSurvey?: Maybe<UpsertGivingWhatWeCanSurveyPayload>;
  voidPayment?: Maybe<VoidPaymentPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddWinningNumberArgs = {
  input: AddWinningNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAnonymizePersonArgs = {
  input: AnonymizePersonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCancelRecurringPaymentArgs = {
  input: CancelRecurringPaymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCancelRecurringReportedDonationArgs = {
  input: CancelRecurringReportedDonationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAcquisitionArgs = {
  input: CreateAcquisitionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAddressByPersonIdArgs = {
  input: CreateAddressByPersonIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAddressByPersonOrTemporaryPersonArgs = {
  input: CreateAddressByPersonOrTemporaryPersonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAddressByTemporaryPersonArgs = {
  input: CreateAddressByTemporaryPersonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExternalOrganizationArgs = {
  input: CreateExternalOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGiftAidClaimArgs = {
  input: CreateGiftAidClaimInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGiftAidClaimFromPaymentArgs = {
  input: CreateGiftAidClaimFromPaymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGiftAidFromPaymentArgs = {
  input: CreateGiftAidFromPaymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGocardlessRedirectFlowArgs = {
  input: CreateGocardlessRedirectFlowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGocardlessRedirectFlowByPersonOrTemporaryPersonArgs = {
  input: CreateGocardlessRedirectFlowByPersonOrTemporaryPersonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGocardlessRedirectFlowByTemporaryPersonArgs = {
  input: CreateGocardlessRedirectFlowByTemporaryPersonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIncomeArgs = {
  input: CreateIncomeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLotteryEntryArgs = {
  input: CreateLotteryEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePaymentBatchArgs = {
  input: CreatePaymentBatchInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePaymentByPersonIdArgs = {
  input: CreatePaymentByPersonIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePaymentByTemporaryPersonArgs = {
  input: CreatePaymentByTemporaryPersonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePayrollGivingProviderCustomerBatchArgs = {
  input: CreatePayrollGivingProviderCustomerBatchInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePersonArgs = {
  input: CreatePersonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePledgeArgs = {
  input: CreatePledgeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePollOptionVoteArgs = {
  input: CreatePollOptionVoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRecurringPaymentArgs = {
  input: CreateRecurringPaymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRecurringPaymentByTemporaryPersonArgs = {
  input: CreateRecurringPaymentByTemporaryPersonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRecurringReportedDonationArgs = {
  input: CreateRecurringReportedDonationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateReportedDonationByPersonIdArgs = {
  input: CreateReportedDonationByPersonIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTemporaryPersonByEmailArgs = {
  input: CreateTemporaryPersonByEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatedDueReportedDonationsByRecurringReportedDonationArgs = {
  input: CreatedDueReportedDonationsByRecurringReportedDonationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGiftAidClaimFromPaymentArgs = {
  input: DeleteGiftAidClaimFromPaymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIncomeArgs = {
  input: DeleteIncomeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReportedDonationArgs = {
  input: DeleteReportedDonationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFindOrRegisterPersonShadowArgs = {
  input: FindOrRegisterPersonShadowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateEoyTaxReceiptsArgs = {
  input: GenerateEoyTaxReceiptsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateGiftAidClaimReportsArgs = {
  input: GenerateGiftAidClaimReportsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateLiabilityArgs = {
  input: GenerateLiabilityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateLiabilityPaymentFromCompletionPaymentArgs = {
  input: GenerateLiabilityPaymentFromCompletionPaymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateLotteryTicketsArgs = {
  input: GenerateLotteryTicketsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetCurrentPersonIdArgs = {
  input: GetCurrentPersonIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetDaterangeOverlapArgs = {
  input: GetDaterangeOverlapInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetPayrollGivingProviderCustomerBatchArgs = {
  input: GetPayrollGivingProviderCustomerBatchInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInsertGiftAidClaimReportArgs = {
  input: InsertGiftAidClaimReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInsertLotteryTicketArgs = {
  input: InsertLotteryTicketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationIsPaymentsManagerArgs = {
  input: IsPaymentsManagerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMakeLotteryTicketArgs = {
  input: MakeLotteryTicketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationNotifyLotteryWinnersArgs = {
  input: NotifyLotteryWinnersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRefreshExpiredTokenArgs = {
  input: RefreshExpiredTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegisterShadowArgs = {
  input: RegisterShadowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSignPledgeArgs = {
  input: SignPledgeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSyncAuth0UserArgs = {
  input: SyncAuth0UserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContactPreferenceByPersonIdArgs = {
  input: UpdateContactPreferenceByPersonIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCryptoPaymentGatewayTransactionIdArgs = {
  input: UpdateCryptoPaymentGatewayTransactionIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIncomeArgs = {
  input: UpdateIncomeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePaymentStatusArgs = {
  input: UpdatePaymentStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePersonByPersonIdArgs = {
  input: UpdatePersonByPersonIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePersonEmailArgs = {
  input: UpdatePersonEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePersonEmailAuth0Args = {
  input: UpdatePersonEmailAuth0Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePersonEmailByEmailArgs = {
  input: UpdatePersonEmailByEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePledgeArgs = {
  input: UpdatePledgeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRecurringPaymentAmountArgs = {
  input: UpdateRecurringPaymentAmountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReportedDonationArgs = {
  input: UpdateReportedDonationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReportedPaymentArgs = {
  input: UpdateReportedPaymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSettingsPrivacyArgs = {
  input: UpdateSettingsPrivacyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertGivingWhatWeCanSurveyArgs = {
  input: UpsertGivingWhatWeCanSurveyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVoidPaymentArgs = {
  input: VoidPaymentInput;
};

export type NewPledgeInfo = {
  __typename?: 'NewPledgeInfo';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  pledgePercentage?: Maybe<Scalars['BigFloat']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `NewPledgeInfo` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NewPledgeInfoCondition = {
  /** Checks for equality with the object’s `addressLine1` field. */
  addressLine1?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `addressLine2` field. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `countryCode` field. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `pledgePercentage` field. */
  pledgePercentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `postalCode` field. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `region` field. */
  region?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `NewPledgeInfo` values. */
export type NewPledgeInfosConnection = {
  __typename?: 'NewPledgeInfosConnection';
  /** A list of edges which contains the `NewPledgeInfo` and cursor to aid in pagination. */
  edges: Array<NewPledgeInfosEdge>;
  /** A list of `NewPledgeInfo` objects. */
  nodes: Array<Maybe<NewPledgeInfo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NewPledgeInfo` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `NewPledgeInfo` edge in the connection. */
export type NewPledgeInfosEdge = {
  __typename?: 'NewPledgeInfosEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `NewPledgeInfo` at the end of the edge. */
  node?: Maybe<NewPledgeInfo>;
};

/** Methods to use when ordering `NewPledgeInfo`. */
export enum NewPledgeInfosOrderBy {
  AddressLine_1Asc = 'ADDRESS_LINE_1_ASC',
  AddressLine_1Desc = 'ADDRESS_LINE_1_DESC',
  AddressLine_2Asc = 'ADDRESS_LINE_2_ASC',
  AddressLine_2Desc = 'ADDRESS_LINE_2_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  HouseNumberAsc = 'HOUSE_NUMBER_ASC',
  HouseNumberDesc = 'HOUSE_NUMBER_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PledgePercentageAsc = 'PLEDGE_PERCENTAGE_ASC',
  PledgePercentageDesc = 'PLEDGE_PERCENTAGE_DESC',
  PostalCodeAsc = 'POSTAL_CODE_ASC',
  PostalCodeDesc = 'POSTAL_CODE_DESC',
  RegionAsc = 'REGION_ASC',
  RegionDesc = 'REGION_DESC'
}

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/** A connection to a list of `NormalizedCurrency` values. */
export type NormalizedCurrenciesConnection = {
  __typename?: 'NormalizedCurrenciesConnection';
  /** A list of edges which contains the `NormalizedCurrency` and cursor to aid in pagination. */
  edges: Array<NormalizedCurrenciesEdge>;
  /** A list of `NormalizedCurrency` objects. */
  nodes: Array<Maybe<NormalizedCurrency>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NormalizedCurrency` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `NormalizedCurrency` edge in the connection. */
export type NormalizedCurrenciesEdge = {
  __typename?: 'NormalizedCurrenciesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `NormalizedCurrency` at the end of the edge. */
  node?: Maybe<NormalizedCurrency>;
};

/** Methods to use when ordering `NormalizedCurrency`. */
export enum NormalizedCurrenciesOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  CurrencyTypeAsc = 'CURRENCY_TYPE_ASC',
  CurrencyTypeDesc = 'CURRENCY_TYPE_DESC',
  DecimalsAsc = 'DECIMALS_ASC',
  DecimalsDesc = 'DECIMALS_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  SymbolAsc = 'SYMBOL_ASC',
  SymbolDesc = 'SYMBOL_DESC'
}

export type NormalizedCurrency = {
  __typename?: 'NormalizedCurrency';
  code?: Maybe<Scalars['String']>;
  currencyType?: Maybe<CurrencyType>;
  decimals?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `NormalizedCurrency` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NormalizedCurrencyCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `currencyType` field. */
  currencyType?: InputMaybe<CurrencyType>;
  /** Checks for equality with the object’s `decimals` field. */
  decimals?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `symbol` field. */
  symbol?: InputMaybe<Scalars['String']>;
};

/** All input for the `notifyLotteryWinners` mutation. */
export type NotifyLotteryWinnersInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lotteryId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `notifyLotteryWinners` mutation. */
export type NotifyLotteryWinnersPayload = {
  __typename?: 'NotifyLotteryWinnersPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Organization = Node & {
  __typename?: 'Organization';
  active: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `DisbursementEntry`. */
  disbursementEntriesByOrganizationSlug: DisbursementEntriesConnection;
  /** Reads and enables pagination through a set of `DisbursementEntry`. */
  disbursementEntriesByOrganizationSlugList: Array<DisbursementEntry>;
  /** Reads a single `ExternalOrganization` that is related to this `Organization`. */
  externalOrganizationByOrganizationSlug?: Maybe<ExternalOrganization>;
  /**
   * Reads and enables pagination through a set of `ExternalOrganization`.
   * @deprecated Please use externalOrganizationByOrganizationSlug instead
   */
  externalOrganizationsByOrganizationSlug: ExternalOrganizationsConnection;
  hidden?: Maybe<Scalars['Boolean']>;
  href?: Maybe<Scalars['String']>;
  isDataSharingPartner: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PaymentSharingConsent`. */
  paymentSharingConsentsByOrganizationSlug: PaymentSharingConsentsConnection;
  /** Reads and enables pagination through a set of `PaymentSharingConsent`. */
  paymentSharingConsentsByOrganizationSlugList: Array<PaymentSharingConsent>;
  program?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `RecipientProgram`. */
  recipientProgramsByOrganizationSlug: RecipientProgramsConnection;
  /** Reads and enables pagination through a set of `RecipientProgram`. */
  recipientProgramsByOrganizationSlugList: Array<RecipientProgram>;
  slug: Scalars['String'];
  sortOrder: Scalars['Int'];
  type?: Maybe<OrganizationType>;
  updatedAt: Scalars['Datetime'];
};


export type OrganizationDisbursementEntriesByOrganizationSlugArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DisbursementEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisbursementEntriesOrderBy>>;
};


export type OrganizationDisbursementEntriesByOrganizationSlugListArgs = {
  condition?: InputMaybe<DisbursementEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisbursementEntriesOrderBy>>;
};


export type OrganizationExternalOrganizationsByOrganizationSlugArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalOrganizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalOrganizationsOrderBy>>;
};


export type OrganizationPaymentSharingConsentsByOrganizationSlugArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentSharingConsentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSharingConsentsOrderBy>>;
};


export type OrganizationPaymentSharingConsentsByOrganizationSlugListArgs = {
  condition?: InputMaybe<PaymentSharingConsentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSharingConsentsOrderBy>>;
};


export type OrganizationRecipientProgramsByOrganizationSlugArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecipientProgramCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecipientProgramsOrderBy>>;
};


export type OrganizationRecipientProgramsByOrganizationSlugListArgs = {
  condition?: InputMaybe<RecipientProgramCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecipientProgramsOrderBy>>;
};

/** A connection to a list of `OrganizationCategory` values. */
export type OrganizationCategoriesConnection = {
  __typename?: 'OrganizationCategoriesConnection';
  /** A list of edges which contains the `OrganizationCategory` and cursor to aid in pagination. */
  edges: Array<OrganizationCategoriesEdge>;
  /** A list of `OrganizationCategory` objects. */
  nodes: Array<Maybe<OrganizationCategory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrganizationCategory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OrganizationCategory` edge in the connection. */
export type OrganizationCategoriesEdge = {
  __typename?: 'OrganizationCategoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OrganizationCategory` at the end of the edge. */
  node?: Maybe<OrganizationCategory>;
};

/** Methods to use when ordering `OrganizationCategory`. */
export enum OrganizationCategoriesOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC'
}

export type OrganizationCategory = Node & {
  __typename?: 'OrganizationCategory';
  description: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  slug: Scalars['String'];
  sortOrder: Scalars['Int'];
};

/**
 * A condition to be used against `OrganizationCategory` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type OrganizationCategoryCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `Organization` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OrganizationCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `hidden` field. */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `href` field. */
  href?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `isDataSharingPartner` field. */
  isDataSharingPartner?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `program` field. */
  program?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<OrganizationType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum OrganizationType {
  Fund = 'FUND',
  Meta = 'META',
  NonProfit = 'NON_PROFIT'
}

/** A connection to a list of `Organization` values. */
export type OrganizationsConnection = {
  __typename?: 'OrganizationsConnection';
  /** A list of edges which contains the `Organization` and cursor to aid in pagination. */
  edges: Array<OrganizationsEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<Organization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection. */
export type OrganizationsEdge = {
  __typename?: 'OrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node?: Maybe<Organization>;
};

/** Methods to use when ordering `Organization`. */
export enum OrganizationsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  HiddenAsc = 'HIDDEN_ASC',
  HiddenDesc = 'HIDDEN_DESC',
  HrefAsc = 'HREF_ASC',
  HrefDesc = 'HREF_DESC',
  IsDataSharingPartnerAsc = 'IS_DATA_SHARING_PARTNER_ASC',
  IsDataSharingPartnerDesc = 'IS_DATA_SHARING_PARTNER_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgramAsc = 'PROGRAM_ASC',
  ProgramDesc = 'PROGRAM_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

export type Payment = Node & {
  __typename?: 'Payment';
  /** Reads and enables pagination through a set of `AccountingInvoice`. */
  accountingInvoicesByPaymentId: AccountingInvoicesConnection;
  /** Reads and enables pagination through a set of `AccountingInvoice`. */
  accountingInvoicesByPaymentIdList: Array<AccountingInvoice>;
  /** Reads a single `Address` that is related to this `Payment`. */
  addressByBillingAddressId?: Maybe<Address>;
  allocation: Scalars['JSON'];
  /** The amount that was charged by the gateway after currency conversion. denominated in `currency_code` */
  amount?: Maybe<Scalars['BigFloat']>;
  amountNormalized?: Maybe<Scalars['BigFloat']>;
  billingAddressId?: Maybe<Scalars['BigInt']>;
  /** The amount that the user requested to be charged in their preferred currency, denominated in `charge_currency_code` */
  chargeAmount: Scalars['BigFloat'];
  chargeCurrencyCode: Scalars['String'];
  /** Reads and enables pagination through a set of `CompletionPayment`. */
  completionPaymentsByPaymentId: CompletionPaymentsConnection;
  /** Reads and enables pagination through a set of `CompletionPayment`. */
  completionPaymentsByPaymentIdList: Array<CompletionPayment>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByChargeCurrencyCode?: Maybe<Currency>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  currencyCode?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `DisbursementEntry`. */
  disbursementEntriesByPaymentId: DisbursementEntriesConnection;
  /** Reads and enables pagination through a set of `DisbursementEntry`. */
  disbursementEntriesByPaymentIdList: Array<DisbursementEntry>;
  fee?: Maybe<Scalars['BigFloat']>;
  feeNormalized?: Maybe<Scalars['BigFloat']>;
  gateway: PaymentGateway;
  gatewayData?: Maybe<Scalars['JSON']>;
  /** Reads a single `GatewayPaymentMethod` that is related to this `Payment`. */
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  /** Reads and enables pagination through a set of `GatewayPayoutReportEntry`. */
  gatewayPayoutReportEntriesByPaymentId: GatewayPayoutReportEntriesConnection;
  /** Reads and enables pagination through a set of `GatewayPayoutReportEntry`. */
  gatewayPayoutReportEntriesByPaymentIdList: Array<GatewayPayoutReportEntry>;
  gatewayTransactionId?: Maybe<Scalars['String']>;
  /** Reads a single `GiftAidClaim` that is related to this `Payment`. */
  giftAidClaimByGiftAidPaymentId?: Maybe<GiftAidClaim>;
  /**
   * Reads and enables pagination through a set of `GiftAidClaim`.
   * @deprecated Please use giftAidClaimByGiftAidPaymentId instead
   */
  giftAidClaimsByGiftAidPaymentId: GiftAidClaimsConnection;
  /** Reads and enables pagination through a set of `GiftAidClaim`. */
  giftAidClaimsByPaymentIdAndPersonId: GiftAidClaimsConnection;
  /** Reads and enables pagination through a set of `GiftAidClaim`. */
  giftAidClaimsByPaymentIdAndPersonIdList: Array<GiftAidClaim>;
  id: Scalars['BigInt'];
  /** Reads and enables pagination through a set of `LiabilityPayment`. */
  liabilityPaymentsByPaymentId: LiabilityPaymentsConnection;
  /** Reads and enables pagination through a set of `LiabilityPayment`. */
  liabilityPaymentsByPaymentIdList: Array<LiabilityPayment>;
  /**
   * Reads and enables pagination through a set of `LotteryEntry`.
   * @deprecated Please use lotteryEntryByPaymentId instead
   */
  lotteryEntriesByPaymentId: LotteryEntriesConnection;
  /** Reads a single `LotteryEntry` that is related to this `Payment`. */
  lotteryEntryByPaymentId?: Maybe<LotteryEntry>;
  metadata?: Maybe<Scalars['JSON']>;
  net?: Maybe<Scalars['BigFloat']>;
  netNormalized?: Maybe<Scalars['BigFloat']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PaymentAccessToken`. */
  paymentAccessTokensByPaymentIdAndPersonId: PaymentAccessTokensConnection;
  /** Reads and enables pagination through a set of `PaymentAccessToken`. */
  paymentAccessTokensByPaymentIdAndPersonIdList: Array<PaymentAccessToken>;
  paymentMethod?: Maybe<PaymentMethod>;
  /** Reads a single `PaymentRecipient` that is related to this `Payment`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Reads and enables pagination through a set of `PaymentSharingConsent`. */
  paymentSharingConsentsByPaymentId: PaymentSharingConsentsConnection;
  /** Reads and enables pagination through a set of `PaymentSharingConsent`. */
  paymentSharingConsentsByPaymentIdList: Array<PaymentSharingConsent>;
  /** Reads a single `Person` that is related to this `Payment`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  recipient: Scalars['String'];
  recurrence: PaymentRecurrence;
  reference?: Maybe<Scalars['String']>;
  status: PaymentStatus;
  statusData?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['Datetime'];
};


export type PaymentAccountingInvoicesByPaymentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountingInvoiceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountingInvoicesOrderBy>>;
};


export type PaymentAccountingInvoicesByPaymentIdListArgs = {
  condition?: InputMaybe<AccountingInvoiceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountingInvoicesOrderBy>>;
};


export type PaymentCompletionPaymentsByPaymentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompletionPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompletionPaymentsOrderBy>>;
};


export type PaymentCompletionPaymentsByPaymentIdListArgs = {
  condition?: InputMaybe<CompletionPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompletionPaymentsOrderBy>>;
};


export type PaymentDisbursementEntriesByPaymentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DisbursementEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisbursementEntriesOrderBy>>;
};


export type PaymentDisbursementEntriesByPaymentIdListArgs = {
  condition?: InputMaybe<DisbursementEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisbursementEntriesOrderBy>>;
};


export type PaymentGatewayPayoutReportEntriesByPaymentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GatewayPayoutReportEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportEntriesOrderBy>>;
};


export type PaymentGatewayPayoutReportEntriesByPaymentIdListArgs = {
  condition?: InputMaybe<GatewayPayoutReportEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportEntriesOrderBy>>;
};


export type PaymentGiftAidClaimsByGiftAidPaymentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GiftAidClaimCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimsOrderBy>>;
};


export type PaymentGiftAidClaimsByPaymentIdAndPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GiftAidClaimCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimsOrderBy>>;
};


export type PaymentGiftAidClaimsByPaymentIdAndPersonIdListArgs = {
  condition?: InputMaybe<GiftAidClaimCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimsOrderBy>>;
};


export type PaymentLiabilityPaymentsByPaymentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LiabilityPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityPaymentsOrderBy>>;
};


export type PaymentLiabilityPaymentsByPaymentIdListArgs = {
  condition?: InputMaybe<LiabilityPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityPaymentsOrderBy>>;
};


export type PaymentLotteryEntriesByPaymentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LotteryEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryEntriesOrderBy>>;
};


export type PaymentPaymentAccessTokensByPaymentIdAndPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentAccessTokenCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentAccessTokensOrderBy>>;
};


export type PaymentPaymentAccessTokensByPaymentIdAndPersonIdListArgs = {
  condition?: InputMaybe<PaymentAccessTokenCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentAccessTokensOrderBy>>;
};


export type PaymentPaymentSharingConsentsByPaymentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentSharingConsentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSharingConsentsOrderBy>>;
};


export type PaymentPaymentSharingConsentsByPaymentIdListArgs = {
  condition?: InputMaybe<PaymentSharingConsentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSharingConsentsOrderBy>>;
};

export type PaymentAccessToken = Node & {
  __typename?: 'PaymentAccessToken';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Payment` that is related to this `PaymentAccessToken`. */
  paymentByPaymentIdAndPersonId?: Maybe<Payment>;
  paymentId: Scalars['BigInt'];
  personId: Scalars['BigInt'];
  token: Scalars['UUID'];
  tokenExpiresAt: Scalars['Datetime'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `PaymentAccessToken` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PaymentAccessTokenCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `paymentId` field. */
  paymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `token` field. */
  token?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `tokenExpiresAt` field. */
  tokenExpiresAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `PaymentAccessToken` values. */
export type PaymentAccessTokensConnection = {
  __typename?: 'PaymentAccessTokensConnection';
  /** A list of edges which contains the `PaymentAccessToken` and cursor to aid in pagination. */
  edges: Array<PaymentAccessTokensEdge>;
  /** A list of `PaymentAccessToken` objects. */
  nodes: Array<Maybe<PaymentAccessToken>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PaymentAccessToken` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PaymentAccessToken` edge in the connection. */
export type PaymentAccessTokensEdge = {
  __typename?: 'PaymentAccessTokensEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PaymentAccessToken` at the end of the edge. */
  node?: Maybe<PaymentAccessToken>;
};

/** Methods to use when ordering `PaymentAccessToken`. */
export enum PaymentAccessTokensOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TokenAsc = 'TOKEN_ASC',
  TokenDesc = 'TOKEN_DESC',
  TokenExpiresAtAsc = 'TOKEN_EXPIRES_AT_ASC',
  TokenExpiresAtDesc = 'TOKEN_EXPIRES_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A condition to be used against `Payment` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PaymentCondition = {
  /** Checks for equality with the object’s `allocation` field. */
  allocation?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `billingAddressId` field. */
  billingAddressId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `chargeAmount` field. */
  chargeAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `chargeCurrencyCode` field. */
  chargeCurrencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `feeNormalized` field. */
  feeNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `gateway` field. */
  gateway?: InputMaybe<PaymentGateway>;
  /** Checks for equality with the object’s `gatewayData` field. */
  gatewayData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `gatewayTransactionId` field. */
  gatewayTransactionId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `net` field. */
  net?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `netNormalized` field. */
  netNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `paymentMethod` field. */
  paymentMethod?: InputMaybe<PaymentMethod>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `recurrence` field. */
  recurrence?: InputMaybe<PaymentRecurrence>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<PaymentStatus>;
  /** Checks for equality with the object’s `statusData` field. */
  statusData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type PaymentDetailsByOrganization = {
  __typename?: 'PaymentDetailsByOrganization';
  amountToOrg?: Maybe<Scalars['BigFloat']>;
  amountToOrgNormalized?: Maybe<Scalars['BigFloat']>;
  currencyCode?: Maybe<Scalars['String']>;
  disbursementName?: Maybe<Scalars['String']>;
  donationDate?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['BigFloat']>;
  feeToOrg?: Maybe<Scalars['BigFloat']>;
  feeToOrgNormalized?: Maybe<Scalars['BigFloat']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  net?: Maybe<Scalars['BigFloat']>;
  netToOrg?: Maybe<Scalars['BigFloat']>;
  netToOrgNormalized?: Maybe<Scalars['BigFloat']>;
  organization?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['BigInt']>;
  percentageToOrg?: Maybe<Scalars['String']>;
  personId?: Maybe<Scalars['BigInt']>;
  recurrence?: Maybe<PaymentRecurrence>;
  reference?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `PaymentDetailsByOrganization` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PaymentDetailsByOrganizationCondition = {
  /** Checks for equality with the object’s `amountToOrg` field. */
  amountToOrg?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountToOrgNormalized` field. */
  amountToOrgNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `disbursementName` field. */
  disbursementName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `donationDate` field. */
  donationDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `feeToOrg` field. */
  feeToOrg?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `feeToOrgNormalized` field. */
  feeToOrgNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `net` field. */
  net?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `netToOrg` field. */
  netToOrg?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `netToOrgNormalized` field. */
  netToOrgNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `organization` field. */
  organization?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `paymentId` field. */
  paymentId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `percentageToOrg` field. */
  percentageToOrg?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recurrence` field. */
  recurrence?: InputMaybe<PaymentRecurrence>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `total` field. */
  total?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `PaymentDetailsByOrganization` values. */
export type PaymentDetailsByOrganizationsConnection = {
  __typename?: 'PaymentDetailsByOrganizationsConnection';
  /** A list of edges which contains the `PaymentDetailsByOrganization` and cursor to aid in pagination. */
  edges: Array<PaymentDetailsByOrganizationsEdge>;
  /** A list of `PaymentDetailsByOrganization` objects. */
  nodes: Array<Maybe<PaymentDetailsByOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PaymentDetailsByOrganization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PaymentDetailsByOrganization` edge in the connection. */
export type PaymentDetailsByOrganizationsEdge = {
  __typename?: 'PaymentDetailsByOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PaymentDetailsByOrganization` at the end of the edge. */
  node?: Maybe<PaymentDetailsByOrganization>;
};

/** Methods to use when ordering `PaymentDetailsByOrganization`. */
export enum PaymentDetailsByOrganizationsOrderBy {
  AmountToOrgAsc = 'AMOUNT_TO_ORG_ASC',
  AmountToOrgDesc = 'AMOUNT_TO_ORG_DESC',
  AmountToOrgNormalizedAsc = 'AMOUNT_TO_ORG_NORMALIZED_ASC',
  AmountToOrgNormalizedDesc = 'AMOUNT_TO_ORG_NORMALIZED_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DisbursementNameAsc = 'DISBURSEMENT_NAME_ASC',
  DisbursementNameDesc = 'DISBURSEMENT_NAME_DESC',
  DonationDateAsc = 'DONATION_DATE_ASC',
  DonationDateDesc = 'DONATION_DATE_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FeeAsc = 'FEE_ASC',
  FeeDesc = 'FEE_DESC',
  FeeToOrgAsc = 'FEE_TO_ORG_ASC',
  FeeToOrgDesc = 'FEE_TO_ORG_DESC',
  FeeToOrgNormalizedAsc = 'FEE_TO_ORG_NORMALIZED_ASC',
  FeeToOrgNormalizedDesc = 'FEE_TO_ORG_NORMALIZED_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  NetAsc = 'NET_ASC',
  NetDesc = 'NET_DESC',
  NetToOrgAsc = 'NET_TO_ORG_ASC',
  NetToOrgDesc = 'NET_TO_ORG_DESC',
  NetToOrgNormalizedAsc = 'NET_TO_ORG_NORMALIZED_ASC',
  NetToOrgNormalizedDesc = 'NET_TO_ORG_NORMALIZED_DESC',
  OrganizationAsc = 'ORGANIZATION_ASC',
  OrganizationDesc = 'ORGANIZATION_DESC',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PercentageToOrgAsc = 'PERCENTAGE_TO_ORG_ASC',
  PercentageToOrgDesc = 'PERCENTAGE_TO_ORG_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  RecurrenceAsc = 'RECURRENCE_ASC',
  RecurrenceDesc = 'RECURRENCE_DESC',
  ReferenceAsc = 'REFERENCE_ASC',
  ReferenceDesc = 'REFERENCE_DESC',
  TotalAsc = 'TOTAL_ASC',
  TotalDesc = 'TOTAL_DESC'
}

export enum PaymentGateway {
  Crypto = 'CRYPTO',
  GiftAid = 'GIFT_AID',
  Gocardless = 'GOCARDLESS',
  Offline = 'OFFLINE',
  Paypal = 'PAYPAL',
  PayrollGiving = 'PAYROLL_GIVING',
  Stripe = 'STRIPE'
}

/** An input for mutations affecting `Payment` */
export type PaymentInput = {
  allocation: Scalars['JSON'];
  /** The amount that was charged by the gateway after currency conversion. denominated in `currency_code` */
  amount?: InputMaybe<Scalars['BigFloat']>;
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  billingAddressId?: InputMaybe<Scalars['BigInt']>;
  /** The amount that the user requested to be charged in their preferred currency, denominated in `charge_currency_code` */
  chargeAmount: Scalars['BigFloat'];
  chargeCurrencyCode: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  fee?: InputMaybe<Scalars['BigFloat']>;
  feeNormalized?: InputMaybe<Scalars['BigFloat']>;
  gateway: PaymentGateway;
  gatewayData?: InputMaybe<Scalars['JSON']>;
  gatewayTransactionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  net?: InputMaybe<Scalars['BigFloat']>;
  netNormalized?: InputMaybe<Scalars['BigFloat']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  personId: Scalars['BigInt'];
  recipient: Scalars['String'];
  recurrence?: InputMaybe<PaymentRecurrence>;
  reference?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PaymentStatus>;
  statusData?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum PaymentMethod {
  Acss = 'ACSS',
  BacsDirectDebit = 'BACS_DIRECT_DEBIT',
  BankTransfer = 'BANK_TRANSFER',
  Cheque = 'CHEQUE',
  CreditCard = 'CREDIT_CARD',
  Crypto = 'CRYPTO',
  PayrollGiving = 'PAYROLL_GIVING',
  Stock = 'STOCK'
}

export type PaymentRecipient = Node & {
  __typename?: 'PaymentRecipient';
  /** Reads a single `Country` that is related to this `PaymentRecipient`. */
  countryByCountryCode?: Maybe<Country>;
  countryCode: Scalars['String'];
  createdAt: Scalars['Datetime'];
  /** Reads a single `Currency` that is related to this `PaymentRecipient`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  currencyCode: Scalars['String'];
  /** Default timezone on tax receipts to this recipient */
  defaultTimezone: Scalars['String'];
  /** Reads and enables pagination through a set of `EoyTaxReceipt`. */
  eoyTaxReceiptsByRecipient: EoyTaxReceiptsConnection;
  /** Reads and enables pagination through a set of `EoyTaxReceipt`. */
  eoyTaxReceiptsByRecipientList: Array<EoyTaxReceipt>;
  /** Reads and enables pagination through a set of `FtxCoin`. */
  ftxCoinsByRecipient: FtxCoinsConnection;
  /** Reads and enables pagination through a set of `FtxCoin`. */
  ftxCoinsByRecipientList: Array<FtxCoin>;
  /** Reads and enables pagination through a set of `FtxConversion`. */
  ftxConversionsByRecipient: FtxConversionsConnection;
  /** Reads and enables pagination through a set of `FtxConversion`. */
  ftxConversionsByRecipientList: Array<FtxConversion>;
  /** Reads and enables pagination through a set of `GatewayPayoutReport`. */
  gatewayPayoutReportsByRecipient: GatewayPayoutReportsConnection;
  /** Reads and enables pagination through a set of `GatewayPayoutReport`. */
  gatewayPayoutReportsByRecipientList: Array<GatewayPayoutReport>;
  /** Reads and enables pagination through a set of `GocardlessCustomer`. */
  gocardlessCustomersByRecipient: GocardlessCustomersConnection;
  /** Reads and enables pagination through a set of `GocardlessCustomer`. */
  gocardlessCustomersByRecipientList: Array<GocardlessCustomer>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByRecipient: PaymentsConnection;
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByRecipientList: Array<Payment>;
  /** Reads and enables pagination through a set of `RecipientProgram`. */
  recipientProgramsByRecipientSlug: RecipientProgramsConnection;
  /** Reads and enables pagination through a set of `RecipientProgram`. */
  recipientProgramsByRecipientSlugList: Array<RecipientProgram>;
  /** Reads and enables pagination through a set of `RecurringPayment`. */
  recurringPaymentsByRecipient: RecurringPaymentsConnection;
  /** Reads and enables pagination through a set of `RecurringPayment`. */
  recurringPaymentsByRecipientList: Array<RecurringPayment>;
  slug: Scalars['String'];
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomersByRecipient: StripeCustomersConnection;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomersByRecipientList: Array<StripeCustomer>;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `XeroAccount`. */
  xeroAccountsByRecipient: XeroAccountsConnection;
  /** Reads and enables pagination through a set of `XeroAccount`. */
  xeroAccountsByRecipientList: Array<XeroAccount>;
  /** Reads and enables pagination through a set of `XeroContact`. */
  xeroContactsByRecipient: XeroContactsConnection;
  /** Reads and enables pagination through a set of `XeroContact`. */
  xeroContactsByRecipientList: Array<XeroContact>;
  /** Reads and enables pagination through a set of `XeroTracking`. */
  xeroTrackingsByRecipient: XeroTrackingsConnection;
  /** Reads and enables pagination through a set of `XeroTracking`. */
  xeroTrackingsByRecipientList: Array<XeroTracking>;
};


export type PaymentRecipientEoyTaxReceiptsByRecipientArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EoyTaxReceiptCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EoyTaxReceiptsOrderBy>>;
};


export type PaymentRecipientEoyTaxReceiptsByRecipientListArgs = {
  condition?: InputMaybe<EoyTaxReceiptCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EoyTaxReceiptsOrderBy>>;
};


export type PaymentRecipientFtxCoinsByRecipientArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FtxCoinCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxCoinsOrderBy>>;
};


export type PaymentRecipientFtxCoinsByRecipientListArgs = {
  condition?: InputMaybe<FtxCoinCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxCoinsOrderBy>>;
};


export type PaymentRecipientFtxConversionsByRecipientArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FtxConversionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxConversionsOrderBy>>;
};


export type PaymentRecipientFtxConversionsByRecipientListArgs = {
  condition?: InputMaybe<FtxConversionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxConversionsOrderBy>>;
};


export type PaymentRecipientGatewayPayoutReportsByRecipientArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GatewayPayoutReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportsOrderBy>>;
};


export type PaymentRecipientGatewayPayoutReportsByRecipientListArgs = {
  condition?: InputMaybe<GatewayPayoutReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportsOrderBy>>;
};


export type PaymentRecipientGocardlessCustomersByRecipientArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GocardlessCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessCustomersOrderBy>>;
};


export type PaymentRecipientGocardlessCustomersByRecipientListArgs = {
  condition?: InputMaybe<GocardlessCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessCustomersOrderBy>>;
};


export type PaymentRecipientPaymentsByRecipientArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type PaymentRecipientPaymentsByRecipientListArgs = {
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type PaymentRecipientRecipientProgramsByRecipientSlugArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecipientProgramCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecipientProgramsOrderBy>>;
};


export type PaymentRecipientRecipientProgramsByRecipientSlugListArgs = {
  condition?: InputMaybe<RecipientProgramCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecipientProgramsOrderBy>>;
};


export type PaymentRecipientRecurringPaymentsByRecipientArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};


export type PaymentRecipientRecurringPaymentsByRecipientListArgs = {
  condition?: InputMaybe<RecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};


export type PaymentRecipientStripeCustomersByRecipientArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StripeCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};


export type PaymentRecipientStripeCustomersByRecipientListArgs = {
  condition?: InputMaybe<StripeCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};


export type PaymentRecipientXeroAccountsByRecipientArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<XeroAccountCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroAccountsOrderBy>>;
};


export type PaymentRecipientXeroAccountsByRecipientListArgs = {
  condition?: InputMaybe<XeroAccountCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroAccountsOrderBy>>;
};


export type PaymentRecipientXeroContactsByRecipientArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<XeroContactCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroContactsOrderBy>>;
};


export type PaymentRecipientXeroContactsByRecipientListArgs = {
  condition?: InputMaybe<XeroContactCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroContactsOrderBy>>;
};


export type PaymentRecipientXeroTrackingsByRecipientArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<XeroTrackingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroTrackingsOrderBy>>;
};


export type PaymentRecipientXeroTrackingsByRecipientListArgs = {
  condition?: InputMaybe<XeroTrackingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroTrackingsOrderBy>>;
};

/**
 * A condition to be used against `PaymentRecipient` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PaymentRecipientCondition = {
  /** Checks for equality with the object’s `countryCode` field. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `defaultTimezone` field. */
  defaultTimezone?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type PaymentRecipientCountriesServiced = Node & {
  __typename?: 'PaymentRecipientCountriesServiced';
  countryCode: Scalars['String'];
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  recipient: Scalars['String'];
  taxDeductible: Scalars['Boolean'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `PaymentRecipientCountriesServiced` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type PaymentRecipientCountriesServicedCondition = {
  /** Checks for equality with the object’s `countryCode` field. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `taxDeductible` field. */
  taxDeductible?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `PaymentRecipientCountriesServiced` values. */
export type PaymentRecipientCountriesServicedsConnection = {
  __typename?: 'PaymentRecipientCountriesServicedsConnection';
  /** A list of edges which contains the `PaymentRecipientCountriesServiced` and cursor to aid in pagination. */
  edges: Array<PaymentRecipientCountriesServicedsEdge>;
  /** A list of `PaymentRecipientCountriesServiced` objects. */
  nodes: Array<Maybe<PaymentRecipientCountriesServiced>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PaymentRecipientCountriesServiced` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PaymentRecipientCountriesServiced` edge in the connection. */
export type PaymentRecipientCountriesServicedsEdge = {
  __typename?: 'PaymentRecipientCountriesServicedsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PaymentRecipientCountriesServiced` at the end of the edge. */
  node?: Maybe<PaymentRecipientCountriesServiced>;
};

/** Methods to use when ordering `PaymentRecipientCountriesServiced`. */
export enum PaymentRecipientCountriesServicedsOrderBy {
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  TaxDeductibleAsc = 'TAX_DEDUCTIBLE_ASC',
  TaxDeductibleDesc = 'TAX_DEDUCTIBLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A connection to a list of `PaymentRecipient` values. */
export type PaymentRecipientsConnection = {
  __typename?: 'PaymentRecipientsConnection';
  /** A list of edges which contains the `PaymentRecipient` and cursor to aid in pagination. */
  edges: Array<PaymentRecipientsEdge>;
  /** A list of `PaymentRecipient` objects. */
  nodes: Array<Maybe<PaymentRecipient>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PaymentRecipient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PaymentRecipient` edge in the connection. */
export type PaymentRecipientsEdge = {
  __typename?: 'PaymentRecipientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PaymentRecipient` at the end of the edge. */
  node?: Maybe<PaymentRecipient>;
};

/** Methods to use when ordering `PaymentRecipient`. */
export enum PaymentRecipientsOrderBy {
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DefaultTimezoneAsc = 'DEFAULT_TIMEZONE_ASC',
  DefaultTimezoneDesc = 'DEFAULT_TIMEZONE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum PaymentRecurrence {
  OneOff = 'ONE_OFF',
  Recurring = 'RECURRING'
}

export type PaymentReportByOrganization = {
  __typename?: 'PaymentReportByOrganization';
  amountToOrg?: Maybe<Scalars['BigFloat']>;
  amountToOrgNormalized?: Maybe<Scalars['BigFloat']>;
  anonymous?: Maybe<Scalars['Boolean']>;
  currencyCode?: Maybe<Scalars['String']>;
  disbursement?: Maybe<Scalars['String']>;
  donationDate?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['BigFloat']>;
  feeToOrg?: Maybe<Scalars['BigFloat']>;
  feeToOrgNormalized?: Maybe<Scalars['BigFloat']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  net?: Maybe<Scalars['BigFloat']>;
  netToOrg?: Maybe<Scalars['BigFloat']>;
  netToOrgNormalized?: Maybe<Scalars['BigFloat']>;
  organization?: Maybe<Scalars['String']>;
  percentageToOrg?: Maybe<Scalars['String']>;
  recurrence?: Maybe<PaymentRecurrence>;
  reference?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `PaymentReportByOrganization` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PaymentReportByOrganizationCondition = {
  /** Checks for equality with the object’s `amountToOrg` field. */
  amountToOrg?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountToOrgNormalized` field. */
  amountToOrgNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `anonymous` field. */
  anonymous?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `disbursement` field. */
  disbursement?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `donationDate` field. */
  donationDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `feeToOrg` field. */
  feeToOrg?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `feeToOrgNormalized` field. */
  feeToOrgNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `net` field. */
  net?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `netToOrg` field. */
  netToOrg?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `netToOrgNormalized` field. */
  netToOrgNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `organization` field. */
  organization?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `percentageToOrg` field. */
  percentageToOrg?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `recurrence` field. */
  recurrence?: InputMaybe<PaymentRecurrence>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `total` field. */
  total?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `PaymentReportByOrganization` values. */
export type PaymentReportByOrganizationsConnection = {
  __typename?: 'PaymentReportByOrganizationsConnection';
  /** A list of edges which contains the `PaymentReportByOrganization` and cursor to aid in pagination. */
  edges: Array<PaymentReportByOrganizationsEdge>;
  /** A list of `PaymentReportByOrganization` objects. */
  nodes: Array<Maybe<PaymentReportByOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PaymentReportByOrganization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PaymentReportByOrganization` edge in the connection. */
export type PaymentReportByOrganizationsEdge = {
  __typename?: 'PaymentReportByOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PaymentReportByOrganization` at the end of the edge. */
  node?: Maybe<PaymentReportByOrganization>;
};

/** Methods to use when ordering `PaymentReportByOrganization`. */
export enum PaymentReportByOrganizationsOrderBy {
  AmountToOrgAsc = 'AMOUNT_TO_ORG_ASC',
  AmountToOrgDesc = 'AMOUNT_TO_ORG_DESC',
  AmountToOrgNormalizedAsc = 'AMOUNT_TO_ORG_NORMALIZED_ASC',
  AmountToOrgNormalizedDesc = 'AMOUNT_TO_ORG_NORMALIZED_DESC',
  AnonymousAsc = 'ANONYMOUS_ASC',
  AnonymousDesc = 'ANONYMOUS_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DisbursementAsc = 'DISBURSEMENT_ASC',
  DisbursementDesc = 'DISBURSEMENT_DESC',
  DonationDateAsc = 'DONATION_DATE_ASC',
  DonationDateDesc = 'DONATION_DATE_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FeeAsc = 'FEE_ASC',
  FeeDesc = 'FEE_DESC',
  FeeToOrgAsc = 'FEE_TO_ORG_ASC',
  FeeToOrgDesc = 'FEE_TO_ORG_DESC',
  FeeToOrgNormalizedAsc = 'FEE_TO_ORG_NORMALIZED_ASC',
  FeeToOrgNormalizedDesc = 'FEE_TO_ORG_NORMALIZED_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  NetAsc = 'NET_ASC',
  NetDesc = 'NET_DESC',
  NetToOrgAsc = 'NET_TO_ORG_ASC',
  NetToOrgDesc = 'NET_TO_ORG_DESC',
  NetToOrgNormalizedAsc = 'NET_TO_ORG_NORMALIZED_ASC',
  NetToOrgNormalizedDesc = 'NET_TO_ORG_NORMALIZED_DESC',
  OrganizationAsc = 'ORGANIZATION_ASC',
  OrganizationDesc = 'ORGANIZATION_DESC',
  PercentageToOrgAsc = 'PERCENTAGE_TO_ORG_ASC',
  PercentageToOrgDesc = 'PERCENTAGE_TO_ORG_DESC',
  RecurrenceAsc = 'RECURRENCE_ASC',
  RecurrenceDesc = 'RECURRENCE_DESC',
  ReferenceAsc = 'REFERENCE_ASC',
  ReferenceDesc = 'REFERENCE_DESC',
  TotalAsc = 'TOTAL_ASC',
  TotalDesc = 'TOTAL_DESC'
}

export type PaymentSharingConsent = Node & {
  __typename?: 'PaymentSharingConsent';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `PaymentSharingConsent`. */
  organizationByOrganizationSlug?: Maybe<Organization>;
  organizationSlug: Scalars['String'];
  /** Reads a single `Payment` that is related to this `PaymentSharingConsent`. */
  paymentByPaymentId?: Maybe<Payment>;
  paymentId: Scalars['BigInt'];
};

/**
 * A condition to be used against `PaymentSharingConsent` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PaymentSharingConsentCondition = {
  /** Checks for equality with the object’s `organizationSlug` field. */
  organizationSlug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `paymentId` field. */
  paymentId?: InputMaybe<Scalars['BigInt']>;
};

/** A connection to a list of `PaymentSharingConsent` values. */
export type PaymentSharingConsentsConnection = {
  __typename?: 'PaymentSharingConsentsConnection';
  /** A list of edges which contains the `PaymentSharingConsent` and cursor to aid in pagination. */
  edges: Array<PaymentSharingConsentsEdge>;
  /** A list of `PaymentSharingConsent` objects. */
  nodes: Array<Maybe<PaymentSharingConsent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PaymentSharingConsent` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PaymentSharingConsent` edge in the connection. */
export type PaymentSharingConsentsEdge = {
  __typename?: 'PaymentSharingConsentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PaymentSharingConsent` at the end of the edge. */
  node?: Maybe<PaymentSharingConsent>;
};

/** Methods to use when ordering `PaymentSharingConsent`. */
export enum PaymentSharingConsentsOrderBy {
  Natural = 'NATURAL',
  OrganizationSlugAsc = 'ORGANIZATION_SLUG_ASC',
  OrganizationSlugDesc = 'ORGANIZATION_SLUG_DESC',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type PaymentStatsAggregate = {
  __typename?: 'PaymentStatsAggregate';
  numDonations?: Maybe<Scalars['BigInt']>;
  numDonationsLastYear?: Maybe<Scalars['BigInt']>;
  numDonors?: Maybe<Scalars['BigInt']>;
  numDonorsLastYear?: Maybe<Scalars['BigInt']>;
  totalDonations?: Maybe<Scalars['BigFloat']>;
  totalDonationsLastYear?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `PaymentStatsAggregate` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PaymentStatsAggregateCondition = {
  /** Checks for equality with the object’s `numDonations` field. */
  numDonations?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `numDonationsLastYear` field. */
  numDonationsLastYear?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `numDonors` field. */
  numDonors?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `numDonorsLastYear` field. */
  numDonorsLastYear?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `totalDonations` field. */
  totalDonations?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `totalDonationsLastYear` field. */
  totalDonationsLastYear?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `PaymentStatsAggregate` values. */
export type PaymentStatsAggregatesConnection = {
  __typename?: 'PaymentStatsAggregatesConnection';
  /** A list of edges which contains the `PaymentStatsAggregate` and cursor to aid in pagination. */
  edges: Array<PaymentStatsAggregatesEdge>;
  /** A list of `PaymentStatsAggregate` objects. */
  nodes: Array<Maybe<PaymentStatsAggregate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PaymentStatsAggregate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PaymentStatsAggregate` edge in the connection. */
export type PaymentStatsAggregatesEdge = {
  __typename?: 'PaymentStatsAggregatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PaymentStatsAggregate` at the end of the edge. */
  node?: Maybe<PaymentStatsAggregate>;
};

/** Methods to use when ordering `PaymentStatsAggregate`. */
export enum PaymentStatsAggregatesOrderBy {
  Natural = 'NATURAL',
  NumDonationsAsc = 'NUM_DONATIONS_ASC',
  NumDonationsDesc = 'NUM_DONATIONS_DESC',
  NumDonationsLastYearAsc = 'NUM_DONATIONS_LAST_YEAR_ASC',
  NumDonationsLastYearDesc = 'NUM_DONATIONS_LAST_YEAR_DESC',
  NumDonorsAsc = 'NUM_DONORS_ASC',
  NumDonorsDesc = 'NUM_DONORS_DESC',
  NumDonorsLastYearAsc = 'NUM_DONORS_LAST_YEAR_ASC',
  NumDonorsLastYearDesc = 'NUM_DONORS_LAST_YEAR_DESC',
  TotalDonationsAsc = 'TOTAL_DONATIONS_ASC',
  TotalDonationsDesc = 'TOTAL_DONATIONS_DESC',
  TotalDonationsLastYearAsc = 'TOTAL_DONATIONS_LAST_YEAR_ASC',
  TotalDonationsLastYearDesc = 'TOTAL_DONATIONS_LAST_YEAR_DESC'
}

export type PaymentStatsByOrganization = {
  __typename?: 'PaymentStatsByOrganization';
  numDonations?: Maybe<Scalars['BigInt']>;
  numDonationsLastYear?: Maybe<Scalars['BigInt']>;
  numDonors?: Maybe<Scalars['BigInt']>;
  numDonorsLastYear?: Maybe<Scalars['BigInt']>;
  organization?: Maybe<Scalars['String']>;
  totalDonations?: Maybe<Scalars['BigFloat']>;
  totalDonationsLastYear?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `PaymentStatsByOrganization` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PaymentStatsByOrganizationCondition = {
  /** Checks for equality with the object’s `numDonations` field. */
  numDonations?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `numDonationsLastYear` field. */
  numDonationsLastYear?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `numDonors` field. */
  numDonors?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `numDonorsLastYear` field. */
  numDonorsLastYear?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `organization` field. */
  organization?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `totalDonations` field. */
  totalDonations?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `totalDonationsLastYear` field. */
  totalDonationsLastYear?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `PaymentStatsByOrganization` values. */
export type PaymentStatsByOrganizationsConnection = {
  __typename?: 'PaymentStatsByOrganizationsConnection';
  /** A list of edges which contains the `PaymentStatsByOrganization` and cursor to aid in pagination. */
  edges: Array<PaymentStatsByOrganizationsEdge>;
  /** A list of `PaymentStatsByOrganization` objects. */
  nodes: Array<Maybe<PaymentStatsByOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PaymentStatsByOrganization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PaymentStatsByOrganization` edge in the connection. */
export type PaymentStatsByOrganizationsEdge = {
  __typename?: 'PaymentStatsByOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PaymentStatsByOrganization` at the end of the edge. */
  node?: Maybe<PaymentStatsByOrganization>;
};

/** Methods to use when ordering `PaymentStatsByOrganization`. */
export enum PaymentStatsByOrganizationsOrderBy {
  Natural = 'NATURAL',
  NumDonationsAsc = 'NUM_DONATIONS_ASC',
  NumDonationsDesc = 'NUM_DONATIONS_DESC',
  NumDonationsLastYearAsc = 'NUM_DONATIONS_LAST_YEAR_ASC',
  NumDonationsLastYearDesc = 'NUM_DONATIONS_LAST_YEAR_DESC',
  NumDonorsAsc = 'NUM_DONORS_ASC',
  NumDonorsDesc = 'NUM_DONORS_DESC',
  NumDonorsLastYearAsc = 'NUM_DONORS_LAST_YEAR_ASC',
  NumDonorsLastYearDesc = 'NUM_DONORS_LAST_YEAR_DESC',
  OrganizationAsc = 'ORGANIZATION_ASC',
  OrganizationDesc = 'ORGANIZATION_DESC',
  TotalDonationsAsc = 'TOTAL_DONATIONS_ASC',
  TotalDonationsDesc = 'TOTAL_DONATIONS_DESC',
  TotalDonationsLastYearAsc = 'TOTAL_DONATIONS_LAST_YEAR_ASC',
  TotalDonationsLastYearDesc = 'TOTAL_DONATIONS_LAST_YEAR_DESC'
}

export enum PaymentStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Succeeded = 'SUCCEEDED',
  Unpaid = 'UNPAID',
  Voided = 'VOIDED'
}

/** A connection to a list of `Payment` values. */
export type PaymentsConnection = {
  __typename?: 'PaymentsConnection';
  /** A list of edges which contains the `Payment` and cursor to aid in pagination. */
  edges: Array<PaymentsEdge>;
  /** A list of `Payment` objects. */
  nodes: Array<Maybe<Payment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Payment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Payment` edge in the connection. */
export type PaymentsEdge = {
  __typename?: 'PaymentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Payment` at the end of the edge. */
  node?: Maybe<Payment>;
};

export type PaymentsManager = Node & {
  __typename?: 'PaymentsManager';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Person` that is related to this `PaymentsManager`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `PaymentsManager` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PaymentsManagerCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `PaymentsManager` values. */
export type PaymentsManagersConnection = {
  __typename?: 'PaymentsManagersConnection';
  /** A list of edges which contains the `PaymentsManager` and cursor to aid in pagination. */
  edges: Array<PaymentsManagersEdge>;
  /** A list of `PaymentsManager` objects. */
  nodes: Array<Maybe<PaymentsManager>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PaymentsManager` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PaymentsManager` edge in the connection. */
export type PaymentsManagersEdge = {
  __typename?: 'PaymentsManagersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PaymentsManager` at the end of the edge. */
  node?: Maybe<PaymentsManager>;
};

/** Methods to use when ordering `PaymentsManager`. */
export enum PaymentsManagersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Methods to use when ordering `Payment`. */
export enum PaymentsOrderBy {
  AllocationAsc = 'ALLOCATION_ASC',
  AllocationDesc = 'ALLOCATION_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  BillingAddressIdAsc = 'BILLING_ADDRESS_ID_ASC',
  BillingAddressIdDesc = 'BILLING_ADDRESS_ID_DESC',
  ChargeAmountAsc = 'CHARGE_AMOUNT_ASC',
  ChargeAmountDesc = 'CHARGE_AMOUNT_DESC',
  ChargeCurrencyCodeAsc = 'CHARGE_CURRENCY_CODE_ASC',
  ChargeCurrencyCodeDesc = 'CHARGE_CURRENCY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  FeeAsc = 'FEE_ASC',
  FeeDesc = 'FEE_DESC',
  FeeNormalizedAsc = 'FEE_NORMALIZED_ASC',
  FeeNormalizedDesc = 'FEE_NORMALIZED_DESC',
  GatewayAsc = 'GATEWAY_ASC',
  GatewayDataAsc = 'GATEWAY_DATA_ASC',
  GatewayDataDesc = 'GATEWAY_DATA_DESC',
  GatewayDesc = 'GATEWAY_DESC',
  GatewayTransactionIdAsc = 'GATEWAY_TRANSACTION_ID_ASC',
  GatewayTransactionIdDesc = 'GATEWAY_TRANSACTION_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MetadataAsc = 'METADATA_ASC',
  MetadataDesc = 'METADATA_DESC',
  Natural = 'NATURAL',
  NetAsc = 'NET_ASC',
  NetDesc = 'NET_DESC',
  NetNormalizedAsc = 'NET_NORMALIZED_ASC',
  NetNormalizedDesc = 'NET_NORMALIZED_DESC',
  PaymentMethodAsc = 'PAYMENT_METHOD_ASC',
  PaymentMethodDesc = 'PAYMENT_METHOD_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  RecurrenceAsc = 'RECURRENCE_ASC',
  RecurrenceDesc = 'RECURRENCE_DESC',
  ReferenceAsc = 'REFERENCE_ASC',
  ReferenceDesc = 'REFERENCE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDataAsc = 'STATUS_DATA_ASC',
  StatusDataDesc = 'STATUS_DATA_DESC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum PayrollGivingProvider {
  Benevity = 'BENEVITY',
  BtMydonate = 'BT_MYDONATE',
  CharitiesAidFoundationDirectGiving = 'CHARITIES_AID_FOUNDATION_DIRECT_GIVING',
  CharitiesAidFoundationPayrollGiving = 'CHARITIES_AID_FOUNDATION_PAYROLL_GIVING',
  CharitiesTrust = 'CHARITIES_TRUST'
}

export type PayrollGivingProviderCustomer = Node & {
  __typename?: 'PayrollGivingProviderCustomer';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Person` that is related to this `PayrollGivingProviderCustomer`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  provider: PayrollGivingProvider;
  providerCustomerId: Scalars['String'];
};

/**
 * A condition to be used against `PayrollGivingProviderCustomer` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PayrollGivingProviderCustomerCondition = {
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<PayrollGivingProvider>;
  /** Checks for equality with the object’s `providerCustomerId` field. */
  providerCustomerId?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `PayrollGivingProviderCustomer` */
export type PayrollGivingProviderCustomerInput = {
  personId: Scalars['BigInt'];
  provider: PayrollGivingProvider;
  providerCustomerId: Scalars['String'];
};

/** A connection to a list of `PayrollGivingProviderCustomer` values. */
export type PayrollGivingProviderCustomersConnection = {
  __typename?: 'PayrollGivingProviderCustomersConnection';
  /** A list of edges which contains the `PayrollGivingProviderCustomer` and cursor to aid in pagination. */
  edges: Array<PayrollGivingProviderCustomersEdge>;
  /** A list of `PayrollGivingProviderCustomer` objects. */
  nodes: Array<Maybe<PayrollGivingProviderCustomer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PayrollGivingProviderCustomer` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PayrollGivingProviderCustomer` edge in the connection. */
export type PayrollGivingProviderCustomersEdge = {
  __typename?: 'PayrollGivingProviderCustomersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PayrollGivingProviderCustomer` at the end of the edge. */
  node?: Maybe<PayrollGivingProviderCustomer>;
};

/** Methods to use when ordering `PayrollGivingProviderCustomer`. */
export enum PayrollGivingProviderCustomersOrderBy {
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderAsc = 'PROVIDER_ASC',
  ProviderCustomerIdAsc = 'PROVIDER_CUSTOMER_ID_ASC',
  ProviderCustomerIdDesc = 'PROVIDER_CUSTOMER_ID_DESC',
  ProviderDesc = 'PROVIDER_DESC'
}

/** A connection to a list of `Person` values. */
export type PeopleConnection = {
  __typename?: 'PeopleConnection';
  /** A list of edges which contains the `Person` and cursor to aid in pagination. */
  edges: Array<PeopleEdge>;
  /** A list of `Person` objects. */
  nodes: Array<Maybe<Person>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Person` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Person` edge in the connection. */
export type PeopleEdge = {
  __typename?: 'PeopleEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Person` at the end of the edge. */
  node?: Maybe<Person>;
};

/** Methods to use when ordering `Person`. */
export enum PeopleOrderBy {
  Auth0UserIdAsc = 'AUTH0_USER_ID_ASC',
  Auth0UserIdDesc = 'AUTH0_USER_ID_DESC',
  BirthDateAsc = 'BIRTH_DATE_ASC',
  BirthDateDesc = 'BIRTH_DATE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  FullNameAsc = 'FULL_NAME_ASC',
  FullNameDesc = 'FULL_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsAnonymizedAsc = 'IS_ANONYMIZED_ASC',
  IsAnonymizedDesc = 'IS_ANONYMIZED_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type Person = Node & {
  __typename?: 'Person';
  /** Reads and enables pagination through a set of `Acquisition`. */
  acquisitionsByPersonId: AcquisitionsConnection;
  /** Reads and enables pagination through a set of `Acquisition`. */
  acquisitionsByPersonIdList: Array<Acquisition>;
  /** Reads and enables pagination through a set of `AddressBackup`. */
  addressBackupsByPersonId: AddressBackupsConnection;
  /** Reads and enables pagination through a set of `AddressBackup`. */
  addressBackupsByPersonIdList: Array<AddressBackup>;
  /** Reads and enables pagination through a set of `Address`. */
  addressesByPersonId: AddressesConnection;
  /** Reads and enables pagination through a set of `Address`. */
  addressesByPersonIdList: Array<Address>;
  /** Reads a single `Allocation` that is related to this `Person`. */
  allocationByPersonId?: Maybe<Allocation>;
  /**
   * Reads and enables pagination through a set of `Allocation`.
   * @deprecated Please use allocationByPersonId instead
   */
  allocationsByPersonId: AllocationsConnection;
  auth0UserId?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['Date']>;
  /** Reads a single `ContactPreference` that is related to this `Person`. */
  contactPreferenceByPersonId?: Maybe<ContactPreference>;
  /**
   * Reads and enables pagination through a set of `ContactPreference`.
   * @deprecated Please use contactPreferenceByPersonId instead
   */
  contactPreferencesByPersonId: ContactPreferencesConnection;
  createdAt: Scalars['Datetime'];
  email?: Maybe<Scalars['String']>;
  /** Reads a single `EmailAddress` that is related to this `Person`. */
  emailAddressByIdAndEmail?: Maybe<EmailAddress>;
  /** Reads and enables pagination through a set of `EmailAddress`. */
  emailAddressesByPersonId: EmailAddressesConnection;
  /** Reads and enables pagination through a set of `EmailAddress`. */
  emailAddressesByPersonIdList: Array<EmailAddress>;
  /** Reads and enables pagination through a set of `EoyTaxReceipt`. */
  eoyTaxReceiptsByPersonId: EoyTaxReceiptsConnection;
  /** Reads and enables pagination through a set of `EoyTaxReceipt`. */
  eoyTaxReceiptsByPersonIdList: Array<EoyTaxReceipt>;
  /** Reads and enables pagination through a set of `FailedRecurringPayment`. */
  failedRecurringPaymentsByPersonId: FailedRecurringPaymentsConnection;
  /** Reads and enables pagination through a set of `FailedRecurringPayment`. */
  failedRecurringPaymentsByPersonIdList: Array<FailedRecurringPayment>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  /** Reads a single `GivingWhatWeCanSurvey` that is related to this `Person`. */
  givingWhatWeCanSurveyByPersonId?: Maybe<GivingWhatWeCanSurvey>;
  /**
   * Reads and enables pagination through a set of `GivingWhatWeCanSurvey`.
   * @deprecated Please use givingWhatWeCanSurveyByPersonId instead
   */
  givingWhatWeCanSurveysByPersonId: GivingWhatWeCanSurveysConnection;
  /** Reads and enables pagination through a set of `GocardlessCustomer`. */
  gocardlessCustomersByPersonId: GocardlessCustomersConnection;
  /** Reads and enables pagination through a set of `GocardlessCustomer`. */
  gocardlessCustomersByPersonIdList: Array<GocardlessCustomer>;
  /** Reads and enables pagination through a set of `GocardlessMandate`. */
  gocardlessMandatesByPersonId: GocardlessMandatesConnection;
  /** Reads and enables pagination through a set of `GocardlessMandate`. */
  gocardlessMandatesByPersonIdList: Array<GocardlessMandate>;
  /** Reads a single `GocardlessRedirectFlow` that is related to this `Person`. */
  gocardlessRedirectFlowByPersonId?: Maybe<GocardlessRedirectFlow>;
  /**
   * Reads and enables pagination through a set of `GocardlessRedirectFlow`.
   * @deprecated Please use gocardlessRedirectFlowByPersonId instead
   */
  gocardlessRedirectFlowsByPersonId: GocardlessRedirectFlowsConnection;
  id: Scalars['BigInt'];
  /** Reads and enables pagination through a set of `Income`. */
  incomesByPersonId: IncomesConnection;
  /** Reads and enables pagination through a set of `Income`. */
  incomesByPersonIdList: Array<Income>;
  isAnonymized: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Liability`. */
  liabilitiesByPersonId: LiabilitiesConnection;
  /** Reads and enables pagination through a set of `Liability`. */
  liabilitiesByPersonIdList: Array<Liability>;
  /** Reads and enables pagination through a set of `LiabilityPayment`. */
  liabilityPaymentsByPersonId: LiabilityPaymentsConnection;
  /** Reads and enables pagination through a set of `LiabilityPayment`. */
  liabilityPaymentsByPersonIdList: Array<LiabilityPayment>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByPersonId: PaymentsConnection;
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByPersonIdList: Array<Payment>;
  /** Reads a single `PaymentsManager` that is related to this `Person`. */
  paymentsManagerByPersonId?: Maybe<PaymentsManager>;
  /**
   * Reads and enables pagination through a set of `PaymentsManager`.
   * @deprecated Please use paymentsManagerByPersonId instead
   */
  paymentsManagersByPersonId: PaymentsManagersConnection;
  /** Reads and enables pagination through a set of `PayrollGivingProviderCustomer`. */
  payrollGivingProviderCustomersByPersonId: PayrollGivingProviderCustomersConnection;
  /** Reads and enables pagination through a set of `PayrollGivingProviderCustomer`. */
  payrollGivingProviderCustomersByPersonIdList: Array<PayrollGivingProviderCustomer>;
  /** Reads and enables pagination through a set of `PledgeRank`. */
  pledgeRanksByPersonId: PledgeRanksConnection;
  /** Reads and enables pagination through a set of `PledgeRank`. */
  pledgeRanksByPersonIdList: Array<PledgeRank>;
  /** Reads and enables pagination through a set of `Pledge`. */
  pledgesByPersonId: PledgesConnection;
  /** Reads and enables pagination through a set of `Pledge`. */
  pledgesByPersonIdList: Array<Pledge>;
  /** Reads a single `PledgesManager` that is related to this `Person`. */
  pledgesManagerByPersonId?: Maybe<PledgesManager>;
  /**
   * Reads and enables pagination through a set of `PledgesManager`.
   * @deprecated Please use pledgesManagerByPersonId instead
   */
  pledgesManagersByPersonId: PledgesManagersConnection;
  /** Reads and enables pagination through a set of `PollOptionVote`. */
  pollOptionVotesByPersonId: PollOptionVotesConnection;
  /** Reads and enables pagination through a set of `PollOptionVote`. */
  pollOptionVotesByPersonIdList: Array<PollOptionVote>;
  /**
   * Reads and enables pagination through a set of `Privacy`.
   * @deprecated Please use privacyByPersonId instead
   */
  privaciesByPersonId: PrivaciesConnection;
  /** Reads a single `Privacy` that is related to this `Person`. */
  privacyByPersonId?: Maybe<Privacy>;
  /** Reads and enables pagination through a set of `ProjectedDonation`. */
  projectedDonationsByPersonId: ProjectedDonationsConnection;
  /** Reads and enables pagination through a set of `ProjectedDonation`. */
  projectedDonationsByPersonIdList: Array<ProjectedDonation>;
  /** Reads and enables pagination through a set of `RecurringPayment`. */
  recurringPaymentsByPersonId: RecurringPaymentsConnection;
  /** Reads and enables pagination through a set of `RecurringPayment`. */
  recurringPaymentsByPersonIdList: Array<RecurringPayment>;
  /** Reads and enables pagination through a set of `RecurringReportedDonation`. */
  recurringReportedDonationsByPersonId: RecurringReportedDonationsConnection;
  /** Reads and enables pagination through a set of `RecurringReportedDonation`. */
  recurringReportedDonationsByPersonIdList: Array<RecurringReportedDonation>;
  /** Reads and enables pagination through a set of `ReportedDonation`. */
  reportedDonationsByPersonId: ReportedDonationsConnection;
  /** Reads and enables pagination through a set of `ReportedDonation`. */
  reportedDonationsByPersonIdList: Array<ReportedDonation>;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomersByPersonId: StripeCustomersConnection;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomersByPersonIdList: Array<StripeCustomer>;
  updatedAt: Scalars['Datetime'];
};


export type PersonAcquisitionsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AcquisitionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AcquisitionsOrderBy>>;
};


export type PersonAcquisitionsByPersonIdListArgs = {
  condition?: InputMaybe<AcquisitionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AcquisitionsOrderBy>>;
};


export type PersonAddressBackupsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AddressBackupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressBackupsOrderBy>>;
};


export type PersonAddressBackupsByPersonIdListArgs = {
  condition?: InputMaybe<AddressBackupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressBackupsOrderBy>>;
};


export type PersonAddressesByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};


export type PersonAddressesByPersonIdListArgs = {
  condition?: InputMaybe<AddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};


export type PersonAllocationsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationsOrderBy>>;
};


export type PersonContactPreferencesByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContactPreferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactPreferencesOrderBy>>;
};


export type PersonEmailAddressesByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmailAddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmailAddressesOrderBy>>;
};


export type PersonEmailAddressesByPersonIdListArgs = {
  condition?: InputMaybe<EmailAddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmailAddressesOrderBy>>;
};


export type PersonEoyTaxReceiptsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EoyTaxReceiptCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EoyTaxReceiptsOrderBy>>;
};


export type PersonEoyTaxReceiptsByPersonIdListArgs = {
  condition?: InputMaybe<EoyTaxReceiptCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EoyTaxReceiptsOrderBy>>;
};


export type PersonFailedRecurringPaymentsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FailedRecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FailedRecurringPaymentsOrderBy>>;
};


export type PersonFailedRecurringPaymentsByPersonIdListArgs = {
  condition?: InputMaybe<FailedRecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FailedRecurringPaymentsOrderBy>>;
};


export type PersonGivingWhatWeCanSurveysByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GivingWhatWeCanSurveyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GivingWhatWeCanSurveysOrderBy>>;
};


export type PersonGocardlessCustomersByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GocardlessCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessCustomersOrderBy>>;
};


export type PersonGocardlessCustomersByPersonIdListArgs = {
  condition?: InputMaybe<GocardlessCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessCustomersOrderBy>>;
};


export type PersonGocardlessMandatesByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GocardlessMandateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessMandatesOrderBy>>;
};


export type PersonGocardlessMandatesByPersonIdListArgs = {
  condition?: InputMaybe<GocardlessMandateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessMandatesOrderBy>>;
};


export type PersonGocardlessRedirectFlowsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GocardlessRedirectFlowCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessRedirectFlowsOrderBy>>;
};


export type PersonIncomesByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IncomeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IncomesOrderBy>>;
};


export type PersonIncomesByPersonIdListArgs = {
  condition?: InputMaybe<IncomeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IncomesOrderBy>>;
};


export type PersonLiabilitiesByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LiabilityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilitiesOrderBy>>;
};


export type PersonLiabilitiesByPersonIdListArgs = {
  condition?: InputMaybe<LiabilityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilitiesOrderBy>>;
};


export type PersonLiabilityPaymentsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LiabilityPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityPaymentsOrderBy>>;
};


export type PersonLiabilityPaymentsByPersonIdListArgs = {
  condition?: InputMaybe<LiabilityPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityPaymentsOrderBy>>;
};


export type PersonPaymentsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type PersonPaymentsByPersonIdListArgs = {
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type PersonPaymentsManagersByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentsManagerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsManagersOrderBy>>;
};


export type PersonPayrollGivingProviderCustomersByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PayrollGivingProviderCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayrollGivingProviderCustomersOrderBy>>;
};


export type PersonPayrollGivingProviderCustomersByPersonIdListArgs = {
  condition?: InputMaybe<PayrollGivingProviderCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayrollGivingProviderCustomersOrderBy>>;
};


export type PersonPledgeRanksByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PledgeRankCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgeRanksOrderBy>>;
};


export type PersonPledgeRanksByPersonIdListArgs = {
  condition?: InputMaybe<PledgeRankCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgeRanksOrderBy>>;
};


export type PersonPledgesByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PledgeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgesOrderBy>>;
};


export type PersonPledgesByPersonIdListArgs = {
  condition?: InputMaybe<PledgeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgesOrderBy>>;
};


export type PersonPledgesManagersByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PledgesManagerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgesManagersOrderBy>>;
};


export type PersonPollOptionVotesByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PollOptionVoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollOptionVotesOrderBy>>;
};


export type PersonPollOptionVotesByPersonIdListArgs = {
  condition?: InputMaybe<PollOptionVoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollOptionVotesOrderBy>>;
};


export type PersonPrivaciesByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PrivacyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PrivaciesOrderBy>>;
};


export type PersonProjectedDonationsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectedDonationsOrderBy>>;
};


export type PersonProjectedDonationsByPersonIdListArgs = {
  condition?: InputMaybe<ProjectedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectedDonationsOrderBy>>;
};


export type PersonRecurringPaymentsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};


export type PersonRecurringPaymentsByPersonIdListArgs = {
  condition?: InputMaybe<RecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};


export type PersonRecurringReportedDonationsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecurringReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringReportedDonationsOrderBy>>;
};


export type PersonRecurringReportedDonationsByPersonIdListArgs = {
  condition?: InputMaybe<RecurringReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringReportedDonationsOrderBy>>;
};


export type PersonReportedDonationsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportedDonationsOrderBy>>;
};


export type PersonReportedDonationsByPersonIdListArgs = {
  condition?: InputMaybe<ReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportedDonationsOrderBy>>;
};


export type PersonStripeCustomersByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StripeCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};


export type PersonStripeCustomersByPersonIdListArgs = {
  condition?: InputMaybe<StripeCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};

/** A condition to be used against `Person` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PersonCondition = {
  /** Checks for equality with the object’s `auth0UserId` field. */
  auth0UserId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `birthDate` field. */
  birthDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fullName` field. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `isAnonymized` field. */
  isAnonymized?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type PersonDonationToOrg = {
  __typename?: 'PersonDonationToOrg';
  amount?: Maybe<Scalars['BigFloat']>;
  avgDonationAmount?: Maybe<Scalars['BigFloat']>;
  currencyCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstDonationDate?: Maybe<Scalars['Date']>;
  firstName?: Maybe<Scalars['String']>;
  lastDonationDate?: Maybe<Scalars['Date']>;
  lastName?: Maybe<Scalars['String']>;
  numDonations?: Maybe<Scalars['BigInt']>;
  organization?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['Date']>;
  periodStart?: Maybe<Scalars['Date']>;
  personId?: Maybe<Scalars['BigInt']>;
};

/** A connection to a list of `PersonDonationToOrg` values. */
export type PersonDonationToOrgsConnection = {
  __typename?: 'PersonDonationToOrgsConnection';
  /** A list of edges which contains the `PersonDonationToOrg` and cursor to aid in pagination. */
  edges: Array<PersonDonationToOrgsEdge>;
  /** A list of `PersonDonationToOrg` objects. */
  nodes: Array<Maybe<PersonDonationToOrg>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PersonDonationToOrg` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PersonDonationToOrg` edge in the connection. */
export type PersonDonationToOrgsEdge = {
  __typename?: 'PersonDonationToOrgsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PersonDonationToOrg` at the end of the edge. */
  node?: Maybe<PersonDonationToOrg>;
};

export type Pledge = Node & {
  __typename?: 'Pledge';
  anonymous: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
  id: Scalars['BigInt'];
  /** Reads and enables pagination through a set of `Liability`. */
  liabilitiesByPledgeId: LiabilitiesConnection;
  /** Reads and enables pagination through a set of `Liability`. */
  liabilitiesByPledgeIdList: Array<Liability>;
  /** Reads and enables pagination through a set of `LiabilityPayment`. */
  liabilityPaymentsByPledgeId: LiabilityPaymentsConnection;
  /** Reads and enables pagination through a set of `LiabilityPayment`. */
  liabilityPaymentsByPledgeIdList: Array<LiabilityPayment>;
  /** Locale in which this pledge was taken */
  locale: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  motivation?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  period: DateRange;
  /** Reads a single `Person` that is related to this `Pledge`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  pledgePercentage: Scalars['BigFloat'];
  /** Reads and enables pagination through a set of `PledgeRank`. */
  pledgeRanksByLatestPledgeId: PledgeRanksConnection;
  /** Reads and enables pagination through a set of `PledgeRank`. */
  pledgeRanksByLatestPledgeIdList: Array<PledgeRank>;
  pledgeType: PledgeType;
  /** Reads and enables pagination through a set of `ProjectedDonation`. */
  projectedDonationsByPledgeId: ProjectedDonationsConnection;
  /** Reads and enables pagination through a set of `ProjectedDonation`. */
  projectedDonationsByPledgeIdList: Array<ProjectedDonation>;
  updatedAt: Scalars['Datetime'];
};


export type PledgeLiabilitiesByPledgeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LiabilityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilitiesOrderBy>>;
};


export type PledgeLiabilitiesByPledgeIdListArgs = {
  condition?: InputMaybe<LiabilityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilitiesOrderBy>>;
};


export type PledgeLiabilityPaymentsByPledgeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LiabilityPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityPaymentsOrderBy>>;
};


export type PledgeLiabilityPaymentsByPledgeIdListArgs = {
  condition?: InputMaybe<LiabilityPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityPaymentsOrderBy>>;
};


export type PledgePledgeRanksByLatestPledgeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PledgeRankCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgeRanksOrderBy>>;
};


export type PledgePledgeRanksByLatestPledgeIdListArgs = {
  condition?: InputMaybe<PledgeRankCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgeRanksOrderBy>>;
};


export type PledgeProjectedDonationsByPledgeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectedDonationsOrderBy>>;
};


export type PledgeProjectedDonationsByPledgeIdListArgs = {
  condition?: InputMaybe<ProjectedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectedDonationsOrderBy>>;
};

/** A condition to be used against `Pledge` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PledgeCondition = {
  /** Checks for equality with the object’s `anonymous` field. */
  anonymous?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `locale` field. */
  locale?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `motivation` field. */
  motivation?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `period` field. */
  period?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pledgePercentage` field. */
  pledgePercentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `pledgeType` field. */
  pledgeType?: InputMaybe<PledgeType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An input for mutations affecting `Pledge` */
export type PledgeInput = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  /** Locale in which this pledge was taken */
  locale?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  motivation?: InputMaybe<Scalars['String']>;
  period: DateRangeInput;
  personId: Scalars['BigInt'];
  pledgePercentage: Scalars['BigFloat'];
  pledgeType: PledgeType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type PledgeRank = Node & {
  __typename?: 'PledgeRank';
  commencementDate: Scalars['Date'];
  createdAt: Scalars['Datetime'];
  latestPledgeId?: Maybe<Scalars['BigInt']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Person` that is related to this `PledgeRank`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  /** Reads a single `Pledge` that is related to this `PledgeRank`. */
  pledgeByLatestPledgeId?: Maybe<Pledge>;
  pledgeType: PledgeType;
  rankByPledgeType: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `PledgeRank` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PledgeRankCondition = {
  /** Checks for equality with the object’s `commencementDate` field. */
  commencementDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `latestPledgeId` field. */
  latestPledgeId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pledgeType` field. */
  pledgeType?: InputMaybe<PledgeType>;
  /** Checks for equality with the object’s `rankByPledgeType` field. */
  rankByPledgeType?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `PledgeRank` values. */
export type PledgeRanksConnection = {
  __typename?: 'PledgeRanksConnection';
  /** A list of edges which contains the `PledgeRank` and cursor to aid in pagination. */
  edges: Array<PledgeRanksEdge>;
  /** A list of `PledgeRank` objects. */
  nodes: Array<Maybe<PledgeRank>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PledgeRank` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PledgeRank` edge in the connection. */
export type PledgeRanksEdge = {
  __typename?: 'PledgeRanksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PledgeRank` at the end of the edge. */
  node?: Maybe<PledgeRank>;
};

/** Methods to use when ordering `PledgeRank`. */
export enum PledgeRanksOrderBy {
  CommencementDateAsc = 'COMMENCEMENT_DATE_ASC',
  CommencementDateDesc = 'COMMENCEMENT_DATE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  LatestPledgeIdAsc = 'LATEST_PLEDGE_ID_ASC',
  LatestPledgeIdDesc = 'LATEST_PLEDGE_ID_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PledgeTypeAsc = 'PLEDGE_TYPE_ASC',
  PledgeTypeDesc = 'PLEDGE_TYPE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RankByPledgeTypeAsc = 'RANK_BY_PLEDGE_TYPE_ASC',
  RankByPledgeTypeDesc = 'RANK_BY_PLEDGE_TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum PledgeType {
  GivingWhatWeCan = 'GIVING_WHAT_WE_CAN',
  TryGiving = 'TRY_GIVING'
}

export type PledgedMember = {
  __typename?: 'PledgedMember';
  active?: Maybe<Scalars['Boolean']>;
  anonymous?: Maybe<Scalars['Boolean']>;
  commencementDate?: Maybe<Scalars['Date']>;
  fullName?: Maybe<Scalars['String']>;
  latestPledgeEndDate?: Maybe<Scalars['Date']>;
  latestPledgePercentage?: Maybe<Scalars['BigFloat']>;
  personId?: Maybe<Scalars['BigInt']>;
  pledgeType?: Maybe<PledgeType>;
  rankByPledgeType?: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `PledgedMember` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PledgedMemberCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `anonymous` field. */
  anonymous?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `commencementDate` field. */
  commencementDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `fullName` field. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `latestPledgeEndDate` field. */
  latestPledgeEndDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `latestPledgePercentage` field. */
  latestPledgePercentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pledgeType` field. */
  pledgeType?: InputMaybe<PledgeType>;
  /** Checks for equality with the object’s `rankByPledgeType` field. */
  rankByPledgeType?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `PledgedMember` values. */
export type PledgedMembersConnection = {
  __typename?: 'PledgedMembersConnection';
  /** A list of edges which contains the `PledgedMember` and cursor to aid in pagination. */
  edges: Array<PledgedMembersEdge>;
  /** A list of `PledgedMember` objects. */
  nodes: Array<Maybe<PledgedMember>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PledgedMember` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PledgedMember` edge in the connection. */
export type PledgedMembersEdge = {
  __typename?: 'PledgedMembersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PledgedMember` at the end of the edge. */
  node?: Maybe<PledgedMember>;
};

/** Methods to use when ordering `PledgedMember`. */
export enum PledgedMembersOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  AnonymousAsc = 'ANONYMOUS_ASC',
  AnonymousDesc = 'ANONYMOUS_DESC',
  CommencementDateAsc = 'COMMENCEMENT_DATE_ASC',
  CommencementDateDesc = 'COMMENCEMENT_DATE_DESC',
  FullNameAsc = 'FULL_NAME_ASC',
  FullNameDesc = 'FULL_NAME_DESC',
  LatestPledgeEndDateAsc = 'LATEST_PLEDGE_END_DATE_ASC',
  LatestPledgeEndDateDesc = 'LATEST_PLEDGE_END_DATE_DESC',
  LatestPledgePercentageAsc = 'LATEST_PLEDGE_PERCENTAGE_ASC',
  LatestPledgePercentageDesc = 'LATEST_PLEDGE_PERCENTAGE_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PledgeTypeAsc = 'PLEDGE_TYPE_ASC',
  PledgeTypeDesc = 'PLEDGE_TYPE_DESC',
  RankByPledgeTypeAsc = 'RANK_BY_PLEDGE_TYPE_ASC',
  RankByPledgeTypeDesc = 'RANK_BY_PLEDGE_TYPE_DESC'
}

export type PledgedMembersPublic = {
  __typename?: 'PledgedMembersPublic';
  active?: Maybe<Scalars['Boolean']>;
  anonymous?: Maybe<Scalars['Boolean']>;
  commencementDate?: Maybe<Scalars['Date']>;
  fullName?: Maybe<Scalars['String']>;
  latestPledgeEndDate?: Maybe<Scalars['Date']>;
  latestPledgePercentage?: Maybe<Scalars['BigFloat']>;
  pledgeType?: Maybe<PledgeType>;
  rankByPledgeType?: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `PledgedMembersPublic` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PledgedMembersPublicCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `anonymous` field. */
  anonymous?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `commencementDate` field. */
  commencementDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `fullName` field. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `latestPledgeEndDate` field. */
  latestPledgeEndDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `latestPledgePercentage` field. */
  latestPledgePercentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `pledgeType` field. */
  pledgeType?: InputMaybe<PledgeType>;
  /** Checks for equality with the object’s `rankByPledgeType` field. */
  rankByPledgeType?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `PledgedMembersPublic` values. */
export type PledgedMembersPublicsConnection = {
  __typename?: 'PledgedMembersPublicsConnection';
  /** A list of edges which contains the `PledgedMembersPublic` and cursor to aid in pagination. */
  edges: Array<PledgedMembersPublicsEdge>;
  /** A list of `PledgedMembersPublic` objects. */
  nodes: Array<Maybe<PledgedMembersPublic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PledgedMembersPublic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PledgedMembersPublic` edge in the connection. */
export type PledgedMembersPublicsEdge = {
  __typename?: 'PledgedMembersPublicsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PledgedMembersPublic` at the end of the edge. */
  node?: Maybe<PledgedMembersPublic>;
};

/** Methods to use when ordering `PledgedMembersPublic`. */
export enum PledgedMembersPublicsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  AnonymousAsc = 'ANONYMOUS_ASC',
  AnonymousDesc = 'ANONYMOUS_DESC',
  CommencementDateAsc = 'COMMENCEMENT_DATE_ASC',
  CommencementDateDesc = 'COMMENCEMENT_DATE_DESC',
  FullNameAsc = 'FULL_NAME_ASC',
  FullNameDesc = 'FULL_NAME_DESC',
  LatestPledgeEndDateAsc = 'LATEST_PLEDGE_END_DATE_ASC',
  LatestPledgeEndDateDesc = 'LATEST_PLEDGE_END_DATE_DESC',
  LatestPledgePercentageAsc = 'LATEST_PLEDGE_PERCENTAGE_ASC',
  LatestPledgePercentageDesc = 'LATEST_PLEDGE_PERCENTAGE_DESC',
  Natural = 'NATURAL',
  PledgeTypeAsc = 'PLEDGE_TYPE_ASC',
  PledgeTypeDesc = 'PLEDGE_TYPE_DESC',
  RankByPledgeTypeAsc = 'RANK_BY_PLEDGE_TYPE_ASC',
  RankByPledgeTypeDesc = 'RANK_BY_PLEDGE_TYPE_DESC'
}

/** A connection to a list of `Pledge` values. */
export type PledgesConnection = {
  __typename?: 'PledgesConnection';
  /** A list of edges which contains the `Pledge` and cursor to aid in pagination. */
  edges: Array<PledgesEdge>;
  /** A list of `Pledge` objects. */
  nodes: Array<Maybe<Pledge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Pledge` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Pledge` edge in the connection. */
export type PledgesEdge = {
  __typename?: 'PledgesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Pledge` at the end of the edge. */
  node?: Maybe<Pledge>;
};

export type PledgesManager = Node & {
  __typename?: 'PledgesManager';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Person` that is related to this `PledgesManager`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `PledgesManager` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PledgesManagerCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `PledgesManager` values. */
export type PledgesManagersConnection = {
  __typename?: 'PledgesManagersConnection';
  /** A list of edges which contains the `PledgesManager` and cursor to aid in pagination. */
  edges: Array<PledgesManagersEdge>;
  /** A list of `PledgesManager` objects. */
  nodes: Array<Maybe<PledgesManager>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PledgesManager` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PledgesManager` edge in the connection. */
export type PledgesManagersEdge = {
  __typename?: 'PledgesManagersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PledgesManager` at the end of the edge. */
  node?: Maybe<PledgesManager>;
};

/** Methods to use when ordering `PledgesManager`. */
export enum PledgesManagersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Methods to use when ordering `Pledge`. */
export enum PledgesOrderBy {
  AnonymousAsc = 'ANONYMOUS_ASC',
  AnonymousDesc = 'ANONYMOUS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LocaleAsc = 'LOCALE_ASC',
  LocaleDesc = 'LOCALE_DESC',
  MetadataAsc = 'METADATA_ASC',
  MetadataDesc = 'METADATA_DESC',
  MotivationAsc = 'MOTIVATION_ASC',
  MotivationDesc = 'MOTIVATION_DESC',
  Natural = 'NATURAL',
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PledgePercentageAsc = 'PLEDGE_PERCENTAGE_ASC',
  PledgePercentageDesc = 'PLEDGE_PERCENTAGE_DESC',
  PledgeTypeAsc = 'PLEDGE_TYPE_ASC',
  PledgeTypeDesc = 'PLEDGE_TYPE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type PollOptionPublic = Node & {
  __typename?: 'PollOptionPublic';
  createdAt: Scalars['Datetime'];
  id: Scalars['BigInt'];
  label: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  pollId: Scalars['BigInt'];
  /** Reads and enables pagination through a set of `PollOptionVote`. */
  pollOptionVotesByPollOptionId: PollOptionVotesConnection;
  /** Reads and enables pagination through a set of `PollOptionVote`. */
  pollOptionVotesByPollOptionIdList: Array<PollOptionVote>;
  /** Reads a single `PollPublic` that is related to this `PollOptionPublic`. */
  pollPublicByPollId?: Maybe<PollPublic>;
  updatedAt: Scalars['Datetime'];
  voteCount: Scalars['Int'];
};


export type PollOptionPublicPollOptionVotesByPollOptionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PollOptionVoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollOptionVotesOrderBy>>;
};


export type PollOptionPublicPollOptionVotesByPollOptionIdListArgs = {
  condition?: InputMaybe<PollOptionVoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollOptionVotesOrderBy>>;
};

/**
 * A condition to be used against `PollOptionPublic` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PollOptionPublicCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `pollId` field. */
  pollId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `voteCount` field. */
  voteCount?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `PollOptionPublic` values. */
export type PollOptionPublicsConnection = {
  __typename?: 'PollOptionPublicsConnection';
  /** A list of edges which contains the `PollOptionPublic` and cursor to aid in pagination. */
  edges: Array<PollOptionPublicsEdge>;
  /** A list of `PollOptionPublic` objects. */
  nodes: Array<Maybe<PollOptionPublic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PollOptionPublic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PollOptionPublic` edge in the connection. */
export type PollOptionPublicsEdge = {
  __typename?: 'PollOptionPublicsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PollOptionPublic` at the end of the edge. */
  node?: Maybe<PollOptionPublic>;
};

/** Methods to use when ordering `PollOptionPublic`. */
export enum PollOptionPublicsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LabelAsc = 'LABEL_ASC',
  LabelDesc = 'LABEL_DESC',
  Natural = 'NATURAL',
  PollIdAsc = 'POLL_ID_ASC',
  PollIdDesc = 'POLL_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VoteCountAsc = 'VOTE_COUNT_ASC',
  VoteCountDesc = 'VOTE_COUNT_DESC'
}

export type PollOptionVote = Node & {
  __typename?: 'PollOptionVote';
  context: Scalars['String'];
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Person` that is related to this `PollOptionVote`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  pollOptionId: Scalars['BigInt'];
  /** Reads a single `PollOptionPublic` that is related to this `PollOptionVote`. */
  pollOptionPublicByPollOptionId?: Maybe<PollOptionPublic>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `PollOptionVote` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PollOptionVoteCondition = {
  /** Checks for equality with the object’s `context` field. */
  context?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pollOptionId` field. */
  pollOptionId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `PollOptionVote` values. */
export type PollOptionVotesConnection = {
  __typename?: 'PollOptionVotesConnection';
  /** A list of edges which contains the `PollOptionVote` and cursor to aid in pagination. */
  edges: Array<PollOptionVotesEdge>;
  /** A list of `PollOptionVote` objects. */
  nodes: Array<Maybe<PollOptionVote>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PollOptionVote` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PollOptionVote` edge in the connection. */
export type PollOptionVotesEdge = {
  __typename?: 'PollOptionVotesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PollOptionVote` at the end of the edge. */
  node?: Maybe<PollOptionVote>;
};

/** Methods to use when ordering `PollOptionVote`. */
export enum PollOptionVotesOrderBy {
  ContextAsc = 'CONTEXT_ASC',
  ContextDesc = 'CONTEXT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PollOptionIdAsc = 'POLL_OPTION_ID_ASC',
  PollOptionIdDesc = 'POLL_OPTION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type PollPublic = Node & {
  __typename?: 'PollPublic';
  createdAt: Scalars['Datetime'];
  id: Scalars['BigInt'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PollOptionPublic`. */
  pollOptionPublicsByPollId: PollOptionPublicsConnection;
  /** Reads and enables pagination through a set of `PollOptionPublic`. */
  pollOptionPublicsByPollIdList: Array<PollOptionPublic>;
  question: Scalars['String'];
  questionOrdering: QuestionOrdering;
  updatedAt: Scalars['Datetime'];
  voteMechanism: VoteMechanism;
};


export type PollPublicPollOptionPublicsByPollIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PollOptionPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollOptionPublicsOrderBy>>;
};


export type PollPublicPollOptionPublicsByPollIdListArgs = {
  condition?: InputMaybe<PollOptionPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollOptionPublicsOrderBy>>;
};

/**
 * A condition to be used against `PollPublic` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PollPublicCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `question` field. */
  question?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `questionOrdering` field. */
  questionOrdering?: InputMaybe<QuestionOrdering>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `voteMechanism` field. */
  voteMechanism?: InputMaybe<VoteMechanism>;
};

/** A connection to a list of `PollPublic` values. */
export type PollPublicsConnection = {
  __typename?: 'PollPublicsConnection';
  /** A list of edges which contains the `PollPublic` and cursor to aid in pagination. */
  edges: Array<PollPublicsEdge>;
  /** A list of `PollPublic` objects. */
  nodes: Array<Maybe<PollPublic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PollPublic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PollPublic` edge in the connection. */
export type PollPublicsEdge = {
  __typename?: 'PollPublicsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PollPublic` at the end of the edge. */
  node?: Maybe<PollPublic>;
};

/** Methods to use when ordering `PollPublic`. */
export enum PollPublicsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  QuestionAsc = 'QUESTION_ASC',
  QuestionDesc = 'QUESTION_DESC',
  QuestionOrderingAsc = 'QUESTION_ORDERING_ASC',
  QuestionOrderingDesc = 'QUESTION_ORDERING_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VoteMechanismAsc = 'VOTE_MECHANISM_ASC',
  VoteMechanismDesc = 'VOTE_MECHANISM_DESC'
}

/** A connection to a list of `Privacy` values. */
export type PrivaciesConnection = {
  __typename?: 'PrivaciesConnection';
  /** A list of edges which contains the `Privacy` and cursor to aid in pagination. */
  edges: Array<PrivaciesEdge>;
  /** A list of `Privacy` objects. */
  nodes: Array<Maybe<Privacy>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Privacy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Privacy` edge in the connection. */
export type PrivaciesEdge = {
  __typename?: 'PrivaciesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Privacy` at the end of the edge. */
  node?: Maybe<Privacy>;
};

/** Methods to use when ordering `Privacy`. */
export enum PrivaciesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PartnerCharitiesCanContactAsc = 'PARTNER_CHARITIES_CAN_CONTACT_ASC',
  PartnerCharitiesCanContactDesc = 'PARTNER_CHARITIES_CAN_CONTACT_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShareDetailsWithPartnerCharitiesAsc = 'SHARE_DETAILS_WITH_PARTNER_CHARITIES_ASC',
  ShareDetailsWithPartnerCharitiesDesc = 'SHARE_DETAILS_WITH_PARTNER_CHARITIES_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type Privacy = Node & {
  __typename?: 'Privacy';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  partnerCharitiesCanContact: Scalars['Boolean'];
  /** Reads a single `Person` that is related to this `Privacy`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  shareDetailsWithPartnerCharities: Scalars['Boolean'];
  updatedAt: Scalars['Datetime'];
};

/** A condition to be used against `Privacy` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PrivacyCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `partnerCharitiesCanContact` field. */
  partnerCharitiesCanContact?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `shareDetailsWithPartnerCharities` field. */
  shareDetailsWithPartnerCharities?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ProjectedDonation = Node & {
  __typename?: 'ProjectedDonation';
  ageAtBaseIncome?: Maybe<Scalars['Int']>;
  ageInYear?: Maybe<Scalars['Int']>;
  baseIncomeAmount?: Maybe<Scalars['BigFloat']>;
  baseIncomeCurrencyCode?: Maybe<Scalars['String']>;
  baseIncomePeriod?: Maybe<DateRange>;
  growthAdjustment?: Maybe<Scalars['BigFloat']>;
  growthAtBaseIncome?: Maybe<Scalars['BigFloat']>;
  growthInYear?: Maybe<Scalars['BigFloat']>;
  isEstimatedBaseIncome?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Person` that is related to this `ProjectedDonation`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  /** Reads a single `Pledge` that is related to this `ProjectedDonation`. */
  pledgeByPledgeId?: Maybe<Pledge>;
  pledgeId: Scalars['BigInt'];
  pledgePercentage?: Maybe<Scalars['BigFloat']>;
  projectedDonations?: Maybe<Scalars['BigFloat']>;
  projectedDonationsCumulative?: Maybe<Scalars['BigFloat']>;
  projectedIncome?: Maybe<Scalars['BigFloat']>;
  projectedIncomeCumulative?: Maybe<Scalars['BigFloat']>;
  projectionYear: Scalars['Date'];
};

/**
 * A condition to be used against `ProjectedDonation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectedDonationCondition = {
  /** Checks for equality with the object’s `ageAtBaseIncome` field. */
  ageAtBaseIncome?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `ageInYear` field. */
  ageInYear?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `baseIncomeAmount` field. */
  baseIncomeAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `baseIncomeCurrencyCode` field. */
  baseIncomeCurrencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `baseIncomePeriod` field. */
  baseIncomePeriod?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `growthAdjustment` field. */
  growthAdjustment?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `growthAtBaseIncome` field. */
  growthAtBaseIncome?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `growthInYear` field. */
  growthInYear?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `isEstimatedBaseIncome` field. */
  isEstimatedBaseIncome?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pledgeId` field. */
  pledgeId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `pledgePercentage` field. */
  pledgePercentage?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `projectedDonations` field. */
  projectedDonations?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `projectedDonationsCumulative` field. */
  projectedDonationsCumulative?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `projectedIncome` field. */
  projectedIncome?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `projectedIncomeCumulative` field. */
  projectedIncomeCumulative?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `projectionYear` field. */
  projectionYear?: InputMaybe<Scalars['Date']>;
};

/** A connection to a list of `ProjectedDonation` values. */
export type ProjectedDonationsConnection = {
  __typename?: 'ProjectedDonationsConnection';
  /** A list of edges which contains the `ProjectedDonation` and cursor to aid in pagination. */
  edges: Array<ProjectedDonationsEdge>;
  /** A list of `ProjectedDonation` objects. */
  nodes: Array<Maybe<ProjectedDonation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectedDonation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectedDonation` edge in the connection. */
export type ProjectedDonationsEdge = {
  __typename?: 'ProjectedDonationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectedDonation` at the end of the edge. */
  node?: Maybe<ProjectedDonation>;
};

/** Methods to use when ordering `ProjectedDonation`. */
export enum ProjectedDonationsOrderBy {
  AgeAtBaseIncomeAsc = 'AGE_AT_BASE_INCOME_ASC',
  AgeAtBaseIncomeDesc = 'AGE_AT_BASE_INCOME_DESC',
  AgeInYearAsc = 'AGE_IN_YEAR_ASC',
  AgeInYearDesc = 'AGE_IN_YEAR_DESC',
  BaseIncomeAmountAsc = 'BASE_INCOME_AMOUNT_ASC',
  BaseIncomeAmountDesc = 'BASE_INCOME_AMOUNT_DESC',
  BaseIncomeCurrencyCodeAsc = 'BASE_INCOME_CURRENCY_CODE_ASC',
  BaseIncomeCurrencyCodeDesc = 'BASE_INCOME_CURRENCY_CODE_DESC',
  BaseIncomePeriodAsc = 'BASE_INCOME_PERIOD_ASC',
  BaseIncomePeriodDesc = 'BASE_INCOME_PERIOD_DESC',
  GrowthAdjustmentAsc = 'GROWTH_ADJUSTMENT_ASC',
  GrowthAdjustmentDesc = 'GROWTH_ADJUSTMENT_DESC',
  GrowthAtBaseIncomeAsc = 'GROWTH_AT_BASE_INCOME_ASC',
  GrowthAtBaseIncomeDesc = 'GROWTH_AT_BASE_INCOME_DESC',
  GrowthInYearAsc = 'GROWTH_IN_YEAR_ASC',
  GrowthInYearDesc = 'GROWTH_IN_YEAR_DESC',
  IsEstimatedBaseIncomeAsc = 'IS_ESTIMATED_BASE_INCOME_ASC',
  IsEstimatedBaseIncomeDesc = 'IS_ESTIMATED_BASE_INCOME_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PledgeIdAsc = 'PLEDGE_ID_ASC',
  PledgeIdDesc = 'PLEDGE_ID_DESC',
  PledgePercentageAsc = 'PLEDGE_PERCENTAGE_ASC',
  PledgePercentageDesc = 'PLEDGE_PERCENTAGE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectedDonationsAsc = 'PROJECTED_DONATIONS_ASC',
  ProjectedDonationsCumulativeAsc = 'PROJECTED_DONATIONS_CUMULATIVE_ASC',
  ProjectedDonationsCumulativeDesc = 'PROJECTED_DONATIONS_CUMULATIVE_DESC',
  ProjectedDonationsDesc = 'PROJECTED_DONATIONS_DESC',
  ProjectedIncomeAsc = 'PROJECTED_INCOME_ASC',
  ProjectedIncomeCumulativeAsc = 'PROJECTED_INCOME_CUMULATIVE_ASC',
  ProjectedIncomeCumulativeDesc = 'PROJECTED_INCOME_CUMULATIVE_DESC',
  ProjectedIncomeDesc = 'PROJECTED_INCOME_DESC',
  ProjectionYearAsc = 'PROJECTION_YEAR_ASC',
  ProjectionYearDesc = 'PROJECTION_YEAR_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Reads a single `AccountingInvoice` using its globally unique `ID`. */
  accountingInvoice?: Maybe<AccountingInvoice>;
  accountingInvoiceByInvoiceId?: Maybe<AccountingInvoice>;
  accountingInvoiceByPaymentIdAndPayoutReportIdAndInvoiceType?: Maybe<AccountingInvoice>;
  /** Reads a single `Acquisition` using its globally unique `ID`. */
  acquisition?: Maybe<Acquisition>;
  acquisitionById?: Maybe<Acquisition>;
  /** Reads a single `Address` using its globally unique `ID`. */
  address?: Maybe<Address>;
  /** Reads a single `AddressBackup` using its globally unique `ID`. */
  addressBackup?: Maybe<AddressBackup>;
  addressBackupById?: Maybe<AddressBackup>;
  addressBackupByIdAndPersonId?: Maybe<AddressBackup>;
  addressBackupByPersonIdAndCoordinates?: Maybe<AddressBackup>;
  addressBackupByPersonIdAndFormattedAddress?: Maybe<AddressBackup>;
  addressBackupByPersonIdAndGooglePlaceId?: Maybe<AddressBackup>;
  addressById?: Maybe<Address>;
  addressByIdAndPersonId?: Maybe<Address>;
  /** Reads and enables pagination through a set of `Address`. */
  addressesByPersonId?: Maybe<AddressesConnection>;
  /** Reads and enables pagination through a set of `Address`. */
  addressesByPersonIdList?: Maybe<Array<Maybe<Address>>>;
  /** Reads and enables pagination through a set of `AccountingInvoice`. */
  allAccountingInvoices?: Maybe<AccountingInvoicesConnection>;
  /** Reads a set of `AccountingInvoice`. */
  allAccountingInvoicesList?: Maybe<Array<AccountingInvoice>>;
  /** Reads and enables pagination through a set of `Acquisition`. */
  allAcquisitions?: Maybe<AcquisitionsConnection>;
  /** Reads a set of `Acquisition`. */
  allAcquisitionsList?: Maybe<Array<Acquisition>>;
  /** Reads and enables pagination through a set of `ActiveExtendedLottery`. */
  allActiveExtendedLotteries?: Maybe<ActiveExtendedLotteriesConnection>;
  /** Reads a set of `ActiveExtendedLottery`. */
  allActiveExtendedLotteriesList?: Maybe<Array<ActiveExtendedLottery>>;
  /** Reads and enables pagination through a set of `AddressBackup`. */
  allAddressBackups?: Maybe<AddressBackupsConnection>;
  /** Reads a set of `AddressBackup`. */
  allAddressBackupsList?: Maybe<Array<AddressBackup>>;
  /** Reads and enables pagination through a set of `Address`. */
  allAddresses?: Maybe<AddressesConnection>;
  /** Reads a set of `Address`. */
  allAddressesList?: Maybe<Array<Address>>;
  /** Reads and enables pagination through a set of `AllPledge`. */
  allAllPledges?: Maybe<AllPledgesConnection>;
  /** Reads a set of `AllPledge`. */
  allAllPledgesList?: Maybe<Array<AllPledge>>;
  /** Reads and enables pagination through a set of `AllPledgesPublic`. */
  allAllPledgesPublics?: Maybe<AllPledgesPublicsConnection>;
  /** Reads a set of `AllPledgesPublic`. */
  allAllPledgesPublicsList?: Maybe<Array<AllPledgesPublic>>;
  /** Reads and enables pagination through a set of `Allocation`. */
  allAllocations?: Maybe<AllocationsConnection>;
  /** Reads a set of `Allocation`. */
  allAllocationsList?: Maybe<Array<Allocation>>;
  /** Reads and enables pagination through a set of `BalanceSheetReportMonthlyTotal`. */
  allBalanceSheetReportMonthlyTotals?: Maybe<BalanceSheetReportMonthlyTotalsConnection>;
  /** Reads a set of `BalanceSheetReportMonthlyTotal`. */
  allBalanceSheetReportMonthlyTotalsList?: Maybe<Array<BalanceSheetReportMonthlyTotal>>;
  /** Reads and enables pagination through a set of `BalanceSheetReportPublic`. */
  allBalanceSheetReportPublics?: Maybe<BalanceSheetReportPublicsConnection>;
  /** Reads a set of `BalanceSheetReportPublic`. */
  allBalanceSheetReportPublicsList?: Maybe<Array<BalanceSheetReportPublic>>;
  /** Reads and enables pagination through a set of `BalanceSheetReport`. */
  allBalanceSheetReports?: Maybe<BalanceSheetReportsConnection>;
  /** Reads a set of `BalanceSheetReport`. */
  allBalanceSheetReportsList?: Maybe<Array<BalanceSheetReport>>;
  /** Reads and enables pagination through a set of `Changelog`. */
  allChangelogs?: Maybe<ChangelogsConnection>;
  /** Reads a set of `Changelog`. */
  allChangelogsList?: Maybe<Array<Changelog>>;
  /** Reads and enables pagination through a set of `Color`. */
  allColors?: Maybe<ColorsConnection>;
  /** Reads a set of `Color`. */
  allColorsList?: Maybe<Array<Color>>;
  /** Reads and enables pagination through a set of `CommonNoun`. */
  allCommonNouns?: Maybe<CommonNounsConnection>;
  /** Reads a set of `CommonNoun`. */
  allCommonNounsList?: Maybe<Array<CommonNoun>>;
  /** Reads and enables pagination through a set of `CompletionPayment`. */
  allCompletionPayments?: Maybe<CompletionPaymentsConnection>;
  /** Reads a set of `CompletionPayment`. */
  allCompletionPaymentsList?: Maybe<Array<CompletionPayment>>;
  /** Reads and enables pagination through a set of `ContactPreference`. */
  allContactPreferences?: Maybe<ContactPreferencesConnection>;
  /** Reads a set of `ContactPreference`. */
  allContactPreferencesList?: Maybe<Array<ContactPreference>>;
  /** Reads and enables pagination through a set of `Country`. */
  allCountries?: Maybe<CountriesConnection>;
  /** Reads a set of `Country`. */
  allCountriesList?: Maybe<Array<Country>>;
  /** Reads and enables pagination through a set of `CountryPaymentMethod`. */
  allCountryPaymentMethods?: Maybe<CountryPaymentMethodsConnection>;
  /** Reads a set of `CountryPaymentMethod`. */
  allCountryPaymentMethodsList?: Maybe<Array<CountryPaymentMethod>>;
  /** Reads and enables pagination through a set of `Currency`. */
  allCurrencies?: Maybe<CurrenciesConnection>;
  /** Reads a set of `Currency`. */
  allCurrenciesList?: Maybe<Array<Currency>>;
  /** Reads and enables pagination through a set of `CurrencyByCountry`. */
  allCurrencyByCountries?: Maybe<CurrencyByCountriesConnection>;
  /** Reads a set of `CurrencyByCountry`. */
  allCurrencyByCountriesList?: Maybe<Array<CurrencyByCountry>>;
  /** Reads and enables pagination through a set of `DisbursementEntry`. */
  allDisbursementEntries?: Maybe<DisbursementEntriesConnection>;
  /** Reads a set of `DisbursementEntry`. */
  allDisbursementEntriesList?: Maybe<Array<DisbursementEntry>>;
  /** Reads and enables pagination through a set of `Disbursement`. */
  allDisbursements?: Maybe<DisbursementsConnection>;
  /** Reads a set of `Disbursement`. */
  allDisbursementsList?: Maybe<Array<Disbursement>>;
  /** Reads and enables pagination through a set of `EmailAddress`. */
  allEmailAddresses?: Maybe<EmailAddressesConnection>;
  /** Reads a set of `EmailAddress`. */
  allEmailAddressesList?: Maybe<Array<EmailAddress>>;
  /** Reads and enables pagination through a set of `EoyTaxReceiptExtended`. */
  allEoyTaxReceiptExtendeds?: Maybe<EoyTaxReceiptExtendedsConnection>;
  /** Reads a set of `EoyTaxReceiptExtended`. */
  allEoyTaxReceiptExtendedsList?: Maybe<Array<EoyTaxReceiptExtended>>;
  /** Reads and enables pagination through a set of `EoyTaxReceipt`. */
  allEoyTaxReceipts?: Maybe<EoyTaxReceiptsConnection>;
  /** Reads a set of `EoyTaxReceipt`. */
  allEoyTaxReceiptsList?: Maybe<Array<EoyTaxReceipt>>;
  /** Reads and enables pagination through a set of `ExchangeRate`. */
  allExchangeRates?: Maybe<ExchangeRatesConnection>;
  /** Reads a set of `ExchangeRate`. */
  allExchangeRatesList?: Maybe<Array<ExchangeRate>>;
  /** Reads and enables pagination through a set of `ExtendedLottery`. */
  allExtendedLotteries?: Maybe<ExtendedLotteriesConnection>;
  /** Reads a set of `ExtendedLottery`. */
  allExtendedLotteriesList?: Maybe<Array<ExtendedLottery>>;
  /** Reads and enables pagination through a set of `ExternalOrganization`. */
  allExternalOrganizations?: Maybe<ExternalOrganizationsConnection>;
  /** Reads a set of `ExternalOrganization`. */
  allExternalOrganizationsList?: Maybe<Array<ExternalOrganization>>;
  /** Reads and enables pagination through a set of `FailedPayment`. */
  allFailedPayments?: Maybe<FailedPaymentsConnection>;
  /** Reads a set of `FailedPayment`. */
  allFailedPaymentsList?: Maybe<Array<FailedPayment>>;
  /** Reads and enables pagination through a set of `FailedRecurringPayment`. */
  allFailedRecurringPayments?: Maybe<FailedRecurringPaymentsConnection>;
  /** Reads a set of `FailedRecurringPayment`. */
  allFailedRecurringPaymentsList?: Maybe<Array<FailedRecurringPayment>>;
  /** Reads and enables pagination through a set of `FtxCoin`. */
  allFtxCoins?: Maybe<FtxCoinsConnection>;
  /** Reads a set of `FtxCoin`. */
  allFtxCoinsList?: Maybe<Array<FtxCoin>>;
  /** Reads and enables pagination through a set of `FtxConversion`. */
  allFtxConversions?: Maybe<FtxConversionsConnection>;
  /** Reads a set of `FtxConversion`. */
  allFtxConversionsList?: Maybe<Array<FtxConversion>>;
  /** Reads and enables pagination through a set of `Fund`. */
  allFunds?: Maybe<FundsConnection>;
  /** Reads a set of `Fund`. */
  allFundsList?: Maybe<Array<Fund>>;
  /** Reads and enables pagination through a set of `GatewayPaymentMethod`. */
  allGatewayPaymentMethods?: Maybe<GatewayPaymentMethodsConnection>;
  /** Reads a set of `GatewayPaymentMethod`. */
  allGatewayPaymentMethodsList?: Maybe<Array<GatewayPaymentMethod>>;
  /** Reads and enables pagination through a set of `GatewayPayoutReportAllocation`. */
  allGatewayPayoutReportAllocations?: Maybe<GatewayPayoutReportAllocationsConnection>;
  /** Reads a set of `GatewayPayoutReportAllocation`. */
  allGatewayPayoutReportAllocationsList?: Maybe<Array<GatewayPayoutReportAllocation>>;
  /** Reads and enables pagination through a set of `GatewayPayoutReportEntry`. */
  allGatewayPayoutReportEntries?: Maybe<GatewayPayoutReportEntriesConnection>;
  /** Reads a set of `GatewayPayoutReportEntry`. */
  allGatewayPayoutReportEntriesList?: Maybe<Array<GatewayPayoutReportEntry>>;
  /** Reads and enables pagination through a set of `GatewayPayoutReportSummary`. */
  allGatewayPayoutReportSummaries?: Maybe<GatewayPayoutReportSummariesConnection>;
  /** Reads a set of `GatewayPayoutReportSummary`. */
  allGatewayPayoutReportSummariesList?: Maybe<Array<GatewayPayoutReportSummary>>;
  /** Reads and enables pagination through a set of `GatewayPayoutReport`. */
  allGatewayPayoutReports?: Maybe<GatewayPayoutReportsConnection>;
  /** Reads a set of `GatewayPayoutReport`. */
  allGatewayPayoutReportsList?: Maybe<Array<GatewayPayoutReport>>;
  /** Reads and enables pagination through a set of `GiftAidClaimBackup`. */
  allGiftAidClaimBackups?: Maybe<GiftAidClaimBackupsConnection>;
  /** Reads a set of `GiftAidClaimBackup`. */
  allGiftAidClaimBackupsList?: Maybe<Array<GiftAidClaimBackup>>;
  /** Reads and enables pagination through a set of `GiftAidClaimReportAllocation`. */
  allGiftAidClaimReportAllocations?: Maybe<GiftAidClaimReportAllocationsConnection>;
  /** Reads a set of `GiftAidClaimReportAllocation`. */
  allGiftAidClaimReportAllocationsList?: Maybe<Array<GiftAidClaimReportAllocation>>;
  /** Reads and enables pagination through a set of `GiftAidClaimReportExtended`. */
  allGiftAidClaimReportExtendeds?: Maybe<GiftAidClaimReportExtendedsConnection>;
  /** Reads a set of `GiftAidClaimReportExtended`. */
  allGiftAidClaimReportExtendedsList?: Maybe<Array<GiftAidClaimReportExtended>>;
  /** Reads and enables pagination through a set of `GiftAidClaimReportSummary`. */
  allGiftAidClaimReportSummaries?: Maybe<GiftAidClaimReportSummariesConnection>;
  /** Reads a set of `GiftAidClaimReportSummary`. */
  allGiftAidClaimReportSummariesList?: Maybe<Array<GiftAidClaimReportSummary>>;
  /** Reads and enables pagination through a set of `GiftAidClaimReport`. */
  allGiftAidClaimReports?: Maybe<GiftAidClaimReportsConnection>;
  /** Reads a set of `GiftAidClaimReport`. */
  allGiftAidClaimReportsList?: Maybe<Array<GiftAidClaimReport>>;
  /** Reads and enables pagination through a set of `GiftAidClaim`. */
  allGiftAidClaims?: Maybe<GiftAidClaimsConnection>;
  /** Reads a set of `GiftAidClaim`. */
  allGiftAidClaimsList?: Maybe<Array<GiftAidClaim>>;
  /** Reads and enables pagination through a set of `GivingWhatWeCanSurvey`. */
  allGivingWhatWeCanSurveys?: Maybe<GivingWhatWeCanSurveysConnection>;
  /** Reads a set of `GivingWhatWeCanSurvey`. */
  allGivingWhatWeCanSurveysList?: Maybe<Array<GivingWhatWeCanSurvey>>;
  /** Reads and enables pagination through a set of `GlobalStat`. */
  allGlobalStats?: Maybe<GlobalStatsConnection>;
  /** Reads a set of `GlobalStat`. */
  allGlobalStatsList?: Maybe<Array<GlobalStat>>;
  /** Reads and enables pagination through a set of `GocardlessCustomer`. */
  allGocardlessCustomers?: Maybe<GocardlessCustomersConnection>;
  /** Reads a set of `GocardlessCustomer`. */
  allGocardlessCustomersList?: Maybe<Array<GocardlessCustomer>>;
  /** Reads and enables pagination through a set of `GocardlessMandate`. */
  allGocardlessMandates?: Maybe<GocardlessMandatesConnection>;
  /** Reads a set of `GocardlessMandate`. */
  allGocardlessMandatesList?: Maybe<Array<GocardlessMandate>>;
  /** Reads and enables pagination through a set of `GocardlessRedirectFlow`. */
  allGocardlessRedirectFlows?: Maybe<GocardlessRedirectFlowsConnection>;
  /** Reads a set of `GocardlessRedirectFlow`. */
  allGocardlessRedirectFlowsList?: Maybe<Array<GocardlessRedirectFlow>>;
  /** Reads and enables pagination through a set of `GwwcCompliance`. */
  allGwwcCompliances?: Maybe<GwwcCompliancesConnection>;
  /** Reads a set of `GwwcCompliance`. */
  allGwwcCompliancesList?: Maybe<Array<GwwcCompliance>>;
  /** Reads and enables pagination through a set of `GwwcMembersByCountry`. */
  allGwwcMembersByCountries?: Maybe<GwwcMembersByCountriesConnection>;
  /** Reads a set of `GwwcMembersByCountry`. */
  allGwwcMembersByCountriesList?: Maybe<Array<GwwcMembersByCountry>>;
  /** Reads and enables pagination through a set of `GwwcMembershipEmailExport`. */
  allGwwcMembershipEmailExports?: Maybe<GwwcMembershipEmailExportsConnection>;
  /** Reads a set of `GwwcMembershipEmailExport`. */
  allGwwcMembershipEmailExportsList?: Maybe<Array<GwwcMembershipEmailExport>>;
  /** Reads and enables pagination through a set of `GwwcNewMemberInfo`. */
  allGwwcNewMemberInfos?: Maybe<GwwcNewMemberInfosConnection>;
  /** Reads a set of `GwwcNewMemberInfo`. */
  allGwwcNewMemberInfosList?: Maybe<Array<GwwcNewMemberInfo>>;
  /** Reads and enables pagination through a set of `GwwcRecurringReportedDonationExtended`. */
  allGwwcRecurringReportedDonationExtendeds?: Maybe<GwwcRecurringReportedDonationExtendedsConnection>;
  /** Reads a set of `GwwcRecurringReportedDonationExtended`. */
  allGwwcRecurringReportedDonationExtendedsList?: Maybe<Array<GwwcRecurringReportedDonationExtended>>;
  /** Reads and enables pagination through a set of `GwwcReportedDonationExtended`. */
  allGwwcReportedDonationExtendeds?: Maybe<GwwcReportedDonationExtendedsConnection>;
  /** Reads a set of `GwwcReportedDonationExtended`. */
  allGwwcReportedDonationExtendedsList?: Maybe<Array<GwwcReportedDonationExtended>>;
  /** Reads and enables pagination through a set of `GwwcSurveyReport`. */
  allGwwcSurveyReports?: Maybe<GwwcSurveyReportsConnection>;
  /** Reads a set of `GwwcSurveyReport`. */
  allGwwcSurveyReportsList?: Maybe<Array<GwwcSurveyReport>>;
  /** Reads and enables pagination through a set of `Income`. */
  allIncomes?: Maybe<IncomesConnection>;
  /** Reads a set of `Income`. */
  allIncomesList?: Maybe<Array<Income>>;
  /** Reads and enables pagination through a set of `IncompleteAddress`. */
  allIncompleteAddresses?: Maybe<IncompleteAddressesConnection>;
  /** Reads a set of `IncompleteAddress`. */
  allIncompleteAddressesList?: Maybe<Array<IncompleteAddress>>;
  /** Reads and enables pagination through a set of `Liability`. */
  allLiabilities?: Maybe<LiabilitiesConnection>;
  /** Reads a set of `Liability`. */
  allLiabilitiesList?: Maybe<Array<Liability>>;
  /** Reads and enables pagination through a set of `LiabilityCompletion`. */
  allLiabilityCompletions?: Maybe<LiabilityCompletionsConnection>;
  /** Reads a set of `LiabilityCompletion`. */
  allLiabilityCompletionsList?: Maybe<Array<LiabilityCompletion>>;
  /** Reads and enables pagination through a set of `LiabilityPayment`. */
  allLiabilityPayments?: Maybe<LiabilityPaymentsConnection>;
  /** Reads a set of `LiabilityPayment`. */
  allLiabilityPaymentsList?: Maybe<Array<LiabilityPayment>>;
  /** Reads and enables pagination through a set of `LiabilityTotalCompletion`. */
  allLiabilityTotalCompletions?: Maybe<LiabilityTotalCompletionsConnection>;
  /** Reads a set of `LiabilityTotalCompletion`. */
  allLiabilityTotalCompletionsList?: Maybe<Array<LiabilityTotalCompletion>>;
  /** Reads and enables pagination through a set of `Lottery`. */
  allLotteries?: Maybe<LotteriesConnection>;
  /** Reads a set of `Lottery`. */
  allLotteriesList?: Maybe<Array<Lottery>>;
  /** Reads and enables pagination through a set of `LotteryEntry`. */
  allLotteryEntries?: Maybe<LotteryEntriesConnection>;
  /** Reads a set of `LotteryEntry`. */
  allLotteryEntriesList?: Maybe<Array<LotteryEntry>>;
  /** Reads and enables pagination through a set of `LotteryEntryComplete`. */
  allLotteryEntryCompletes?: Maybe<LotteryEntryCompletesConnection>;
  /** Reads a set of `LotteryEntryComplete`. */
  allLotteryEntryCompletesList?: Maybe<Array<LotteryEntryComplete>>;
  /** Reads and enables pagination through a set of `LotteryEntryPublic`. */
  allLotteryEntryPublics?: Maybe<LotteryEntryPublicsConnection>;
  /** Reads a set of `LotteryEntryPublic`. */
  allLotteryEntryPublicsList?: Maybe<Array<LotteryEntryPublic>>;
  /** Reads and enables pagination through a set of `LotterySummary`. */
  allLotterySummaries?: Maybe<LotterySummariesConnection>;
  /** Reads a set of `LotterySummary`. */
  allLotterySummariesList?: Maybe<Array<LotterySummary>>;
  /** Reads and enables pagination through a set of `LotteryTicketPublic`. */
  allLotteryTicketPublics?: Maybe<LotteryTicketPublicsConnection>;
  /** Reads a set of `LotteryTicketPublic`. */
  allLotteryTicketPublicsList?: Maybe<Array<LotteryTicketPublic>>;
  /** Reads and enables pagination through a set of `LotteryTicket`. */
  allLotteryTickets?: Maybe<LotteryTicketsConnection>;
  /** Reads a set of `LotteryTicket`. */
  allLotteryTicketsList?: Maybe<Array<LotteryTicket>>;
  /** Reads and enables pagination through a set of `LotteryWinner`. */
  allLotteryWinners?: Maybe<LotteryWinnersConnection>;
  /** Reads a set of `LotteryWinner`. */
  allLotteryWinnersList?: Maybe<Array<LotteryWinner>>;
  /** Reads and enables pagination through a set of `NewPledgeInfo`. */
  allNewPledgeInfos?: Maybe<NewPledgeInfosConnection>;
  /** Reads a set of `NewPledgeInfo`. */
  allNewPledgeInfosList?: Maybe<Array<NewPledgeInfo>>;
  /** Reads and enables pagination through a set of `NormalizedCurrency`. */
  allNormalizedCurrencies?: Maybe<NormalizedCurrenciesConnection>;
  /** Reads a set of `NormalizedCurrency`. */
  allNormalizedCurrenciesList?: Maybe<Array<NormalizedCurrency>>;
  /** Reads and enables pagination through a set of `OrganizationCategory`. */
  allOrganizationCategories?: Maybe<OrganizationCategoriesConnection>;
  /** Reads a set of `OrganizationCategory`. */
  allOrganizationCategoriesList?: Maybe<Array<OrganizationCategory>>;
  /** Reads and enables pagination through a set of `Organization`. */
  allOrganizations?: Maybe<OrganizationsConnection>;
  /** Reads a set of `Organization`. */
  allOrganizationsList?: Maybe<Array<Organization>>;
  /** Reads and enables pagination through a set of `PaymentAccessToken`. */
  allPaymentAccessTokens?: Maybe<PaymentAccessTokensConnection>;
  /** Reads a set of `PaymentAccessToken`. */
  allPaymentAccessTokensList?: Maybe<Array<PaymentAccessToken>>;
  /** Reads and enables pagination through a set of `PaymentDetailsByOrganization`. */
  allPaymentDetailsByOrganizations?: Maybe<PaymentDetailsByOrganizationsConnection>;
  /** Reads a set of `PaymentDetailsByOrganization`. */
  allPaymentDetailsByOrganizationsList?: Maybe<Array<PaymentDetailsByOrganization>>;
  /** Reads and enables pagination through a set of `PaymentRecipientCountriesServiced`. */
  allPaymentRecipientCountriesServiceds?: Maybe<PaymentRecipientCountriesServicedsConnection>;
  /** Reads a set of `PaymentRecipientCountriesServiced`. */
  allPaymentRecipientCountriesServicedsList?: Maybe<Array<PaymentRecipientCountriesServiced>>;
  /** Reads and enables pagination through a set of `PaymentRecipient`. */
  allPaymentRecipients?: Maybe<PaymentRecipientsConnection>;
  /** Reads a set of `PaymentRecipient`. */
  allPaymentRecipientsList?: Maybe<Array<PaymentRecipient>>;
  /** Reads and enables pagination through a set of `PaymentReportByOrganization`. */
  allPaymentReportByOrganizations?: Maybe<PaymentReportByOrganizationsConnection>;
  /** Reads a set of `PaymentReportByOrganization`. */
  allPaymentReportByOrganizationsList?: Maybe<Array<PaymentReportByOrganization>>;
  /** Reads and enables pagination through a set of `PaymentSharingConsent`. */
  allPaymentSharingConsents?: Maybe<PaymentSharingConsentsConnection>;
  /** Reads a set of `PaymentSharingConsent`. */
  allPaymentSharingConsentsList?: Maybe<Array<PaymentSharingConsent>>;
  /** Reads and enables pagination through a set of `PaymentStatsAggregate`. */
  allPaymentStatsAggregates?: Maybe<PaymentStatsAggregatesConnection>;
  /** Reads a set of `PaymentStatsAggregate`. */
  allPaymentStatsAggregatesList?: Maybe<Array<PaymentStatsAggregate>>;
  /** Reads and enables pagination through a set of `PaymentStatsByOrganization`. */
  allPaymentStatsByOrganizations?: Maybe<PaymentStatsByOrganizationsConnection>;
  /** Reads a set of `PaymentStatsByOrganization`. */
  allPaymentStatsByOrganizationsList?: Maybe<Array<PaymentStatsByOrganization>>;
  /** Reads and enables pagination through a set of `Payment`. */
  allPayments?: Maybe<PaymentsConnection>;
  /** Reads a set of `Payment`. */
  allPaymentsList?: Maybe<Array<Payment>>;
  /** Reads and enables pagination through a set of `PaymentsManager`. */
  allPaymentsManagers?: Maybe<PaymentsManagersConnection>;
  /** Reads a set of `PaymentsManager`. */
  allPaymentsManagersList?: Maybe<Array<PaymentsManager>>;
  /** Reads and enables pagination through a set of `PayrollGivingProviderCustomer`. */
  allPayrollGivingProviderCustomers?: Maybe<PayrollGivingProviderCustomersConnection>;
  /** Reads a set of `PayrollGivingProviderCustomer`. */
  allPayrollGivingProviderCustomersList?: Maybe<Array<PayrollGivingProviderCustomer>>;
  /** Reads and enables pagination through a set of `Person`. */
  allPeople?: Maybe<PeopleConnection>;
  /** Reads a set of `Person`. */
  allPeopleList?: Maybe<Array<Person>>;
  /** Reads and enables pagination through a set of `PledgeRank`. */
  allPledgeRanks?: Maybe<PledgeRanksConnection>;
  /** Reads a set of `PledgeRank`. */
  allPledgeRanksList?: Maybe<Array<PledgeRank>>;
  /** Reads and enables pagination through a set of `PledgedMember`. */
  allPledgedMembers?: Maybe<PledgedMembersConnection>;
  /** Reads a set of `PledgedMember`. */
  allPledgedMembersList?: Maybe<Array<PledgedMember>>;
  /** Reads and enables pagination through a set of `PledgedMembersPublic`. */
  allPledgedMembersPublics?: Maybe<PledgedMembersPublicsConnection>;
  /** Reads a set of `PledgedMembersPublic`. */
  allPledgedMembersPublicsList?: Maybe<Array<PledgedMembersPublic>>;
  /** Reads and enables pagination through a set of `Pledge`. */
  allPledges?: Maybe<PledgesConnection>;
  /** Reads a set of `Pledge`. */
  allPledgesList?: Maybe<Array<Pledge>>;
  /** Reads and enables pagination through a set of `PledgesManager`. */
  allPledgesManagers?: Maybe<PledgesManagersConnection>;
  /** Reads a set of `PledgesManager`. */
  allPledgesManagersList?: Maybe<Array<PledgesManager>>;
  /** Reads and enables pagination through a set of `PollOptionPublic`. */
  allPollOptionPublics?: Maybe<PollOptionPublicsConnection>;
  /** Reads a set of `PollOptionPublic`. */
  allPollOptionPublicsList?: Maybe<Array<PollOptionPublic>>;
  /** Reads and enables pagination through a set of `PollOptionVote`. */
  allPollOptionVotes?: Maybe<PollOptionVotesConnection>;
  /** Reads a set of `PollOptionVote`. */
  allPollOptionVotesList?: Maybe<Array<PollOptionVote>>;
  /** Reads and enables pagination through a set of `PollPublic`. */
  allPollPublics?: Maybe<PollPublicsConnection>;
  /** Reads a set of `PollPublic`. */
  allPollPublicsList?: Maybe<Array<PollPublic>>;
  /** Reads and enables pagination through a set of `Privacy`. */
  allPrivacies?: Maybe<PrivaciesConnection>;
  /** Reads a set of `Privacy`. */
  allPrivaciesList?: Maybe<Array<Privacy>>;
  /** Reads and enables pagination through a set of `ProjectedDonation`. */
  allProjectedDonations?: Maybe<ProjectedDonationsConnection>;
  /** Reads a set of `ProjectedDonation`. */
  allProjectedDonationsList?: Maybe<Array<ProjectedDonation>>;
  /** Reads and enables pagination through a set of `RecipientProgram`. */
  allRecipientPrograms?: Maybe<RecipientProgramsConnection>;
  /** Reads a set of `RecipientProgram`. */
  allRecipientProgramsList?: Maybe<Array<RecipientProgram>>;
  /** Reads and enables pagination through a set of `RecurringPayment`. */
  allRecurringPayments?: Maybe<RecurringPaymentsConnection>;
  /** Reads a set of `RecurringPayment`. */
  allRecurringPaymentsList?: Maybe<Array<RecurringPayment>>;
  /** Reads and enables pagination through a set of `RecurringReportedDonation`. */
  allRecurringReportedDonations?: Maybe<RecurringReportedDonationsConnection>;
  /** Reads a set of `RecurringReportedDonation`. */
  allRecurringReportedDonationsList?: Maybe<Array<RecurringReportedDonation>>;
  /** Reads and enables pagination through a set of `ReferralSource`. */
  allReferralSources?: Maybe<ReferralSourcesConnection>;
  /** Reads a set of `ReferralSource`. */
  allReferralSourcesList?: Maybe<Array<ReferralSource>>;
  /** Reads and enables pagination through a set of `ReportedDonationInfo`. */
  allReportedDonationInfos?: Maybe<ReportedDonationInfosConnection>;
  /** Reads a set of `ReportedDonationInfo`. */
  allReportedDonationInfosList?: Maybe<Array<ReportedDonationInfo>>;
  /** Reads and enables pagination through a set of `ReportedDonation`. */
  allReportedDonations?: Maybe<ReportedDonationsConnection>;
  /** Reads a set of `ReportedDonation`. */
  allReportedDonationsList?: Maybe<Array<ReportedDonation>>;
  /** Reads and enables pagination through a set of `ShortPayment`. */
  allShortPayments?: Maybe<ShortPaymentsConnection>;
  /** Reads a set of `ShortPayment`. */
  allShortPaymentsList?: Maybe<Array<ShortPayment>>;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  allStripeCustomers?: Maybe<StripeCustomersConnection>;
  /** Reads a set of `StripeCustomer`. */
  allStripeCustomersList?: Maybe<Array<StripeCustomer>>;
  /** Reads and enables pagination through a set of `SucceededPayment`. */
  allSucceededPayments?: Maybe<SucceededPaymentsConnection>;
  /** Reads a set of `SucceededPayment`. */
  allSucceededPaymentsList?: Maybe<Array<SucceededPayment>>;
  /** Reads and enables pagination through a set of `TemporaryPerson`. */
  allTemporaryPeople?: Maybe<TemporaryPeopleConnection>;
  /** Reads a set of `TemporaryPerson`. */
  allTemporaryPeopleList?: Maybe<Array<TemporaryPerson>>;
  /** Reads and enables pagination through a set of `TotalProjectedDonation`. */
  allTotalProjectedDonations?: Maybe<TotalProjectedDonationsConnection>;
  /** Reads a set of `TotalProjectedDonation`. */
  allTotalProjectedDonationsList?: Maybe<Array<TotalProjectedDonation>>;
  /** Reads and enables pagination through a set of `UnpaidPayment`. */
  allUnpaidPayments?: Maybe<UnpaidPaymentsConnection>;
  /** Reads a set of `UnpaidPayment`. */
  allUnpaidPaymentsList?: Maybe<Array<UnpaidPayment>>;
  /** Reads and enables pagination through a set of `WageGrowthInterpolated`. */
  allWageGrowthInterpolateds?: Maybe<WageGrowthInterpolatedsConnection>;
  /** Reads a set of `WageGrowthInterpolated`. */
  allWageGrowthInterpolatedsList?: Maybe<Array<WageGrowthInterpolated>>;
  /** Reads and enables pagination through a set of `WageGrowth`. */
  allWageGrowths?: Maybe<WageGrowthsConnection>;
  /** Reads a set of `WageGrowth`. */
  allWageGrowthsList?: Maybe<Array<WageGrowth>>;
  /** Reads and enables pagination through a set of `WorldFiscalYear`. */
  allWorldFiscalYears?: Maybe<WorldFiscalYearsConnection>;
  /** Reads a set of `WorldFiscalYear`. */
  allWorldFiscalYearsList?: Maybe<Array<WorldFiscalYear>>;
  /** Reads and enables pagination through a set of `WorldIncome`. */
  allWorldIncomes?: Maybe<WorldIncomesConnection>;
  /** Reads a set of `WorldIncome`. */
  allWorldIncomesList?: Maybe<Array<WorldIncome>>;
  /** Reads and enables pagination through a set of `XeroAccount`. */
  allXeroAccounts?: Maybe<XeroAccountsConnection>;
  /** Reads a set of `XeroAccount`. */
  allXeroAccountsList?: Maybe<Array<XeroAccount>>;
  /** Reads and enables pagination through a set of `XeroApp`. */
  allXeroApps?: Maybe<XeroAppsConnection>;
  /** Reads a set of `XeroApp`. */
  allXeroAppsList?: Maybe<Array<XeroApp>>;
  /** Reads and enables pagination through a set of `XeroContact`. */
  allXeroContacts?: Maybe<XeroContactsConnection>;
  /** Reads a set of `XeroContact`. */
  allXeroContactsList?: Maybe<Array<XeroContact>>;
  /** Reads and enables pagination through a set of `XeroTracking`. */
  allXeroTrackings?: Maybe<XeroTrackingsConnection>;
  /** Reads a set of `XeroTracking`. */
  allXeroTrackingsList?: Maybe<Array<XeroTracking>>;
  /** Reads a single `Allocation` using its globally unique `ID`. */
  allocation?: Maybe<Allocation>;
  allocationByPersonId?: Maybe<Allocation>;
  arraySuffix?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reads a single `BalanceSheetReport` using its globally unique `ID`. */
  balanceSheetReport?: Maybe<BalanceSheetReport>;
  balanceSheetReportByReportDateAndRecipientAndReference?: Maybe<BalanceSheetReport>;
  /** Reads a single `Changelog` using its globally unique `ID`. */
  changelog?: Maybe<Changelog>;
  changelogById?: Maybe<Changelog>;
  closestExchangeRate?: Maybe<ExchangeRate>;
  /** Reads a single `ContactPreference` using its globally unique `ID`. */
  contactPreference?: Maybe<ContactPreference>;
  contactPreferenceByPersonId?: Maybe<ContactPreference>;
  convertCurrency?: Maybe<Scalars['BigFloat']>;
  /** Reads a single `Country` using its globally unique `ID`. */
  country?: Maybe<Country>;
  countryByIsoAlpha2?: Maybe<Country>;
  /** Reads a single `CountryPaymentMethod` using its globally unique `ID`. */
  countryPaymentMethod?: Maybe<CountryPaymentMethod>;
  countryPaymentMethodByCountryCodeAndGatewayAndPaymentMethod?: Maybe<CountryPaymentMethod>;
  /** Reads a single `Currency` using its globally unique `ID`. */
  currency?: Maybe<Currency>;
  currencyByCode?: Maybe<Currency>;
  /** Reads a single `CurrencyByCountry` using its globally unique `ID`. */
  currencyByCountry?: Maybe<CurrencyByCountry>;
  currencyByCountryByCountryCodeAndCurrencyCode?: Maybe<CurrencyByCountry>;
  currentPerson?: Maybe<Person>;
  decodeHashid?: Maybe<Scalars['BigInt']>;
  /** Reads a single `Disbursement` using its globally unique `ID`. */
  disbursement?: Maybe<Disbursement>;
  disbursementByName?: Maybe<Disbursement>;
  /** Reads a single `DisbursementEntry` using its globally unique `ID`. */
  disbursementEntry?: Maybe<DisbursementEntry>;
  disbursementEntryByDisbursementNameAndPaymentIdAndOrganizationSlug?: Maybe<DisbursementEntry>;
  /** Reads a single `EmailAddress` using its globally unique `ID`. */
  emailAddress?: Maybe<EmailAddress>;
  emailAddressByEmail?: Maybe<EmailAddress>;
  emailAddressByPersonIdAndEmail?: Maybe<EmailAddress>;
  /** Reads and enables pagination through a set of `EmailAddress`. */
  emailAddressesByPersonId?: Maybe<EmailAddressesConnection>;
  /** Reads and enables pagination through a set of `EmailAddress`. */
  emailAddressesByPersonIdList?: Maybe<Array<Maybe<EmailAddress>>>;
  encodeHashid?: Maybe<Scalars['String']>;
  /** Reads a single `EoyTaxReceipt` using its globally unique `ID`. */
  eoyTaxReceipt?: Maybe<EoyTaxReceipt>;
  eoyTaxReceiptByPersonIdAndRecipientAndPeriod?: Maybe<EoyTaxReceipt>;
  /** Reads a single `ExchangeRate` using its globally unique `ID`. */
  exchangeRate?: Maybe<ExchangeRate>;
  exchangeRateByCurrencyCodeAndDate?: Maybe<ExchangeRate>;
  extendedLotteryById?: Maybe<ExtendedLottery>;
  /** Reads a single `ExternalOrganization` using its globally unique `ID`. */
  externalOrganization?: Maybe<ExternalOrganization>;
  externalOrganizationById?: Maybe<ExternalOrganization>;
  externalOrganizationByName?: Maybe<ExternalOrganization>;
  externalOrganizationByOrganizationSlug?: Maybe<ExternalOrganization>;
  /** Reads and enables pagination through a set of `ExternalOrganization`. */
  externalOrganizationTypeahead?: Maybe<ExternalOrganizationsConnection>;
  /** Reads and enables pagination through a set of `ExternalOrganization`. */
  externalOrganizationTypeaheadList?: Maybe<Array<Maybe<ExternalOrganization>>>;
  /** Reads a single `FailedRecurringPayment` using its globally unique `ID`. */
  failedRecurringPayment?: Maybe<FailedRecurringPayment>;
  failedRecurringPaymentByRecurringPaymentId?: Maybe<FailedRecurringPayment>;
  findClosestLiability?: Maybe<Liability>;
  /** Reads and enables pagination through a set of `Person`. */
  findPersonByNameFuzzy?: Maybe<PeopleConnection>;
  /** Reads and enables pagination through a set of `Person`. */
  findPersonByNameFuzzyList?: Maybe<Array<Maybe<Person>>>;
  /** Reads and enables pagination through a set of `Person`. */
  findPersonByNameOrEmail?: Maybe<PeopleConnection>;
  /** Reads and enables pagination through a set of `Person`. */
  findPersonByNameOrEmailList?: Maybe<Array<Maybe<Person>>>;
  /** Reads and enables pagination through a set of `Person`. */
  findPersonByPaymentReference?: Maybe<PeopleConnection>;
  /** Reads and enables pagination through a set of `Person`. */
  findPersonByPaymentReferenceList?: Maybe<Array<Maybe<Person>>>;
  /** Reads a single `FtxCoin` using its globally unique `ID`. */
  ftxCoin?: Maybe<FtxCoin>;
  ftxCoinByCodeAndRecipientAndMethod?: Maybe<FtxCoin>;
  /** Reads a single `FtxConversion` using its globally unique `ID`. */
  ftxConversion?: Maybe<FtxConversion>;
  ftxConversionByGatewayTransactionId?: Maybe<FtxConversion>;
  ftxConversionById?: Maybe<FtxConversion>;
  /** Reads a single `GatewayPaymentMethod` using its globally unique `ID`. */
  gatewayPaymentMethod?: Maybe<GatewayPaymentMethod>;
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  /** Reads a single `GatewayPayoutReport` using its globally unique `ID`. */
  gatewayPayoutReport?: Maybe<GatewayPayoutReport>;
  gatewayPayoutReportByPayoutId?: Maybe<GatewayPayoutReport>;
  /** Reads a single `GatewayPayoutReportEntry` using its globally unique `ID`. */
  gatewayPayoutReportEntry?: Maybe<GatewayPayoutReportEntry>;
  gatewayPayoutReportEntryById?: Maybe<GatewayPayoutReportEntry>;
  gatewayPayoutReportEntryByPayoutIdAndGatewayTransactionIdAndEntryType?: Maybe<GatewayPayoutReportEntry>;
  /** Reads and enables pagination through a set of `Address`. */
  getAddressesByPersonOrTemporaryPerson?: Maybe<AddressesConnection>;
  /** Reads and enables pagination through a set of `Address`. */
  getAddressesByPersonOrTemporaryPersonList?: Maybe<Array<Maybe<Address>>>;
  /** Reads and enables pagination through a set of `Address`. */
  getAddressesByTemporaryPerson?: Maybe<AddressesConnection>;
  /** Reads and enables pagination through a set of `Address`. */
  getAddressesByTemporaryPersonList?: Maybe<Array<Maybe<Address>>>;
  /** Reads and enables pagination through a set of `BalanceSheetReportMonthlyTotal`. */
  getBalanceSheetMonthlyTotalByReference?: Maybe<BalanceSheetReportMonthlyTotalsConnection>;
  /** Reads and enables pagination through a set of `BalanceSheetReportMonthlyTotal`. */
  getBalanceSheetMonthlyTotalByReferenceList?: Maybe<Array<Maybe<BalanceSheetReportMonthlyTotal>>>;
  /** Reads and enables pagination through a set of `BalanceSheetReportMonthlyTotal`. */
  getBalanceSheetReportMonthlyTotal?: Maybe<BalanceSheetReportMonthlyTotalsConnection>;
  /** Reads and enables pagination through a set of `BalanceSheetReportMonthlyTotal`. */
  getBalanceSheetReportMonthlyTotalList?: Maybe<Array<Maybe<BalanceSheetReportMonthlyTotal>>>;
  getConstantDefaultBirthDate?: Maybe<Scalars['Date']>;
  getConstantDefaultIncome?: Maybe<Scalars['BigFloat']>;
  getConstantDefaultRetirementAge?: Maybe<Interval>;
  getFullPledgeLiability?: Maybe<Scalars['BigFloat']>;
  /** Reads and enables pagination through a set of `FundraiserStat`. */
  getFundraiserStats?: Maybe<FundraiserStatsConnection>;
  /** Reads and enables pagination through a set of `FundraiserStat`. */
  getFundraiserStatsList?: Maybe<Array<Maybe<FundraiserStat>>>;
  getGiftAidClaim?: Maybe<GiftAidClaim>;
  /** Reads and enables pagination through a set of `GetGivingSeasonStatsT`. */
  getGivingSeasonStats?: Maybe<GetGivingSeasonStatsTsConnection>;
  /** Reads and enables pagination through a set of `GetGivingSeasonStatsT`. */
  getGivingSeasonStatsList?: Maybe<Array<Maybe<GetGivingSeasonStatsT>>>;
  /** Reads and enables pagination through a set of `GocardlessMandate`. */
  getGocardlessMandatesByPersonOrTemporaryPerson?: Maybe<GocardlessMandatesConnection>;
  /** Reads and enables pagination through a set of `GocardlessMandate`. */
  getGocardlessMandatesByPersonOrTemporaryPersonList?: Maybe<Array<Maybe<GocardlessMandate>>>;
  /** Reads and enables pagination through a set of `GocardlessMandate`. */
  getGocardlessMandatesByTemporaryPerson?: Maybe<GocardlessMandatesConnection>;
  /** Reads and enables pagination through a set of `GocardlessMandate`. */
  getGocardlessMandatesByTemporaryPersonList?: Maybe<Array<Maybe<GocardlessMandate>>>;
  getGocardlessRedirectFlowByPersonOrTemporaryPerson?: Maybe<GocardlessRedirectFlow>;
  getGocardlessRedirectFlowByTemporaryPerson?: Maybe<GocardlessRedirectFlow>;
  getGwwcMemberCount?: Maybe<Scalars['BigInt']>;
  /** Reads and enables pagination through a set of `CountryCount`. */
  getGwwcMemberCountries?: Maybe<CountryCountsConnection>;
  /** Reads and enables pagination through a set of `CountryCount`. */
  getGwwcMemberCountriesList?: Maybe<Array<Maybe<CountryCount>>>;
  getImpliedExchangeRate?: Maybe<Scalars['BigFloat']>;
  /** Reads and enables pagination through a set of `Income`. */
  getIncomesByPersonId?: Maybe<IncomesConnection>;
  /** Reads and enables pagination through a set of `Income`. */
  getIncomesByPersonIdList?: Maybe<Array<Maybe<Income>>>;
  /** Reads and enables pagination through a set of `Liability`. */
  getLiabilitiesForPledge?: Maybe<LiabilitiesConnection>;
  /** Reads and enables pagination through a set of `Liability`. */
  getLiabilitiesForPledgeList?: Maybe<Array<Maybe<Liability>>>;
  /** Reads and enables pagination through a set of `LiabilityCompletionT`. */
  getLiabilityCompletion?: Maybe<LiabilityCompletionTsConnection>;
  /** Reads and enables pagination through a set of `LiabilityCompletionT`. */
  getLiabilityCompletionByPledge?: Maybe<LiabilityCompletionTsConnection>;
  /** Reads and enables pagination through a set of `LiabilityCompletionT`. */
  getLiabilityCompletionByPledgeList?: Maybe<Array<Maybe<LiabilityCompletionT>>>;
  /** Reads and enables pagination through a set of `LiabilityCompletionT`. */
  getLiabilityCompletionList?: Maybe<Array<Maybe<LiabilityCompletionT>>>;
  /** Reads and enables pagination through a set of `LiabilityTotalCompletionT`. */
  getLiabilityTotalCompletion?: Maybe<LiabilityTotalCompletionTsConnection>;
  /** Reads and enables pagination through a set of `LiabilityTotalCompletionT`. */
  getLiabilityTotalCompletionList?: Maybe<Array<Maybe<LiabilityTotalCompletionT>>>;
  /** Reads and enables pagination through a set of `LotteryEntryPublic`. */
  getLotteryEntriesByLotteryId?: Maybe<LotteryEntryPublicsConnection>;
  /** Reads and enables pagination through a set of `LotteryEntryPublic`. */
  getLotteryEntriesByLotteryIdList?: Maybe<Array<Maybe<LotteryEntryPublic>>>;
  /** Reads and enables pagination through a set of `LotteryEntryComplete`. */
  getLotteryEntriesCompleteByLotteryId?: Maybe<LotteryEntryCompletesConnection>;
  /** Reads and enables pagination through a set of `LotteryEntryComplete`. */
  getLotteryEntriesCompleteByLotteryIdList?: Maybe<Array<Maybe<LotteryEntryComplete>>>;
  getLotterySummaryByLotteryId?: Maybe<LotterySummary>;
  getPaymentAccessTokenByPersonOrTemporaryPerson?: Maybe<PaymentAccessToken>;
  getPaymentAccessTokenByTemporaryPerson?: Maybe<PaymentAccessToken>;
  getPaymentByAccessToken?: Maybe<Payment>;
  getPaymentByPersonOrTemporaryPerson?: Maybe<Payment>;
  getPaymentByTemporaryPerson?: Maybe<Payment>;
  /** Reads and enables pagination through a set of `PaymentDetailsByOrganization`. */
  getPaymentDetailsByOrganization?: Maybe<PaymentDetailsByOrganizationsConnection>;
  /** Reads and enables pagination through a set of `PaymentDetailsByOrganization`. */
  getPaymentDetailsByOrganizationList?: Maybe<Array<Maybe<PaymentDetailsByOrganization>>>;
  /** Reads and enables pagination through a set of `PaymentReportByOrganization`. */
  getPaymentReportByOrganization?: Maybe<PaymentReportByOrganizationsConnection>;
  /** Reads and enables pagination through a set of `PaymentReportByOrganization`. */
  getPaymentReportByOrganizationList?: Maybe<Array<Maybe<PaymentReportByOrganization>>>;
  getPaymentStatsAggregate?: Maybe<PaymentStatsAggregate>;
  getPaymentStatsByOrganization?: Maybe<PaymentStatsByOrganization>;
  getPayrollGivingProviderCustomer?: Maybe<PayrollGivingProviderCustomer>;
  getPledgeLiabilityThroughToday?: Maybe<Scalars['BigFloat']>;
  /** Reads and enables pagination through a set of `Pledge`. */
  getPledgesByPersonId?: Maybe<PledgesConnection>;
  /** Reads and enables pagination through a set of `Pledge`. */
  getPledgesByPersonIdList?: Maybe<Array<Maybe<Pledge>>>;
  /** Reads and enables pagination through a set of `ProjectedDonation`. */
  getProjectedDonationsByPledge?: Maybe<ProjectedDonationsConnection>;
  /** Reads and enables pagination through a set of `ProjectedDonation`. */
  getProjectedDonationsByPledgeList?: Maybe<Array<Maybe<ProjectedDonation>>>;
  getRecurringPaymentByPersonOrTemporaryPerson?: Maybe<RecurringPayment>;
  getRecurringPaymentByTemporaryPerson?: Maybe<RecurringPayment>;
  /** Reads and enables pagination through a set of `RecurringReportedDonation`. */
  getRecurringReportedDonationsByPersonId?: Maybe<RecurringReportedDonationsConnection>;
  /** Reads and enables pagination through a set of `RecurringReportedDonation`. */
  getRecurringReportedDonationsByPersonIdList?: Maybe<Array<Maybe<RecurringReportedDonation>>>;
  getTemporaryPersonBySessionToken?: Maybe<TemporaryPerson>;
  getTotalGwwcDonations?: Maybe<Scalars['BigFloat']>;
  getTotalProjectedDonations?: Maybe<GetTotalProjectedDonationsT>;
  /** Reads and enables pagination through a set of `CompletionPayment`. */
  getUnattachedCompletionPayments?: Maybe<CompletionPaymentsConnection>;
  /** Reads and enables pagination through a set of `CompletionPayment`. */
  getUnattachedCompletionPaymentsList?: Maybe<Array<Maybe<CompletionPayment>>>;
  /** Reads a single `GiftAidClaim` using its globally unique `ID`. */
  giftAidClaim?: Maybe<GiftAidClaim>;
  /** Reads a single `GiftAidClaimBackup` using its globally unique `ID`. */
  giftAidClaimBackup?: Maybe<GiftAidClaimBackup>;
  giftAidClaimBackupByPaymentId?: Maybe<GiftAidClaimBackup>;
  giftAidClaimByGiftAidPaymentId?: Maybe<GiftAidClaim>;
  giftAidClaimByPaymentId?: Maybe<GiftAidClaim>;
  /** Reads a single `GivingWhatWeCanSurvey` using its globally unique `ID`. */
  givingWhatWeCanSurvey?: Maybe<GivingWhatWeCanSurvey>;
  givingWhatWeCanSurveyByPersonId?: Maybe<GivingWhatWeCanSurvey>;
  gocardlessCustomerByGocardlessCustomerId?: Maybe<GocardlessCustomer>;
  gocardlessCustomerByPersonIdAndGocardlessCustomerId?: Maybe<GocardlessCustomer>;
  gocardlessMandateByGocardlessMandateId?: Maybe<GocardlessMandate>;
  /** Reads a single `GocardlessRedirectFlow` using its globally unique `ID`. */
  gocardlessRedirectFlow?: Maybe<GocardlessRedirectFlow>;
  gocardlessRedirectFlowByGocardlessRedirectFlowId?: Maybe<GocardlessRedirectFlow>;
  gocardlessRedirectFlowByGocardlessRedirectFlowUrl?: Maybe<GocardlessRedirectFlow>;
  gocardlessRedirectFlowByPersonId?: Maybe<GocardlessRedirectFlow>;
  gocardlessRedirectFlowBySessionToken?: Maybe<GocardlessRedirectFlow>;
  hashidsdefaultalphabet?: Maybe<Scalars['String']>;
  hex2Bigint?: Maybe<Scalars['BigInt']>;
  /** Reads a single `Income` using its globally unique `ID`. */
  income?: Maybe<Income>;
  incomeById?: Maybe<Income>;
  isValidJson?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Liability` using its globally unique `ID`. */
  liability?: Maybe<Liability>;
  liabilityByPledgeIdAndIncomeId?: Maybe<Liability>;
  /** Reads a single `LiabilityPayment` using its globally unique `ID`. */
  liabilityPayment?: Maybe<LiabilityPayment>;
  liabilityPaymentById?: Maybe<LiabilityPayment>;
  liabilityPaymentByPersonIdAndPaymentId?: Maybe<LiabilityPayment>;
  liabilityPaymentByPersonIdAndReportedDonationId?: Maybe<LiabilityPayment>;
  /** Reads a single `Lottery` using its globally unique `ID`. */
  lottery?: Maybe<Lottery>;
  lotteryById?: Maybe<Lottery>;
  /** Reads a single `LotteryEntry` using its globally unique `ID`. */
  lotteryEntry?: Maybe<LotteryEntry>;
  lotteryEntryByLotteryIdAndPaymentId?: Maybe<LotteryEntry>;
  lotteryEntryByPaymentId?: Maybe<LotteryEntry>;
  /** Reads a single `LotteryTicket` using its globally unique `ID`. */
  lotteryTicket?: Maybe<LotteryTicket>;
  lotteryTicketByLotteryIdAndPaymentIdAndBlockId?: Maybe<LotteryTicket>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  normalizeAmountToUsd?: Maybe<Scalars['BigFloat']>;
  /** Reads a single `Organization` using its globally unique `ID`. */
  organization?: Maybe<Organization>;
  organizationByNameAndProgram?: Maybe<Organization>;
  organizationBySlug?: Maybe<Organization>;
  /** Reads a single `OrganizationCategory` using its globally unique `ID`. */
  organizationCategory?: Maybe<OrganizationCategory>;
  organizationCategoryBySlug?: Maybe<OrganizationCategory>;
  organizationCategoryCheck?: Maybe<Scalars['Boolean']>;
  organizationSlugsArray?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reads a single `Payment` using its globally unique `ID`. */
  payment?: Maybe<Payment>;
  /** Reads a single `PaymentAccessToken` using its globally unique `ID`. */
  paymentAccessToken?: Maybe<PaymentAccessToken>;
  paymentAccessTokenByPaymentId?: Maybe<PaymentAccessToken>;
  paymentAccessTokenByToken?: Maybe<PaymentAccessToken>;
  paymentByGatewayAndGatewayTransactionId?: Maybe<Payment>;
  paymentById?: Maybe<Payment>;
  paymentByIdAndPersonId?: Maybe<Payment>;
  paymentByReference?: Maybe<Payment>;
  /** Reads a single `PaymentRecipient` using its globally unique `ID`. */
  paymentRecipient?: Maybe<PaymentRecipient>;
  paymentRecipientBySlug?: Maybe<PaymentRecipient>;
  /** Reads a single `PaymentRecipientCountriesServiced` using its globally unique `ID`. */
  paymentRecipientCountriesServiced?: Maybe<PaymentRecipientCountriesServiced>;
  paymentRecipientCountriesServicedByCountryCode?: Maybe<PaymentRecipientCountriesServiced>;
  paymentRecipientCountriesServicedByRecipientAndCountryCode?: Maybe<PaymentRecipientCountriesServiced>;
  /** Reads a single `PaymentSharingConsent` using its globally unique `ID`. */
  paymentSharingConsent?: Maybe<PaymentSharingConsent>;
  paymentSharingConsentByPaymentIdAndOrganizationSlug?: Maybe<PaymentSharingConsent>;
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByPersonId?: Maybe<PaymentsConnection>;
  /** Reads and enables pagination through a set of `Payment`. */
  paymentsByPersonIdList?: Maybe<Array<Maybe<Payment>>>;
  /** Reads a single `PaymentsManager` using its globally unique `ID`. */
  paymentsManager?: Maybe<PaymentsManager>;
  paymentsManagerByPersonId?: Maybe<PaymentsManager>;
  /** Reads a single `PayrollGivingProviderCustomer` using its globally unique `ID`. */
  payrollGivingProviderCustomer?: Maybe<PayrollGivingProviderCustomer>;
  payrollGivingProviderCustomerByProviderAndProviderCustomerId?: Maybe<PayrollGivingProviderCustomer>;
  /** Reads a single `Person` using its globally unique `ID`. */
  person?: Maybe<Person>;
  personByAuth0UserId?: Maybe<Person>;
  personByEmail?: Maybe<Person>;
  personById?: Maybe<Person>;
  /** Reads and enables pagination through a set of `PersonDonationToOrg`. */
  personDonationsToOrg?: Maybe<PersonDonationToOrgsConnection>;
  /** Reads and enables pagination through a set of `PersonDonationToOrg`. */
  personDonationsToOrgList?: Maybe<Array<Maybe<PersonDonationToOrg>>>;
  /** Reads and enables pagination through a set of `Person`. */
  personSearchName?: Maybe<PeopleConnection>;
  /** Reads and enables pagination through a set of `Person`. */
  personSearchNameList?: Maybe<Array<Maybe<Person>>>;
  /** Reads a single `Pledge` using its globally unique `ID`. */
  pledge?: Maybe<Pledge>;
  pledgeById?: Maybe<Pledge>;
  pledgeCount?: Maybe<Scalars['Int']>;
  /** Reads a single `PledgeRank` using its globally unique `ID`. */
  pledgeRank?: Maybe<PledgeRank>;
  pledgeRankByPersonIdAndPledgeType?: Maybe<PledgeRank>;
  /** Reads a single `PledgesManager` using its globally unique `ID`. */
  pledgesManager?: Maybe<PledgesManager>;
  pledgesManagerByPersonId?: Maybe<PledgesManager>;
  /** Reads a single `PollOptionPublic` using its globally unique `ID`. */
  pollOptionPublic?: Maybe<PollOptionPublic>;
  pollOptionPublicById?: Maybe<PollOptionPublic>;
  /** Reads a single `PollOptionVote` using its globally unique `ID`. */
  pollOptionVote?: Maybe<PollOptionVote>;
  pollOptionVoteByPersonIdAndPollOptionId?: Maybe<PollOptionVote>;
  /** Reads a single `PollPublic` using its globally unique `ID`. */
  pollPublic?: Maybe<PollPublic>;
  pollPublicById?: Maybe<PollPublic>;
  /** Reads a single `Privacy` using its globally unique `ID`. */
  privacy?: Maybe<Privacy>;
  privacyByPersonId?: Maybe<Privacy>;
  /** Reads a single `ProjectedDonation` using its globally unique `ID`. */
  projectedDonation?: Maybe<ProjectedDonation>;
  projectedDonationByPersonIdAndPledgeIdAndProjectionYear?: Maybe<ProjectedDonation>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads a single `RecipientProgram` using its globally unique `ID`. */
  recipientProgram?: Maybe<RecipientProgram>;
  recipientProgramByOrganizationSlugAndRecipientSlug?: Maybe<RecipientProgram>;
  /** Reads a single `RecurringPayment` using its globally unique `ID`. */
  recurringPayment?: Maybe<RecurringPayment>;
  recurringPaymentById?: Maybe<RecurringPayment>;
  /** Reads and enables pagination through a set of `RecurringPayment`. */
  recurringPaymentsByPersonId?: Maybe<RecurringPaymentsConnection>;
  /** Reads and enables pagination through a set of `RecurringPayment`. */
  recurringPaymentsByPersonIdList?: Maybe<Array<Maybe<RecurringPayment>>>;
  /** Reads a single `RecurringReportedDonation` using its globally unique `ID`. */
  recurringReportedDonation?: Maybe<RecurringReportedDonation>;
  recurringReportedDonationById?: Maybe<RecurringReportedDonation>;
  /** Reads a single `ReferralSource` using its globally unique `ID`. */
  referralSource?: Maybe<ReferralSource>;
  referralSourceBySlug?: Maybe<ReferralSource>;
  referralSourceCheck?: Maybe<Scalars['Boolean']>;
  /** Reads a single `ReportedDonation` using its globally unique `ID`. */
  reportedDonation?: Maybe<ReportedDonation>;
  reportedDonationById?: Maybe<ReportedDonation>;
  /** Reads and enables pagination through a set of `ReportedDonation`. */
  reportedDonationsByPersonId?: Maybe<ReportedDonationsConnection>;
  /** Reads and enables pagination through a set of `ReportedDonation`. */
  reportedDonationsByPersonIdList?: Maybe<Array<Maybe<ReportedDonation>>>;
  sendReceipt?: Maybe<Scalars['String']>;
  slugify?: Maybe<Scalars['String']>;
  /** Reads a single `StripeCustomer` using its globally unique `ID`. */
  stripeCustomer?: Maybe<StripeCustomer>;
  stripeCustomerByPersonIdAndRecipientAndCurrencyCode?: Maybe<StripeCustomer>;
  stripeCustomerByStripeCustomerId?: Maybe<StripeCustomer>;
  /** Reads a single `TemporaryPerson` using its globally unique `ID`. */
  temporaryPerson?: Maybe<TemporaryPerson>;
  temporaryPersonByEmail?: Maybe<TemporaryPerson>;
  validHref?: Maybe<Scalars['Boolean']>;
  validRelativeUrl?: Maybe<Scalars['Boolean']>;
  validUrl?: Maybe<Scalars['Boolean']>;
  validateAllocation?: Maybe<Scalars['Boolean']>;
  validateCryptoSpotPrice?: Maybe<Scalars['Boolean']>;
  /** Reads a single `WorldFiscalYear` using its globally unique `ID`. */
  worldFiscalYear?: Maybe<WorldFiscalYear>;
  worldFiscalYearByCountryCode?: Maybe<WorldFiscalYear>;
  /** Reads a single `WorldIncome` using its globally unique `ID`. */
  worldIncome?: Maybe<WorldIncome>;
  worldIncomeByCurrencyCodeAndCountryCodeAndCohortAndDataYear?: Maybe<WorldIncome>;
  /** Reads a single `XeroAccount` using its globally unique `ID`. */
  xeroAccount?: Maybe<XeroAccount>;
  xeroAccountByRecipientAndReference?: Maybe<XeroAccount>;
  /** Reads a single `XeroApp` using its globally unique `ID`. */
  xeroApp?: Maybe<XeroApp>;
  xeroAppByAppName?: Maybe<XeroApp>;
  xeroAppByClientId?: Maybe<XeroApp>;
  /** Reads a single `XeroContact` using its globally unique `ID`. */
  xeroContact?: Maybe<XeroContact>;
  xeroContactByPersonIdAndRecipient?: Maybe<XeroContact>;
  xeroContactByXeroContactId?: Maybe<XeroContact>;
  /** Reads a single `XeroTracking` using its globally unique `ID`. */
  xeroTracking?: Maybe<XeroTracking>;
  xeroTrackingByRecipientAndReferenceAndXeroTrackingCategoryName?: Maybe<XeroTracking>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountingInvoiceArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountingInvoiceByInvoiceIdArgs = {
  invoiceId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountingInvoiceByPaymentIdAndPayoutReportIdAndInvoiceTypeArgs = {
  invoiceType: InvoiceType;
  paymentId: Scalars['BigInt'];
  payoutReportId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAcquisitionArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAcquisitionByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddressArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddressBackupArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddressBackupByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddressBackupByIdAndPersonIdArgs = {
  id: Scalars['BigInt'];
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddressBackupByPersonIdAndCoordinatesArgs = {
  coordinates: Scalars['String'];
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddressBackupByPersonIdAndFormattedAddressArgs = {
  formattedAddress: Scalars['String'];
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddressBackupByPersonIdAndGooglePlaceIdArgs = {
  googlePlaceId: Scalars['String'];
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddressByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddressByIdAndPersonIdArgs = {
  id: Scalars['BigInt'];
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddressesByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddressesByPersonIdListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAccountingInvoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountingInvoiceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountingInvoicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAccountingInvoicesListArgs = {
  condition?: InputMaybe<AccountingInvoiceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountingInvoicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAcquisitionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AcquisitionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AcquisitionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAcquisitionsListArgs = {
  condition?: InputMaybe<AcquisitionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AcquisitionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllActiveExtendedLotteriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ActiveExtendedLotteryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActiveExtendedLotteriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllActiveExtendedLotteriesListArgs = {
  condition?: InputMaybe<ActiveExtendedLotteryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActiveExtendedLotteriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAddressBackupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AddressBackupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressBackupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAddressBackupsListArgs = {
  condition?: InputMaybe<AddressBackupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressBackupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAddressesListArgs = {
  condition?: InputMaybe<AddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAllPledgesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllPledgeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllPledgesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAllPledgesListArgs = {
  condition?: InputMaybe<AllPledgeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllPledgesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAllPledgesPublicsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllPledgesPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllPledgesPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAllPledgesPublicsListArgs = {
  condition?: InputMaybe<AllPledgesPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllPledgesPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAllocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllocationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAllocationsListArgs = {
  condition?: InputMaybe<AllocationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBalanceSheetReportMonthlyTotalsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BalanceSheetReportMonthlyTotalCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BalanceSheetReportMonthlyTotalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBalanceSheetReportMonthlyTotalsListArgs = {
  condition?: InputMaybe<BalanceSheetReportMonthlyTotalCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BalanceSheetReportMonthlyTotalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBalanceSheetReportPublicsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BalanceSheetReportPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BalanceSheetReportPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBalanceSheetReportPublicsListArgs = {
  condition?: InputMaybe<BalanceSheetReportPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BalanceSheetReportPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBalanceSheetReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BalanceSheetReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BalanceSheetReportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBalanceSheetReportsListArgs = {
  condition?: InputMaybe<BalanceSheetReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BalanceSheetReportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllChangelogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ChangelogCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChangelogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllChangelogsListArgs = {
  condition?: InputMaybe<ChangelogCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChangelogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllColorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ColorCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ColorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllColorsListArgs = {
  condition?: InputMaybe<ColorCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ColorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCommonNounsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CommonNounCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommonNounsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCommonNounsListArgs = {
  condition?: InputMaybe<CommonNounCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommonNounsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCompletionPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompletionPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompletionPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCompletionPaymentsListArgs = {
  condition?: InputMaybe<CompletionPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompletionPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllContactPreferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContactPreferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactPreferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllContactPreferencesListArgs = {
  condition?: InputMaybe<ContactPreferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactPreferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCountriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CountryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCountriesListArgs = {
  condition?: InputMaybe<CountryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCountryPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CountryPaymentMethodCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountryPaymentMethodsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCountryPaymentMethodsListArgs = {
  condition?: InputMaybe<CountryPaymentMethodCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountryPaymentMethodsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCurrenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CurrencyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrenciesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCurrenciesListArgs = {
  condition?: InputMaybe<CurrencyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrenciesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCurrencyByCountriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CurrencyByCountryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrencyByCountriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCurrencyByCountriesListArgs = {
  condition?: InputMaybe<CurrencyByCountryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrencyByCountriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDisbursementEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DisbursementEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisbursementEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDisbursementEntriesListArgs = {
  condition?: InputMaybe<DisbursementEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisbursementEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDisbursementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DisbursementCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisbursementsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDisbursementsListArgs = {
  condition?: InputMaybe<DisbursementCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisbursementsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEmailAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmailAddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmailAddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEmailAddressesListArgs = {
  condition?: InputMaybe<EmailAddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmailAddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEoyTaxReceiptExtendedsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EoyTaxReceiptExtendedCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EoyTaxReceiptExtendedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEoyTaxReceiptExtendedsListArgs = {
  condition?: InputMaybe<EoyTaxReceiptExtendedCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EoyTaxReceiptExtendedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEoyTaxReceiptsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EoyTaxReceiptCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EoyTaxReceiptsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEoyTaxReceiptsListArgs = {
  condition?: InputMaybe<EoyTaxReceiptCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EoyTaxReceiptsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllExchangeRatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExchangeRateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExchangeRatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllExchangeRatesListArgs = {
  condition?: InputMaybe<ExchangeRateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExchangeRatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllExtendedLotteriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExtendedLotteryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExtendedLotteriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllExtendedLotteriesListArgs = {
  condition?: InputMaybe<ExtendedLotteryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExtendedLotteriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllExternalOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalOrganizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllExternalOrganizationsListArgs = {
  condition?: InputMaybe<ExternalOrganizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFailedPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FailedPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FailedPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFailedPaymentsListArgs = {
  condition?: InputMaybe<FailedPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FailedPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFailedRecurringPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FailedRecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FailedRecurringPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFailedRecurringPaymentsListArgs = {
  condition?: InputMaybe<FailedRecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FailedRecurringPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFtxCoinsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FtxCoinCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxCoinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFtxCoinsListArgs = {
  condition?: InputMaybe<FtxCoinCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxCoinsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFtxConversionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FtxConversionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxConversionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFtxConversionsListArgs = {
  condition?: InputMaybe<FtxConversionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FtxConversionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFundsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FundCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FundsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFundsListArgs = {
  condition?: InputMaybe<FundCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FundsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGatewayPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GatewayPaymentMethodCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPaymentMethodsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGatewayPaymentMethodsListArgs = {
  condition?: InputMaybe<GatewayPaymentMethodCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPaymentMethodsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGatewayPayoutReportAllocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GatewayPayoutReportAllocationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportAllocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGatewayPayoutReportAllocationsListArgs = {
  condition?: InputMaybe<GatewayPayoutReportAllocationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportAllocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGatewayPayoutReportEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GatewayPayoutReportEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGatewayPayoutReportEntriesListArgs = {
  condition?: InputMaybe<GatewayPayoutReportEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGatewayPayoutReportSummariesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GatewayPayoutReportSummaryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportSummariesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGatewayPayoutReportSummariesListArgs = {
  condition?: InputMaybe<GatewayPayoutReportSummaryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportSummariesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGatewayPayoutReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GatewayPayoutReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGatewayPayoutReportsListArgs = {
  condition?: InputMaybe<GatewayPayoutReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GatewayPayoutReportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGiftAidClaimBackupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GiftAidClaimBackupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimBackupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGiftAidClaimBackupsListArgs = {
  condition?: InputMaybe<GiftAidClaimBackupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimBackupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGiftAidClaimReportAllocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GiftAidClaimReportAllocationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimReportAllocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGiftAidClaimReportAllocationsListArgs = {
  condition?: InputMaybe<GiftAidClaimReportAllocationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimReportAllocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGiftAidClaimReportExtendedsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GiftAidClaimReportExtendedCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimReportExtendedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGiftAidClaimReportExtendedsListArgs = {
  condition?: InputMaybe<GiftAidClaimReportExtendedCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimReportExtendedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGiftAidClaimReportSummariesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GiftAidClaimReportSummaryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimReportSummariesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGiftAidClaimReportSummariesListArgs = {
  condition?: InputMaybe<GiftAidClaimReportSummaryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimReportSummariesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGiftAidClaimReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GiftAidClaimReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimReportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGiftAidClaimReportsListArgs = {
  condition?: InputMaybe<GiftAidClaimReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimReportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGiftAidClaimsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GiftAidClaimCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGiftAidClaimsListArgs = {
  condition?: InputMaybe<GiftAidClaimCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GiftAidClaimsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGivingWhatWeCanSurveysArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GivingWhatWeCanSurveyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GivingWhatWeCanSurveysOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGivingWhatWeCanSurveysListArgs = {
  condition?: InputMaybe<GivingWhatWeCanSurveyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GivingWhatWeCanSurveysOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGlobalStatsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GlobalStatCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GlobalStatsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGlobalStatsListArgs = {
  condition?: InputMaybe<GlobalStatCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GlobalStatsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGocardlessCustomersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GocardlessCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessCustomersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGocardlessCustomersListArgs = {
  condition?: InputMaybe<GocardlessCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessCustomersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGocardlessMandatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GocardlessMandateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessMandatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGocardlessMandatesListArgs = {
  condition?: InputMaybe<GocardlessMandateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessMandatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGocardlessRedirectFlowsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GocardlessRedirectFlowCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessRedirectFlowsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGocardlessRedirectFlowsListArgs = {
  condition?: InputMaybe<GocardlessRedirectFlowCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GocardlessRedirectFlowsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcCompliancesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GwwcComplianceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcCompliancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcCompliancesListArgs = {
  condition?: InputMaybe<GwwcComplianceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcCompliancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcMembersByCountriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GwwcMembersByCountryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcMembersByCountriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcMembersByCountriesListArgs = {
  condition?: InputMaybe<GwwcMembersByCountryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcMembersByCountriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcMembershipEmailExportsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GwwcMembershipEmailExportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcMembershipEmailExportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcMembershipEmailExportsListArgs = {
  condition?: InputMaybe<GwwcMembershipEmailExportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcMembershipEmailExportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcNewMemberInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GwwcNewMemberInfoCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcNewMemberInfosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcNewMemberInfosListArgs = {
  condition?: InputMaybe<GwwcNewMemberInfoCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcNewMemberInfosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcRecurringReportedDonationExtendedsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GwwcRecurringReportedDonationExtendedCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcRecurringReportedDonationExtendedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcRecurringReportedDonationExtendedsListArgs = {
  condition?: InputMaybe<GwwcRecurringReportedDonationExtendedCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcRecurringReportedDonationExtendedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcReportedDonationExtendedsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GwwcReportedDonationExtendedCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcReportedDonationExtendedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcReportedDonationExtendedsListArgs = {
  condition?: InputMaybe<GwwcReportedDonationExtendedCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcReportedDonationExtendedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcSurveyReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GwwcSurveyReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcSurveyReportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGwwcSurveyReportsListArgs = {
  condition?: InputMaybe<GwwcSurveyReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GwwcSurveyReportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllIncomesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IncomeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IncomesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllIncomesListArgs = {
  condition?: InputMaybe<IncomeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IncomesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllIncompleteAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IncompleteAddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IncompleteAddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllIncompleteAddressesListArgs = {
  condition?: InputMaybe<IncompleteAddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IncompleteAddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiabilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LiabilityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiabilitiesListArgs = {
  condition?: InputMaybe<LiabilityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiabilityCompletionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LiabilityCompletionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityCompletionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiabilityCompletionsListArgs = {
  condition?: InputMaybe<LiabilityCompletionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityCompletionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiabilityPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LiabilityPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiabilityPaymentsListArgs = {
  condition?: InputMaybe<LiabilityPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiabilityTotalCompletionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LiabilityTotalCompletionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityTotalCompletionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiabilityTotalCompletionsListArgs = {
  condition?: InputMaybe<LiabilityTotalCompletionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityTotalCompletionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LotteryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteriesListArgs = {
  condition?: InputMaybe<LotteryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteryEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LotteryEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteryEntriesListArgs = {
  condition?: InputMaybe<LotteryEntryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteryEntryCompletesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LotteryEntryCompleteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryEntryCompletesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteryEntryCompletesListArgs = {
  condition?: InputMaybe<LotteryEntryCompleteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryEntryCompletesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteryEntryPublicsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LotteryEntryPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryEntryPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteryEntryPublicsListArgs = {
  condition?: InputMaybe<LotteryEntryPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryEntryPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotterySummariesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LotterySummaryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotterySummariesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotterySummariesListArgs = {
  condition?: InputMaybe<LotterySummaryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotterySummariesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteryTicketPublicsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LotteryTicketPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryTicketPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteryTicketPublicsListArgs = {
  condition?: InputMaybe<LotteryTicketPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryTicketPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteryTicketsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LotteryTicketCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryTicketsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteryTicketsListArgs = {
  condition?: InputMaybe<LotteryTicketCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryTicketsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteryWinnersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LotteryWinnerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryWinnersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLotteryWinnersListArgs = {
  condition?: InputMaybe<LotteryWinnerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LotteryWinnersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllNewPledgeInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NewPledgeInfoCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NewPledgeInfosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllNewPledgeInfosListArgs = {
  condition?: InputMaybe<NewPledgeInfoCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NewPledgeInfosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllNormalizedCurrenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NormalizedCurrencyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NormalizedCurrenciesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllNormalizedCurrenciesListArgs = {
  condition?: InputMaybe<NormalizedCurrencyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NormalizedCurrenciesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrganizationCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrganizationCategoryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationCategoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrganizationCategoriesListArgs = {
  condition?: InputMaybe<OrganizationCategoryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationCategoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrganizationsListArgs = {
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentAccessTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentAccessTokenCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentAccessTokensOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentAccessTokensListArgs = {
  condition?: InputMaybe<PaymentAccessTokenCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentAccessTokensOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentDetailsByOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentDetailsByOrganizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentDetailsByOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentDetailsByOrganizationsListArgs = {
  condition?: InputMaybe<PaymentDetailsByOrganizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentDetailsByOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentRecipientCountriesServicedsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentRecipientCountriesServicedCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecipientCountriesServicedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentRecipientCountriesServicedsListArgs = {
  condition?: InputMaybe<PaymentRecipientCountriesServicedCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecipientCountriesServicedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecipientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentRecipientsListArgs = {
  condition?: InputMaybe<PaymentRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecipientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentReportByOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentReportByOrganizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentReportByOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentReportByOrganizationsListArgs = {
  condition?: InputMaybe<PaymentReportByOrganizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentReportByOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentSharingConsentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentSharingConsentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSharingConsentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentSharingConsentsListArgs = {
  condition?: InputMaybe<PaymentSharingConsentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSharingConsentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentStatsAggregatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentStatsAggregateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatsAggregatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentStatsAggregatesListArgs = {
  condition?: InputMaybe<PaymentStatsAggregateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatsAggregatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentStatsByOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentStatsByOrganizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatsByOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentStatsByOrganizationsListArgs = {
  condition?: InputMaybe<PaymentStatsByOrganizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatsByOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentsListArgs = {
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentsManagersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentsManagerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsManagersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPaymentsManagersListArgs = {
  condition?: InputMaybe<PaymentsManagerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsManagersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPayrollGivingProviderCustomersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PayrollGivingProviderCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayrollGivingProviderCustomersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPayrollGivingProviderCustomersListArgs = {
  condition?: InputMaybe<PayrollGivingProviderCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayrollGivingProviderCustomersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPeopleArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PersonCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PeopleOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPeopleListArgs = {
  condition?: InputMaybe<PersonCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PeopleOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPledgeRanksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PledgeRankCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgeRanksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPledgeRanksListArgs = {
  condition?: InputMaybe<PledgeRankCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgeRanksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPledgedMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PledgedMemberCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgedMembersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPledgedMembersListArgs = {
  condition?: InputMaybe<PledgedMemberCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgedMembersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPledgedMembersPublicsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PledgedMembersPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgedMembersPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPledgedMembersPublicsListArgs = {
  condition?: InputMaybe<PledgedMembersPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgedMembersPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPledgesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PledgeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPledgesListArgs = {
  condition?: InputMaybe<PledgeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPledgesManagersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PledgesManagerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgesManagersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPledgesManagersListArgs = {
  condition?: InputMaybe<PledgesManagerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PledgesManagersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPollOptionPublicsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PollOptionPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollOptionPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPollOptionPublicsListArgs = {
  condition?: InputMaybe<PollOptionPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollOptionPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPollOptionVotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PollOptionVoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollOptionVotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPollOptionVotesListArgs = {
  condition?: InputMaybe<PollOptionVoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollOptionVotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPollPublicsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PollPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPollPublicsListArgs = {
  condition?: InputMaybe<PollPublicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollPublicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPrivaciesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PrivacyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PrivaciesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPrivaciesListArgs = {
  condition?: InputMaybe<PrivacyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PrivaciesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllProjectedDonationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectedDonationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllProjectedDonationsListArgs = {
  condition?: InputMaybe<ProjectedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectedDonationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRecipientProgramsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecipientProgramCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecipientProgramsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRecipientProgramsListArgs = {
  condition?: InputMaybe<RecipientProgramCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecipientProgramsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRecurringPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRecurringPaymentsListArgs = {
  condition?: InputMaybe<RecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRecurringReportedDonationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecurringReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringReportedDonationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRecurringReportedDonationsListArgs = {
  condition?: InputMaybe<RecurringReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurringReportedDonationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllReferralSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReferralSourceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReferralSourcesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllReferralSourcesListArgs = {
  condition?: InputMaybe<ReferralSourceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReferralSourcesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllReportedDonationInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportedDonationInfoCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportedDonationInfosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllReportedDonationInfosListArgs = {
  condition?: InputMaybe<ReportedDonationInfoCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportedDonationInfosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllReportedDonationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportedDonationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllReportedDonationsListArgs = {
  condition?: InputMaybe<ReportedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportedDonationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllShortPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShortPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShortPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllShortPaymentsListArgs = {
  condition?: InputMaybe<ShortPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShortPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllStripeCustomersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StripeCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllStripeCustomersListArgs = {
  condition?: InputMaybe<StripeCustomerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSucceededPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SucceededPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SucceededPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSucceededPaymentsListArgs = {
  condition?: InputMaybe<SucceededPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SucceededPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTemporaryPeopleArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TemporaryPersonCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TemporaryPeopleOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTemporaryPeopleListArgs = {
  condition?: InputMaybe<TemporaryPersonCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TemporaryPeopleOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTotalProjectedDonationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TotalProjectedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TotalProjectedDonationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTotalProjectedDonationsListArgs = {
  condition?: InputMaybe<TotalProjectedDonationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TotalProjectedDonationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllUnpaidPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UnpaidPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UnpaidPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllUnpaidPaymentsListArgs = {
  condition?: InputMaybe<UnpaidPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UnpaidPaymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllWageGrowthInterpolatedsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WageGrowthInterpolatedCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WageGrowthInterpolatedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllWageGrowthInterpolatedsListArgs = {
  condition?: InputMaybe<WageGrowthInterpolatedCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WageGrowthInterpolatedsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllWageGrowthsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WageGrowthCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WageGrowthsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllWageGrowthsListArgs = {
  condition?: InputMaybe<WageGrowthCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WageGrowthsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllWorldFiscalYearsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WorldFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WorldFiscalYearsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllWorldFiscalYearsListArgs = {
  condition?: InputMaybe<WorldFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WorldFiscalYearsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllWorldIncomesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WorldIncomeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WorldIncomesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllWorldIncomesListArgs = {
  condition?: InputMaybe<WorldIncomeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WorldIncomesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllXeroAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<XeroAccountCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroAccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllXeroAccountsListArgs = {
  condition?: InputMaybe<XeroAccountCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroAccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllXeroAppsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<XeroAppCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroAppsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllXeroAppsListArgs = {
  condition?: InputMaybe<XeroAppCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroAppsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllXeroContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<XeroContactCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroContactsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllXeroContactsListArgs = {
  condition?: InputMaybe<XeroContactCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroContactsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllXeroTrackingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<XeroTrackingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroTrackingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllXeroTrackingsListArgs = {
  condition?: InputMaybe<XeroTrackingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<XeroTrackingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllocationByPersonIdArgs = {
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryArraySuffixArgs = {
  arr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  suffix?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBalanceSheetReportArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBalanceSheetReportByReportDateAndRecipientAndReferenceArgs = {
  recipient: Scalars['String'];
  reference: Scalars['String'];
  reportDate: Scalars['Date'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChangelogArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChangelogByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClosestExchangeRateArgs = {
  currencyCode?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContactPreferenceArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContactPreferenceByPersonIdArgs = {
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConvertCurrencyArgs = {
  amount?: InputMaybe<Scalars['BigFloat']>;
  exchangeRateDate?: InputMaybe<Scalars['Date']>;
  fromCurrencyCode?: InputMaybe<Scalars['String']>;
  toCurrencyCode?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCountryArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCountryByIsoAlpha2Args = {
  isoAlpha2: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCountryPaymentMethodArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCountryPaymentMethodByCountryCodeAndGatewayAndPaymentMethodArgs = {
  countryCode: Scalars['String'];
  gateway: PaymentGateway;
  paymentMethod: PaymentMethod;
};


/** The root query type which gives access points into the data universe. */
export type QueryCurrencyArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCurrencyByCodeArgs = {
  code: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCurrencyByCountryArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCurrencyByCountryByCountryCodeAndCurrencyCodeArgs = {
  countryCode: Scalars['String'];
  currencyCode: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDecodeHashidArgs = {
  hashid: Scalars['String'];
  slug: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDisbursementArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDisbursementByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDisbursementEntryArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDisbursementEntryByDisbursementNameAndPaymentIdAndOrganizationSlugArgs = {
  disbursementName: Scalars['String'];
  organizationSlug: Scalars['String'];
  paymentId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailAddressArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailAddressByEmailArgs = {
  email: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailAddressByPersonIdAndEmailArgs = {
  email: Scalars['String'];
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailAddressesByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailAddressesByPersonIdListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEncodeHashidArgs = {
  key: Scalars['BigInt'];
  slug: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEoyTaxReceiptArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEoyTaxReceiptByPersonIdAndRecipientAndPeriodArgs = {
  period: DateRangeInput;
  personId: Scalars['BigInt'];
  recipient: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExchangeRateArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExchangeRateByCurrencyCodeAndDateArgs = {
  currencyCode: Scalars['String'];
  date: Scalars['Date'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExtendedLotteryByIdArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalOrganizationArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalOrganizationByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalOrganizationByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalOrganizationByOrganizationSlugArgs = {
  organizationSlug: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalOrganizationTypeaheadArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalOrganizationTypeaheadListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFailedRecurringPaymentArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFailedRecurringPaymentByRecurringPaymentIdArgs = {
  recurringPaymentId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFindClosestLiabilityArgs = {
  personId?: InputMaybe<Scalars['BigInt']>;
  searchDate?: InputMaybe<Scalars['Date']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFindPersonByNameFuzzyArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFindPersonByNameFuzzyListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFindPersonByNameOrEmailArgs = {
  _limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFindPersonByNameOrEmailListArgs = {
  _limit?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFindPersonByPaymentReferenceArgs = {
  _limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFindPersonByPaymentReferenceListArgs = {
  _limit?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFtxCoinArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFtxCoinByCodeAndRecipientAndMethodArgs = {
  code: Scalars['String'];
  method: Scalars['String'];
  recipient: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFtxConversionArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFtxConversionByGatewayTransactionIdArgs = {
  gatewayTransactionId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFtxConversionByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGatewayPaymentMethodArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGatewayPaymentMethodByGatewayAndPaymentMethodArgs = {
  gateway: PaymentGateway;
  paymentMethod: PaymentMethod;
};


/** The root query type which gives access points into the data universe. */
export type QueryGatewayPayoutReportArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGatewayPayoutReportByPayoutIdArgs = {
  payoutId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGatewayPayoutReportEntryArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGatewayPayoutReportEntryByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGatewayPayoutReportEntryByPayoutIdAndGatewayTransactionIdAndEntryTypeArgs = {
  entryType: Scalars['String'];
  gatewayTransactionId: Scalars['String'];
  payoutId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAddressesByPersonOrTemporaryPersonArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAddressesByPersonOrTemporaryPersonListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAddressesByTemporaryPersonArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sessionToken: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAddressesByTemporaryPersonListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sessionToken: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetBalanceSheetMonthlyTotalByReferenceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  nearestReportDate?: InputMaybe<Scalars['Date']>;
  offset?: InputMaybe<Scalars['Int']>;
  reference?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetBalanceSheetMonthlyTotalByReferenceListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  nearestReportDate?: InputMaybe<Scalars['Date']>;
  offset?: InputMaybe<Scalars['Int']>;
  reference?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetBalanceSheetReportMonthlyTotalArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  nearestReportDate?: InputMaybe<Scalars['Date']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetBalanceSheetReportMonthlyTotalListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  nearestReportDate?: InputMaybe<Scalars['Date']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetFullPledgeLiabilityArgs = {
  _pledgeId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetFundraiserStatsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  fundraiserId?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetFundraiserStatsListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  fundraiserId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetGiftAidClaimArgs = {
  paymentId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetGivingSeasonStatsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  givingSeasonStartDate?: InputMaybe<Scalars['Date']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetGivingSeasonStatsListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  givingSeasonStartDate?: InputMaybe<Scalars['Date']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetGocardlessMandatesByPersonOrTemporaryPersonArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetGocardlessMandatesByPersonOrTemporaryPersonListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetGocardlessMandatesByTemporaryPersonArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sessionToken: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetGocardlessMandatesByTemporaryPersonListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sessionToken: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetGocardlessRedirectFlowByPersonOrTemporaryPersonArgs = {
  personId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetGocardlessRedirectFlowByTemporaryPersonArgs = {
  sessionToken: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetGwwcMemberCountArgs = {
  pledgeType?: InputMaybe<PledgeType>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetGwwcMemberCountriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetGwwcMemberCountriesListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetImpliedExchangeRateArgs = {
  exchangeRateDate?: InputMaybe<Scalars['Date']>;
  fromCurrencyCode?: InputMaybe<Scalars['String']>;
  toCurrencyCode?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetIncomesByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetIncomesByPersonIdListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLiabilitiesForPledgeArgs = {
  _pledgeId?: InputMaybe<Scalars['BigInt']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLiabilitiesForPledgeListArgs = {
  _pledgeId?: InputMaybe<Scalars['BigInt']>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLiabilityCompletionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  incomeId: Scalars['BigInt'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pledgeId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLiabilityCompletionByPledgeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pledgeId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLiabilityCompletionByPledgeListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pledgeId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLiabilityCompletionListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  incomeId: Scalars['BigInt'];
  offset?: InputMaybe<Scalars['Int']>;
  pledgeId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLiabilityTotalCompletionArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pledgeId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLiabilityTotalCompletionListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pledgeId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLotteryEntriesByLotteryIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLotteryEntriesByLotteryIdListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLotteryEntriesCompleteByLotteryIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLotteryEntriesCompleteByLotteryIdListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  lotteryId?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLotterySummaryByLotteryIdArgs = {
  lotteryId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPaymentAccessTokenByPersonOrTemporaryPersonArgs = {
  paymentId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPaymentAccessTokenByTemporaryPersonArgs = {
  sessionToken: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPaymentByAccessTokenArgs = {
  token: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPaymentByPersonOrTemporaryPersonArgs = {
  paymentId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPaymentByTemporaryPersonArgs = {
  sessionToken: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPaymentDetailsByOrganizationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  dateBounds?: InputMaybe<DateRangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationSlug: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPaymentDetailsByOrganizationListArgs = {
  dateBounds?: InputMaybe<DateRangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationSlug: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPaymentReportByOrganizationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  dateBounds?: InputMaybe<DateRangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationSlug: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPaymentReportByOrganizationListArgs = {
  dateBounds?: InputMaybe<DateRangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationSlug: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPaymentStatsByOrganizationArgs = {
  organizationSlug?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPayrollGivingProviderCustomerArgs = {
  provider?: InputMaybe<PayrollGivingProvider>;
  providerCustomerId?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPledgeLiabilityThroughTodayArgs = {
  pledgeId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPledgesByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPledgesByPersonIdListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetProjectedDonationsByPledgeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pledgeId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetProjectedDonationsByPledgeListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pledgeId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetRecurringPaymentByPersonOrTemporaryPersonArgs = {
  recurringPaymentId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetRecurringPaymentByTemporaryPersonArgs = {
  sessionToken: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetRecurringReportedDonationsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetRecurringReportedDonationsByPersonIdListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetTemporaryPersonBySessionTokenArgs = {
  sessionToken: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetTotalGwwcDonationsArgs = {
  period?: InputMaybe<DateRangeInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetTotalProjectedDonationsArgs = {
  joinPeriod?: InputMaybe<DateRangeInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetUnattachedCompletionPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetUnattachedCompletionPaymentsListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGiftAidClaimArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGiftAidClaimBackupArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGiftAidClaimBackupByPaymentIdArgs = {
  paymentId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGiftAidClaimByGiftAidPaymentIdArgs = {
  giftAidPaymentId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGiftAidClaimByPaymentIdArgs = {
  paymentId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGivingWhatWeCanSurveyArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGivingWhatWeCanSurveyByPersonIdArgs = {
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGocardlessCustomerByGocardlessCustomerIdArgs = {
  gocardlessCustomerId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGocardlessCustomerByPersonIdAndGocardlessCustomerIdArgs = {
  gocardlessCustomerId: Scalars['String'];
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGocardlessMandateByGocardlessMandateIdArgs = {
  gocardlessMandateId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGocardlessRedirectFlowArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGocardlessRedirectFlowByGocardlessRedirectFlowIdArgs = {
  gocardlessRedirectFlowId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGocardlessRedirectFlowByGocardlessRedirectFlowUrlArgs = {
  gocardlessRedirectFlowUrl: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGocardlessRedirectFlowByPersonIdArgs = {
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGocardlessRedirectFlowBySessionTokenArgs = {
  sessionToken: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHex2BigintArgs = {
  hex?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIncomeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIncomeByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIsValidJsonArgs = {
  pJson: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiabilityArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiabilityByPledgeIdAndIncomeIdArgs = {
  incomeId: Scalars['BigInt'];
  pledgeId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiabilityPaymentArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiabilityPaymentByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiabilityPaymentByPersonIdAndPaymentIdArgs = {
  paymentId: Scalars['BigInt'];
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiabilityPaymentByPersonIdAndReportedDonationIdArgs = {
  personId: Scalars['BigInt'];
  reportedDonationId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLotteryArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLotteryByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLotteryEntryArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLotteryEntryByLotteryIdAndPaymentIdArgs = {
  lotteryId: Scalars['BigInt'];
  paymentId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLotteryEntryByPaymentIdArgs = {
  paymentId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLotteryTicketArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLotteryTicketByLotteryIdAndPaymentIdAndBlockIdArgs = {
  blockId: Scalars['Int'];
  lotteryId: Scalars['BigInt'];
  paymentId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNormalizeAmountToUsdArgs = {
  amount?: InputMaybe<Scalars['BigFloat']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  exchangeRateDate?: InputMaybe<Scalars['Date']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationByNameAndProgramArgs = {
  name: Scalars['String'];
  program: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationBySlugArgs = {
  slug: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationCategoryArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationCategoryBySlugArgs = {
  slug: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationCategoryCheckArgs = {
  organizationCategoryArray?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentAccessTokenArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentAccessTokenByPaymentIdArgs = {
  paymentId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentAccessTokenByTokenArgs = {
  token: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentByGatewayAndGatewayTransactionIdArgs = {
  gateway: PaymentGateway;
  gatewayTransactionId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentByIdAndPersonIdArgs = {
  id: Scalars['BigInt'];
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentByReferenceArgs = {
  reference: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentRecipientArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentRecipientBySlugArgs = {
  slug: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentRecipientCountriesServicedArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentRecipientCountriesServicedByCountryCodeArgs = {
  countryCode: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentRecipientCountriesServicedByRecipientAndCountryCodeArgs = {
  countryCode: Scalars['String'];
  recipient: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentSharingConsentArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentSharingConsentByPaymentIdAndOrganizationSlugArgs = {
  organizationSlug: Scalars['String'];
  paymentId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentsByPersonIdListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentsManagerArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentsManagerByPersonIdArgs = {
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPayrollGivingProviderCustomerArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPayrollGivingProviderCustomerByProviderAndProviderCustomerIdArgs = {
  provider: PayrollGivingProvider;
  providerCustomerId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPersonArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPersonByAuth0UserIdArgs = {
  auth0UserId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPersonByEmailArgs = {
  email: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPersonByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPersonDonationsToOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  dateBounds?: InputMaybe<DateRangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationSlug?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPersonDonationsToOrgListArgs = {
  dateBounds?: InputMaybe<DateRangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationSlug?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPersonSearchNameArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPersonSearchNameListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPledgeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPledgeByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPledgeCountArgs = {
  pledgeType?: InputMaybe<PledgeType>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPledgeRankArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPledgeRankByPersonIdAndPledgeTypeArgs = {
  personId: Scalars['BigInt'];
  pledgeType: PledgeType;
};


/** The root query type which gives access points into the data universe. */
export type QueryPledgesManagerArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPledgesManagerByPersonIdArgs = {
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPollOptionPublicArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPollOptionPublicByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPollOptionVoteArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPollOptionVoteByPersonIdAndPollOptionIdArgs = {
  personId: Scalars['BigInt'];
  pollOptionId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPollPublicArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPollPublicByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPrivacyArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPrivacyByPersonIdArgs = {
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectedDonationArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectedDonationByPersonIdAndPledgeIdAndProjectionYearArgs = {
  personId: Scalars['BigInt'];
  pledgeId: Scalars['BigInt'];
  projectionYear: Scalars['Date'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRecipientProgramArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRecipientProgramByOrganizationSlugAndRecipientSlugArgs = {
  organizationSlug: Scalars['String'];
  recipientSlug: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRecurringPaymentArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRecurringPaymentByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRecurringPaymentsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRecurringPaymentsByPersonIdListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRecurringReportedDonationArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRecurringReportedDonationByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReferralSourceArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReferralSourceBySlugArgs = {
  slug: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReferralSourceCheckArgs = {
  referralSourceArray?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryReportedDonationArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReportedDonationByIdArgs = {
  id: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReportedDonationsByPersonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryReportedDonationsByPersonIdListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySendReceiptArgs = {
  paymentId?: InputMaybe<Scalars['BigInt']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySlugifyArgs = {
  value: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStripeCustomerArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStripeCustomerByPersonIdAndRecipientAndCurrencyCodeArgs = {
  currencyCode: Scalars['String'];
  personId: Scalars['BigInt'];
  recipient: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStripeCustomerByStripeCustomerIdArgs = {
  stripeCustomerId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTemporaryPersonArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTemporaryPersonByEmailArgs = {
  email: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryValidHrefArgs = {
  href: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryValidRelativeUrlArgs = {
  url: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryValidUrlArgs = {
  url: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryValidateAllocationArgs = {
  allocation: Scalars['JSON'];
};


/** The root query type which gives access points into the data universe. */
export type QueryValidateCryptoSpotPriceArgs = {
  amount?: InputMaybe<Scalars['BigFloat']>;
  chargeAmount?: InputMaybe<Scalars['BigFloat']>;
  chargeCurrencyCode?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  gatewayData?: InputMaybe<Scalars['JSON']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryWorldFiscalYearArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorldFiscalYearByCountryCodeArgs = {
  countryCode: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorldIncomeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorldIncomeByCurrencyCodeAndCountryCodeAndCohortAndDataYearArgs = {
  cohort: Scalars['String'];
  countryCode: Scalars['String'];
  currencyCode: Scalars['String'];
  dataYear: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryXeroAccountArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryXeroAccountByRecipientAndReferenceArgs = {
  recipient: Scalars['String'];
  reference: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryXeroAppArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryXeroAppByAppNameArgs = {
  appName: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryXeroAppByClientIdArgs = {
  clientId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryXeroContactArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryXeroContactByPersonIdAndRecipientArgs = {
  personId: Scalars['BigInt'];
  recipient: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryXeroContactByXeroContactIdArgs = {
  xeroContactId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryXeroTrackingArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryXeroTrackingByRecipientAndReferenceAndXeroTrackingCategoryNameArgs = {
  recipient: Scalars['String'];
  reference: Scalars['String'];
  xeroTrackingCategoryName: Scalars['String'];
};

export enum QuestionOrdering {
  Random = 'RANDOM'
}

export type RecipientProgram = Node & {
  __typename?: 'RecipientProgram';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `RecipientProgram`. */
  organizationByOrganizationSlug?: Maybe<Organization>;
  organizationSlug: Scalars['String'];
  /** Reads a single `PaymentRecipient` that is related to this `RecipientProgram`. */
  paymentRecipientByRecipientSlug?: Maybe<PaymentRecipient>;
  recipientSlug: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `RecipientProgram` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RecipientProgramCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `organizationSlug` field. */
  organizationSlug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `recipientSlug` field. */
  recipientSlug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `RecipientProgram` values. */
export type RecipientProgramsConnection = {
  __typename?: 'RecipientProgramsConnection';
  /** A list of edges which contains the `RecipientProgram` and cursor to aid in pagination. */
  edges: Array<RecipientProgramsEdge>;
  /** A list of `RecipientProgram` objects. */
  nodes: Array<Maybe<RecipientProgram>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RecipientProgram` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RecipientProgram` edge in the connection. */
export type RecipientProgramsEdge = {
  __typename?: 'RecipientProgramsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RecipientProgram` at the end of the edge. */
  node?: Maybe<RecipientProgram>;
};

/** Methods to use when ordering `RecipientProgram`. */
export enum RecipientProgramsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  OrganizationSlugAsc = 'ORGANIZATION_SLUG_ASC',
  OrganizationSlugDesc = 'ORGANIZATION_SLUG_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientSlugAsc = 'RECIPIENT_SLUG_ASC',
  RecipientSlugDesc = 'RECIPIENT_SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum RecurrencePeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type RecurringPayment = Node & {
  __typename?: 'RecurringPayment';
  /** Reads a single `Address` that is related to this `RecurringPayment`. */
  addressByBillingAddressId?: Maybe<Address>;
  allocation: Scalars['JSON'];
  amount: Scalars['BigFloat'];
  billingAddressId?: Maybe<Scalars['BigInt']>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `Currency` that is related to this `RecurringPayment`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  currencyCode: Scalars['String'];
  /** Reads a single `FailedRecurringPayment` that is related to this `RecurringPayment`. */
  failedRecurringPaymentByRecurringPaymentId?: Maybe<FailedRecurringPayment>;
  /**
   * Reads and enables pagination through a set of `FailedRecurringPayment`.
   * @deprecated Please use failedRecurringPaymentByRecurringPaymentId instead
   */
  failedRecurringPaymentsByRecurringPaymentId: FailedRecurringPaymentsConnection;
  gateway: PaymentGateway;
  gatewayData?: Maybe<Scalars['JSON']>;
  /** Reads a single `GatewayPaymentMethod` that is related to this `RecurringPayment`. */
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  id: Scalars['BigInt'];
  metadata?: Maybe<Scalars['JSON']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  paymentMethod?: Maybe<PaymentMethod>;
  /** Reads a single `PaymentRecipient` that is related to this `RecurringPayment`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  period: RecurrencePeriod;
  periodIndex: Scalars['Int'];
  periodInterval: Scalars['Int'];
  /** Reads a single `Person` that is related to this `RecurringPayment`. */
  personByPersonId?: Maybe<Person>;
  personId?: Maybe<Scalars['BigInt']>;
  recipient: Scalars['String'];
  status: RecurringPaymentStatus;
  statusData?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['Datetime'];
};


export type RecurringPaymentFailedRecurringPaymentsByRecurringPaymentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FailedRecurringPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FailedRecurringPaymentsOrderBy>>;
};

/**
 * A condition to be used against `RecurringPayment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RecurringPaymentCondition = {
  /** Checks for equality with the object’s `allocation` field. */
  allocation?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `billingAddressId` field. */
  billingAddressId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `gateway` field. */
  gateway?: InputMaybe<PaymentGateway>;
  /** Checks for equality with the object’s `gatewayData` field. */
  gatewayData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `paymentMethod` field. */
  paymentMethod?: InputMaybe<PaymentMethod>;
  /** Checks for equality with the object’s `period` field. */
  period?: InputMaybe<RecurrencePeriod>;
  /** Checks for equality with the object’s `periodIndex` field. */
  periodIndex?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `periodInterval` field. */
  periodInterval?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<RecurringPaymentStatus>;
  /** Checks for equality with the object’s `statusData` field. */
  statusData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum RecurringPaymentStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Incomplete = 'INCOMPLETE',
  Pending = 'PENDING',
  Updating = 'UPDATING'
}

/** A connection to a list of `RecurringPayment` values. */
export type RecurringPaymentsConnection = {
  __typename?: 'RecurringPaymentsConnection';
  /** A list of edges which contains the `RecurringPayment` and cursor to aid in pagination. */
  edges: Array<RecurringPaymentsEdge>;
  /** A list of `RecurringPayment` objects. */
  nodes: Array<Maybe<RecurringPayment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RecurringPayment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RecurringPayment` edge in the connection. */
export type RecurringPaymentsEdge = {
  __typename?: 'RecurringPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RecurringPayment` at the end of the edge. */
  node?: Maybe<RecurringPayment>;
};

/** Methods to use when ordering `RecurringPayment`. */
export enum RecurringPaymentsOrderBy {
  AllocationAsc = 'ALLOCATION_ASC',
  AllocationDesc = 'ALLOCATION_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  BillingAddressIdAsc = 'BILLING_ADDRESS_ID_ASC',
  BillingAddressIdDesc = 'BILLING_ADDRESS_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  GatewayAsc = 'GATEWAY_ASC',
  GatewayDataAsc = 'GATEWAY_DATA_ASC',
  GatewayDataDesc = 'GATEWAY_DATA_DESC',
  GatewayDesc = 'GATEWAY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MetadataAsc = 'METADATA_ASC',
  MetadataDesc = 'METADATA_DESC',
  Natural = 'NATURAL',
  PaymentMethodAsc = 'PAYMENT_METHOD_ASC',
  PaymentMethodDesc = 'PAYMENT_METHOD_DESC',
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC',
  PeriodIndexAsc = 'PERIOD_INDEX_ASC',
  PeriodIndexDesc = 'PERIOD_INDEX_DESC',
  PeriodIntervalAsc = 'PERIOD_INTERVAL_ASC',
  PeriodIntervalDesc = 'PERIOD_INTERVAL_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDataAsc = 'STATUS_DATA_ASC',
  StatusDataDesc = 'STATUS_DATA_DESC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type RecurringReportedDonation = Node & {
  __typename?: 'RecurringReportedDonation';
  amount: Scalars['BigFloat'];
  createdAt: Scalars['Datetime'];
  /** Reads a single `Currency` that is related to this `RecurringReportedDonation`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  currencyCode: Scalars['String'];
  /** Reads a single `ExternalOrganization` that is related to this `RecurringReportedDonation`. */
  externalOrganizationByOrganizationId?: Maybe<ExternalOrganization>;
  id: Scalars['BigInt'];
  nextDate: Scalars['Date'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  organizationId: Scalars['BigInt'];
  /** Reads a single `Person` that is related to this `RecurringReportedDonation`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  recurrenceInterval: Interval;
  startDate: Scalars['Date'];
  status: RecurringPaymentStatus;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `RecurringReportedDonation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RecurringReportedDonationCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `nextDate` field. */
  nextDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recurrenceInterval` field. */
  recurrenceInterval?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<RecurringPaymentStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An input for mutations affecting `RecurringReportedDonation` */
export type RecurringReportedDonationInput = {
  amount: Scalars['BigFloat'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currencyCode: Scalars['String'];
  id?: InputMaybe<Scalars['BigInt']>;
  nextDate: Scalars['Date'];
  organizationId: Scalars['BigInt'];
  personId: Scalars['BigInt'];
  recurrenceInterval: IntervalInput;
  startDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<RecurringPaymentStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `RecurringReportedDonation` values. */
export type RecurringReportedDonationsConnection = {
  __typename?: 'RecurringReportedDonationsConnection';
  /** A list of edges which contains the `RecurringReportedDonation` and cursor to aid in pagination. */
  edges: Array<RecurringReportedDonationsEdge>;
  /** A list of `RecurringReportedDonation` objects. */
  nodes: Array<Maybe<RecurringReportedDonation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RecurringReportedDonation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RecurringReportedDonation` edge in the connection. */
export type RecurringReportedDonationsEdge = {
  __typename?: 'RecurringReportedDonationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RecurringReportedDonation` at the end of the edge. */
  node?: Maybe<RecurringReportedDonation>;
};

/** Methods to use when ordering `RecurringReportedDonation`. */
export enum RecurringReportedDonationsOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NextDateAsc = 'NEXT_DATE_ASC',
  NextDateDesc = 'NEXT_DATE_DESC',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecurrenceIntervalAsc = 'RECURRENCE_INTERVAL_ASC',
  RecurrenceIntervalDesc = 'RECURRENCE_INTERVAL_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ReferralSource = Node & {
  __typename?: 'ReferralSource';
  description: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  slug: Scalars['String'];
  sortOrder: Scalars['Int'];
};

/**
 * A condition to be used against `ReferralSource` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ReferralSourceCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ReferralSource` values. */
export type ReferralSourcesConnection = {
  __typename?: 'ReferralSourcesConnection';
  /** A list of edges which contains the `ReferralSource` and cursor to aid in pagination. */
  edges: Array<ReferralSourcesEdge>;
  /** A list of `ReferralSource` objects. */
  nodes: Array<Maybe<ReferralSource>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReferralSource` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ReferralSource` edge in the connection. */
export type ReferralSourcesEdge = {
  __typename?: 'ReferralSourcesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ReferralSource` at the end of the edge. */
  node?: Maybe<ReferralSource>;
};

/** Methods to use when ordering `ReferralSource`. */
export enum ReferralSourcesOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC'
}

/** All input for the `refreshExpiredToken` mutation. */
export type RefreshExpiredTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  personId: Scalars['BigInt'];
  refreshToken: Scalars['UUID'];
};

/** The output of our `refreshExpiredToken` mutation. */
export type RefreshExpiredTokenPayload = {
  __typename?: 'RefreshExpiredTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwt?: Maybe<Jwt>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `registerShadow` mutation. */
export type RegisterShadowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

/** The output of our `registerShadow` mutation. */
export type RegisterShadowPayload = {
  __typename?: 'RegisterShadowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwt?: Maybe<Jwt>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export enum RegistrationMethod {
  Direct = 'DIRECT',
  GroupMembership = 'GROUP_MEMBERSHIP',
  Import = 'IMPORT',
  PayrollGiving = 'PAYROLL_GIVING'
}

export type ReportedDonation = Node & {
  __typename?: 'ReportedDonation';
  amount?: Maybe<Scalars['BigFloat']>;
  amountNormalized?: Maybe<Scalars['BigFloat']>;
  /** Reads and enables pagination through a set of `CompletionPayment`. */
  completionPaymentsByReportedDonationId: CompletionPaymentsConnection;
  /** Reads and enables pagination through a set of `CompletionPayment`. */
  completionPaymentsByReportedDonationIdList: Array<CompletionPayment>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `Currency` that is related to this `ReportedDonation`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  currencyCode?: Maybe<Scalars['String']>;
  donationDate?: Maybe<Scalars['Date']>;
  /** Reads a single `ExternalOrganization` that is related to this `ReportedDonation`. */
  externalOrganizationByOrganizationId?: Maybe<ExternalOrganization>;
  id: Scalars['BigInt'];
  /** Reads and enables pagination through a set of `LiabilityPayment`. */
  liabilityPaymentsByReportedDonationId: LiabilityPaymentsConnection;
  /** Reads and enables pagination through a set of `LiabilityPayment`. */
  liabilityPaymentsByReportedDonationIdList: Array<LiabilityPayment>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  organizationId: Scalars['BigInt'];
  /** Reads a single `Person` that is related to this `ReportedDonation`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  recurrence: PaymentRecurrence;
  updatedAt: Scalars['Datetime'];
};


export type ReportedDonationCompletionPaymentsByReportedDonationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompletionPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompletionPaymentsOrderBy>>;
};


export type ReportedDonationCompletionPaymentsByReportedDonationIdListArgs = {
  condition?: InputMaybe<CompletionPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompletionPaymentsOrderBy>>;
};


export type ReportedDonationLiabilityPaymentsByReportedDonationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LiabilityPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityPaymentsOrderBy>>;
};


export type ReportedDonationLiabilityPaymentsByReportedDonationIdListArgs = {
  condition?: InputMaybe<LiabilityPaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LiabilityPaymentsOrderBy>>;
};

/**
 * A condition to be used against `ReportedDonation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ReportedDonationCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `donationDate` field. */
  donationDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recurrence` field. */
  recurrence?: InputMaybe<PaymentRecurrence>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ReportedDonationInfo = {
  __typename?: 'ReportedDonationInfo';
  amount?: Maybe<Scalars['BigFloat']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  currencyCode?: Maybe<Scalars['String']>;
  donationDate?: Maybe<Scalars['Date']>;
  organizationSlug?: Maybe<Scalars['String']>;
  personId?: Maybe<Scalars['BigInt']>;
  recurrence?: Maybe<PaymentRecurrence>;
};

/**
 * A condition to be used against `ReportedDonationInfo` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ReportedDonationInfoCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `donationDate` field. */
  donationDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `organizationSlug` field. */
  organizationSlug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recurrence` field. */
  recurrence?: InputMaybe<PaymentRecurrence>;
};

/** A connection to a list of `ReportedDonationInfo` values. */
export type ReportedDonationInfosConnection = {
  __typename?: 'ReportedDonationInfosConnection';
  /** A list of edges which contains the `ReportedDonationInfo` and cursor to aid in pagination. */
  edges: Array<ReportedDonationInfosEdge>;
  /** A list of `ReportedDonationInfo` objects. */
  nodes: Array<Maybe<ReportedDonationInfo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReportedDonationInfo` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ReportedDonationInfo` edge in the connection. */
export type ReportedDonationInfosEdge = {
  __typename?: 'ReportedDonationInfosEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ReportedDonationInfo` at the end of the edge. */
  node?: Maybe<ReportedDonationInfo>;
};

/** Methods to use when ordering `ReportedDonationInfo`. */
export enum ReportedDonationInfosOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DonationDateAsc = 'DONATION_DATE_ASC',
  DonationDateDesc = 'DONATION_DATE_DESC',
  Natural = 'NATURAL',
  OrganizationSlugAsc = 'ORGANIZATION_SLUG_ASC',
  OrganizationSlugDesc = 'ORGANIZATION_SLUG_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  RecurrenceAsc = 'RECURRENCE_ASC',
  RecurrenceDesc = 'RECURRENCE_DESC'
}

/** A connection to a list of `ReportedDonation` values. */
export type ReportedDonationsConnection = {
  __typename?: 'ReportedDonationsConnection';
  /** A list of edges which contains the `ReportedDonation` and cursor to aid in pagination. */
  edges: Array<ReportedDonationsEdge>;
  /** A list of `ReportedDonation` objects. */
  nodes: Array<Maybe<ReportedDonation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReportedDonation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ReportedDonation` edge in the connection. */
export type ReportedDonationsEdge = {
  __typename?: 'ReportedDonationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ReportedDonation` at the end of the edge. */
  node?: Maybe<ReportedDonation>;
};

/** Methods to use when ordering `ReportedDonation`. */
export enum ReportedDonationsOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DonationDateAsc = 'DONATION_DATE_ASC',
  DonationDateDesc = 'DONATION_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecurrenceAsc = 'RECURRENCE_ASC',
  RecurrenceDesc = 'RECURRENCE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ShortPayment = {
  __typename?: 'ShortPayment';
  allocation?: Maybe<Scalars['JSON']>;
  amount?: Maybe<Scalars['BigFloat']>;
  amountNormalized?: Maybe<Scalars['BigFloat']>;
  chargeAmount?: Maybe<Scalars['BigFloat']>;
  chargeCurrencyCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  currencyCode?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['BigFloat']>;
  gateway?: Maybe<PaymentGateway>;
  gatewayData?: Maybe<Scalars['JSON']>;
  gatewayTransactionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  net?: Maybe<Scalars['BigFloat']>;
  personId?: Maybe<Scalars['BigInt']>;
  recipient?: Maybe<Scalars['String']>;
  recurrence?: Maybe<PaymentRecurrence>;
  reference?: Maybe<Scalars['String']>;
  status?: Maybe<PaymentStatus>;
  statusData?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `ShortPayment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ShortPaymentCondition = {
  /** Checks for equality with the object’s `allocation` field. */
  allocation?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `chargeAmount` field. */
  chargeAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `chargeCurrencyCode` field. */
  chargeCurrencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `gateway` field. */
  gateway?: InputMaybe<PaymentGateway>;
  /** Checks for equality with the object’s `gatewayData` field. */
  gatewayData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `gatewayTransactionId` field. */
  gatewayTransactionId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `net` field. */
  net?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `recurrence` field. */
  recurrence?: InputMaybe<PaymentRecurrence>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<PaymentStatus>;
  /** Checks for equality with the object’s `statusData` field. */
  statusData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `ShortPayment` values. */
export type ShortPaymentsConnection = {
  __typename?: 'ShortPaymentsConnection';
  /** A list of edges which contains the `ShortPayment` and cursor to aid in pagination. */
  edges: Array<ShortPaymentsEdge>;
  /** A list of `ShortPayment` objects. */
  nodes: Array<Maybe<ShortPayment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ShortPayment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ShortPayment` edge in the connection. */
export type ShortPaymentsEdge = {
  __typename?: 'ShortPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ShortPayment` at the end of the edge. */
  node?: Maybe<ShortPayment>;
};

/** Methods to use when ordering `ShortPayment`. */
export enum ShortPaymentsOrderBy {
  AllocationAsc = 'ALLOCATION_ASC',
  AllocationDesc = 'ALLOCATION_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  ChargeAmountAsc = 'CHARGE_AMOUNT_ASC',
  ChargeAmountDesc = 'CHARGE_AMOUNT_DESC',
  ChargeCurrencyCodeAsc = 'CHARGE_CURRENCY_CODE_ASC',
  ChargeCurrencyCodeDesc = 'CHARGE_CURRENCY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  FeeAsc = 'FEE_ASC',
  FeeDesc = 'FEE_DESC',
  GatewayAsc = 'GATEWAY_ASC',
  GatewayDataAsc = 'GATEWAY_DATA_ASC',
  GatewayDataDesc = 'GATEWAY_DATA_DESC',
  GatewayDesc = 'GATEWAY_DESC',
  GatewayTransactionIdAsc = 'GATEWAY_TRANSACTION_ID_ASC',
  GatewayTransactionIdDesc = 'GATEWAY_TRANSACTION_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NetAsc = 'NET_ASC',
  NetDesc = 'NET_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  RecurrenceAsc = 'RECURRENCE_ASC',
  RecurrenceDesc = 'RECURRENCE_DESC',
  ReferenceAsc = 'REFERENCE_ASC',
  ReferenceDesc = 'REFERENCE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDataAsc = 'STATUS_DATA_ASC',
  StatusDataDesc = 'STATUS_DATA_DESC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** All input for the `signPledge` mutation. */
export type SignPledgeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  incomeAmount?: InputMaybe<Scalars['BigFloat']>;
  incomeCurrencyCode?: InputMaybe<Scalars['String']>;
  incomeEmploymentStatus?: InputMaybe<IncomeEmploymentStatus>;
  locale?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  motivation?: InputMaybe<Scalars['String']>;
  personBirthDate?: InputMaybe<Scalars['Date']>;
  personFirstName?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  personLastName?: InputMaybe<Scalars['String']>;
  pledgePercentage?: InputMaybe<Scalars['BigFloat']>;
  pledgePeriod?: InputMaybe<DateRangeInput>;
  pledgeType?: InputMaybe<PledgeType>;
};

/** The output of our `signPledge` mutation. */
export type SignPledgePayload = {
  __typename?: 'SignPledgePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Person` that is related to this `Pledge`. */
  personByPersonId?: Maybe<Person>;
  pledge?: Maybe<Pledge>;
  /** An edge for our `Pledge`. May be used by Relay 1. */
  pledgeEdge?: Maybe<PledgesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `signPledge` mutation. */
export type SignPledgePayloadPledgeEdgeArgs = {
  orderBy?: InputMaybe<Array<PledgesOrderBy>>;
};

export type StripeCustomer = Node & {
  __typename?: 'StripeCustomer';
  createdAt: Scalars['Datetime'];
  /** Reads a single `Currency` that is related to this `StripeCustomer`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  currencyCode: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `PaymentRecipient` that is related to this `StripeCustomer`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Reads a single `Person` that is related to this `StripeCustomer`. */
  personByPersonId?: Maybe<Person>;
  personId: Scalars['BigInt'];
  recipient: Scalars['String'];
  stripeCustomerId: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `StripeCustomer` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type StripeCustomerCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `stripeCustomerId` field. */
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `StripeCustomer` values. */
export type StripeCustomersConnection = {
  __typename?: 'StripeCustomersConnection';
  /** A list of edges which contains the `StripeCustomer` and cursor to aid in pagination. */
  edges: Array<StripeCustomersEdge>;
  /** A list of `StripeCustomer` objects. */
  nodes: Array<Maybe<StripeCustomer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `StripeCustomer` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `StripeCustomer` edge in the connection. */
export type StripeCustomersEdge = {
  __typename?: 'StripeCustomersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `StripeCustomer` at the end of the edge. */
  node?: Maybe<StripeCustomer>;
};

/** Methods to use when ordering `StripeCustomer`. */
export enum StripeCustomersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  StripeCustomerIdAsc = 'STRIPE_CUSTOMER_ID_ASC',
  StripeCustomerIdDesc = 'STRIPE_CUSTOMER_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type SucceededPayment = {
  __typename?: 'SucceededPayment';
  allocation?: Maybe<Scalars['JSON']>;
  amount?: Maybe<Scalars['BigFloat']>;
  amountNormalized?: Maybe<Scalars['BigFloat']>;
  chargeAmount?: Maybe<Scalars['BigFloat']>;
  chargeCurrencyCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  currencyCode?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['BigFloat']>;
  gateway?: Maybe<PaymentGateway>;
  gatewayData?: Maybe<Scalars['JSON']>;
  gatewayTransactionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  metadata?: Maybe<Scalars['JSON']>;
  net?: Maybe<Scalars['BigFloat']>;
  personId?: Maybe<Scalars['BigInt']>;
  recipient?: Maybe<Scalars['String']>;
  recurrence?: Maybe<PaymentRecurrence>;
  reference?: Maybe<Scalars['String']>;
  status?: Maybe<PaymentStatus>;
  statusData?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `SucceededPayment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SucceededPaymentCondition = {
  /** Checks for equality with the object’s `allocation` field. */
  allocation?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `chargeAmount` field. */
  chargeAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `chargeCurrencyCode` field. */
  chargeCurrencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `gateway` field. */
  gateway?: InputMaybe<PaymentGateway>;
  /** Checks for equality with the object’s `gatewayData` field. */
  gatewayData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `gatewayTransactionId` field. */
  gatewayTransactionId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `net` field. */
  net?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `recurrence` field. */
  recurrence?: InputMaybe<PaymentRecurrence>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<PaymentStatus>;
  /** Checks for equality with the object’s `statusData` field. */
  statusData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `SucceededPayment` values. */
export type SucceededPaymentsConnection = {
  __typename?: 'SucceededPaymentsConnection';
  /** A list of edges which contains the `SucceededPayment` and cursor to aid in pagination. */
  edges: Array<SucceededPaymentsEdge>;
  /** A list of `SucceededPayment` objects. */
  nodes: Array<Maybe<SucceededPayment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SucceededPayment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SucceededPayment` edge in the connection. */
export type SucceededPaymentsEdge = {
  __typename?: 'SucceededPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SucceededPayment` at the end of the edge. */
  node?: Maybe<SucceededPayment>;
};

/** Methods to use when ordering `SucceededPayment`. */
export enum SucceededPaymentsOrderBy {
  AllocationAsc = 'ALLOCATION_ASC',
  AllocationDesc = 'ALLOCATION_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  ChargeAmountAsc = 'CHARGE_AMOUNT_ASC',
  ChargeAmountDesc = 'CHARGE_AMOUNT_DESC',
  ChargeCurrencyCodeAsc = 'CHARGE_CURRENCY_CODE_ASC',
  ChargeCurrencyCodeDesc = 'CHARGE_CURRENCY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  FeeAsc = 'FEE_ASC',
  FeeDesc = 'FEE_DESC',
  GatewayAsc = 'GATEWAY_ASC',
  GatewayDataAsc = 'GATEWAY_DATA_ASC',
  GatewayDataDesc = 'GATEWAY_DATA_DESC',
  GatewayDesc = 'GATEWAY_DESC',
  GatewayTransactionIdAsc = 'GATEWAY_TRANSACTION_ID_ASC',
  GatewayTransactionIdDesc = 'GATEWAY_TRANSACTION_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MetadataAsc = 'METADATA_ASC',
  MetadataDesc = 'METADATA_DESC',
  Natural = 'NATURAL',
  NetAsc = 'NET_ASC',
  NetDesc = 'NET_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  RecurrenceAsc = 'RECURRENCE_ASC',
  RecurrenceDesc = 'RECURRENCE_DESC',
  ReferenceAsc = 'REFERENCE_ASC',
  ReferenceDesc = 'REFERENCE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDataAsc = 'STATUS_DATA_ASC',
  StatusDataDesc = 'STATUS_DATA_DESC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** All input for the `syncAuth0User` mutation. */
export type SyncAuth0UserInput = {
  auth0User?: InputMaybe<Scalars['JSON']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `syncAuth0User` mutation. */
export type SyncAuth0UserPayload = {
  __typename?: 'SyncAuth0UserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EmailAddress` that is related to this `Person`. */
  emailAddressByIdAndEmail?: Maybe<EmailAddress>;
  person?: Maybe<Person>;
  /** An edge for our `Person`. May be used by Relay 1. */
  personEdge?: Maybe<PeopleEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `syncAuth0User` mutation. */
export type SyncAuth0UserPayloadPersonEdgeArgs = {
  orderBy?: InputMaybe<Array<PeopleOrderBy>>;
};

/** A connection to a list of `TemporaryPerson` values. */
export type TemporaryPeopleConnection = {
  __typename?: 'TemporaryPeopleConnection';
  /** A list of edges which contains the `TemporaryPerson` and cursor to aid in pagination. */
  edges: Array<TemporaryPeopleEdge>;
  /** A list of `TemporaryPerson` objects. */
  nodes: Array<Maybe<TemporaryPerson>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TemporaryPerson` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TemporaryPerson` edge in the connection. */
export type TemporaryPeopleEdge = {
  __typename?: 'TemporaryPeopleEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TemporaryPerson` at the end of the edge. */
  node?: Maybe<TemporaryPerson>;
};

/** Methods to use when ordering `TemporaryPerson`. */
export enum TemporaryPeopleOrderBy {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SessionTokenAsc = 'SESSION_TOKEN_ASC',
  SessionTokenDesc = 'SESSION_TOKEN_DESC',
  TokenExpiresAtAsc = 'TOKEN_EXPIRES_AT_ASC',
  TokenExpiresAtDesc = 'TOKEN_EXPIRES_AT_DESC',
  TokenIssuedAtAsc = 'TOKEN_ISSUED_AT_ASC',
  TokenIssuedAtDesc = 'TOKEN_ISSUED_AT_DESC'
}

export type TemporaryPerson = Node & {
  __typename?: 'TemporaryPerson';
  email: Scalars['String'];
  /** Reads a single `EmailAddress` that is related to this `TemporaryPerson`. */
  emailAddressByEmail?: Maybe<EmailAddress>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  sessionToken: Scalars['UUID'];
  tokenExpiresAt: Scalars['Datetime'];
  tokenIssuedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `TemporaryPerson` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TemporaryPersonCondition = {
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sessionToken` field. */
  sessionToken?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `tokenExpiresAt` field. */
  tokenExpiresAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `tokenIssuedAt` field. */
  tokenIssuedAt?: InputMaybe<Scalars['Datetime']>;
};

export type TotalProjectedDonation = {
  __typename?: 'TotalProjectedDonation';
  numPledges?: Maybe<Scalars['Int']>;
  projectedDonationsTotal?: Maybe<Scalars['BigFloat']>;
  projectedIncomeTotal?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `TotalProjectedDonation` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type TotalProjectedDonationCondition = {
  /** Checks for equality with the object’s `numPledges` field. */
  numPledges?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `projectedDonationsTotal` field. */
  projectedDonationsTotal?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `projectedIncomeTotal` field. */
  projectedIncomeTotal?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `TotalProjectedDonation` values. */
export type TotalProjectedDonationsConnection = {
  __typename?: 'TotalProjectedDonationsConnection';
  /** A list of edges which contains the `TotalProjectedDonation` and cursor to aid in pagination. */
  edges: Array<TotalProjectedDonationsEdge>;
  /** A list of `TotalProjectedDonation` objects. */
  nodes: Array<Maybe<TotalProjectedDonation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TotalProjectedDonation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TotalProjectedDonation` edge in the connection. */
export type TotalProjectedDonationsEdge = {
  __typename?: 'TotalProjectedDonationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TotalProjectedDonation` at the end of the edge. */
  node?: Maybe<TotalProjectedDonation>;
};

/** Methods to use when ordering `TotalProjectedDonation`. */
export enum TotalProjectedDonationsOrderBy {
  Natural = 'NATURAL',
  NumPledgesAsc = 'NUM_PLEDGES_ASC',
  NumPledgesDesc = 'NUM_PLEDGES_DESC',
  ProjectedDonationsTotalAsc = 'PROJECTED_DONATIONS_TOTAL_ASC',
  ProjectedDonationsTotalDesc = 'PROJECTED_DONATIONS_TOTAL_DESC',
  ProjectedIncomeTotalAsc = 'PROJECTED_INCOME_TOTAL_ASC',
  ProjectedIncomeTotalDesc = 'PROJECTED_INCOME_TOTAL_DESC'
}

export type UnpaidPayment = {
  __typename?: 'UnpaidPayment';
  allocation?: Maybe<Scalars['JSON']>;
  amount?: Maybe<Scalars['BigFloat']>;
  amountNormalized?: Maybe<Scalars['BigFloat']>;
  chargeAmount?: Maybe<Scalars['BigFloat']>;
  chargeCurrencyCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  currencyCode?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['BigFloat']>;
  gateway?: Maybe<PaymentGateway>;
  gatewayData?: Maybe<Scalars['JSON']>;
  gatewayTransactionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  metadata?: Maybe<Scalars['JSON']>;
  net?: Maybe<Scalars['BigFloat']>;
  personId?: Maybe<Scalars['BigInt']>;
  recipient?: Maybe<Scalars['String']>;
  recurrence?: Maybe<PaymentRecurrence>;
  reference?: Maybe<Scalars['String']>;
  status?: Maybe<PaymentStatus>;
  statusData?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `UnpaidPayment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UnpaidPaymentCondition = {
  /** Checks for equality with the object’s `allocation` field. */
  allocation?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `chargeAmount` field. */
  chargeAmount?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `chargeCurrencyCode` field. */
  chargeCurrencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `gateway` field. */
  gateway?: InputMaybe<PaymentGateway>;
  /** Checks for equality with the object’s `gatewayData` field. */
  gatewayData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `gatewayTransactionId` field. */
  gatewayTransactionId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `net` field. */
  net?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `recurrence` field. */
  recurrence?: InputMaybe<PaymentRecurrence>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<PaymentStatus>;
  /** Checks for equality with the object’s `statusData` field. */
  statusData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `UnpaidPayment` values. */
export type UnpaidPaymentsConnection = {
  __typename?: 'UnpaidPaymentsConnection';
  /** A list of edges which contains the `UnpaidPayment` and cursor to aid in pagination. */
  edges: Array<UnpaidPaymentsEdge>;
  /** A list of `UnpaidPayment` objects. */
  nodes: Array<Maybe<UnpaidPayment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UnpaidPayment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UnpaidPayment` edge in the connection. */
export type UnpaidPaymentsEdge = {
  __typename?: 'UnpaidPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UnpaidPayment` at the end of the edge. */
  node?: Maybe<UnpaidPayment>;
};

/** Methods to use when ordering `UnpaidPayment`. */
export enum UnpaidPaymentsOrderBy {
  AllocationAsc = 'ALLOCATION_ASC',
  AllocationDesc = 'ALLOCATION_DESC',
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  ChargeAmountAsc = 'CHARGE_AMOUNT_ASC',
  ChargeAmountDesc = 'CHARGE_AMOUNT_DESC',
  ChargeCurrencyCodeAsc = 'CHARGE_CURRENCY_CODE_ASC',
  ChargeCurrencyCodeDesc = 'CHARGE_CURRENCY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  FeeAsc = 'FEE_ASC',
  FeeDesc = 'FEE_DESC',
  GatewayAsc = 'GATEWAY_ASC',
  GatewayDataAsc = 'GATEWAY_DATA_ASC',
  GatewayDataDesc = 'GATEWAY_DATA_DESC',
  GatewayDesc = 'GATEWAY_DESC',
  GatewayTransactionIdAsc = 'GATEWAY_TRANSACTION_ID_ASC',
  GatewayTransactionIdDesc = 'GATEWAY_TRANSACTION_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MetadataAsc = 'METADATA_ASC',
  MetadataDesc = 'METADATA_DESC',
  Natural = 'NATURAL',
  NetAsc = 'NET_ASC',
  NetDesc = 'NET_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  RecurrenceAsc = 'RECURRENCE_ASC',
  RecurrenceDesc = 'RECURRENCE_DESC',
  ReferenceAsc = 'REFERENCE_ASC',
  ReferenceDesc = 'REFERENCE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDataAsc = 'STATUS_DATA_ASC',
  StatusDataDesc = 'STATUS_DATA_DESC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** All input for the `updateContactPreferenceByPersonId` mutation. */
export type UpdateContactPreferenceByPersonIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  currentAddressId?: InputMaybe<Scalars['BigInt']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `updateContactPreferenceByPersonId` mutation. */
export type UpdateContactPreferenceByPersonIdPayload = {
  __typename?: 'UpdateContactPreferenceByPersonIdPayload';
  /** Reads a single `Address` that is related to this `ContactPreference`. */
  addressByCurrentAddressId?: Maybe<Address>;
  /** Reads a single `Address` that is related to this `ContactPreference`. */
  addressByPersonIdAndCurrentAddressId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  contactPreference?: Maybe<ContactPreference>;
  /** An edge for our `ContactPreference`. May be used by Relay 1. */
  contactPreferenceEdge?: Maybe<ContactPreferencesEdge>;
  /** Reads a single `Person` that is related to this `ContactPreference`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateContactPreferenceByPersonId` mutation. */
export type UpdateContactPreferenceByPersonIdPayloadContactPreferenceEdgeArgs = {
  orderBy?: InputMaybe<Array<ContactPreferencesOrderBy>>;
};

/** All input for the `updateCryptoPaymentGatewayTransactionId` mutation. */
export type UpdateCryptoPaymentGatewayTransactionIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  gatewayTransactionId: Scalars['String'];
  paymentAccessToken: Scalars['UUID'];
};

/** The output of our `updateCryptoPaymentGatewayTransactionId` mutation. */
export type UpdateCryptoPaymentGatewayTransactionIdPayload = {
  __typename?: 'UpdateCryptoPaymentGatewayTransactionIdPayload';
  /** Reads a single `Address` that is related to this `Payment`. */
  addressByBillingAddressId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByChargeCurrencyCode?: Maybe<Currency>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `GatewayPaymentMethod` that is related to this `Payment`. */
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  payment?: Maybe<Payment>;
  /** An edge for our `Payment`. May be used by Relay 1. */
  paymentEdge?: Maybe<PaymentsEdge>;
  /** Reads a single `PaymentRecipient` that is related to this `Payment`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Reads a single `Person` that is related to this `Payment`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateCryptoPaymentGatewayTransactionId` mutation. */
export type UpdateCryptoPaymentGatewayTransactionIdPayloadPaymentEdgeArgs = {
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};

/** All input for the `updateIncome` mutation. */
export type UpdateIncomeInput = {
  amount: Scalars['BigFloat'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  currencyCode: Scalars['String'];
  donationsTaxDeductible: Scalars['Boolean'];
  employmentStatus: IncomeEmploymentStatus;
  id: Scalars['BigInt'];
  period: DateRangeInput;
};

/** The output of our `updateIncome` mutation. */
export type UpdateIncomePayload = {
  __typename?: 'UpdateIncomePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `Income`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  income?: Maybe<Income>;
  /** An edge for our `Income`. May be used by Relay 1. */
  incomeEdge?: Maybe<IncomesEdge>;
  /** Reads a single `Person` that is related to this `Income`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateIncome` mutation. */
export type UpdateIncomePayloadIncomeEdgeArgs = {
  orderBy?: InputMaybe<Array<IncomesOrderBy>>;
};

/** All input for the `updatePaymentStatus` mutation. */
export type UpdatePaymentStatusInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<PaymentStatus>;
};

/** The output of our `updatePaymentStatus` mutation. */
export type UpdatePaymentStatusPayload = {
  __typename?: 'UpdatePaymentStatusPayload';
  /** Reads a single `Address` that is related to this `Payment`. */
  addressByBillingAddressId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByChargeCurrencyCode?: Maybe<Currency>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `GatewayPaymentMethod` that is related to this `Payment`. */
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  payment?: Maybe<Payment>;
  /** An edge for our `Payment`. May be used by Relay 1. */
  paymentEdge?: Maybe<PaymentsEdge>;
  /** Reads a single `PaymentRecipient` that is related to this `Payment`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Reads a single `Person` that is related to this `Payment`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updatePaymentStatus` mutation. */
export type UpdatePaymentStatusPayloadPaymentEdgeArgs = {
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};

/** All input for the `updatePersonByPersonId` mutation. */
export type UpdatePersonByPersonIdInput = {
  birthDate?: InputMaybe<Scalars['Date']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `updatePersonByPersonId` mutation. */
export type UpdatePersonByPersonIdPayload = {
  __typename?: 'UpdatePersonByPersonIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EmailAddress` that is related to this `Person`. */
  emailAddressByIdAndEmail?: Maybe<EmailAddress>;
  person?: Maybe<Person>;
  /** An edge for our `Person`. May be used by Relay 1. */
  personEdge?: Maybe<PeopleEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updatePersonByPersonId` mutation. */
export type UpdatePersonByPersonIdPayloadPersonEdgeArgs = {
  orderBy?: InputMaybe<Array<PeopleOrderBy>>;
};

/** All input for the `updatePersonEmailAuth0` mutation. */
export type UpdatePersonEmailAuth0Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `updatePersonEmailAuth0` mutation. */
export type UpdatePersonEmailAuth0Payload = {
  __typename?: 'UpdatePersonEmailAuth0Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  string?: Maybe<Scalars['String']>;
};

/** All input for the `updatePersonEmailByEmail` mutation. */
export type UpdatePersonEmailByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  newEmail?: InputMaybe<Scalars['String']>;
  oldEmail?: InputMaybe<Scalars['String']>;
};

/** The output of our `updatePersonEmailByEmail` mutation. */
export type UpdatePersonEmailByEmailPayload = {
  __typename?: 'UpdatePersonEmailByEmailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EmailAddress` that is related to this `Person`. */
  emailAddressByIdAndEmail?: Maybe<EmailAddress>;
  person?: Maybe<Person>;
  /** An edge for our `Person`. May be used by Relay 1. */
  personEdge?: Maybe<PeopleEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updatePersonEmailByEmail` mutation. */
export type UpdatePersonEmailByEmailPayloadPersonEdgeArgs = {
  orderBy?: InputMaybe<Array<PeopleOrderBy>>;
};

/** All input for the `updatePersonEmail` mutation. */
export type UpdatePersonEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `updatePersonEmail` mutation. */
export type UpdatePersonEmailPayload = {
  __typename?: 'UpdatePersonEmailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EmailAddress` that is related to this `Person`. */
  emailAddressByIdAndEmail?: Maybe<EmailAddress>;
  person?: Maybe<Person>;
  /** An edge for our `Person`. May be used by Relay 1. */
  personEdge?: Maybe<PeopleEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updatePersonEmail` mutation. */
export type UpdatePersonEmailPayloadPersonEdgeArgs = {
  orderBy?: InputMaybe<Array<PeopleOrderBy>>;
};

/** All input for the `updatePledge` mutation. */
export type UpdatePledgeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['BigInt'];
  metadata: Scalars['JSON'];
};

/** The output of our `updatePledge` mutation. */
export type UpdatePledgePayload = {
  __typename?: 'UpdatePledgePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Person` that is related to this `Pledge`. */
  personByPersonId?: Maybe<Person>;
  pledge?: Maybe<Pledge>;
  /** An edge for our `Pledge`. May be used by Relay 1. */
  pledgeEdge?: Maybe<PledgesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updatePledge` mutation. */
export type UpdatePledgePayloadPledgeEdgeArgs = {
  orderBy?: InputMaybe<Array<PledgesOrderBy>>;
};

/** All input for the `updateRecurringPaymentAmount` mutation. */
export type UpdateRecurringPaymentAmountInput = {
  amount: Scalars['BigFloat'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  recurringPaymentId: Scalars['BigInt'];
};

/** The output of our `updateRecurringPaymentAmount` mutation. */
export type UpdateRecurringPaymentAmountPayload = {
  __typename?: 'UpdateRecurringPaymentAmountPayload';
  /** Reads a single `Address` that is related to this `RecurringPayment`. */
  addressByBillingAddressId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `RecurringPayment`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `GatewayPaymentMethod` that is related to this `RecurringPayment`. */
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  /** Reads a single `PaymentRecipient` that is related to this `RecurringPayment`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Reads a single `Person` that is related to this `RecurringPayment`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  recurringPayment?: Maybe<RecurringPayment>;
  /** An edge for our `RecurringPayment`. May be used by Relay 1. */
  recurringPaymentEdge?: Maybe<RecurringPaymentsEdge>;
};


/** The output of our `updateRecurringPaymentAmount` mutation. */
export type UpdateRecurringPaymentAmountPayloadRecurringPaymentEdgeArgs = {
  orderBy?: InputMaybe<Array<RecurringPaymentsOrderBy>>;
};

/** All input for the `updateReportedDonation` mutation. */
export type UpdateReportedDonationInput = {
  amount?: InputMaybe<Scalars['BigFloat']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  donationDate?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['BigInt']>;
  incomeId?: InputMaybe<Scalars['BigInt']>;
  organizationId?: InputMaybe<Scalars['BigInt']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  pledgeId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `updateReportedDonation` mutation. */
export type UpdateReportedDonationPayload = {
  __typename?: 'UpdateReportedDonationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `ReportedDonation`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `ExternalOrganization` that is related to this `ReportedDonation`. */
  externalOrganizationByOrganizationId?: Maybe<ExternalOrganization>;
  /** Reads a single `Person` that is related to this `ReportedDonation`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  reportedDonation?: Maybe<ReportedDonation>;
  /** An edge for our `ReportedDonation`. May be used by Relay 1. */
  reportedDonationEdge?: Maybe<ReportedDonationsEdge>;
};


/** The output of our `updateReportedDonation` mutation. */
export type UpdateReportedDonationPayloadReportedDonationEdgeArgs = {
  orderBy?: InputMaybe<Array<ReportedDonationsOrderBy>>;
};

/** All input for the `updateReportedPayment` mutation. */
export type UpdateReportedPaymentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  incomeId?: InputMaybe<Scalars['BigInt']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  pledgeId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `updateReportedPayment` mutation. */
export type UpdateReportedPaymentPayload = {
  __typename?: 'UpdateReportedPaymentPayload';
  /** Reads a single `Address` that is related to this `Payment`. */
  addressByBillingAddressId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByChargeCurrencyCode?: Maybe<Currency>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `GatewayPaymentMethod` that is related to this `Payment`. */
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  payment?: Maybe<Payment>;
  /** An edge for our `Payment`. May be used by Relay 1. */
  paymentEdge?: Maybe<PaymentsEdge>;
  /** Reads a single `PaymentRecipient` that is related to this `Payment`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Reads a single `Person` that is related to this `Payment`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateReportedPayment` mutation. */
export type UpdateReportedPaymentPayloadPaymentEdgeArgs = {
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};

/** All input for the `updateSettingsPrivacy` mutation. */
export type UpdateSettingsPrivacyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  partnerCharitiesCanContact?: InputMaybe<Scalars['Boolean']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  shareDetailsWithPartnerCharities?: InputMaybe<Scalars['Boolean']>;
};

/** The output of our `updateSettingsPrivacy` mutation. */
export type UpdateSettingsPrivacyPayload = {
  __typename?: 'UpdateSettingsPrivacyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Person` that is related to this `Privacy`. */
  personByPersonId?: Maybe<Person>;
  privacy?: Maybe<Privacy>;
  /** An edge for our `Privacy`. May be used by Relay 1. */
  privacyEdge?: Maybe<PrivaciesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateSettingsPrivacy` mutation. */
export type UpdateSettingsPrivacyPayloadPrivacyEdgeArgs = {
  orderBy?: InputMaybe<Array<PrivaciesOrderBy>>;
};

/** All input for the `upsertGivingWhatWeCanSurvey` mutation. */
export type UpsertGivingWhatWeCanSurveyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  counterfactualDonationPercentage?: InputMaybe<Scalars['Float']>;
  gwwcDonationInfluence?: InputMaybe<Scalars['String']>;
  otherComments?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['BigInt']>;
  referrer?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  referrerNotes?: InputMaybe<Scalars['String']>;
  wherePlanningToGive?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wherePlanningToGiveNotes?: InputMaybe<Scalars['String']>;
};

/** The output of our `upsertGivingWhatWeCanSurvey` mutation. */
export type UpsertGivingWhatWeCanSurveyPayload = {
  __typename?: 'UpsertGivingWhatWeCanSurveyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  givingWhatWeCanSurvey?: Maybe<GivingWhatWeCanSurvey>;
  /** An edge for our `GivingWhatWeCanSurvey`. May be used by Relay 1. */
  givingWhatWeCanSurveyEdge?: Maybe<GivingWhatWeCanSurveysEdge>;
  /** Reads a single `Person` that is related to this `GivingWhatWeCanSurvey`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `upsertGivingWhatWeCanSurvey` mutation. */
export type UpsertGivingWhatWeCanSurveyPayloadGivingWhatWeCanSurveyEdgeArgs = {
  orderBy?: InputMaybe<Array<GivingWhatWeCanSurveysOrderBy>>;
};

/** All input for the `voidPayment` mutation. */
export type VoidPaymentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['BigInt']>;
};

/** The output of our `voidPayment` mutation. */
export type VoidPaymentPayload = {
  __typename?: 'VoidPaymentPayload';
  /** Reads a single `Address` that is related to this `Payment`. */
  addressByBillingAddressId?: Maybe<Address>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByChargeCurrencyCode?: Maybe<Currency>;
  /** Reads a single `Currency` that is related to this `Payment`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  /** Reads a single `GatewayPaymentMethod` that is related to this `Payment`. */
  gatewayPaymentMethodByGatewayAndPaymentMethod?: Maybe<GatewayPaymentMethod>;
  payment?: Maybe<Payment>;
  /** An edge for our `Payment`. May be used by Relay 1. */
  paymentEdge?: Maybe<PaymentsEdge>;
  /** Reads a single `PaymentRecipient` that is related to this `Payment`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  /** Reads a single `Person` that is related to this `Payment`. */
  personByPersonId?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `voidPayment` mutation. */
export type VoidPaymentPayloadPaymentEdgeArgs = {
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};

export enum VoteMechanism {
  Multiple = 'MULTIPLE'
}

export type WageGrowth = {
  __typename?: 'WageGrowth';
  age?: Maybe<Scalars['Int']>;
  growth?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `WageGrowth` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type WageGrowthCondition = {
  /** Checks for equality with the object’s `age` field. */
  age?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `growth` field. */
  growth?: InputMaybe<Scalars['BigFloat']>;
};

export type WageGrowthInterpolated = {
  __typename?: 'WageGrowthInterpolated';
  age?: Maybe<Scalars['Int']>;
  growth?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `WageGrowthInterpolated` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type WageGrowthInterpolatedCondition = {
  /** Checks for equality with the object’s `age` field. */
  age?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `growth` field. */
  growth?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `WageGrowthInterpolated` values. */
export type WageGrowthInterpolatedsConnection = {
  __typename?: 'WageGrowthInterpolatedsConnection';
  /** A list of edges which contains the `WageGrowthInterpolated` and cursor to aid in pagination. */
  edges: Array<WageGrowthInterpolatedsEdge>;
  /** A list of `WageGrowthInterpolated` objects. */
  nodes: Array<Maybe<WageGrowthInterpolated>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WageGrowthInterpolated` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `WageGrowthInterpolated` edge in the connection. */
export type WageGrowthInterpolatedsEdge = {
  __typename?: 'WageGrowthInterpolatedsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `WageGrowthInterpolated` at the end of the edge. */
  node?: Maybe<WageGrowthInterpolated>;
};

/** Methods to use when ordering `WageGrowthInterpolated`. */
export enum WageGrowthInterpolatedsOrderBy {
  AgeAsc = 'AGE_ASC',
  AgeDesc = 'AGE_DESC',
  GrowthAsc = 'GROWTH_ASC',
  GrowthDesc = 'GROWTH_DESC',
  Natural = 'NATURAL'
}

/** A connection to a list of `WageGrowth` values. */
export type WageGrowthsConnection = {
  __typename?: 'WageGrowthsConnection';
  /** A list of edges which contains the `WageGrowth` and cursor to aid in pagination. */
  edges: Array<WageGrowthsEdge>;
  /** A list of `WageGrowth` objects. */
  nodes: Array<Maybe<WageGrowth>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WageGrowth` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `WageGrowth` edge in the connection. */
export type WageGrowthsEdge = {
  __typename?: 'WageGrowthsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `WageGrowth` at the end of the edge. */
  node?: Maybe<WageGrowth>;
};

/** Methods to use when ordering `WageGrowth`. */
export enum WageGrowthsOrderBy {
  AgeAsc = 'AGE_ASC',
  AgeDesc = 'AGE_DESC',
  GrowthAsc = 'GROWTH_ASC',
  GrowthDesc = 'GROWTH_DESC',
  Natural = 'NATURAL'
}

export type WorldFiscalYear = Node & {
  __typename?: 'WorldFiscalYear';
  countryCode: Scalars['String'];
  fiscalYearStartDate?: Maybe<Scalars['Date']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `WorldFiscalYear` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WorldFiscalYearCondition = {
  /** Checks for equality with the object’s `countryCode` field. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fiscalYearStartDate` field. */
  fiscalYearStartDate?: InputMaybe<Scalars['Date']>;
};

/** A connection to a list of `WorldFiscalYear` values. */
export type WorldFiscalYearsConnection = {
  __typename?: 'WorldFiscalYearsConnection';
  /** A list of edges which contains the `WorldFiscalYear` and cursor to aid in pagination. */
  edges: Array<WorldFiscalYearsEdge>;
  /** A list of `WorldFiscalYear` objects. */
  nodes: Array<Maybe<WorldFiscalYear>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorldFiscalYear` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `WorldFiscalYear` edge in the connection. */
export type WorldFiscalYearsEdge = {
  __typename?: 'WorldFiscalYearsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `WorldFiscalYear` at the end of the edge. */
  node?: Maybe<WorldFiscalYear>;
};

/** Methods to use when ordering `WorldFiscalYear`. */
export enum WorldFiscalYearsOrderBy {
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  FiscalYearStartDateAsc = 'FISCAL_YEAR_START_DATE_ASC',
  FiscalYearStartDateDesc = 'FISCAL_YEAR_START_DATE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type WorldIncome = Node & {
  __typename?: 'WorldIncome';
  amount: Scalars['Int'];
  amountNormalized: Scalars['Int'];
  cohort: Scalars['String'];
  countryCode: Scalars['String'];
  /** Reads a single `Currency` that is related to this `WorldIncome`. */
  currencyByCurrencyCode?: Maybe<Currency>;
  currencyCode: Scalars['String'];
  dataYear: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `WorldIncome` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type WorldIncomeCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `amountNormalized` field. */
  amountNormalized?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `cohort` field. */
  cohort?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `countryCode` field. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `dataYear` field. */
  dataYear?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `WorldIncome` values. */
export type WorldIncomesConnection = {
  __typename?: 'WorldIncomesConnection';
  /** A list of edges which contains the `WorldIncome` and cursor to aid in pagination. */
  edges: Array<WorldIncomesEdge>;
  /** A list of `WorldIncome` objects. */
  nodes: Array<Maybe<WorldIncome>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorldIncome` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `WorldIncome` edge in the connection. */
export type WorldIncomesEdge = {
  __typename?: 'WorldIncomesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `WorldIncome` at the end of the edge. */
  node?: Maybe<WorldIncome>;
};

/** Methods to use when ordering `WorldIncome`. */
export enum WorldIncomesOrderBy {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  AmountNormalizedAsc = 'AMOUNT_NORMALIZED_ASC',
  AmountNormalizedDesc = 'AMOUNT_NORMALIZED_DESC',
  CohortAsc = 'COHORT_ASC',
  CohortDesc = 'COHORT_DESC',
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DataYearAsc = 'DATA_YEAR_ASC',
  DataYearDesc = 'DATA_YEAR_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type XeroAccount = Node & {
  __typename?: 'XeroAccount';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `PaymentRecipient` that is related to this `XeroAccount`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  recipient: Scalars['String'];
  reference: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  xeroAccountCode: Scalars['String'];
};

/**
 * A condition to be used against `XeroAccount` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type XeroAccountCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `xeroAccountCode` field. */
  xeroAccountCode?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `XeroAccount` values. */
export type XeroAccountsConnection = {
  __typename?: 'XeroAccountsConnection';
  /** A list of edges which contains the `XeroAccount` and cursor to aid in pagination. */
  edges: Array<XeroAccountsEdge>;
  /** A list of `XeroAccount` objects. */
  nodes: Array<Maybe<XeroAccount>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `XeroAccount` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `XeroAccount` edge in the connection. */
export type XeroAccountsEdge = {
  __typename?: 'XeroAccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `XeroAccount` at the end of the edge. */
  node?: Maybe<XeroAccount>;
};

/** Methods to use when ordering `XeroAccount`. */
export enum XeroAccountsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  ReferenceAsc = 'REFERENCE_ASC',
  ReferenceDesc = 'REFERENCE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  XeroAccountCodeAsc = 'XERO_ACCOUNT_CODE_ASC',
  XeroAccountCodeDesc = 'XERO_ACCOUNT_CODE_DESC'
}

export type XeroApp = Node & {
  __typename?: 'XeroApp';
  appName: Scalars['String'];
  clientId: Scalars['String'];
  clientSecretEncrypted: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  tokenSetEncrypted: Scalars['String'];
};

/** A condition to be used against `XeroApp` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type XeroAppCondition = {
  /** Checks for equality with the object’s `appName` field. */
  appName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `clientSecretEncrypted` field. */
  clientSecretEncrypted?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `tokenSetEncrypted` field. */
  tokenSetEncrypted?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `XeroApp` values. */
export type XeroAppsConnection = {
  __typename?: 'XeroAppsConnection';
  /** A list of edges which contains the `XeroApp` and cursor to aid in pagination. */
  edges: Array<XeroAppsEdge>;
  /** A list of `XeroApp` objects. */
  nodes: Array<Maybe<XeroApp>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `XeroApp` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `XeroApp` edge in the connection. */
export type XeroAppsEdge = {
  __typename?: 'XeroAppsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `XeroApp` at the end of the edge. */
  node?: Maybe<XeroApp>;
};

/** Methods to use when ordering `XeroApp`. */
export enum XeroAppsOrderBy {
  AppNameAsc = 'APP_NAME_ASC',
  AppNameDesc = 'APP_NAME_DESC',
  ClientIdAsc = 'CLIENT_ID_ASC',
  ClientIdDesc = 'CLIENT_ID_DESC',
  ClientSecretEncryptedAsc = 'CLIENT_SECRET_ENCRYPTED_ASC',
  ClientSecretEncryptedDesc = 'CLIENT_SECRET_ENCRYPTED_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TokenSetEncryptedAsc = 'TOKEN_SET_ENCRYPTED_ASC',
  TokenSetEncryptedDesc = 'TOKEN_SET_ENCRYPTED_DESC'
}

export type XeroContact = Node & {
  __typename?: 'XeroContact';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `PaymentRecipient` that is related to this `XeroContact`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  personId: Scalars['BigInt'];
  recipient: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  xeroContactId: Scalars['UUID'];
};

/**
 * A condition to be used against `XeroContact` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type XeroContactCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `xeroContactId` field. */
  xeroContactId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `XeroContact` values. */
export type XeroContactsConnection = {
  __typename?: 'XeroContactsConnection';
  /** A list of edges which contains the `XeroContact` and cursor to aid in pagination. */
  edges: Array<XeroContactsEdge>;
  /** A list of `XeroContact` objects. */
  nodes: Array<Maybe<XeroContact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `XeroContact` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `XeroContact` edge in the connection. */
export type XeroContactsEdge = {
  __typename?: 'XeroContactsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `XeroContact` at the end of the edge. */
  node?: Maybe<XeroContact>;
};

/** Methods to use when ordering `XeroContact`. */
export enum XeroContactsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  XeroContactIdAsc = 'XERO_CONTACT_ID_ASC',
  XeroContactIdDesc = 'XERO_CONTACT_ID_DESC'
}

export type XeroTracking = Node & {
  __typename?: 'XeroTracking';
  /** Reads and enables pagination through a set of `BalanceSheetReport`. */
  balanceSheetReportsByReferenceAndRecipientAndXeroTrackingCategoryName: BalanceSheetReportsConnection;
  /** Reads and enables pagination through a set of `BalanceSheetReport`. */
  balanceSheetReportsByReferenceAndRecipientAndXeroTrackingCategoryNameList: Array<BalanceSheetReport>;
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `PaymentRecipient` that is related to this `XeroTracking`. */
  paymentRecipientByRecipient?: Maybe<PaymentRecipient>;
  recipient: Scalars['String'];
  reference: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  xeroTrackingCategoryName: Scalars['String'];
  xeroTrackingCategoryOption: Scalars['String'];
};


export type XeroTrackingBalanceSheetReportsByReferenceAndRecipientAndXeroTrackingCategoryNameArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BalanceSheetReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BalanceSheetReportsOrderBy>>;
};


export type XeroTrackingBalanceSheetReportsByReferenceAndRecipientAndXeroTrackingCategoryNameListArgs = {
  condition?: InputMaybe<BalanceSheetReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BalanceSheetReportsOrderBy>>;
};

/**
 * A condition to be used against `XeroTracking` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type XeroTrackingCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `recipient` field. */
  recipient?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `xeroTrackingCategoryName` field. */
  xeroTrackingCategoryName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `xeroTrackingCategoryOption` field. */
  xeroTrackingCategoryOption?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `XeroTracking` values. */
export type XeroTrackingsConnection = {
  __typename?: 'XeroTrackingsConnection';
  /** A list of edges which contains the `XeroTracking` and cursor to aid in pagination. */
  edges: Array<XeroTrackingsEdge>;
  /** A list of `XeroTracking` objects. */
  nodes: Array<Maybe<XeroTracking>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `XeroTracking` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `XeroTracking` edge in the connection. */
export type XeroTrackingsEdge = {
  __typename?: 'XeroTrackingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `XeroTracking` at the end of the edge. */
  node?: Maybe<XeroTracking>;
};

/** Methods to use when ordering `XeroTracking`. */
export enum XeroTrackingsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  ReferenceAsc = 'REFERENCE_ASC',
  ReferenceDesc = 'REFERENCE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  XeroTrackingCategoryNameAsc = 'XERO_TRACKING_CATEGORY_NAME_ASC',
  XeroTrackingCategoryNameDesc = 'XERO_TRACKING_CATEGORY_NAME_DESC',
  XeroTrackingCategoryOptionAsc = 'XERO_TRACKING_CATEGORY_OPTION_ASC',
  XeroTrackingCategoryOptionDesc = 'XERO_TRACKING_CATEGORY_OPTION_DESC'
}

export type CreateExternalOrganizationMutationVariables = Exact<{
  name: Scalars['String'];
  organizationSlug?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type CreateExternalOrganizationMutation = { __typename?: 'Mutation', createExternalOrganization?: { __typename?: 'CreateExternalOrganizationPayload', externalOrganization?: { __typename?: 'ExternalOrganization', id: string, name: string, keywords?: Array<string | null | undefined> | null | undefined, organizationSlug?: string | null | undefined, url?: string | null | undefined } | null | undefined } | null | undefined };

export type GetExternalOrganizationTypeaheadQueryVariables = Exact<{
  searchText: Scalars['String'];
}>;


export type GetExternalOrganizationTypeaheadQuery = { __typename?: 'Query', ExternalOrganizations?: { __typename?: 'ExternalOrganizationsConnection', edges: Array<{ __typename?: 'ExternalOrganizationsEdge', node?: { __typename?: 'ExternalOrganization', id: string, name: string, organizationSlug?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetExternalOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalOrganizationsQuery = { __typename?: 'Query', ExternalOrganizations?: { __typename?: 'ExternalOrganizationsConnection', edges: Array<{ __typename?: 'ExternalOrganizationsEdge', node?: { __typename?: 'ExternalOrganization', id: string, name: string, organizationSlug?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsQuery = { __typename?: 'Query', Organizations?: { __typename?: 'OrganizationsConnection', edges: Array<{ __typename?: 'OrganizationsEdge', node?: { __typename?: 'Organization', slug: string, name: string, program?: string | null | undefined, type?: OrganizationType | null | undefined, active: boolean, hidden?: boolean | null | undefined, sortOrder: number, href?: string | null | undefined, isDataSharingPartner: boolean } | null | undefined }> } | null | undefined };

export type CancelRecurringPaymentMutationVariables = Exact<{
  recurringPaymentId: Scalars['BigInt'];
}>;


export type CancelRecurringPaymentMutation = { __typename?: 'Mutation', cancelRecurringPayment?: { __typename?: 'CancelRecurringPaymentPayload', clientMutationId?: string | null | undefined } | null | undefined };

export type CreateGiftAidClaimMutationVariables = Exact<{
  paymentId: Scalars['BigInt'];
  addressId: Scalars['BigInt'];
}>;


export type CreateGiftAidClaimMutation = { __typename?: 'Mutation', createGiftAidClaimFromPayment?: { __typename?: 'CreateGiftAidClaimFromPaymentPayload', giftAidClaim?: { __typename?: 'GiftAidClaim', paymentId: string, personId: string, addressId: string, reportId?: number | null | undefined } | null | undefined } | null | undefined };

export type CreateGocardlessRedirectFlowMutationVariables = Exact<{
  personId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateGocardlessRedirectFlowMutation = { __typename?: 'Mutation', mutationResult?: { __typename?: 'CreateGocardlessRedirectFlowByPersonOrTemporaryPersonPayload', RedirectFlow?: { __typename?: 'GocardlessRedirectFlow', personId: string, sessionToken: string, gocardlessRedirectFlowId?: string | null | undefined, gocardlessRedirectFlowUrl?: string | null | undefined, expires: string, createdAt: string, updatedAt: string } | null | undefined } | null | undefined };

export type CreatePaymentMutationVariables = Exact<{
  personId: Scalars['BigInt'];
  currencyCode: Scalars['String'];
  amount: Scalars['BigFloat'];
  recipient: Scalars['String'];
  allocation: Scalars['JSON'];
  gateway: PaymentGateway;
  gatewayData?: InputMaybe<Scalars['JSON']>;
  paymentMethod: PaymentMethod;
  billingAddressId?: InputMaybe<Scalars['BigInt']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<PaymentStatus>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
}>;


export type CreatePaymentMutation = { __typename?: 'Mutation', mutationResult?: { __typename?: 'CreatePaymentByPersonIdPayload', payment?: { __typename?: 'Payment', id: string, personId: string, chargeCurrencyCode: string, chargeAmount: string, currencyCode?: string | null | undefined, amount?: string | null | undefined, amountNormalized?: string | null | undefined, net?: string | null | undefined, fee?: string | null | undefined, recipient: string, allocation: unknown, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, gatewayTransactionId?: string | null | undefined, paymentMethod?: PaymentMethod | null | undefined, recurrence: PaymentRecurrence, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: PaymentStatus, statusData?: unknown | null | undefined, reference?: string | null | undefined, createdAt: string, updatedAt: string } | null | undefined } | null | undefined };

export type CreatePaymentByTemporaryPersonMutationVariables = Exact<{
  sessionToken: Scalars['UUID'];
  currencyCode: Scalars['String'];
  amount: Scalars['BigFloat'];
  recipient: Scalars['String'];
  allocation: Scalars['JSON'];
  gateway: PaymentGateway;
  gatewayData?: InputMaybe<Scalars['JSON']>;
  paymentMethod: PaymentMethod;
  billingAddressId?: InputMaybe<Scalars['BigInt']>;
  metadata?: InputMaybe<Scalars['JSON']>;
}>;


export type CreatePaymentByTemporaryPersonMutation = { __typename?: 'Mutation', mutationResult?: { __typename?: 'CreatePaymentByTemporaryPersonPayload', payment?: { __typename?: 'Payment', id: string, personId: string, chargeCurrencyCode: string, chargeAmount: string, currencyCode?: string | null | undefined, amount?: string | null | undefined, amountNormalized?: string | null | undefined, net?: string | null | undefined, fee?: string | null | undefined, recipient: string, allocation: unknown, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, gatewayTransactionId?: string | null | undefined, paymentMethod?: PaymentMethod | null | undefined, recurrence: PaymentRecurrence, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: PaymentStatus, statusData?: unknown | null | undefined, reference?: string | null | undefined, createdAt: string, updatedAt: string } | null | undefined } | null | undefined };

export type CreateRecurringPaymentMutationVariables = Exact<{
  personId: Scalars['BigInt'];
  period: RecurrencePeriod;
  periodIndex: Scalars['Int'];
  allocation: Scalars['JSON'];
  amount: Scalars['BigFloat'];
  currencyCode: Scalars['String'];
  recipient: Scalars['String'];
  gateway: PaymentGateway;
  gatewayData?: InputMaybe<Scalars['JSON']>;
  paymentMethod: PaymentMethod;
  billingAddressId?: InputMaybe<Scalars['BigInt']>;
  metadata?: InputMaybe<Scalars['JSON']>;
}>;


export type CreateRecurringPaymentMutation = { __typename?: 'Mutation', mutationResult?: { __typename?: 'CreateRecurringPaymentPayload', recurringPayment?: { __typename?: 'RecurringPayment', id: string, personId?: string | null | undefined, period: RecurrencePeriod, periodIndex: number, periodInterval: number, allocation: unknown, amount: string, currencyCode: string, recipient: string, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, paymentMethod?: PaymentMethod | null | undefined, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: RecurringPaymentStatus, statusData?: unknown | null | undefined, createdAt: string, updatedAt: string } | null | undefined } | null | undefined };

export type CreateRecurringPaymentByTemporaryPersonMutationVariables = Exact<{
  sessionToken: Scalars['UUID'];
  period: RecurrencePeriod;
  periodIndex: Scalars['Int'];
  allocation: Scalars['JSON'];
  amount: Scalars['BigFloat'];
  currencyCode: Scalars['String'];
  recipient: Scalars['String'];
  gateway: PaymentGateway;
  gatewayData?: InputMaybe<Scalars['JSON']>;
  paymentMethod: PaymentMethod;
  billingAddressId?: InputMaybe<Scalars['BigInt']>;
  metadata?: InputMaybe<Scalars['JSON']>;
}>;


export type CreateRecurringPaymentByTemporaryPersonMutation = { __typename?: 'Mutation', mutationResult?: { __typename?: 'CreateRecurringPaymentByTemporaryPersonPayload', recurringPayment?: { __typename?: 'RecurringPayment', id: string, personId?: string | null | undefined, period: RecurrencePeriod, periodIndex: number, periodInterval: number, allocation: unknown, amount: string, currencyCode: string, recipient: string, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, paymentMethod?: PaymentMethod | null | undefined, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: RecurringPaymentStatus, statusData?: unknown | null | undefined, createdAt: string, updatedAt: string } | null | undefined } | null | undefined };

export type DeleteGiftAidClaimMutationVariables = Exact<{
  paymentId: Scalars['BigInt'];
}>;


export type DeleteGiftAidClaimMutation = { __typename?: 'Mutation', GiftAidClaim?: { __typename?: 'DeleteGiftAidClaimFromPaymentPayload', giftAidClaim?: { __typename?: 'GiftAidClaim', paymentId: string, personId: string, addressId: string, reportId?: number | null | undefined } | null | undefined } | null | undefined };

export type UpdateRecurringPaymentAmountMutationVariables = Exact<{
  recurringPaymentId: Scalars['BigInt'];
  amount: Scalars['BigFloat'];
}>;


export type UpdateRecurringPaymentAmountMutation = { __typename?: 'Mutation', updateRecurringPaymentAmount?: { __typename?: 'UpdateRecurringPaymentAmountPayload', clientMutationId?: string | null | undefined } | null | undefined };

export type UpdateCryptoPaymentGatewayTransactionIdMutationVariables = Exact<{
  paymentAccessToken: Scalars['UUID'];
  gatewayTransactionId: Scalars['String'];
}>;


export type UpdateCryptoPaymentGatewayTransactionIdMutation = { __typename?: 'Mutation', updateCryptoPaymentGatewayTransactionId?: { __typename?: 'UpdateCryptoPaymentGatewayTransactionIdPayload', payment?: { __typename?: 'Payment', id: string, personId: string, chargeCurrencyCode: string, chargeAmount: string, currencyCode?: string | null | undefined, amount?: string | null | undefined, amountNormalized?: string | null | undefined, net?: string | null | undefined, fee?: string | null | undefined, recipient: string, allocation: unknown, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, gatewayTransactionId?: string | null | undefined, paymentMethod?: PaymentMethod | null | undefined, recurrence: PaymentRecurrence, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: PaymentStatus, statusData?: unknown | null | undefined, reference?: string | null | undefined, createdAt: string, updatedAt: string } | null | undefined } | null | undefined };

export type UpdatePaymentStatusMutationVariables = Exact<{
  paymentId: Scalars['BigInt'];
  status: PaymentStatus;
}>;


export type UpdatePaymentStatusMutation = { __typename?: 'Mutation', updatePaymentStatus?: { __typename?: 'UpdatePaymentStatusPayload', payment?: { __typename?: 'Payment', id: string, status: PaymentStatus } | null | undefined } | null | undefined };

export type VoidPaymentMutationVariables = Exact<{
  paymentId: Scalars['BigInt'];
}>;


export type VoidPaymentMutation = { __typename?: 'Mutation', voidPayment?: { __typename?: 'VoidPaymentPayload', payment?: { __typename?: 'Payment', id: string, status: PaymentStatus } | null | undefined } | null | undefined };

export type LotteryFieldsFragment = { __typename?: 'ExtendedLottery', id?: string | null | undefined, blockSize?: string | null | undefined, closeTimestamp?: string | null | undefined, lockTimestamp?: string | null | undefined, drawTimestamp?: string | null | undefined, drawEpoch?: number | null | undefined, status?: string | null | undefined, winningNumber?: string | null | undefined };

export type LotterySummaryFieldsFragment = { __typename?: 'LotterySummary', id?: string | null | undefined, blockSize?: string | null | undefined, closeTimestamp?: string | null | undefined, lockTimestamp?: string | null | undefined, drawTimestamp?: string | null | undefined, winningNumber?: string | null | undefined, winningNumberHex?: string | null | undefined, drawEpoch?: string | null | undefined, status?: string | null | undefined, ticketsAssigned?: boolean | null | undefined, maxBlockId?: number | null | undefined, numEntries?: number | null | undefined, entriesTotalNormalized?: string | null | undefined, benefactorLiability?: string | null | undefined, benefactorStartingTicketNumber?: string | null | undefined, benefactorWinsLastBlock?: boolean | null | undefined, winningTickets?: unknown | null | undefined };

export type PaymentFieldsFragment = { __typename?: 'Payment', id: string, personId: string, chargeCurrencyCode: string, chargeAmount: string, currencyCode?: string | null | undefined, amount?: string | null | undefined, amountNormalized?: string | null | undefined, net?: string | null | undefined, fee?: string | null | undefined, recipient: string, allocation: unknown, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, gatewayTransactionId?: string | null | undefined, paymentMethod?: PaymentMethod | null | undefined, recurrence: PaymentRecurrence, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: PaymentStatus, statusData?: unknown | null | undefined, reference?: string | null | undefined, createdAt: string, updatedAt: string };

export type RecurringPaymentFieldsFragment = { __typename?: 'RecurringPayment', id: string, personId?: string | null | undefined, period: RecurrencePeriod, periodIndex: number, periodInterval: number, allocation: unknown, amount: string, currencyCode: string, recipient: string, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, paymentMethod?: PaymentMethod | null | undefined, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: RecurringPaymentStatus, statusData?: unknown | null | undefined, createdAt: string, updatedAt: string };

export type AllPaymentsManagersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPaymentsManagersQuery = { __typename?: 'Query', PaymentsManagers?: { __typename?: 'PaymentsManagersConnection', edges: Array<{ __typename?: 'PaymentsManagersEdge', node?: { __typename?: 'PaymentsManager', personId: string } | null | undefined }> } | null | undefined };

export type GetAllRecipientProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRecipientProgramsQuery = { __typename?: 'Query', RecipientPrograms?: Array<{ __typename?: 'RecipientProgram', organizationSlug: string, recipientSlug: string }> | null | undefined };

export type GetAllocationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllocationQuery = { __typename?: 'Query', allocation?: { __typename?: 'AllocationsConnection', edges: Array<{ __typename?: 'AllocationsEdge', node?: { __typename?: 'Allocation', personId: string, allocation: unknown } | null | undefined }> } | null | undefined };

export type GetAllocationByPersonIdQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetAllocationByPersonIdQuery = { __typename?: 'Query', Allocation?: { __typename?: 'Allocation', personId: string, allocation: unknown } | null | undefined };

export type GetFundraiserStatsQueryVariables = Exact<{
  fundraiserId: Scalars['String'];
}>;


export type GetFundraiserStatsQuery = { __typename?: 'Query', FundraiserStats?: { __typename?: 'FundraiserStatsConnection', edges: Array<{ __typename?: 'FundraiserStatsEdge', node?: { __typename?: 'FundraiserStat', fundraiserId?: string | null | undefined, amountRaisedNormalized?: string | null | undefined, numDonors?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetGivingSeasonStatsQueryVariables = Exact<{
  start: Scalars['Date'];
}>;


export type GetGivingSeasonStatsQuery = { __typename?: 'Query', GivingSeasonStats?: { __typename?: 'GetGivingSeasonStatsTsConnection', edges: Array<{ __typename?: 'GetGivingSeasonStatsTsEdge', node?: { __typename?: 'GetGivingSeasonStatsT', slug?: string | null | undefined, amountNormalized?: string | null | undefined, numDonations?: string | null | undefined, numPeople?: string | null | undefined, numCountries?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetGocardlessMandatesQueryVariables = Exact<{
  personId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
}>;


export type GetGocardlessMandatesQuery = { __typename?: 'Query', gocardlessMandates?: { __typename?: 'GocardlessMandatesConnection', edges: Array<{ __typename?: 'GocardlessMandatesEdge', node?: { __typename?: 'GocardlessMandate', personId: string, gocardlessCustomerId: string, gocardlessMandateId: string, status: GocardlessMandateStatus, gocardlessBankAccountId?: string | null | undefined, gocardlessBankAccountHolderName?: string | null | undefined, gocardlessBankAccountBankName?: string | null | undefined, gocardlessBankAccountNumberEnding?: number | null | undefined } | null | undefined }> } | null | undefined };

export type GetGocardlessRedirectFlowQueryVariables = Exact<{
  personId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
}>;


export type GetGocardlessRedirectFlowQuery = { __typename?: 'Query', GocardlessRedirectFlow?: { __typename?: 'GocardlessRedirectFlow', personId: string, sessionToken: string, gocardlessRedirectFlowId?: string | null | undefined, gocardlessRedirectFlowUrl?: string | null | undefined, expires: string, createdAt: string, updatedAt: string } | null | undefined };

export type GetLotteriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLotteriesQuery = { __typename?: 'Query', Lotteries?: { __typename?: 'ExtendedLotteriesConnection', edges: Array<{ __typename?: 'ExtendedLotteriesEdge', node?: { __typename?: 'ExtendedLottery', id?: string | null | undefined, blockSize?: string | null | undefined, closeTimestamp?: string | null | undefined, lockTimestamp?: string | null | undefined, drawTimestamp?: string | null | undefined, drawEpoch?: number | null | undefined, status?: string | null | undefined, winningNumber?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetLotteryByIdQueryVariables = Exact<{
  lotteryId: Scalars['BigInt'];
}>;


export type GetLotteryByIdQuery = { __typename?: 'Query', Lottery?: { __typename?: 'ExtendedLottery', id?: string | null | undefined, blockSize?: string | null | undefined, closeTimestamp?: string | null | undefined, lockTimestamp?: string | null | undefined, drawTimestamp?: string | null | undefined, drawEpoch?: number | null | undefined, status?: string | null | undefined, winningNumber?: string | null | undefined } | null | undefined };

export type GetLotteryEntriesCompleteQueryVariables = Exact<{
  lotteryId: Scalars['BigInt'];
}>;


export type GetLotteryEntriesCompleteQuery = { __typename?: 'Query', LotteryEntriesComplete?: { __typename?: 'LotteryEntryCompletesConnection', edges: Array<{ __typename?: 'LotteryEntryCompletesEdge', node?: { __typename?: 'LotteryEntryComplete', lotteryId?: string | null | undefined, paymentReference?: string | null | undefined, amountNormalized?: string | null | undefined, displayName?: string | null | undefined, tickets?: unknown | null | undefined, createdAt?: string | null | undefined, benefactor?: boolean | null | undefined } | null | undefined }> } | null | undefined };

export type GetLotteryEntriesPublicByLotteryIdQueryVariables = Exact<{
  lotteryId: Scalars['BigInt'];
}>;


export type GetLotteryEntriesPublicByLotteryIdQuery = { __typename?: 'Query', LotteryEntriesPublic?: { __typename?: 'LotteryEntryPublicsConnection', edges: Array<{ __typename?: 'LotteryEntryPublicsEdge', node?: { __typename?: 'LotteryEntryPublic', lotteryId?: string | null | undefined, paymentReference?: string | null | undefined, amount?: string | null | undefined, currencyCode?: string | null | undefined, amountNormalized?: string | null | undefined, giftAid?: string | null | undefined, total?: string | null | undefined, displayName?: string | null | undefined, createdAt?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetLotterySummariesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLotterySummariesQuery = { __typename?: 'Query', Lotteries?: { __typename?: 'LotterySummariesConnection', edges: Array<{ __typename?: 'LotterySummariesEdge', node?: { __typename?: 'LotterySummary', id?: string | null | undefined, blockSize?: string | null | undefined, closeTimestamp?: string | null | undefined, lockTimestamp?: string | null | undefined, drawTimestamp?: string | null | undefined, winningNumber?: string | null | undefined, winningNumberHex?: string | null | undefined, drawEpoch?: string | null | undefined, status?: string | null | undefined, ticketsAssigned?: boolean | null | undefined, maxBlockId?: number | null | undefined, numEntries?: number | null | undefined, entriesTotalNormalized?: string | null | undefined, benefactorLiability?: string | null | undefined, benefactorStartingTicketNumber?: string | null | undefined, benefactorWinsLastBlock?: boolean | null | undefined, winningTickets?: unknown | null | undefined } | null | undefined }> } | null | undefined };

export type GetLotterySummaryQueryVariables = Exact<{
  lotteryId: Scalars['BigInt'];
}>;


export type GetLotterySummaryQuery = { __typename?: 'Query', LotterySummary?: { __typename?: 'LotterySummary', id?: string | null | undefined, blockSize?: string | null | undefined, closeTimestamp?: string | null | undefined, lockTimestamp?: string | null | undefined, drawTimestamp?: string | null | undefined, winningNumber?: string | null | undefined, winningNumberHex?: string | null | undefined, drawEpoch?: string | null | undefined, status?: string | null | undefined, ticketsAssigned?: boolean | null | undefined, maxBlockId?: number | null | undefined, numEntries?: number | null | undefined, entriesTotalNormalized?: string | null | undefined, benefactorLiability?: string | null | undefined, benefactorStartingTicketNumber?: string | null | undefined, benefactorWinsLastBlock?: boolean | null | undefined, winningTickets?: unknown | null | undefined } | null | undefined };

export type GetLotteryTicketsPublicByLotteryIdQueryVariables = Exact<{
  lotteryId: Scalars['BigInt'];
}>;


export type GetLotteryTicketsPublicByLotteryIdQuery = { __typename?: 'Query', LotteryTicketsPublic?: { __typename?: 'LotteryTicketPublicsConnection', edges: Array<{ __typename?: 'LotteryTicketPublicsEdge', node?: { __typename?: 'LotteryTicketPublic', lotteryId?: string | null | undefined, paymentReference?: string | null | undefined, blockId?: number | null | undefined, benefactor?: boolean | null | undefined, winRange?: { __typename?: 'BigIntRange', start?: { __typename?: 'BigIntRangeBound', value: string, inclusive: boolean } | null | undefined, end?: { __typename?: 'BigIntRangeBound', value: string, inclusive: boolean } | null | undefined } | null | undefined } | null | undefined }> } | null | undefined };

export type GetLotteryWinnersQueryVariables = Exact<{
  lotteryId: Scalars['BigInt'];
}>;


export type GetLotteryWinnersQuery = { __typename?: 'Query', LotteryWinners?: { __typename?: 'LotteryWinnersConnection', edges: Array<{ __typename?: 'LotteryWinnersEdge', node?: { __typename?: 'LotteryWinner', lotteryId?: string | null | undefined, paymentReference?: string | null | undefined, blockId?: number | null | undefined, benefactor?: boolean | null | undefined } | null | undefined }> } | null | undefined };

export type GetPaymentQueryVariables = Exact<{
  paymentId: Scalars['BigInt'];
}>;


export type GetPaymentQuery = { __typename?: 'Query', Payment?: { __typename?: 'Payment', id: string, personId: string, chargeCurrencyCode: string, chargeAmount: string, currencyCode?: string | null | undefined, amount?: string | null | undefined, amountNormalized?: string | null | undefined, net?: string | null | undefined, fee?: string | null | undefined, recipient: string, allocation: unknown, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, gatewayTransactionId?: string | null | undefined, paymentMethod?: PaymentMethod | null | undefined, recurrence: PaymentRecurrence, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: PaymentStatus, statusData?: unknown | null | undefined, reference?: string | null | undefined, createdAt: string, updatedAt: string } | null | undefined };

export type GetPaymentAccessTokenQueryVariables = Exact<{
  paymentId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
}>;


export type GetPaymentAccessTokenQuery = { __typename?: 'Query', PaymentAccessToken?: { __typename?: 'PaymentAccessToken', paymentId: string, personId: string, token: string, tokenExpiresAt: string } | null | undefined };

export type GetPaymentByAccessTokenQueryVariables = Exact<{
  token: Scalars['UUID'];
}>;


export type GetPaymentByAccessTokenQuery = { __typename?: 'Query', Payment?: { __typename?: 'Payment', id: string, personId: string, chargeCurrencyCode: string, chargeAmount: string, currencyCode?: string | null | undefined, amount?: string | null | undefined, amountNormalized?: string | null | undefined, net?: string | null | undefined, fee?: string | null | undefined, recipient: string, allocation: unknown, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, gatewayTransactionId?: string | null | undefined, paymentMethod?: PaymentMethod | null | undefined, recurrence: PaymentRecurrence, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: PaymentStatus, statusData?: unknown | null | undefined, reference?: string | null | undefined, createdAt: string, updatedAt: string } | null | undefined };

export type GetPaymentByPersonOrTemporaryPersonQueryVariables = Exact<{
  paymentId: Scalars['BigInt'];
  sessionToken?: InputMaybe<Scalars['UUID']>;
}>;


export type GetPaymentByPersonOrTemporaryPersonQuery = { __typename?: 'Query', Payment?: { __typename?: 'Payment', id: string, personId: string, chargeCurrencyCode: string, chargeAmount: string, currencyCode?: string | null | undefined, amount?: string | null | undefined, amountNormalized?: string | null | undefined, net?: string | null | undefined, fee?: string | null | undefined, recipient: string, allocation: unknown, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, gatewayTransactionId?: string | null | undefined, paymentMethod?: PaymentMethod | null | undefined, recurrence: PaymentRecurrence, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: PaymentStatus, statusData?: unknown | null | undefined, reference?: string | null | undefined, createdAt: string, updatedAt: string } | null | undefined };

export type GetPaymentsQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetPaymentsQuery = { __typename?: 'Query', Payments?: { __typename?: 'PaymentsConnection', edges: Array<{ __typename?: 'PaymentsEdge', node?: { __typename?: 'Payment', id: string, personId: string, chargeCurrencyCode: string, chargeAmount: string, currencyCode?: string | null | undefined, amount?: string | null | undefined, amountNormalized?: string | null | undefined, net?: string | null | undefined, fee?: string | null | undefined, recipient: string, allocation: unknown, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, gatewayTransactionId?: string | null | undefined, paymentMethod?: PaymentMethod | null | undefined, recurrence: PaymentRecurrence, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: PaymentStatus, statusData?: unknown | null | undefined, reference?: string | null | undefined, createdAt: string, updatedAt: string, giftAidClaimsByPaymentIdAndPersonId: { __typename?: 'GiftAidClaimsConnection', edges: Array<{ __typename?: 'GiftAidClaimsEdge', node?: { __typename?: 'GiftAidClaim', nodeId: string, paymentId: string, personId: string, addressId: string, reportId?: number | null | undefined } | null | undefined }> } } | null | undefined }> } | null | undefined };

export type GetRecurringPaymentQueryVariables = Exact<{
  id: Scalars['BigInt'];
}>;


export type GetRecurringPaymentQuery = { __typename?: 'Query', recurringPayment?: { __typename?: 'RecurringPayment', id: string, personId?: string | null | undefined, period: RecurrencePeriod, periodIndex: number, periodInterval: number, allocation: unknown, amount: string, currencyCode: string, recipient: string, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, paymentMethod?: PaymentMethod | null | undefined, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: RecurringPaymentStatus, statusData?: unknown | null | undefined, createdAt: string, updatedAt: string } | null | undefined };

export type GetRecurringPaymentByPersonOrTemporaryPersonQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
}>;


export type GetRecurringPaymentByPersonOrTemporaryPersonQuery = { __typename?: 'Query', recurringPayment?: { __typename?: 'RecurringPayment', id: string, personId?: string | null | undefined, period: RecurrencePeriod, periodIndex: number, periodInterval: number, allocation: unknown, amount: string, currencyCode: string, recipient: string, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, paymentMethod?: PaymentMethod | null | undefined, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: RecurringPaymentStatus, statusData?: unknown | null | undefined, createdAt: string, updatedAt: string } | null | undefined };

export type GetRecurringPaymentsQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetRecurringPaymentsQuery = { __typename?: 'Query', RecurringPayments?: { __typename?: 'RecurringPaymentsConnection', edges: Array<{ __typename?: 'RecurringPaymentsEdge', node?: { __typename?: 'RecurringPayment', id: string, personId?: string | null | undefined, period: RecurrencePeriod, periodIndex: number, periodInterval: number, allocation: unknown, amount: string, currencyCode: string, recipient: string, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, paymentMethod?: PaymentMethod | null | undefined, billingAddressId?: string | null | undefined, metadata?: unknown | null | undefined, status: RecurringPaymentStatus, statusData?: unknown | null | undefined, createdAt: string, updatedAt: string } | null | undefined }> } | null | undefined };

export type SendReceiptQueryVariables = Exact<{
  paymentId: Scalars['BigInt'];
}>;


export type SendReceiptQuery = { __typename?: 'Query', sendReceipt?: string | null | undefined };

export type CreateAcquisitionMutationVariables = Exact<{
  personId: Scalars['BigInt'];
  source: Scalars['String'];
  medium?: InputMaybe<Scalars['String']>;
  campaign?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['Int'];
}>;


export type CreateAcquisitionMutation = { __typename?: 'Mutation', createAcquisition?: { __typename?: 'CreateAcquisitionPayload', acquisition?: { __typename?: 'Acquisition', id: string, personId: string, source: string, medium?: string | null | undefined, campaign?: string | null | undefined, createdAt: string, updatedAt: string } | null | undefined } | null | undefined };

export type CreateAddressMutationVariables = Exact<{
  personId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
  addressType?: InputMaybe<AddressType>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
}>;


export type CreateAddressMutation = { __typename?: 'Mutation', mutationResult?: { __typename?: 'CreateAddressByPersonOrTemporaryPersonPayload', address?: { __typename?: 'Address', id: string, personId: string, addressType?: AddressType | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, houseNumber?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, city?: string | null | undefined, region?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined } | null | undefined } | null | undefined };

export type CreateTemporaryPersonMutationVariables = Exact<{
  email: Scalars['String'];
  recaptchaToken: Scalars['String'];
}>;


export type CreateTemporaryPersonMutation = { __typename?: 'Mutation', createTemporaryPersonByEmail?: { __typename?: 'CreateTemporaryPersonByEmailPayload', TemporaryPerson?: { __typename?: 'TemporaryPerson', email: string, sessionToken: string, tokenIssuedAt: string, tokenExpiresAt: string } | null | undefined } | null | undefined };

export type SyncAuth0UserMutationVariables = Exact<{
  auth0User: Scalars['JSON'];
}>;


export type SyncAuth0UserMutation = { __typename?: 'Mutation', syncAuth0User?: { __typename?: 'SyncAuth0UserPayload', Person?: { __typename?: 'Person', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, fullName?: string | null | undefined, birthDate?: string | null | undefined, createdAt: string, updatedAt: string, isAnonymized: boolean, auth0UserId?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdatePersonByIdMutationVariables = Exact<{
  personId: Scalars['BigInt'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['Date']>;
}>;


export type UpdatePersonByIdMutation = { __typename?: 'Mutation', updatePersonByPersonId?: { __typename?: 'UpdatePersonByPersonIdPayload', person?: { __typename?: 'Person', id: string, fullName?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, birthDate?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdatePersonEmailMutationVariables = Exact<{
  personId: Scalars['BigInt'];
  email: Scalars['String'];
}>;


export type UpdatePersonEmailMutation = { __typename?: 'Mutation', Person?: { __typename?: 'UpdatePersonEmailAuth0Payload', message?: string | null | undefined } | null | undefined };

export type FindPersonByNameOrEmailQueryVariables = Exact<{
  searchText: Scalars['String'];
}>;


export type FindPersonByNameOrEmailQuery = { __typename?: 'Query', People?: { __typename?: 'PeopleConnection', edges: Array<{ __typename?: 'PeopleEdge', node?: { __typename?: 'Person', id: string, email?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> } | null | undefined };

export type FindPersonByPayRefQueryVariables = Exact<{
  searchText: Scalars['String'];
}>;


export type FindPersonByPayRefQuery = { __typename?: 'Query', FoundPeople?: { __typename?: 'PeopleConnection', edges: Array<{ __typename?: 'PeopleEdge', node?: { __typename?: 'Person', id: string, email?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetAddressesQueryVariables = Exact<{
  personId?: InputMaybe<Scalars['BigInt']>;
  sessionToken?: InputMaybe<Scalars['UUID']>;
}>;


export type GetAddressesQuery = { __typename?: 'Query', Addresses?: { __typename?: 'AddressesConnection', edges: Array<{ __typename?: 'AddressesEdge', node?: { __typename?: 'Address', id: string, personId: string, addressType?: AddressType | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, houseNumber?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, city?: string | null | undefined, region?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined, coordinates?: string | null | undefined, createdAt: string, updatedAt: string } | null | undefined }> } | null | undefined };

export type GetEmailAddressesQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetEmailAddressesQuery = { __typename?: 'Query', Emails?: { __typename?: 'EmailAddressesConnection', edges: Array<{ __typename?: 'EmailAddressesEdge', node?: { __typename?: 'EmailAddress', email: string, personId: string } | null | undefined }> } | null | undefined };

export type GetPersonQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonQuery = { __typename?: 'Query', Person?: { __typename?: 'Person', id: string, email?: string | null | undefined, fullName?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, birthDate?: string | null | undefined, auth0UserId?: string | null | undefined } | null | undefined };

export type GetPersonAllDataQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetPersonAllDataQuery = { __typename?: 'Query', RequestedPerson?: { __typename?: 'Person', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined, email?: string | null | undefined, birthDate?: string | null | undefined } | null | undefined, EmailAddresses?: { __typename?: 'EmailAddressesConnection', edges: Array<{ __typename?: 'EmailAddressesEdge', node?: { __typename?: 'EmailAddress', email: string, personId: string } | null | undefined }> } | null | undefined, Addresses?: { __typename?: 'AddressesConnection', edges: Array<{ __typename?: 'AddressesEdge', node?: { __typename?: 'Address', id: string, personId: string, firstName?: string | null | undefined, lastName?: string | null | undefined, houseNumber?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, city?: string | null | undefined, region?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined, coordinates?: string | null | undefined } | null | undefined }> } | null | undefined, Allocation?: { __typename?: 'Allocation', personId: string, allocation: unknown, createdAt: string, updatedAt: string } | null | undefined, Pledges?: { __typename?: 'PledgesConnection', edges: Array<{ __typename?: 'PledgesEdge', node?: { __typename?: 'Pledge', id: string, personId: string, pledgePercentage: string, pledgeType: PledgeType, period: { __typename?: 'DateRange', start?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined, end?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined } } | null | undefined }> } | null | undefined, Payments?: { __typename?: 'PaymentsConnection', edges: Array<{ __typename?: 'PaymentsEdge', node?: { __typename?: 'Payment', id: string, personId: string, allocation: unknown, recipient: string, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, status: PaymentStatus, statusData?: unknown | null | undefined, gatewayTransactionId?: string | null | undefined, amount?: string | null | undefined, net?: string | null | undefined, fee?: string | null | undefined, currencyCode?: string | null | undefined, chargeAmount: string, chargeCurrencyCode: string, createdAt: string, reference?: string | null | undefined, giftAidClaim: { __typename?: 'GiftAidClaimsConnection', edges: Array<{ __typename?: 'GiftAidClaimsEdge', node?: { __typename?: 'GiftAidClaim', paymentId: string, personId: string, addressId: string, createdAt: string, updatedAt: string } | null | undefined }> } } | null | undefined }> } | null | undefined, RecurringPayments?: { __typename?: 'RecurringPaymentsConnection', edges: Array<{ __typename?: 'RecurringPaymentsEdge', node?: { __typename?: 'RecurringPayment', id: string, personId?: string | null | undefined, period: RecurrencePeriod, periodIndex: number, allocation: unknown, amount: string, currencyCode: string, recipient: string, gateway: PaymentGateway, gatewayData?: unknown | null | undefined, createdAt: string } | null | undefined }> } | null | undefined };

export type GetPersonByIdQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetPersonByIdQuery = { __typename?: 'Query', Person?: { __typename?: 'Person', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined, email?: string | null | undefined, birthDate?: string | null | undefined, createdAt: string, updatedAt: string, auth0UserId?: string | null | undefined } | null | undefined };

export type CancelRecurringReportedDonationMutationVariables = Exact<{
  recurringReportedDonationId: Scalars['BigInt'];
}>;


export type CancelRecurringReportedDonationMutation = { __typename?: 'Mutation', cancelRecurringReportedDonation?: { __typename?: 'CancelRecurringReportedDonationPayload', RecurringReportedDonation?: { __typename?: 'RecurringReportedDonation', id: string } | null | undefined } | null | undefined };

export type CreateIncomeMutationVariables = Exact<{
  personId: Scalars['BigInt'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  amount: Scalars['BigFloat'];
  currencyCode: Scalars['String'];
  employmentStatus: IncomeEmploymentStatus;
  donationsTaxDeductible: Scalars['Boolean'];
}>;


export type CreateIncomeMutation = { __typename?: 'Mutation', createIncome?: { __typename?: 'CreateIncomePayload', income?: { __typename?: 'Income', id: string, personId: string, currencyCode: string, employmentStatus?: IncomeEmploymentStatus | null | undefined, donationsTaxDeductible?: boolean | null | undefined, period: { __typename?: 'DateRange', start?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined, end?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined } } | null | undefined } | null | undefined };

export type CreateRecurringReportedDonationMutationVariables = Exact<{
  personId: Scalars['BigInt'];
  organizationId: Scalars['BigInt'];
  amount: Scalars['BigFloat'];
  currencyCode: Scalars['String'];
  startDate: Scalars['Date'];
  recurrenceInterval: IntervalInput;
}>;


export type CreateRecurringReportedDonationMutation = { __typename?: 'Mutation', RecurringReportedDonation?: { __typename?: 'CreateRecurringReportedDonationPayload', recurringReportedDonation?: { __typename?: 'RecurringReportedDonation', id: string, personId: string, organizationId: string, amount: string, currencyCode: string, startDate: string, nextDate: string, status: RecurringPaymentStatus, createdAt: string, updatedAt: string, recurrenceInterval: { __typename?: 'Interval', years?: number | null | undefined, months?: number | null | undefined, days?: number | null | undefined, hours?: number | null | undefined, minutes?: number | null | undefined, seconds?: number | null | undefined } } | null | undefined } | null | undefined };

export type CreateReportedDonationMutationVariables = Exact<{
  personId: Scalars['BigInt'];
  donationDate: Scalars['Date'];
  amount: Scalars['BigFloat'];
  currencyCode: Scalars['String'];
  organizationId: Scalars['BigInt'];
  pledgeId?: InputMaybe<Scalars['BigInt']>;
  incomeId?: InputMaybe<Scalars['BigInt']>;
}>;


export type CreateReportedDonationMutation = { __typename?: 'Mutation', createReportedDonationByPersonId?: { __typename?: 'CreateReportedDonationByPersonIdPayload', reportedDonation?: { __typename?: 'ReportedDonation', id: string, personId: string, donationDate?: string | null | undefined, amount?: string | null | undefined, currencyCode?: string | null | undefined, organizationId: string } | null | undefined } | null | undefined };

export type DeleteIncomeMutationVariables = Exact<{
  id: Scalars['BigInt'];
}>;


export type DeleteIncomeMutation = { __typename?: 'Mutation', deleteIncome?: { __typename?: 'DeleteIncomePayload', clientMutationId?: string | null | undefined } | null | undefined };

export type DeleteReportedDonationMutationVariables = Exact<{
  reportedDonationId: Scalars['BigInt'];
}>;


export type DeleteReportedDonationMutation = { __typename?: 'Mutation', deleteReportedDonation?: { __typename?: 'DeleteReportedDonationPayload', clientMutationId?: string | null | undefined } | null | undefined };

export type SignPledgeMutationVariables = Exact<{
  personId: Scalars['BigInt'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  pledgePercentage: Scalars['BigFloat'];
  pledgeType: PledgeType;
  motivation?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  metadata: Scalars['JSON'];
  amount: Scalars['BigFloat'];
  currencyCode: Scalars['String'];
  employmentStatus: IncomeEmploymentStatus;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['Date']>;
}>;


export type SignPledgeMutation = { __typename?: 'Mutation', signPledge?: { __typename?: 'SignPledgePayload', pledge?: { __typename?: 'Pledge', id: string, personId: string, pledgePercentage: string, motivation?: string | null | undefined, locale: string, metadata?: unknown | null | undefined, period: { __typename?: 'DateRange', start?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined, end?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined } } | null | undefined } | null | undefined };

export type UpdateIncomeMutationVariables = Exact<{
  id: Scalars['BigInt'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  amount: Scalars['BigFloat'];
  currencyCode: Scalars['String'];
  employmentStatus: IncomeEmploymentStatus;
  donationsTaxDeductible: Scalars['Boolean'];
}>;


export type UpdateIncomeMutation = { __typename?: 'Mutation', updateIncome?: { __typename?: 'UpdateIncomePayload', income?: { __typename?: 'Income', id: string, personId: string, currencyCode: string, employmentStatus?: IncomeEmploymentStatus | null | undefined, donationsTaxDeductible?: boolean | null | undefined, period: { __typename?: 'DateRange', start?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined, end?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined } } | null | undefined } | null | undefined };

export type UpdateReportedPaymentMutationVariables = Exact<{
  id: Scalars['BigInt'];
  personId: Scalars['BigInt'];
  pledgeId?: InputMaybe<Scalars['BigInt']>;
  incomeId?: InputMaybe<Scalars['BigInt']>;
}>;


export type UpdateReportedPaymentMutation = { __typename?: 'Mutation', updateReportedPayment?: { __typename?: 'UpdateReportedPaymentPayload', payment?: { __typename?: 'Payment', id: string } | null | undefined } | null | undefined };

export type UpdatePledgeMutationVariables = Exact<{
  id: Scalars['BigInt'];
  metadata: Scalars['JSON'];
}>;


export type UpdatePledgeMutation = { __typename?: 'Mutation', updatePledge?: { __typename?: 'UpdatePledgePayload', pledge?: { __typename?: 'Pledge', id: string, metadata?: unknown | null | undefined } | null | undefined } | null | undefined };

export type UpdateReportedDonationMutationVariables = Exact<{
  id: Scalars['BigInt'];
  personId: Scalars['BigInt'];
  donationDate: Scalars['Date'];
  amount: Scalars['BigFloat'];
  currencyCode: Scalars['String'];
  organizationId: Scalars['BigInt'];
  pledgeId?: InputMaybe<Scalars['BigInt']>;
  incomeId?: InputMaybe<Scalars['BigInt']>;
}>;


export type UpdateReportedDonationMutation = { __typename?: 'Mutation', updateReportedDonation?: { __typename?: 'UpdateReportedDonationPayload', reportedDonation?: { __typename?: 'ReportedDonation', id: string, personId: string, donationDate?: string | null | undefined, amount?: string | null | undefined, currencyCode?: string | null | undefined, organizationId: string } | null | undefined } | null | undefined };

export type RecurringReportedDonationFragment = { __typename?: 'RecurringReportedDonation', id: string, personId: string, organizationId: string, amount: string, currencyCode: string, startDate: string, nextDate: string, status: RecurringPaymentStatus, createdAt: string, updatedAt: string, externalOrganization?: { __typename?: 'ExternalOrganization', id: string, name: string, organizationSlug?: string | null | undefined, url?: string | null | undefined } | null | undefined, recurrenceInterval: { __typename?: 'Interval', years?: number | null | undefined, months?: number | null | undefined, days?: number | null | undefined, hours?: number | null | undefined, minutes?: number | null | undefined, seconds?: number | null | undefined } };

export type ReportedDonationFragment = { __typename?: 'ReportedDonation', id: string, personId: string, amount?: string | null | undefined, amountNormalized?: string | null | undefined, currencyCode?: string | null | undefined, donationDate?: string | null | undefined, organization?: { __typename?: 'ExternalOrganization', id: string, name: string, organizationSlug?: string | null | undefined } | null | undefined };

export type AllPledgesManagersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPledgesManagersQuery = { __typename?: 'Query', PledgesManagers?: { __typename?: 'PledgesManagersConnection', edges: Array<{ __typename?: 'PledgesManagersEdge', node?: { __typename?: 'PledgesManager', personId: string } | null | undefined }> } | null | undefined };

export type GetCompletionPaymentsByPersonIdQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetCompletionPaymentsByPersonIdQuery = { __typename?: 'Query', CompletionPayments?: { __typename?: 'CompletionPaymentsConnection', edges: Array<{ __typename?: 'CompletionPaymentsEdge', node?: { __typename?: 'CompletionPayment', objectId: string, objectType: CompletionPaymentObjectType, reportedDonationId?: string | null | undefined, organizationId?: string | null | undefined, paymentId?: string | null | undefined, personId?: string | null | undefined, pledgeId?: string | null | undefined, incomeId?: string | null | undefined, amount: string, currencyCode: string, amountNormalized?: string | null | undefined, allocation?: unknown | null | undefined, donationDate: string, externalOrganization?: { __typename?: 'ExternalOrganization', id: string, name: string } | null | undefined, liability?: { __typename?: 'Liability', pledgeIncomePeriod: { __typename?: 'DateRange', start?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined, end?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined } } | null | undefined } | null | undefined }> } | null | undefined };

export type GetIncomesByPersonIdQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetIncomesByPersonIdQuery = { __typename?: 'Query', Incomes?: { __typename?: 'IncomesConnection', edges: Array<{ __typename?: 'IncomesEdge', node?: { __typename?: 'Income', id: string, personId: string, amount: string, currencyCode: string, employmentStatus?: IncomeEmploymentStatus | null | undefined, donationsTaxDeductible?: boolean | null | undefined, period: { __typename?: 'DateRange', start?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined, end?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined }, liabilities: { __typename?: 'LiabilitiesConnection', edges: Array<{ __typename?: 'LiabilitiesEdge', node?: { __typename?: 'Liability', nodeId: string, pledgeId: string, incomeId: string, personId: string, currencyCode: string, liabilityAmount: string, liabilityNormalized: string, createdAt: string, updatedAt: string, pledgeIncomePeriod: { __typename?: 'DateRange', start?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined, end?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined } } | null | undefined }> } } | null | undefined }> } | null | undefined };

export type GetLiabilitiesByPersonIdQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetLiabilitiesByPersonIdQuery = { __typename?: 'Query', Liabilities?: { __typename?: 'LiabilitiesConnection', edges: Array<{ __typename?: 'LiabilitiesEdge', node?: { __typename?: 'Liability', personId: string, pledgeId: string, incomeId: string, pledgeIncomePeriod: { __typename?: 'DateRange', start?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined, end?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined } } | null | undefined }> } | null | undefined };

export type GetLiabilityCompletionsQueryVariables = Exact<{
  pledgeId: Scalars['BigInt'];
}>;


export type GetLiabilityCompletionsQuery = { __typename?: 'Query', LiabilityCompletions?: { __typename?: 'LiabilityCompletionTsConnection', edges: Array<{ __typename?: 'LiabilityCompletionTsEdge', node?: { __typename?: 'LiabilityCompletionT', personId?: string | null | undefined, pledgeId?: string | null | undefined, incomeId?: string | null | undefined, currencyCode?: string | null | undefined, liabilityAmount?: string | null | undefined, completionAmount?: string | null | undefined, completionAmountNormalized?: string | null | undefined, completionPercentage?: string | null | undefined, period?: { __typename?: 'DateRange', start?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined, end?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined } | null | undefined } | null | undefined }> } | null | undefined };

export type GetLiabilityTotalCompletionsQueryVariables = Exact<{
  pledgeId: Scalars['BigInt'];
}>;


export type GetLiabilityTotalCompletionsQuery = { __typename?: 'Query', LiabilityTotalCompletions?: { __typename?: 'LiabilityTotalCompletionTsConnection', edges: Array<{ __typename?: 'LiabilityTotalCompletionTsEdge', node?: { __typename?: 'LiabilityTotalCompletionT', pledgeId?: string | null | undefined, currencyCode?: string | null | undefined, currencySortOrder?: string | null | undefined, liabilityAmount?: string | null | undefined, liabilityAmountNormalized?: string | null | undefined, completionAmount?: string | null | undefined, completionAmountNormalized?: string | null | undefined, completionPercentage?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetPledgeQueryVariables = Exact<{
  id: Scalars['BigInt'];
}>;


export type GetPledgeQuery = { __typename?: 'Query', Pledge?: { __typename?: 'Pledge', id: string, personId: string, pledgePercentage: string, pledgeType: PledgeType, motivation?: string | null | undefined, locale: string, metadata?: unknown | null | undefined, period: { __typename?: 'DateRange', start?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined, end?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined } } | null | undefined };

export type GetPledgeLiabilityThroughTodayQueryVariables = Exact<{
  pledgeId: Scalars['BigInt'];
}>;


export type GetPledgeLiabilityThroughTodayQuery = { __typename?: 'Query', normalizedLiability?: string | null | undefined };

export type GetPledgeRanksByPersonIdQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetPledgeRanksByPersonIdQuery = { __typename?: 'Query', PledgeRanks?: { __typename?: 'PledgeRanksConnection', edges: Array<{ __typename?: 'PledgeRanksEdge', node?: { __typename?: 'PledgeRank', createdAt: string, pledgeType: PledgeType, rankByPledgeType: number, commencementDate: string, personByPersonId?: { __typename?: 'Person', id: string, fullName?: string | null | undefined } | null | undefined } | null | undefined }> } | null | undefined };

export type GetActivePledgedMemberPublicsQueryVariables = Exact<{
  pledgeType?: InputMaybe<PledgeType>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetActivePledgedMemberPublicsQuery = { __typename?: 'Query', PledgedMembers?: { __typename?: 'PledgedMembersPublicsConnection', edges: Array<{ __typename?: 'PledgedMembersPublicsEdge', node?: { __typename?: 'PledgedMembersPublic', fullName?: string | null | undefined, anonymous?: boolean | null | undefined, pledgeType?: PledgeType | null | undefined, commencementDate?: string | null | undefined, rankByPledgeType?: number | null | undefined, active?: boolean | null | undefined, latestPledgePercentage?: string | null | undefined, latestPledgeEndDate?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetPledgedMemberPublicsLatestRankQueryVariables = Exact<{
  pledgeType?: InputMaybe<PledgeType>;
}>;


export type GetPledgedMemberPublicsLatestRankQuery = { __typename?: 'Query', PledgedMembers?: Array<{ __typename?: 'PledgedMembersPublic', rankByPledgeType?: number | null | undefined }> | null | undefined };

export type GetPledgesByPersonIdQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetPledgesByPersonIdQuery = { __typename?: 'Query', Pledges?: { __typename?: 'PledgesConnection', edges: Array<{ __typename?: 'PledgesEdge', node?: { __typename?: 'Pledge', id: string, personId: string, pledgePercentage: string, pledgeType: PledgeType, motivation?: string | null | undefined, createdAt: string, period: { __typename?: 'DateRange', start?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined, end?: { __typename?: 'DateRangeBound', value: string, inclusive: boolean } | null | undefined }, liabilities: { __typename?: 'LiabilitiesConnection', edges: Array<{ __typename?: 'LiabilitiesEdge', node?: { __typename?: 'Liability', nodeId: string, pledgeId: string, incomeId: string, personId: string, currencyCode: string, liabilityAmount: string, liabilityNormalized: string, createdAt: string, updatedAt: string } | null | undefined }> } } | null | undefined }> } | null | undefined };

export type GetRecurringReportedDonationQueryVariables = Exact<{
  recurringReportedDonationId: Scalars['BigInt'];
}>;


export type GetRecurringReportedDonationQuery = { __typename?: 'Query', RecurringReportedDonation?: { __typename?: 'RecurringReportedDonation', id: string, personId: string, organizationId: string, amount: string, currencyCode: string, startDate: string, nextDate: string, status: RecurringPaymentStatus, createdAt: string, updatedAt: string, externalOrganization?: { __typename?: 'ExternalOrganization', id: string, name: string, organizationSlug?: string | null | undefined, url?: string | null | undefined } | null | undefined, recurrenceInterval: { __typename?: 'Interval', years?: number | null | undefined, months?: number | null | undefined, days?: number | null | undefined, hours?: number | null | undefined, minutes?: number | null | undefined, seconds?: number | null | undefined } } | null | undefined };

export type GetRecurringReportedDonationsByPersonIdQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetRecurringReportedDonationsByPersonIdQuery = { __typename?: 'Query', RecurringReportedDonations?: { __typename?: 'RecurringReportedDonationsConnection', edges: Array<{ __typename?: 'RecurringReportedDonationsEdge', node?: { __typename?: 'RecurringReportedDonation', id: string, personId: string, organizationId: string, amount: string, currencyCode: string, startDate: string, nextDate: string, status: RecurringPaymentStatus, createdAt: string, updatedAt: string, externalOrganization?: { __typename?: 'ExternalOrganization', id: string, name: string, organizationSlug?: string | null | undefined, url?: string | null | undefined } | null | undefined, recurrenceInterval: { __typename?: 'Interval', years?: number | null | undefined, months?: number | null | undefined, days?: number | null | undefined, hours?: number | null | undefined, minutes?: number | null | undefined, seconds?: number | null | undefined } } | null | undefined }> } | null | undefined };

export type GetReportedDonationQueryVariables = Exact<{
  reportedDonationId: Scalars['BigInt'];
}>;


export type GetReportedDonationQuery = { __typename?: 'Query', ReportedDonation?: { __typename?: 'ReportedDonation', id: string, personId: string, amount?: string | null | undefined, amountNormalized?: string | null | undefined, currencyCode?: string | null | undefined, donationDate?: string | null | undefined, organization?: { __typename?: 'ExternalOrganization', id: string, name: string, organizationSlug?: string | null | undefined } | null | undefined } | null | undefined };

export type GetReportedDonationsByPersonIdQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetReportedDonationsByPersonIdQuery = { __typename?: 'Query', ReportedDonations?: { __typename?: 'ReportedDonationsConnection', edges: Array<{ __typename?: 'ReportedDonationsEdge', node?: { __typename?: 'ReportedDonation', id: string, personId: string, amount?: string | null | undefined, amountNormalized?: string | null | undefined, currencyCode?: string | null | undefined, donationDate?: string | null | undefined, createdAt: string, updatedAt: string, externalOrganization?: { __typename?: 'ExternalOrganization', id: string, name: string, organizationSlug?: string | null | undefined } | null | undefined } | null | undefined }> } | null | undefined };

export type CreatePollOptionVoteMutationVariables = Exact<{
  personId: Scalars['BigInt'];
  pollOptionId: Scalars['BigInt'];
  context: Scalars['String'];
}>;


export type CreatePollOptionVoteMutation = { __typename?: 'Mutation', createPollOptionVote?: { __typename?: 'CreatePollOptionVotePayload', pollOptionVote?: { __typename?: 'PollOptionVote', personId: string, pollOptionId: string, context: string } | null | undefined } | null | undefined };

export type GetPollByPollIdQueryVariables = Exact<{
  pollId: Scalars['BigInt'];
}>;


export type GetPollByPollIdQuery = { __typename?: 'Query', Poll?: { __typename?: 'PollPublic', id: string, voteMechanism: VoteMechanism, questionOrdering: QuestionOrdering, question: string, pollOptionPublicsByPollIdList: Array<{ __typename?: 'PollOptionPublic', id: string, pollId: string, label: string, voteCount: number, pollOptionVotesByPollOptionIdList: Array<{ __typename?: 'PollOptionVote', personId: string, pollOptionId: string, context: string }> }> } | null | undefined };

export type AllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCountriesQuery = { __typename?: 'Query', Countries?: { __typename?: 'CountriesConnection', edges: Array<{ __typename?: 'CountriesEdge', node?: { __typename?: 'Country', name: string, isoAlpha2: string, isoAlpha3: string } | null | undefined }> } | null | undefined };

export type AllCountriesWithCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCountriesWithCurrenciesQuery = { __typename?: 'Query', Countries?: { __typename?: 'CountriesConnection', edges: Array<{ __typename?: 'CountriesEdge', node?: { __typename?: 'Country', name: string, isoAlpha2: string, isoAlpha3: string, currencies: Array<{ __typename?: 'CurrencyByCountry', currencyCode: string }> } | null | undefined }> } | null | undefined };

export type AllCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCurrenciesQuery = { __typename?: 'Query', Currencies?: { __typename?: 'CurrenciesConnection', edges: Array<{ __typename?: 'CurrenciesEdge', node?: { __typename?: 'Currency', name: string, code: string, decimals: number, symbol?: string | null | undefined, currencyType: CurrencyType } | null | undefined }> } | null | undefined };

export type AllMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMembersQuery = { __typename?: 'Query', Pledges?: Array<{ __typename?: 'PledgedMembersPublic', pledgeType?: PledgeType | null | undefined, active?: boolean | null | undefined, rankByPledgeType?: number | null | undefined, fullName?: string | null | undefined, commencementDate?: string | null | undefined }> | null | undefined };

export type ClosestExchangeRateQueryVariables = Exact<{
  currencyCode: Scalars['String'];
  date: Scalars['Date'];
}>;


export type ClosestExchangeRateQuery = { __typename?: 'Query', ExchangeRate?: { __typename?: 'ExchangeRate', currencyCode: string, date: string, rate?: string | null | undefined } | null | undefined };

export type GetCurrencyQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetCurrencyQuery = { __typename?: 'Query', Currency?: { __typename?: 'Currency', name: string, code: string, decimals: number, symbol?: string | null | undefined, currencyType: CurrencyType } | null | undefined };

export type CurrencyFieldsFragment = { __typename?: 'Currency', name: string, code: string, decimals: number, symbol?: string | null | undefined };

export type PaymentCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentCurrenciesQuery = { __typename?: 'Query', USD?: { __typename?: 'Currency', name: string, code: string, decimals: number, symbol?: string | null | undefined } | null | undefined, GBP?: { __typename?: 'Currency', name: string, code: string, decimals: number, symbol?: string | null | undefined } | null | undefined };

export type ExchangeRateFieldsFragment = { __typename?: 'ExchangeRate', currencyCode: string, date: string, rate?: string | null | undefined };

export type PaymentExchangeRatesQueryVariables = Exact<{
  date: Scalars['Date'];
}>;


export type PaymentExchangeRatesQuery = { __typename?: 'Query', GBP?: { __typename?: 'ExchangeRate', currencyCode: string, date: string, rate?: string | null | undefined } | null | undefined, BTC?: { __typename?: 'ExchangeRate', currencyCode: string, date: string, rate?: string | null | undefined } | null | undefined, ETH?: { __typename?: 'ExchangeRate', currencyCode: string, date: string, rate?: string | null | undefined } | null | undefined, LTC?: { __typename?: 'ExchangeRate', currencyCode: string, date: string, rate?: string | null | undefined } | null | undefined };

export type GetStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatsQuery = { __typename?: 'Query', allGlobalStatsList?: Array<{ __typename?: 'GlobalStat', gwwcPledgesTotal?: number | null | undefined, activeTryGivingPledgesTotal?: number | null | undefined, tryGivingCompletedTotal?: number | null | undefined, pledgersCountriesTotal?: number | null | undefined, pledgesDonationsTotal?: string | null | undefined, projectedDonationsTotal?: string | null | undefined }> | null | undefined };

export type GetPaymentStatsAggregateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentStatsAggregateQuery = { __typename?: 'Query', PaymentStats?: { __typename?: 'PaymentStatsAggregate', totalDonations?: string | null | undefined, numDonations?: string | null | undefined, numDonors?: string | null | undefined, totalDonationsLastYear?: string | null | undefined, numDonationsLastYear?: string | null | undefined, numDonorsLastYear?: string | null | undefined } | null | undefined };

export type GetXeroBalanceSheetByOrganizationQueryVariables = Exact<{
  reference: Scalars['String'];
  nearestReportDate?: InputMaybe<Scalars['Date']>;
}>;


export type GetXeroBalanceSheetByOrganizationQuery = { __typename?: 'Query', XeroBalanceSheet?: { __typename?: 'BalanceSheetReportMonthlyTotalsConnection', edges: Array<{ __typename?: 'BalanceSheetReportMonthlyTotalsEdge', node?: { __typename?: 'BalanceSheetReportMonthlyTotal', reportDate?: string | null | undefined, reference?: string | null | undefined, amount?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetXeroBalanceSheetReportMonthlyTotalQueryVariables = Exact<{
  nearestReportDate?: InputMaybe<Scalars['Date']>;
}>;


export type GetXeroBalanceSheetReportMonthlyTotalQuery = { __typename?: 'Query', XeroBalanceSheets?: { __typename?: 'BalanceSheetReportMonthlyTotalsConnection', edges: Array<{ __typename?: 'BalanceSheetReportMonthlyTotalsEdge', node?: { __typename?: 'BalanceSheetReportMonthlyTotal', reportDate?: string | null | undefined, reference?: string | null | undefined, amount?: string | null | undefined } | null | undefined }> } | null | undefined };

export type UpdateSettingsContactPreferenceMutationVariables = Exact<{
  personId: Scalars['BigInt'];
  currentAddressId?: InputMaybe<Scalars['BigInt']>;
}>;


export type UpdateSettingsContactPreferenceMutation = { __typename?: 'Mutation', updateContactPreferenceByPersonId?: { __typename?: 'UpdateContactPreferenceByPersonIdPayload', contactPreference?: { __typename?: 'ContactPreference', personId: string, currentAddressId?: string | null | undefined } | null | undefined } | null | undefined };

export type GetSettingsQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GetSettingsQuery = { __typename?: 'Query', ContactPreference?: { __typename?: 'ContactPreference', currentAddressId?: string | null | undefined } | null | undefined };

export type UpsertGivingWhatWeCanSurveyMutationVariables = Exact<{
  personId: Scalars['BigInt'];
  counterfactualDonationPercentage?: InputMaybe<Scalars['Float']>;
  wherePlanningToGive?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  wherePlanningToGiveNotes?: InputMaybe<Scalars['String']>;
  referrer?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  referrerNotes?: InputMaybe<Scalars['String']>;
  gwwcDonationInfluence?: InputMaybe<Scalars['String']>;
  otherComments?: InputMaybe<Scalars['String']>;
}>;


export type UpsertGivingWhatWeCanSurveyMutation = { __typename?: 'Mutation', upsertGivingWhatWeCanSurvey?: { __typename?: 'UpsertGivingWhatWeCanSurveyPayload', givingWhatWeCanSurvey?: { __typename?: 'GivingWhatWeCanSurvey', personId: string, counterfactualDonationPercentage?: number | null | undefined, wherePlanningToGive?: Array<string | null | undefined> | null | undefined, referrer?: Array<string | null | undefined> | null | undefined, referrerNotes?: string | null | undefined, gwwcDonationInfluence?: string | null | undefined, otherComments?: string | null | undefined, createdAt: string, updatedAt: string } | null | undefined } | null | undefined };

export type GwwcSurveyFragment = { __typename?: 'GivingWhatWeCanSurvey', personId: string, counterfactualDonationPercentage?: number | null | undefined, wherePlanningToGive?: Array<string | null | undefined> | null | undefined, referrer?: Array<string | null | undefined> | null | undefined, referrerNotes?: string | null | undefined, gwwcDonationInfluence?: string | null | undefined, otherComments?: string | null | undefined, createdAt: string, updatedAt: string };

export type AllOrganizationCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllOrganizationCategoriesQuery = { __typename?: 'Query', OrganizationCategories?: { __typename?: 'OrganizationCategoriesConnection', edges: Array<{ __typename?: 'OrganizationCategoriesEdge', node?: { __typename?: 'OrganizationCategory', slug: string, description: string } | null | undefined }> } | null | undefined };

export type AllReferralSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllReferralSourcesQuery = { __typename?: 'Query', ReferralSources?: { __typename?: 'ReferralSourcesConnection', edges: Array<{ __typename?: 'ReferralSourcesEdge', node?: { __typename?: 'ReferralSource', slug: string, description: string } | null | undefined }> } | null | undefined };

export type GivingWhatWeCanSurveyByPersonIdQueryVariables = Exact<{
  personId: Scalars['BigInt'];
}>;


export type GivingWhatWeCanSurveyByPersonIdQuery = { __typename?: 'Query', GivingWhatWeCanSurvey?: { __typename?: 'GivingWhatWeCanSurvey', personId: string, counterfactualDonationPercentage?: number | null | undefined, wherePlanningToGive?: Array<string | null | undefined> | null | undefined, referrer?: Array<string | null | undefined> | null | undefined, referrerNotes?: string | null | undefined, gwwcDonationInfluence?: string | null | undefined, otherComments?: string | null | undefined, createdAt: string, updatedAt: string } | null | undefined };

export const LotteryFieldsFragmentDoc = gql`
    fragment LotteryFields on ExtendedLottery {
  id
  blockSize
  closeTimestamp
  lockTimestamp
  drawTimestamp
  drawEpoch
  status
  winningNumber
}
    `;
export const LotterySummaryFieldsFragmentDoc = gql`
    fragment LotterySummaryFields on LotterySummary {
  id
  blockSize
  closeTimestamp
  lockTimestamp
  drawTimestamp
  winningNumber
  winningNumberHex
  drawEpoch
  status
  ticketsAssigned
  maxBlockId
  numEntries
  entriesTotalNormalized
  benefactorLiability
  benefactorStartingTicketNumber
  benefactorWinsLastBlock
  winningTickets
}
    `;
export const PaymentFieldsFragmentDoc = gql`
    fragment PaymentFields on Payment {
  id
  personId
  chargeCurrencyCode
  chargeAmount
  currencyCode
  amount
  amountNormalized
  net
  fee
  recipient
  allocation
  gateway
  gatewayData
  gatewayTransactionId
  paymentMethod
  recurrence
  billingAddressId
  metadata
  status
  statusData
  reference
  createdAt
  updatedAt
}
    `;
export const RecurringPaymentFieldsFragmentDoc = gql`
    fragment RecurringPaymentFields on RecurringPayment {
  id
  personId
  period
  periodIndex
  periodInterval
  allocation
  amount
  currencyCode
  recipient
  gateway
  gatewayData
  paymentMethod
  billingAddressId
  metadata
  status
  statusData
  createdAt
  updatedAt
}
    `;
export const RecurringReportedDonationFragmentDoc = gql`
    fragment RecurringReportedDonation on RecurringReportedDonation {
  id
  personId
  organizationId
  externalOrganization: externalOrganizationByOrganizationId {
    id
    name
    organizationSlug
    url
  }
  amount
  currencyCode
  startDate
  recurrenceInterval {
    years
    months
    days
    hours
    minutes
    seconds
  }
  nextDate
  status
  createdAt
  updatedAt
}
    `;
export const ReportedDonationFragmentDoc = gql`
    fragment ReportedDonation on ReportedDonation {
  id
  personId
  amount
  amountNormalized
  currencyCode
  donationDate
  organization: externalOrganizationByOrganizationId {
    id
    name
    organizationSlug
  }
}
    `;
export const CurrencyFieldsFragmentDoc = gql`
    fragment currencyFields on Currency {
  name
  code
  decimals
  symbol
}
    `;
export const ExchangeRateFieldsFragmentDoc = gql`
    fragment exchangeRateFields on ExchangeRate {
  currencyCode
  date
  rate
}
    `;
export const GwwcSurveyFragmentDoc = gql`
    fragment GWWCSurvey on GivingWhatWeCanSurvey {
  personId
  counterfactualDonationPercentage
  wherePlanningToGive
  referrer
  referrerNotes
  gwwcDonationInfluence
  otherComments
  createdAt
  updatedAt
}
    `;
export const CreateExternalOrganizationDocument = gql`
    mutation createExternalOrganization($name: String!, $organizationSlug: String, $url: String, $keywords: [String]) {
  createExternalOrganization(
    input: {name: $name, organizationSlug: $organizationSlug, url: $url, keywords: $keywords}
  ) {
    externalOrganization {
      id
      name
      keywords
      organizationSlug
      url
    }
  }
}
    `;
export type CreateExternalOrganizationMutationFn = Apollo.MutationFunction<CreateExternalOrganizationMutation, CreateExternalOrganizationMutationVariables>;

/**
 * __useCreateExternalOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateExternalOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalOrganizationMutation, { data, loading, error }] = useCreateExternalOrganizationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      organizationSlug: // value for 'organizationSlug'
 *      url: // value for 'url'
 *      keywords: // value for 'keywords'
 *   },
 * });
 */
export function useCreateExternalOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateExternalOrganizationMutation, CreateExternalOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExternalOrganizationMutation, CreateExternalOrganizationMutationVariables>(CreateExternalOrganizationDocument, options);
      }
export type CreateExternalOrganizationMutationHookResult = ReturnType<typeof useCreateExternalOrganizationMutation>;
export type CreateExternalOrganizationMutationResult = Apollo.MutationResult<CreateExternalOrganizationMutation>;
export type CreateExternalOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateExternalOrganizationMutation, CreateExternalOrganizationMutationVariables>;
export const GetExternalOrganizationTypeaheadDocument = gql`
    query getExternalOrganizationTypeahead($searchText: String!) {
  ExternalOrganizations: externalOrganizationTypeahead(
    searchText: $searchText
    first: 10
  ) {
    edges {
      node {
        id
        name
        organizationSlug
        url
      }
    }
  }
}
    `;

/**
 * __useGetExternalOrganizationTypeaheadQuery__
 *
 * To run a query within a React component, call `useGetExternalOrganizationTypeaheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalOrganizationTypeaheadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalOrganizationTypeaheadQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetExternalOrganizationTypeaheadQuery(baseOptions: Apollo.QueryHookOptions<GetExternalOrganizationTypeaheadQuery, GetExternalOrganizationTypeaheadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalOrganizationTypeaheadQuery, GetExternalOrganizationTypeaheadQueryVariables>(GetExternalOrganizationTypeaheadDocument, options);
      }
export function useGetExternalOrganizationTypeaheadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalOrganizationTypeaheadQuery, GetExternalOrganizationTypeaheadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalOrganizationTypeaheadQuery, GetExternalOrganizationTypeaheadQueryVariables>(GetExternalOrganizationTypeaheadDocument, options);
        }
export type GetExternalOrganizationTypeaheadQueryHookResult = ReturnType<typeof useGetExternalOrganizationTypeaheadQuery>;
export type GetExternalOrganizationTypeaheadLazyQueryHookResult = ReturnType<typeof useGetExternalOrganizationTypeaheadLazyQuery>;
export type GetExternalOrganizationTypeaheadQueryResult = Apollo.QueryResult<GetExternalOrganizationTypeaheadQuery, GetExternalOrganizationTypeaheadQueryVariables>;
export const GetExternalOrganizationsDocument = gql`
    query getExternalOrganizations {
  ExternalOrganizations: allExternalOrganizations(orderBy: [NAME_ASC]) {
    edges {
      node {
        id
        name
        organizationSlug
        url
      }
    }
  }
}
    `;

/**
 * __useGetExternalOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetExternalOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExternalOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalOrganizationsQuery, GetExternalOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalOrganizationsQuery, GetExternalOrganizationsQueryVariables>(GetExternalOrganizationsDocument, options);
      }
export function useGetExternalOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalOrganizationsQuery, GetExternalOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalOrganizationsQuery, GetExternalOrganizationsQueryVariables>(GetExternalOrganizationsDocument, options);
        }
export type GetExternalOrganizationsQueryHookResult = ReturnType<typeof useGetExternalOrganizationsQuery>;
export type GetExternalOrganizationsLazyQueryHookResult = ReturnType<typeof useGetExternalOrganizationsLazyQuery>;
export type GetExternalOrganizationsQueryResult = Apollo.QueryResult<GetExternalOrganizationsQuery, GetExternalOrganizationsQueryVariables>;
export const GetOrganizationsDocument = gql`
    query getOrganizations {
  Organizations: allOrganizations(
    orderBy: [SORT_ORDER_ASC, NAME_ASC, PROGRAM_ASC]
  ) {
    edges {
      node {
        slug
        name
        program
        type
        active
        hidden
        sortOrder
        href
        isDataSharingPartner
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const CancelRecurringPaymentDocument = gql`
    mutation cancelRecurringPayment($recurringPaymentId: BigInt!) {
  cancelRecurringPayment(input: {recurringPaymentId: $recurringPaymentId}) {
    clientMutationId
  }
}
    `;
export type CancelRecurringPaymentMutationFn = Apollo.MutationFunction<CancelRecurringPaymentMutation, CancelRecurringPaymentMutationVariables>;

/**
 * __useCancelRecurringPaymentMutation__
 *
 * To run a mutation, you first call `useCancelRecurringPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRecurringPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRecurringPaymentMutation, { data, loading, error }] = useCancelRecurringPaymentMutation({
 *   variables: {
 *      recurringPaymentId: // value for 'recurringPaymentId'
 *   },
 * });
 */
export function useCancelRecurringPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CancelRecurringPaymentMutation, CancelRecurringPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelRecurringPaymentMutation, CancelRecurringPaymentMutationVariables>(CancelRecurringPaymentDocument, options);
      }
export type CancelRecurringPaymentMutationHookResult = ReturnType<typeof useCancelRecurringPaymentMutation>;
export type CancelRecurringPaymentMutationResult = Apollo.MutationResult<CancelRecurringPaymentMutation>;
export type CancelRecurringPaymentMutationOptions = Apollo.BaseMutationOptions<CancelRecurringPaymentMutation, CancelRecurringPaymentMutationVariables>;
export const CreateGiftAidClaimDocument = gql`
    mutation createGiftAidClaim($paymentId: BigInt!, $addressId: BigInt!) {
  createGiftAidClaimFromPayment(
    input: {paymentId: $paymentId, addressId: $addressId}
  ) {
    giftAidClaim {
      paymentId
      personId
      addressId
      reportId
    }
  }
}
    `;
export type CreateGiftAidClaimMutationFn = Apollo.MutationFunction<CreateGiftAidClaimMutation, CreateGiftAidClaimMutationVariables>;

/**
 * __useCreateGiftAidClaimMutation__
 *
 * To run a mutation, you first call `useCreateGiftAidClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGiftAidClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGiftAidClaimMutation, { data, loading, error }] = useCreateGiftAidClaimMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useCreateGiftAidClaimMutation(baseOptions?: Apollo.MutationHookOptions<CreateGiftAidClaimMutation, CreateGiftAidClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGiftAidClaimMutation, CreateGiftAidClaimMutationVariables>(CreateGiftAidClaimDocument, options);
      }
export type CreateGiftAidClaimMutationHookResult = ReturnType<typeof useCreateGiftAidClaimMutation>;
export type CreateGiftAidClaimMutationResult = Apollo.MutationResult<CreateGiftAidClaimMutation>;
export type CreateGiftAidClaimMutationOptions = Apollo.BaseMutationOptions<CreateGiftAidClaimMutation, CreateGiftAidClaimMutationVariables>;
export const CreateGocardlessRedirectFlowDocument = gql`
    mutation createGocardlessRedirectFlow($personId: BigInt, $sessionToken: UUID) {
  mutationResult: createGocardlessRedirectFlowByPersonOrTemporaryPerson(
    input: {personId: $personId, sessionToken: $sessionToken}
  ) {
    RedirectFlow: gocardlessRedirectFlow {
      personId
      sessionToken
      gocardlessRedirectFlowId
      gocardlessRedirectFlowUrl
      expires
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateGocardlessRedirectFlowMutationFn = Apollo.MutationFunction<CreateGocardlessRedirectFlowMutation, CreateGocardlessRedirectFlowMutationVariables>;

/**
 * __useCreateGocardlessRedirectFlowMutation__
 *
 * To run a mutation, you first call `useCreateGocardlessRedirectFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGocardlessRedirectFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGocardlessRedirectFlowMutation, { data, loading, error }] = useCreateGocardlessRedirectFlowMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useCreateGocardlessRedirectFlowMutation(baseOptions?: Apollo.MutationHookOptions<CreateGocardlessRedirectFlowMutation, CreateGocardlessRedirectFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGocardlessRedirectFlowMutation, CreateGocardlessRedirectFlowMutationVariables>(CreateGocardlessRedirectFlowDocument, options);
      }
export type CreateGocardlessRedirectFlowMutationHookResult = ReturnType<typeof useCreateGocardlessRedirectFlowMutation>;
export type CreateGocardlessRedirectFlowMutationResult = Apollo.MutationResult<CreateGocardlessRedirectFlowMutation>;
export type CreateGocardlessRedirectFlowMutationOptions = Apollo.BaseMutationOptions<CreateGocardlessRedirectFlowMutation, CreateGocardlessRedirectFlowMutationVariables>;
export const CreatePaymentDocument = gql`
    mutation createPayment($personId: BigInt!, $currencyCode: String!, $amount: BigFloat!, $recipient: String!, $allocation: JSON!, $gateway: PaymentGateway!, $gatewayData: JSON, $paymentMethod: PaymentMethod!, $billingAddressId: BigInt, $metadata: JSON, $status: PaymentStatus, $createdAt: Datetime) {
  mutationResult: createPaymentByPersonId(
    input: {personId: $personId, currencyCode: $currencyCode, amount: $amount, recipient: $recipient, allocation: $allocation, gateway: $gateway, gatewayData: $gatewayData, paymentMethod: $paymentMethod, billingAddressId: $billingAddressId, metadata: $metadata, status: $status, createdAt: $createdAt}
  ) {
    payment {
      ...PaymentFields
    }
  }
}
    ${PaymentFieldsFragmentDoc}`;
export type CreatePaymentMutationFn = Apollo.MutationFunction<CreatePaymentMutation, CreatePaymentMutationVariables>;

/**
 * __useCreatePaymentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMutation, { data, loading, error }] = useCreatePaymentMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      currencyCode: // value for 'currencyCode'
 *      amount: // value for 'amount'
 *      recipient: // value for 'recipient'
 *      allocation: // value for 'allocation'
 *      gateway: // value for 'gateway'
 *      gatewayData: // value for 'gatewayData'
 *      paymentMethod: // value for 'paymentMethod'
 *      billingAddressId: // value for 'billingAddressId'
 *      metadata: // value for 'metadata'
 *      status: // value for 'status'
 *      createdAt: // value for 'createdAt'
 *   },
 * });
 */
export function useCreatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentMutation, CreatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument, options);
      }
export type CreatePaymentMutationHookResult = ReturnType<typeof useCreatePaymentMutation>;
export type CreatePaymentMutationResult = Apollo.MutationResult<CreatePaymentMutation>;
export type CreatePaymentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMutation, CreatePaymentMutationVariables>;
export const CreatePaymentByTemporaryPersonDocument = gql`
    mutation createPaymentByTemporaryPerson($sessionToken: UUID!, $currencyCode: String!, $amount: BigFloat!, $recipient: String!, $allocation: JSON!, $gateway: PaymentGateway!, $gatewayData: JSON, $paymentMethod: PaymentMethod!, $billingAddressId: BigInt, $metadata: JSON) {
  mutationResult: createPaymentByTemporaryPerson(
    input: {sessionToken: $sessionToken, currencyCode: $currencyCode, amount: $amount, recipient: $recipient, allocation: $allocation, gateway: $gateway, gatewayData: $gatewayData, paymentMethod: $paymentMethod, billingAddressId: $billingAddressId, metadata: $metadata}
  ) {
    payment {
      ...PaymentFields
    }
  }
}
    ${PaymentFieldsFragmentDoc}`;
export type CreatePaymentByTemporaryPersonMutationFn = Apollo.MutationFunction<CreatePaymentByTemporaryPersonMutation, CreatePaymentByTemporaryPersonMutationVariables>;

/**
 * __useCreatePaymentByTemporaryPersonMutation__
 *
 * To run a mutation, you first call `useCreatePaymentByTemporaryPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentByTemporaryPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentByTemporaryPersonMutation, { data, loading, error }] = useCreatePaymentByTemporaryPersonMutation({
 *   variables: {
 *      sessionToken: // value for 'sessionToken'
 *      currencyCode: // value for 'currencyCode'
 *      amount: // value for 'amount'
 *      recipient: // value for 'recipient'
 *      allocation: // value for 'allocation'
 *      gateway: // value for 'gateway'
 *      gatewayData: // value for 'gatewayData'
 *      paymentMethod: // value for 'paymentMethod'
 *      billingAddressId: // value for 'billingAddressId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreatePaymentByTemporaryPersonMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentByTemporaryPersonMutation, CreatePaymentByTemporaryPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentByTemporaryPersonMutation, CreatePaymentByTemporaryPersonMutationVariables>(CreatePaymentByTemporaryPersonDocument, options);
      }
export type CreatePaymentByTemporaryPersonMutationHookResult = ReturnType<typeof useCreatePaymentByTemporaryPersonMutation>;
export type CreatePaymentByTemporaryPersonMutationResult = Apollo.MutationResult<CreatePaymentByTemporaryPersonMutation>;
export type CreatePaymentByTemporaryPersonMutationOptions = Apollo.BaseMutationOptions<CreatePaymentByTemporaryPersonMutation, CreatePaymentByTemporaryPersonMutationVariables>;
export const CreateRecurringPaymentDocument = gql`
    mutation createRecurringPayment($personId: BigInt!, $period: RecurrencePeriod!, $periodIndex: Int!, $allocation: JSON!, $amount: BigFloat!, $currencyCode: String!, $recipient: String!, $gateway: PaymentGateway!, $gatewayData: JSON, $paymentMethod: PaymentMethod!, $billingAddressId: BigInt, $metadata: JSON) {
  mutationResult: createRecurringPayment(
    input: {personId: $personId, period: $period, periodIndex: $periodIndex, allocation: $allocation, amount: $amount, currencyCode: $currencyCode, recipient: $recipient, gateway: $gateway, gatewayData: $gatewayData, paymentMethod: $paymentMethod, billingAddressId: $billingAddressId, metadata: $metadata}
  ) {
    recurringPayment {
      ...RecurringPaymentFields
    }
  }
}
    ${RecurringPaymentFieldsFragmentDoc}`;
export type CreateRecurringPaymentMutationFn = Apollo.MutationFunction<CreateRecurringPaymentMutation, CreateRecurringPaymentMutationVariables>;

/**
 * __useCreateRecurringPaymentMutation__
 *
 * To run a mutation, you first call `useCreateRecurringPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringPaymentMutation, { data, loading, error }] = useCreateRecurringPaymentMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      period: // value for 'period'
 *      periodIndex: // value for 'periodIndex'
 *      allocation: // value for 'allocation'
 *      amount: // value for 'amount'
 *      currencyCode: // value for 'currencyCode'
 *      recipient: // value for 'recipient'
 *      gateway: // value for 'gateway'
 *      gatewayData: // value for 'gatewayData'
 *      paymentMethod: // value for 'paymentMethod'
 *      billingAddressId: // value for 'billingAddressId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateRecurringPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecurringPaymentMutation, CreateRecurringPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecurringPaymentMutation, CreateRecurringPaymentMutationVariables>(CreateRecurringPaymentDocument, options);
      }
export type CreateRecurringPaymentMutationHookResult = ReturnType<typeof useCreateRecurringPaymentMutation>;
export type CreateRecurringPaymentMutationResult = Apollo.MutationResult<CreateRecurringPaymentMutation>;
export type CreateRecurringPaymentMutationOptions = Apollo.BaseMutationOptions<CreateRecurringPaymentMutation, CreateRecurringPaymentMutationVariables>;
export const CreateRecurringPaymentByTemporaryPersonDocument = gql`
    mutation createRecurringPaymentByTemporaryPerson($sessionToken: UUID!, $period: RecurrencePeriod!, $periodIndex: Int!, $allocation: JSON!, $amount: BigFloat!, $currencyCode: String!, $recipient: String!, $gateway: PaymentGateway!, $gatewayData: JSON, $paymentMethod: PaymentMethod!, $billingAddressId: BigInt, $metadata: JSON) {
  mutationResult: createRecurringPaymentByTemporaryPerson(
    input: {sessionToken: $sessionToken, period: $period, periodIndex: $periodIndex, allocation: $allocation, amount: $amount, currencyCode: $currencyCode, recipient: $recipient, gateway: $gateway, gatewayData: $gatewayData, paymentMethod: $paymentMethod, billingAddressId: $billingAddressId, metadata: $metadata}
  ) {
    recurringPayment {
      ...RecurringPaymentFields
    }
  }
}
    ${RecurringPaymentFieldsFragmentDoc}`;
export type CreateRecurringPaymentByTemporaryPersonMutationFn = Apollo.MutationFunction<CreateRecurringPaymentByTemporaryPersonMutation, CreateRecurringPaymentByTemporaryPersonMutationVariables>;

/**
 * __useCreateRecurringPaymentByTemporaryPersonMutation__
 *
 * To run a mutation, you first call `useCreateRecurringPaymentByTemporaryPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringPaymentByTemporaryPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringPaymentByTemporaryPersonMutation, { data, loading, error }] = useCreateRecurringPaymentByTemporaryPersonMutation({
 *   variables: {
 *      sessionToken: // value for 'sessionToken'
 *      period: // value for 'period'
 *      periodIndex: // value for 'periodIndex'
 *      allocation: // value for 'allocation'
 *      amount: // value for 'amount'
 *      currencyCode: // value for 'currencyCode'
 *      recipient: // value for 'recipient'
 *      gateway: // value for 'gateway'
 *      gatewayData: // value for 'gatewayData'
 *      paymentMethod: // value for 'paymentMethod'
 *      billingAddressId: // value for 'billingAddressId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateRecurringPaymentByTemporaryPersonMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecurringPaymentByTemporaryPersonMutation, CreateRecurringPaymentByTemporaryPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecurringPaymentByTemporaryPersonMutation, CreateRecurringPaymentByTemporaryPersonMutationVariables>(CreateRecurringPaymentByTemporaryPersonDocument, options);
      }
export type CreateRecurringPaymentByTemporaryPersonMutationHookResult = ReturnType<typeof useCreateRecurringPaymentByTemporaryPersonMutation>;
export type CreateRecurringPaymentByTemporaryPersonMutationResult = Apollo.MutationResult<CreateRecurringPaymentByTemporaryPersonMutation>;
export type CreateRecurringPaymentByTemporaryPersonMutationOptions = Apollo.BaseMutationOptions<CreateRecurringPaymentByTemporaryPersonMutation, CreateRecurringPaymentByTemporaryPersonMutationVariables>;
export const DeleteGiftAidClaimDocument = gql`
    mutation deleteGiftAidClaim($paymentId: BigInt!) {
  GiftAidClaim: deleteGiftAidClaimFromPayment(input: {paymentId: $paymentId}) {
    giftAidClaim {
      paymentId
      personId
      addressId
      reportId
    }
  }
}
    `;
export type DeleteGiftAidClaimMutationFn = Apollo.MutationFunction<DeleteGiftAidClaimMutation, DeleteGiftAidClaimMutationVariables>;

/**
 * __useDeleteGiftAidClaimMutation__
 *
 * To run a mutation, you first call `useDeleteGiftAidClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGiftAidClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGiftAidClaimMutation, { data, loading, error }] = useDeleteGiftAidClaimMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useDeleteGiftAidClaimMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGiftAidClaimMutation, DeleteGiftAidClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGiftAidClaimMutation, DeleteGiftAidClaimMutationVariables>(DeleteGiftAidClaimDocument, options);
      }
export type DeleteGiftAidClaimMutationHookResult = ReturnType<typeof useDeleteGiftAidClaimMutation>;
export type DeleteGiftAidClaimMutationResult = Apollo.MutationResult<DeleteGiftAidClaimMutation>;
export type DeleteGiftAidClaimMutationOptions = Apollo.BaseMutationOptions<DeleteGiftAidClaimMutation, DeleteGiftAidClaimMutationVariables>;
export const UpdateRecurringPaymentAmountDocument = gql`
    mutation updateRecurringPaymentAmount($recurringPaymentId: BigInt!, $amount: BigFloat!) {
  updateRecurringPaymentAmount(
    input: {recurringPaymentId: $recurringPaymentId, amount: $amount}
  ) {
    clientMutationId
  }
}
    `;
export type UpdateRecurringPaymentAmountMutationFn = Apollo.MutationFunction<UpdateRecurringPaymentAmountMutation, UpdateRecurringPaymentAmountMutationVariables>;

/**
 * __useUpdateRecurringPaymentAmountMutation__
 *
 * To run a mutation, you first call `useUpdateRecurringPaymentAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurringPaymentAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurringPaymentAmountMutation, { data, loading, error }] = useUpdateRecurringPaymentAmountMutation({
 *   variables: {
 *      recurringPaymentId: // value for 'recurringPaymentId'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useUpdateRecurringPaymentAmountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecurringPaymentAmountMutation, UpdateRecurringPaymentAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecurringPaymentAmountMutation, UpdateRecurringPaymentAmountMutationVariables>(UpdateRecurringPaymentAmountDocument, options);
      }
export type UpdateRecurringPaymentAmountMutationHookResult = ReturnType<typeof useUpdateRecurringPaymentAmountMutation>;
export type UpdateRecurringPaymentAmountMutationResult = Apollo.MutationResult<UpdateRecurringPaymentAmountMutation>;
export type UpdateRecurringPaymentAmountMutationOptions = Apollo.BaseMutationOptions<UpdateRecurringPaymentAmountMutation, UpdateRecurringPaymentAmountMutationVariables>;
export const UpdateCryptoPaymentGatewayTransactionIdDocument = gql`
    mutation updateCryptoPaymentGatewayTransactionId($paymentAccessToken: UUID!, $gatewayTransactionId: String!) {
  updateCryptoPaymentGatewayTransactionId(
    input: {paymentAccessToken: $paymentAccessToken, gatewayTransactionId: $gatewayTransactionId}
  ) {
    payment {
      ...PaymentFields
    }
  }
}
    ${PaymentFieldsFragmentDoc}`;
export type UpdateCryptoPaymentGatewayTransactionIdMutationFn = Apollo.MutationFunction<UpdateCryptoPaymentGatewayTransactionIdMutation, UpdateCryptoPaymentGatewayTransactionIdMutationVariables>;

/**
 * __useUpdateCryptoPaymentGatewayTransactionIdMutation__
 *
 * To run a mutation, you first call `useUpdateCryptoPaymentGatewayTransactionIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCryptoPaymentGatewayTransactionIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCryptoPaymentGatewayTransactionIdMutation, { data, loading, error }] = useUpdateCryptoPaymentGatewayTransactionIdMutation({
 *   variables: {
 *      paymentAccessToken: // value for 'paymentAccessToken'
 *      gatewayTransactionId: // value for 'gatewayTransactionId'
 *   },
 * });
 */
export function useUpdateCryptoPaymentGatewayTransactionIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCryptoPaymentGatewayTransactionIdMutation, UpdateCryptoPaymentGatewayTransactionIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCryptoPaymentGatewayTransactionIdMutation, UpdateCryptoPaymentGatewayTransactionIdMutationVariables>(UpdateCryptoPaymentGatewayTransactionIdDocument, options);
      }
export type UpdateCryptoPaymentGatewayTransactionIdMutationHookResult = ReturnType<typeof useUpdateCryptoPaymentGatewayTransactionIdMutation>;
export type UpdateCryptoPaymentGatewayTransactionIdMutationResult = Apollo.MutationResult<UpdateCryptoPaymentGatewayTransactionIdMutation>;
export type UpdateCryptoPaymentGatewayTransactionIdMutationOptions = Apollo.BaseMutationOptions<UpdateCryptoPaymentGatewayTransactionIdMutation, UpdateCryptoPaymentGatewayTransactionIdMutationVariables>;
export const UpdatePaymentStatusDocument = gql`
    mutation updatePaymentStatus($paymentId: BigInt!, $status: PaymentStatus!) {
  updatePaymentStatus(input: {paymentId: $paymentId, status: $status}) {
    payment {
      id
      status
    }
  }
}
    `;
export type UpdatePaymentStatusMutationFn = Apollo.MutationFunction<UpdatePaymentStatusMutation, UpdatePaymentStatusMutationVariables>;

/**
 * __useUpdatePaymentStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentStatusMutation, { data, loading, error }] = useUpdatePaymentStatusMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdatePaymentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentStatusMutation, UpdatePaymentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentStatusMutation, UpdatePaymentStatusMutationVariables>(UpdatePaymentStatusDocument, options);
      }
export type UpdatePaymentStatusMutationHookResult = ReturnType<typeof useUpdatePaymentStatusMutation>;
export type UpdatePaymentStatusMutationResult = Apollo.MutationResult<UpdatePaymentStatusMutation>;
export type UpdatePaymentStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentStatusMutation, UpdatePaymentStatusMutationVariables>;
export const VoidPaymentDocument = gql`
    mutation voidPayment($paymentId: BigInt!) {
  voidPayment(input: {paymentId: $paymentId}) {
    payment {
      id
      status
    }
  }
}
    `;
export type VoidPaymentMutationFn = Apollo.MutationFunction<VoidPaymentMutation, VoidPaymentMutationVariables>;

/**
 * __useVoidPaymentMutation__
 *
 * To run a mutation, you first call `useVoidPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidPaymentMutation, { data, loading, error }] = useVoidPaymentMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useVoidPaymentMutation(baseOptions?: Apollo.MutationHookOptions<VoidPaymentMutation, VoidPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidPaymentMutation, VoidPaymentMutationVariables>(VoidPaymentDocument, options);
      }
export type VoidPaymentMutationHookResult = ReturnType<typeof useVoidPaymentMutation>;
export type VoidPaymentMutationResult = Apollo.MutationResult<VoidPaymentMutation>;
export type VoidPaymentMutationOptions = Apollo.BaseMutationOptions<VoidPaymentMutation, VoidPaymentMutationVariables>;
export const AllPaymentsManagersDocument = gql`
    query allPaymentsManagers {
  PaymentsManagers: allPaymentsManagers {
    edges {
      node {
        personId
      }
    }
  }
}
    `;

/**
 * __useAllPaymentsManagersQuery__
 *
 * To run a query within a React component, call `useAllPaymentsManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPaymentsManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPaymentsManagersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPaymentsManagersQuery(baseOptions?: Apollo.QueryHookOptions<AllPaymentsManagersQuery, AllPaymentsManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPaymentsManagersQuery, AllPaymentsManagersQueryVariables>(AllPaymentsManagersDocument, options);
      }
export function useAllPaymentsManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPaymentsManagersQuery, AllPaymentsManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPaymentsManagersQuery, AllPaymentsManagersQueryVariables>(AllPaymentsManagersDocument, options);
        }
export type AllPaymentsManagersQueryHookResult = ReturnType<typeof useAllPaymentsManagersQuery>;
export type AllPaymentsManagersLazyQueryHookResult = ReturnType<typeof useAllPaymentsManagersLazyQuery>;
export type AllPaymentsManagersQueryResult = Apollo.QueryResult<AllPaymentsManagersQuery, AllPaymentsManagersQueryVariables>;
export const GetAllRecipientProgramsDocument = gql`
    query getAllRecipientPrograms {
  RecipientPrograms: allRecipientProgramsList {
    organizationSlug
    recipientSlug
  }
}
    `;

/**
 * __useGetAllRecipientProgramsQuery__
 *
 * To run a query within a React component, call `useGetAllRecipientProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRecipientProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRecipientProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRecipientProgramsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRecipientProgramsQuery, GetAllRecipientProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRecipientProgramsQuery, GetAllRecipientProgramsQueryVariables>(GetAllRecipientProgramsDocument, options);
      }
export function useGetAllRecipientProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRecipientProgramsQuery, GetAllRecipientProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRecipientProgramsQuery, GetAllRecipientProgramsQueryVariables>(GetAllRecipientProgramsDocument, options);
        }
export type GetAllRecipientProgramsQueryHookResult = ReturnType<typeof useGetAllRecipientProgramsQuery>;
export type GetAllRecipientProgramsLazyQueryHookResult = ReturnType<typeof useGetAllRecipientProgramsLazyQuery>;
export type GetAllRecipientProgramsQueryResult = Apollo.QueryResult<GetAllRecipientProgramsQuery, GetAllRecipientProgramsQueryVariables>;
export const GetAllocationDocument = gql`
    query getAllocation {
  allocation: allAllocations {
    edges {
      node {
        personId
        allocation
      }
    }
  }
}
    `;

/**
 * __useGetAllocationQuery__
 *
 * To run a query within a React component, call `useGetAllocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllocationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllocationQuery(baseOptions?: Apollo.QueryHookOptions<GetAllocationQuery, GetAllocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllocationQuery, GetAllocationQueryVariables>(GetAllocationDocument, options);
      }
export function useGetAllocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllocationQuery, GetAllocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllocationQuery, GetAllocationQueryVariables>(GetAllocationDocument, options);
        }
export type GetAllocationQueryHookResult = ReturnType<typeof useGetAllocationQuery>;
export type GetAllocationLazyQueryHookResult = ReturnType<typeof useGetAllocationLazyQuery>;
export type GetAllocationQueryResult = Apollo.QueryResult<GetAllocationQuery, GetAllocationQueryVariables>;
export const GetAllocationByPersonIdDocument = gql`
    query getAllocationByPersonId($personId: BigInt!) {
  Allocation: allocationByPersonId(personId: $personId) {
    personId
    allocation
  }
}
    `;

/**
 * __useGetAllocationByPersonIdQuery__
 *
 * To run a query within a React component, call `useGetAllocationByPersonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllocationByPersonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllocationByPersonIdQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetAllocationByPersonIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllocationByPersonIdQuery, GetAllocationByPersonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllocationByPersonIdQuery, GetAllocationByPersonIdQueryVariables>(GetAllocationByPersonIdDocument, options);
      }
export function useGetAllocationByPersonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllocationByPersonIdQuery, GetAllocationByPersonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllocationByPersonIdQuery, GetAllocationByPersonIdQueryVariables>(GetAllocationByPersonIdDocument, options);
        }
export type GetAllocationByPersonIdQueryHookResult = ReturnType<typeof useGetAllocationByPersonIdQuery>;
export type GetAllocationByPersonIdLazyQueryHookResult = ReturnType<typeof useGetAllocationByPersonIdLazyQuery>;
export type GetAllocationByPersonIdQueryResult = Apollo.QueryResult<GetAllocationByPersonIdQuery, GetAllocationByPersonIdQueryVariables>;
export const GetFundraiserStatsDocument = gql`
    query getFundraiserStats($fundraiserId: String!) {
  FundraiserStats: getFundraiserStats(fundraiserId: $fundraiserId) {
    edges {
      node {
        fundraiserId
        amountRaisedNormalized
        numDonors
      }
    }
  }
}
    `;

/**
 * __useGetFundraiserStatsQuery__
 *
 * To run a query within a React component, call `useGetFundraiserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundraiserStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundraiserStatsQuery({
 *   variables: {
 *      fundraiserId: // value for 'fundraiserId'
 *   },
 * });
 */
export function useGetFundraiserStatsQuery(baseOptions: Apollo.QueryHookOptions<GetFundraiserStatsQuery, GetFundraiserStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundraiserStatsQuery, GetFundraiserStatsQueryVariables>(GetFundraiserStatsDocument, options);
      }
export function useGetFundraiserStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFundraiserStatsQuery, GetFundraiserStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundraiserStatsQuery, GetFundraiserStatsQueryVariables>(GetFundraiserStatsDocument, options);
        }
export type GetFundraiserStatsQueryHookResult = ReturnType<typeof useGetFundraiserStatsQuery>;
export type GetFundraiserStatsLazyQueryHookResult = ReturnType<typeof useGetFundraiserStatsLazyQuery>;
export type GetFundraiserStatsQueryResult = Apollo.QueryResult<GetFundraiserStatsQuery, GetFundraiserStatsQueryVariables>;
export const GetGivingSeasonStatsDocument = gql`
    query getGivingSeasonStats($start: Date!) {
  GivingSeasonStats: getGivingSeasonStats(givingSeasonStartDate: $start) {
    edges {
      node {
        slug
        amountNormalized
        numDonations
        numPeople
        numCountries
      }
    }
  }
}
    `;

/**
 * __useGetGivingSeasonStatsQuery__
 *
 * To run a query within a React component, call `useGetGivingSeasonStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGivingSeasonStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGivingSeasonStatsQuery({
 *   variables: {
 *      start: // value for 'start'
 *   },
 * });
 */
export function useGetGivingSeasonStatsQuery(baseOptions: Apollo.QueryHookOptions<GetGivingSeasonStatsQuery, GetGivingSeasonStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGivingSeasonStatsQuery, GetGivingSeasonStatsQueryVariables>(GetGivingSeasonStatsDocument, options);
      }
export function useGetGivingSeasonStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGivingSeasonStatsQuery, GetGivingSeasonStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGivingSeasonStatsQuery, GetGivingSeasonStatsQueryVariables>(GetGivingSeasonStatsDocument, options);
        }
export type GetGivingSeasonStatsQueryHookResult = ReturnType<typeof useGetGivingSeasonStatsQuery>;
export type GetGivingSeasonStatsLazyQueryHookResult = ReturnType<typeof useGetGivingSeasonStatsLazyQuery>;
export type GetGivingSeasonStatsQueryResult = Apollo.QueryResult<GetGivingSeasonStatsQuery, GetGivingSeasonStatsQueryVariables>;
export const GetGocardlessMandatesDocument = gql`
    query getGocardlessMandates($personId: BigInt, $sessionToken: UUID) {
  gocardlessMandates: getGocardlessMandatesByPersonOrTemporaryPerson(
    personId: $personId
    sessionToken: $sessionToken
  ) {
    edges {
      node {
        personId
        gocardlessCustomerId
        gocardlessMandateId
        status
        gocardlessBankAccountId
        gocardlessBankAccountHolderName
        gocardlessBankAccountBankName
        gocardlessBankAccountNumberEnding
      }
    }
  }
}
    `;

/**
 * __useGetGocardlessMandatesQuery__
 *
 * To run a query within a React component, call `useGetGocardlessMandatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGocardlessMandatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGocardlessMandatesQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useGetGocardlessMandatesQuery(baseOptions?: Apollo.QueryHookOptions<GetGocardlessMandatesQuery, GetGocardlessMandatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGocardlessMandatesQuery, GetGocardlessMandatesQueryVariables>(GetGocardlessMandatesDocument, options);
      }
export function useGetGocardlessMandatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGocardlessMandatesQuery, GetGocardlessMandatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGocardlessMandatesQuery, GetGocardlessMandatesQueryVariables>(GetGocardlessMandatesDocument, options);
        }
export type GetGocardlessMandatesQueryHookResult = ReturnType<typeof useGetGocardlessMandatesQuery>;
export type GetGocardlessMandatesLazyQueryHookResult = ReturnType<typeof useGetGocardlessMandatesLazyQuery>;
export type GetGocardlessMandatesQueryResult = Apollo.QueryResult<GetGocardlessMandatesQuery, GetGocardlessMandatesQueryVariables>;
export const GetGocardlessRedirectFlowDocument = gql`
    query getGocardlessRedirectFlow($personId: BigInt, $sessionToken: UUID) {
  GocardlessRedirectFlow: getGocardlessRedirectFlowByPersonOrTemporaryPerson(
    personId: $personId
    sessionToken: $sessionToken
  ) {
    personId
    sessionToken
    gocardlessRedirectFlowId
    gocardlessRedirectFlowUrl
    expires
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetGocardlessRedirectFlowQuery__
 *
 * To run a query within a React component, call `useGetGocardlessRedirectFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGocardlessRedirectFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGocardlessRedirectFlowQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useGetGocardlessRedirectFlowQuery(baseOptions?: Apollo.QueryHookOptions<GetGocardlessRedirectFlowQuery, GetGocardlessRedirectFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGocardlessRedirectFlowQuery, GetGocardlessRedirectFlowQueryVariables>(GetGocardlessRedirectFlowDocument, options);
      }
export function useGetGocardlessRedirectFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGocardlessRedirectFlowQuery, GetGocardlessRedirectFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGocardlessRedirectFlowQuery, GetGocardlessRedirectFlowQueryVariables>(GetGocardlessRedirectFlowDocument, options);
        }
export type GetGocardlessRedirectFlowQueryHookResult = ReturnType<typeof useGetGocardlessRedirectFlowQuery>;
export type GetGocardlessRedirectFlowLazyQueryHookResult = ReturnType<typeof useGetGocardlessRedirectFlowLazyQuery>;
export type GetGocardlessRedirectFlowQueryResult = Apollo.QueryResult<GetGocardlessRedirectFlowQuery, GetGocardlessRedirectFlowQueryVariables>;
export const GetLotteriesDocument = gql`
    query getLotteries {
  Lotteries: allExtendedLotteries(orderBy: [DRAW_TIMESTAMP_DESC, BLOCK_SIZE_ASC]) {
    edges {
      node {
        ...LotteryFields
      }
    }
  }
}
    ${LotteryFieldsFragmentDoc}`;

/**
 * __useGetLotteriesQuery__
 *
 * To run a query within a React component, call `useGetLotteriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLotteriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLotteriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLotteriesQuery(baseOptions?: Apollo.QueryHookOptions<GetLotteriesQuery, GetLotteriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLotteriesQuery, GetLotteriesQueryVariables>(GetLotteriesDocument, options);
      }
export function useGetLotteriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLotteriesQuery, GetLotteriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLotteriesQuery, GetLotteriesQueryVariables>(GetLotteriesDocument, options);
        }
export type GetLotteriesQueryHookResult = ReturnType<typeof useGetLotteriesQuery>;
export type GetLotteriesLazyQueryHookResult = ReturnType<typeof useGetLotteriesLazyQuery>;
export type GetLotteriesQueryResult = Apollo.QueryResult<GetLotteriesQuery, GetLotteriesQueryVariables>;
export const GetLotteryByIdDocument = gql`
    query getLotteryById($lotteryId: BigInt!) {
  Lottery: extendedLotteryById(id: $lotteryId) {
    ...LotteryFields
  }
}
    ${LotteryFieldsFragmentDoc}`;

/**
 * __useGetLotteryByIdQuery__
 *
 * To run a query within a React component, call `useGetLotteryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLotteryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLotteryByIdQuery({
 *   variables: {
 *      lotteryId: // value for 'lotteryId'
 *   },
 * });
 */
export function useGetLotteryByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLotteryByIdQuery, GetLotteryByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLotteryByIdQuery, GetLotteryByIdQueryVariables>(GetLotteryByIdDocument, options);
      }
export function useGetLotteryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLotteryByIdQuery, GetLotteryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLotteryByIdQuery, GetLotteryByIdQueryVariables>(GetLotteryByIdDocument, options);
        }
export type GetLotteryByIdQueryHookResult = ReturnType<typeof useGetLotteryByIdQuery>;
export type GetLotteryByIdLazyQueryHookResult = ReturnType<typeof useGetLotteryByIdLazyQuery>;
export type GetLotteryByIdQueryResult = Apollo.QueryResult<GetLotteryByIdQuery, GetLotteryByIdQueryVariables>;
export const GetLotteryEntriesCompleteDocument = gql`
    query getLotteryEntriesComplete($lotteryId: BigInt!) {
  LotteryEntriesComplete: getLotteryEntriesCompleteByLotteryId(
    lotteryId: $lotteryId
  ) {
    edges {
      node {
        lotteryId
        paymentReference
        amountNormalized
        displayName
        tickets
        createdAt
        benefactor
      }
    }
  }
}
    `;

/**
 * __useGetLotteryEntriesCompleteQuery__
 *
 * To run a query within a React component, call `useGetLotteryEntriesCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLotteryEntriesCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLotteryEntriesCompleteQuery({
 *   variables: {
 *      lotteryId: // value for 'lotteryId'
 *   },
 * });
 */
export function useGetLotteryEntriesCompleteQuery(baseOptions: Apollo.QueryHookOptions<GetLotteryEntriesCompleteQuery, GetLotteryEntriesCompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLotteryEntriesCompleteQuery, GetLotteryEntriesCompleteQueryVariables>(GetLotteryEntriesCompleteDocument, options);
      }
export function useGetLotteryEntriesCompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLotteryEntriesCompleteQuery, GetLotteryEntriesCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLotteryEntriesCompleteQuery, GetLotteryEntriesCompleteQueryVariables>(GetLotteryEntriesCompleteDocument, options);
        }
export type GetLotteryEntriesCompleteQueryHookResult = ReturnType<typeof useGetLotteryEntriesCompleteQuery>;
export type GetLotteryEntriesCompleteLazyQueryHookResult = ReturnType<typeof useGetLotteryEntriesCompleteLazyQuery>;
export type GetLotteryEntriesCompleteQueryResult = Apollo.QueryResult<GetLotteryEntriesCompleteQuery, GetLotteryEntriesCompleteQueryVariables>;
export const GetLotteryEntriesPublicByLotteryIdDocument = gql`
    query getLotteryEntriesPublicByLotteryId($lotteryId: BigInt!) {
  LotteryEntriesPublic: getLotteryEntriesByLotteryId(lotteryId: $lotteryId) {
    edges {
      node {
        lotteryId
        paymentReference
        amount
        currencyCode
        amountNormalized
        giftAid
        total
        displayName
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetLotteryEntriesPublicByLotteryIdQuery__
 *
 * To run a query within a React component, call `useGetLotteryEntriesPublicByLotteryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLotteryEntriesPublicByLotteryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLotteryEntriesPublicByLotteryIdQuery({
 *   variables: {
 *      lotteryId: // value for 'lotteryId'
 *   },
 * });
 */
export function useGetLotteryEntriesPublicByLotteryIdQuery(baseOptions: Apollo.QueryHookOptions<GetLotteryEntriesPublicByLotteryIdQuery, GetLotteryEntriesPublicByLotteryIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLotteryEntriesPublicByLotteryIdQuery, GetLotteryEntriesPublicByLotteryIdQueryVariables>(GetLotteryEntriesPublicByLotteryIdDocument, options);
      }
export function useGetLotteryEntriesPublicByLotteryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLotteryEntriesPublicByLotteryIdQuery, GetLotteryEntriesPublicByLotteryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLotteryEntriesPublicByLotteryIdQuery, GetLotteryEntriesPublicByLotteryIdQueryVariables>(GetLotteryEntriesPublicByLotteryIdDocument, options);
        }
export type GetLotteryEntriesPublicByLotteryIdQueryHookResult = ReturnType<typeof useGetLotteryEntriesPublicByLotteryIdQuery>;
export type GetLotteryEntriesPublicByLotteryIdLazyQueryHookResult = ReturnType<typeof useGetLotteryEntriesPublicByLotteryIdLazyQuery>;
export type GetLotteryEntriesPublicByLotteryIdQueryResult = Apollo.QueryResult<GetLotteryEntriesPublicByLotteryIdQuery, GetLotteryEntriesPublicByLotteryIdQueryVariables>;
export const GetLotterySummariesDocument = gql`
    query getLotterySummaries {
  Lotteries: allLotterySummaries(orderBy: [DRAW_TIMESTAMP_DESC, BLOCK_SIZE_ASC]) {
    edges {
      node {
        ...LotterySummaryFields
      }
    }
  }
}
    ${LotterySummaryFieldsFragmentDoc}`;

/**
 * __useGetLotterySummariesQuery__
 *
 * To run a query within a React component, call `useGetLotterySummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLotterySummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLotterySummariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLotterySummariesQuery(baseOptions?: Apollo.QueryHookOptions<GetLotterySummariesQuery, GetLotterySummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLotterySummariesQuery, GetLotterySummariesQueryVariables>(GetLotterySummariesDocument, options);
      }
export function useGetLotterySummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLotterySummariesQuery, GetLotterySummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLotterySummariesQuery, GetLotterySummariesQueryVariables>(GetLotterySummariesDocument, options);
        }
export type GetLotterySummariesQueryHookResult = ReturnType<typeof useGetLotterySummariesQuery>;
export type GetLotterySummariesLazyQueryHookResult = ReturnType<typeof useGetLotterySummariesLazyQuery>;
export type GetLotterySummariesQueryResult = Apollo.QueryResult<GetLotterySummariesQuery, GetLotterySummariesQueryVariables>;
export const GetLotterySummaryDocument = gql`
    query getLotterySummary($lotteryId: BigInt!) {
  LotterySummary: getLotterySummaryByLotteryId(lotteryId: $lotteryId) {
    ...LotterySummaryFields
  }
}
    ${LotterySummaryFieldsFragmentDoc}`;

/**
 * __useGetLotterySummaryQuery__
 *
 * To run a query within a React component, call `useGetLotterySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLotterySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLotterySummaryQuery({
 *   variables: {
 *      lotteryId: // value for 'lotteryId'
 *   },
 * });
 */
export function useGetLotterySummaryQuery(baseOptions: Apollo.QueryHookOptions<GetLotterySummaryQuery, GetLotterySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLotterySummaryQuery, GetLotterySummaryQueryVariables>(GetLotterySummaryDocument, options);
      }
export function useGetLotterySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLotterySummaryQuery, GetLotterySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLotterySummaryQuery, GetLotterySummaryQueryVariables>(GetLotterySummaryDocument, options);
        }
export type GetLotterySummaryQueryHookResult = ReturnType<typeof useGetLotterySummaryQuery>;
export type GetLotterySummaryLazyQueryHookResult = ReturnType<typeof useGetLotterySummaryLazyQuery>;
export type GetLotterySummaryQueryResult = Apollo.QueryResult<GetLotterySummaryQuery, GetLotterySummaryQueryVariables>;
export const GetLotteryTicketsPublicByLotteryIdDocument = gql`
    query getLotteryTicketsPublicByLotteryId($lotteryId: BigInt!) {
  LotteryTicketsPublic: allLotteryTicketPublics(
    condition: {lotteryId: $lotteryId}
    orderBy: [WIN_RANGE_ASC]
  ) {
    edges {
      node {
        lotteryId
        paymentReference
        blockId
        winRange {
          start {
            value
            inclusive
          }
          end {
            value
            inclusive
          }
        }
        benefactor
      }
    }
  }
}
    `;

/**
 * __useGetLotteryTicketsPublicByLotteryIdQuery__
 *
 * To run a query within a React component, call `useGetLotteryTicketsPublicByLotteryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLotteryTicketsPublicByLotteryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLotteryTicketsPublicByLotteryIdQuery({
 *   variables: {
 *      lotteryId: // value for 'lotteryId'
 *   },
 * });
 */
export function useGetLotteryTicketsPublicByLotteryIdQuery(baseOptions: Apollo.QueryHookOptions<GetLotteryTicketsPublicByLotteryIdQuery, GetLotteryTicketsPublicByLotteryIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLotteryTicketsPublicByLotteryIdQuery, GetLotteryTicketsPublicByLotteryIdQueryVariables>(GetLotteryTicketsPublicByLotteryIdDocument, options);
      }
export function useGetLotteryTicketsPublicByLotteryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLotteryTicketsPublicByLotteryIdQuery, GetLotteryTicketsPublicByLotteryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLotteryTicketsPublicByLotteryIdQuery, GetLotteryTicketsPublicByLotteryIdQueryVariables>(GetLotteryTicketsPublicByLotteryIdDocument, options);
        }
export type GetLotteryTicketsPublicByLotteryIdQueryHookResult = ReturnType<typeof useGetLotteryTicketsPublicByLotteryIdQuery>;
export type GetLotteryTicketsPublicByLotteryIdLazyQueryHookResult = ReturnType<typeof useGetLotteryTicketsPublicByLotteryIdLazyQuery>;
export type GetLotteryTicketsPublicByLotteryIdQueryResult = Apollo.QueryResult<GetLotteryTicketsPublicByLotteryIdQuery, GetLotteryTicketsPublicByLotteryIdQueryVariables>;
export const GetLotteryWinnersDocument = gql`
    query getLotteryWinners($lotteryId: BigInt!) {
  LotteryWinners: allLotteryWinners(condition: {lotteryId: $lotteryId}) {
    edges {
      node {
        lotteryId
        paymentReference
        blockId
        benefactor
      }
    }
  }
}
    `;

/**
 * __useGetLotteryWinnersQuery__
 *
 * To run a query within a React component, call `useGetLotteryWinnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLotteryWinnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLotteryWinnersQuery({
 *   variables: {
 *      lotteryId: // value for 'lotteryId'
 *   },
 * });
 */
export function useGetLotteryWinnersQuery(baseOptions: Apollo.QueryHookOptions<GetLotteryWinnersQuery, GetLotteryWinnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLotteryWinnersQuery, GetLotteryWinnersQueryVariables>(GetLotteryWinnersDocument, options);
      }
export function useGetLotteryWinnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLotteryWinnersQuery, GetLotteryWinnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLotteryWinnersQuery, GetLotteryWinnersQueryVariables>(GetLotteryWinnersDocument, options);
        }
export type GetLotteryWinnersQueryHookResult = ReturnType<typeof useGetLotteryWinnersQuery>;
export type GetLotteryWinnersLazyQueryHookResult = ReturnType<typeof useGetLotteryWinnersLazyQuery>;
export type GetLotteryWinnersQueryResult = Apollo.QueryResult<GetLotteryWinnersQuery, GetLotteryWinnersQueryVariables>;
export const GetPaymentDocument = gql`
    query getPayment($paymentId: BigInt!) {
  Payment: paymentById(id: $paymentId) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useGetPaymentQuery__
 *
 * To run a query within a React component, call `useGetPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useGetPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
      }
export function useGetPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
export type GetPaymentQueryHookResult = ReturnType<typeof useGetPaymentQuery>;
export type GetPaymentLazyQueryHookResult = ReturnType<typeof useGetPaymentLazyQuery>;
export type GetPaymentQueryResult = Apollo.QueryResult<GetPaymentQuery, GetPaymentQueryVariables>;
export const GetPaymentAccessTokenDocument = gql`
    query getPaymentAccessToken($paymentId: BigInt, $sessionToken: UUID) {
  PaymentAccessToken: getPaymentAccessTokenByPersonOrTemporaryPerson(
    paymentId: $paymentId
    sessionToken: $sessionToken
  ) {
    paymentId
    personId
    token
    tokenExpiresAt
  }
}
    `;

/**
 * __useGetPaymentAccessTokenQuery__
 *
 * To run a query within a React component, call `useGetPaymentAccessTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentAccessTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentAccessTokenQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useGetPaymentAccessTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentAccessTokenQuery, GetPaymentAccessTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentAccessTokenQuery, GetPaymentAccessTokenQueryVariables>(GetPaymentAccessTokenDocument, options);
      }
export function useGetPaymentAccessTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentAccessTokenQuery, GetPaymentAccessTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentAccessTokenQuery, GetPaymentAccessTokenQueryVariables>(GetPaymentAccessTokenDocument, options);
        }
export type GetPaymentAccessTokenQueryHookResult = ReturnType<typeof useGetPaymentAccessTokenQuery>;
export type GetPaymentAccessTokenLazyQueryHookResult = ReturnType<typeof useGetPaymentAccessTokenLazyQuery>;
export type GetPaymentAccessTokenQueryResult = Apollo.QueryResult<GetPaymentAccessTokenQuery, GetPaymentAccessTokenQueryVariables>;
export const GetPaymentByAccessTokenDocument = gql`
    query getPaymentByAccessToken($token: UUID!) {
  Payment: getPaymentByAccessToken(token: $token) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useGetPaymentByAccessTokenQuery__
 *
 * To run a query within a React component, call `useGetPaymentByAccessTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentByAccessTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentByAccessTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetPaymentByAccessTokenQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentByAccessTokenQuery, GetPaymentByAccessTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentByAccessTokenQuery, GetPaymentByAccessTokenQueryVariables>(GetPaymentByAccessTokenDocument, options);
      }
export function useGetPaymentByAccessTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentByAccessTokenQuery, GetPaymentByAccessTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentByAccessTokenQuery, GetPaymentByAccessTokenQueryVariables>(GetPaymentByAccessTokenDocument, options);
        }
export type GetPaymentByAccessTokenQueryHookResult = ReturnType<typeof useGetPaymentByAccessTokenQuery>;
export type GetPaymentByAccessTokenLazyQueryHookResult = ReturnType<typeof useGetPaymentByAccessTokenLazyQuery>;
export type GetPaymentByAccessTokenQueryResult = Apollo.QueryResult<GetPaymentByAccessTokenQuery, GetPaymentByAccessTokenQueryVariables>;
export const GetPaymentByPersonOrTemporaryPersonDocument = gql`
    query getPaymentByPersonOrTemporaryPerson($paymentId: BigInt!, $sessionToken: UUID) {
  Payment: getPaymentByPersonOrTemporaryPerson(
    paymentId: $paymentId
    sessionToken: $sessionToken
  ) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useGetPaymentByPersonOrTemporaryPersonQuery__
 *
 * To run a query within a React component, call `useGetPaymentByPersonOrTemporaryPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentByPersonOrTemporaryPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentByPersonOrTemporaryPersonQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useGetPaymentByPersonOrTemporaryPersonQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentByPersonOrTemporaryPersonQuery, GetPaymentByPersonOrTemporaryPersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentByPersonOrTemporaryPersonQuery, GetPaymentByPersonOrTemporaryPersonQueryVariables>(GetPaymentByPersonOrTemporaryPersonDocument, options);
      }
export function useGetPaymentByPersonOrTemporaryPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentByPersonOrTemporaryPersonQuery, GetPaymentByPersonOrTemporaryPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentByPersonOrTemporaryPersonQuery, GetPaymentByPersonOrTemporaryPersonQueryVariables>(GetPaymentByPersonOrTemporaryPersonDocument, options);
        }
export type GetPaymentByPersonOrTemporaryPersonQueryHookResult = ReturnType<typeof useGetPaymentByPersonOrTemporaryPersonQuery>;
export type GetPaymentByPersonOrTemporaryPersonLazyQueryHookResult = ReturnType<typeof useGetPaymentByPersonOrTemporaryPersonLazyQuery>;
export type GetPaymentByPersonOrTemporaryPersonQueryResult = Apollo.QueryResult<GetPaymentByPersonOrTemporaryPersonQuery, GetPaymentByPersonOrTemporaryPersonQueryVariables>;
export const GetPaymentsDocument = gql`
    query getPayments($personId: BigInt!) {
  Payments: paymentsByPersonId(personId: $personId) {
    edges {
      node {
        ...PaymentFields
        giftAidClaimsByPaymentIdAndPersonId {
          edges {
            node {
              nodeId
              paymentId
              personId
              addressId
              reportId
            }
          }
        }
      }
    }
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useGetPaymentsQuery__
 *
 * To run a query within a React component, call `useGetPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetPaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentsQuery, GetPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentsQuery, GetPaymentsQueryVariables>(GetPaymentsDocument, options);
      }
export function useGetPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentsQuery, GetPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentsQuery, GetPaymentsQueryVariables>(GetPaymentsDocument, options);
        }
export type GetPaymentsQueryHookResult = ReturnType<typeof useGetPaymentsQuery>;
export type GetPaymentsLazyQueryHookResult = ReturnType<typeof useGetPaymentsLazyQuery>;
export type GetPaymentsQueryResult = Apollo.QueryResult<GetPaymentsQuery, GetPaymentsQueryVariables>;
export const GetRecurringPaymentDocument = gql`
    query getRecurringPayment($id: BigInt!) {
  recurringPayment: recurringPaymentById(id: $id) {
    ...RecurringPaymentFields
  }
}
    ${RecurringPaymentFieldsFragmentDoc}`;

/**
 * __useGetRecurringPaymentQuery__
 *
 * To run a query within a React component, call `useGetRecurringPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRecurringPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetRecurringPaymentQuery, GetRecurringPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurringPaymentQuery, GetRecurringPaymentQueryVariables>(GetRecurringPaymentDocument, options);
      }
export function useGetRecurringPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurringPaymentQuery, GetRecurringPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurringPaymentQuery, GetRecurringPaymentQueryVariables>(GetRecurringPaymentDocument, options);
        }
export type GetRecurringPaymentQueryHookResult = ReturnType<typeof useGetRecurringPaymentQuery>;
export type GetRecurringPaymentLazyQueryHookResult = ReturnType<typeof useGetRecurringPaymentLazyQuery>;
export type GetRecurringPaymentQueryResult = Apollo.QueryResult<GetRecurringPaymentQuery, GetRecurringPaymentQueryVariables>;
export const GetRecurringPaymentByPersonOrTemporaryPersonDocument = gql`
    query getRecurringPaymentByPersonOrTemporaryPerson($id: BigInt, $sessionToken: UUID) {
  recurringPayment: getRecurringPaymentByPersonOrTemporaryPerson(
    recurringPaymentId: $id
    sessionToken: $sessionToken
  ) {
    ...RecurringPaymentFields
  }
}
    ${RecurringPaymentFieldsFragmentDoc}`;

/**
 * __useGetRecurringPaymentByPersonOrTemporaryPersonQuery__
 *
 * To run a query within a React component, call `useGetRecurringPaymentByPersonOrTemporaryPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringPaymentByPersonOrTemporaryPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringPaymentByPersonOrTemporaryPersonQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useGetRecurringPaymentByPersonOrTemporaryPersonQuery(baseOptions?: Apollo.QueryHookOptions<GetRecurringPaymentByPersonOrTemporaryPersonQuery, GetRecurringPaymentByPersonOrTemporaryPersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurringPaymentByPersonOrTemporaryPersonQuery, GetRecurringPaymentByPersonOrTemporaryPersonQueryVariables>(GetRecurringPaymentByPersonOrTemporaryPersonDocument, options);
      }
export function useGetRecurringPaymentByPersonOrTemporaryPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurringPaymentByPersonOrTemporaryPersonQuery, GetRecurringPaymentByPersonOrTemporaryPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurringPaymentByPersonOrTemporaryPersonQuery, GetRecurringPaymentByPersonOrTemporaryPersonQueryVariables>(GetRecurringPaymentByPersonOrTemporaryPersonDocument, options);
        }
export type GetRecurringPaymentByPersonOrTemporaryPersonQueryHookResult = ReturnType<typeof useGetRecurringPaymentByPersonOrTemporaryPersonQuery>;
export type GetRecurringPaymentByPersonOrTemporaryPersonLazyQueryHookResult = ReturnType<typeof useGetRecurringPaymentByPersonOrTemporaryPersonLazyQuery>;
export type GetRecurringPaymentByPersonOrTemporaryPersonQueryResult = Apollo.QueryResult<GetRecurringPaymentByPersonOrTemporaryPersonQuery, GetRecurringPaymentByPersonOrTemporaryPersonQueryVariables>;
export const GetRecurringPaymentsDocument = gql`
    query getRecurringPayments($personId: BigInt!) {
  RecurringPayments: recurringPaymentsByPersonId(personId: $personId) {
    edges {
      node {
        ...RecurringPaymentFields
      }
    }
  }
}
    ${RecurringPaymentFieldsFragmentDoc}`;

/**
 * __useGetRecurringPaymentsQuery__
 *
 * To run a query within a React component, call `useGetRecurringPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringPaymentsQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetRecurringPaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetRecurringPaymentsQuery, GetRecurringPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurringPaymentsQuery, GetRecurringPaymentsQueryVariables>(GetRecurringPaymentsDocument, options);
      }
export function useGetRecurringPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurringPaymentsQuery, GetRecurringPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurringPaymentsQuery, GetRecurringPaymentsQueryVariables>(GetRecurringPaymentsDocument, options);
        }
export type GetRecurringPaymentsQueryHookResult = ReturnType<typeof useGetRecurringPaymentsQuery>;
export type GetRecurringPaymentsLazyQueryHookResult = ReturnType<typeof useGetRecurringPaymentsLazyQuery>;
export type GetRecurringPaymentsQueryResult = Apollo.QueryResult<GetRecurringPaymentsQuery, GetRecurringPaymentsQueryVariables>;
export const SendReceiptDocument = gql`
    query sendReceipt($paymentId: BigInt!) {
  sendReceipt(paymentId: $paymentId)
}
    `;

/**
 * __useSendReceiptQuery__
 *
 * To run a query within a React component, call `useSendReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendReceiptQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useSendReceiptQuery(baseOptions: Apollo.QueryHookOptions<SendReceiptQuery, SendReceiptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendReceiptQuery, SendReceiptQueryVariables>(SendReceiptDocument, options);
      }
export function useSendReceiptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendReceiptQuery, SendReceiptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendReceiptQuery, SendReceiptQueryVariables>(SendReceiptDocument, options);
        }
export type SendReceiptQueryHookResult = ReturnType<typeof useSendReceiptQuery>;
export type SendReceiptLazyQueryHookResult = ReturnType<typeof useSendReceiptLazyQuery>;
export type SendReceiptQueryResult = Apollo.QueryResult<SendReceiptQuery, SendReceiptQueryVariables>;
export const CreateAcquisitionDocument = gql`
    mutation createAcquisition($personId: BigInt!, $source: String!, $medium: String, $campaign: String, $createdAt: Int!) {
  createAcquisition(
    input: {personId: $personId, source: $source, medium: $medium, campaign: $campaign, createdAt: $createdAt}
  ) {
    acquisition {
      id
      personId
      source
      medium
      campaign
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateAcquisitionMutationFn = Apollo.MutationFunction<CreateAcquisitionMutation, CreateAcquisitionMutationVariables>;

/**
 * __useCreateAcquisitionMutation__
 *
 * To run a mutation, you first call `useCreateAcquisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAcquisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAcquisitionMutation, { data, loading, error }] = useCreateAcquisitionMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      source: // value for 'source'
 *      medium: // value for 'medium'
 *      campaign: // value for 'campaign'
 *      createdAt: // value for 'createdAt'
 *   },
 * });
 */
export function useCreateAcquisitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAcquisitionMutation, CreateAcquisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAcquisitionMutation, CreateAcquisitionMutationVariables>(CreateAcquisitionDocument, options);
      }
export type CreateAcquisitionMutationHookResult = ReturnType<typeof useCreateAcquisitionMutation>;
export type CreateAcquisitionMutationResult = Apollo.MutationResult<CreateAcquisitionMutation>;
export type CreateAcquisitionMutationOptions = Apollo.BaseMutationOptions<CreateAcquisitionMutation, CreateAcquisitionMutationVariables>;
export const CreateAddressDocument = gql`
    mutation createAddress($personId: BigInt, $sessionToken: UUID, $addressType: AddressType, $firstName: String, $lastName: String, $houseNumber: String, $addressLine1: String, $addressLine2: String, $city: String, $region: String, $countryCode: String, $postalCode: String, $latitude: Float, $longitude: Float, $googlePlaceId: String) {
  mutationResult: createAddressByPersonOrTemporaryPerson(
    input: {personId: $personId, sessionToken: $sessionToken, addressType: $addressType, firstName: $firstName, lastName: $lastName, houseNumber: $houseNumber, addressLine1: $addressLine1, addressLine2: $addressLine2, city: $city, region: $region, countryCode: $countryCode, postalCode: $postalCode, latitude: $latitude, longitude: $longitude, googlePlaceId: $googlePlaceId}
  ) {
    address {
      id
      personId
      addressType
      firstName
      lastName
      houseNumber
      addressLine1
      addressLine2
      city
      region
      postalCode
      countryCode
    }
  }
}
    `;
export type CreateAddressMutationFn = Apollo.MutationFunction<CreateAddressMutation, CreateAddressMutationVariables>;

/**
 * __useCreateAddressMutation__
 *
 * To run a mutation, you first call `useCreateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddressMutation, { data, loading, error }] = useCreateAddressMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      sessionToken: // value for 'sessionToken'
 *      addressType: // value for 'addressType'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      houseNumber: // value for 'houseNumber'
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      city: // value for 'city'
 *      region: // value for 'region'
 *      countryCode: // value for 'countryCode'
 *      postalCode: // value for 'postalCode'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      googlePlaceId: // value for 'googlePlaceId'
 *   },
 * });
 */
export function useCreateAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateAddressMutation, CreateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAddressMutation, CreateAddressMutationVariables>(CreateAddressDocument, options);
      }
export type CreateAddressMutationHookResult = ReturnType<typeof useCreateAddressMutation>;
export type CreateAddressMutationResult = Apollo.MutationResult<CreateAddressMutation>;
export type CreateAddressMutationOptions = Apollo.BaseMutationOptions<CreateAddressMutation, CreateAddressMutationVariables>;
export const CreateTemporaryPersonDocument = gql`
    mutation createTemporaryPerson($email: String!, $recaptchaToken: String!) {
  createTemporaryPersonByEmail(
    input: {email: $email, recaptchaToken: $recaptchaToken}
  ) {
    TemporaryPerson: temporaryPerson {
      email
      sessionToken
      tokenIssuedAt
      tokenExpiresAt
    }
  }
}
    `;
export type CreateTemporaryPersonMutationFn = Apollo.MutationFunction<CreateTemporaryPersonMutation, CreateTemporaryPersonMutationVariables>;

/**
 * __useCreateTemporaryPersonMutation__
 *
 * To run a mutation, you first call `useCreateTemporaryPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemporaryPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemporaryPersonMutation, { data, loading, error }] = useCreateTemporaryPersonMutation({
 *   variables: {
 *      email: // value for 'email'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useCreateTemporaryPersonMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemporaryPersonMutation, CreateTemporaryPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemporaryPersonMutation, CreateTemporaryPersonMutationVariables>(CreateTemporaryPersonDocument, options);
      }
export type CreateTemporaryPersonMutationHookResult = ReturnType<typeof useCreateTemporaryPersonMutation>;
export type CreateTemporaryPersonMutationResult = Apollo.MutationResult<CreateTemporaryPersonMutation>;
export type CreateTemporaryPersonMutationOptions = Apollo.BaseMutationOptions<CreateTemporaryPersonMutation, CreateTemporaryPersonMutationVariables>;
export const SyncAuth0UserDocument = gql`
    mutation syncAuth0User($auth0User: JSON!) {
  syncAuth0User(input: {auth0User: $auth0User}) {
    Person: person {
      id
      firstName
      lastName
      email
      fullName
      birthDate
      createdAt
      updatedAt
      isAnonymized
      auth0UserId
    }
  }
}
    `;
export type SyncAuth0UserMutationFn = Apollo.MutationFunction<SyncAuth0UserMutation, SyncAuth0UserMutationVariables>;

/**
 * __useSyncAuth0UserMutation__
 *
 * To run a mutation, you first call `useSyncAuth0UserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncAuth0UserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncAuth0UserMutation, { data, loading, error }] = useSyncAuth0UserMutation({
 *   variables: {
 *      auth0User: // value for 'auth0User'
 *   },
 * });
 */
export function useSyncAuth0UserMutation(baseOptions?: Apollo.MutationHookOptions<SyncAuth0UserMutation, SyncAuth0UserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncAuth0UserMutation, SyncAuth0UserMutationVariables>(SyncAuth0UserDocument, options);
      }
export type SyncAuth0UserMutationHookResult = ReturnType<typeof useSyncAuth0UserMutation>;
export type SyncAuth0UserMutationResult = Apollo.MutationResult<SyncAuth0UserMutation>;
export type SyncAuth0UserMutationOptions = Apollo.BaseMutationOptions<SyncAuth0UserMutation, SyncAuth0UserMutationVariables>;
export const UpdatePersonByIdDocument = gql`
    mutation updatePersonById($personId: BigInt!, $firstName: String, $lastName: String, $email: String, $birthDate: Date) {
  updatePersonByPersonId(
    input: {personId: $personId, firstName: $firstName, lastName: $lastName, email: $email, birthDate: $birthDate}
  ) {
    person {
      id
      fullName
      firstName
      lastName
      email
      birthDate
    }
  }
}
    `;
export type UpdatePersonByIdMutationFn = Apollo.MutationFunction<UpdatePersonByIdMutation, UpdatePersonByIdMutationVariables>;

/**
 * __useUpdatePersonByIdMutation__
 *
 * To run a mutation, you first call `useUpdatePersonByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonByIdMutation, { data, loading, error }] = useUpdatePersonByIdMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      birthDate: // value for 'birthDate'
 *   },
 * });
 */
export function useUpdatePersonByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonByIdMutation, UpdatePersonByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonByIdMutation, UpdatePersonByIdMutationVariables>(UpdatePersonByIdDocument, options);
      }
export type UpdatePersonByIdMutationHookResult = ReturnType<typeof useUpdatePersonByIdMutation>;
export type UpdatePersonByIdMutationResult = Apollo.MutationResult<UpdatePersonByIdMutation>;
export type UpdatePersonByIdMutationOptions = Apollo.BaseMutationOptions<UpdatePersonByIdMutation, UpdatePersonByIdMutationVariables>;
export const UpdatePersonEmailDocument = gql`
    mutation updatePersonEmail($personId: BigInt!, $email: String!) {
  Person: updatePersonEmailAuth0(input: {personId: $personId, email: $email}) {
    message: string
  }
}
    `;
export type UpdatePersonEmailMutationFn = Apollo.MutationFunction<UpdatePersonEmailMutation, UpdatePersonEmailMutationVariables>;

/**
 * __useUpdatePersonEmailMutation__
 *
 * To run a mutation, you first call `useUpdatePersonEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonEmailMutation, { data, loading, error }] = useUpdatePersonEmailMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdatePersonEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonEmailMutation, UpdatePersonEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonEmailMutation, UpdatePersonEmailMutationVariables>(UpdatePersonEmailDocument, options);
      }
export type UpdatePersonEmailMutationHookResult = ReturnType<typeof useUpdatePersonEmailMutation>;
export type UpdatePersonEmailMutationResult = Apollo.MutationResult<UpdatePersonEmailMutation>;
export type UpdatePersonEmailMutationOptions = Apollo.BaseMutationOptions<UpdatePersonEmailMutation, UpdatePersonEmailMutationVariables>;
export const FindPersonByNameOrEmailDocument = gql`
    query findPersonByNameOrEmail($searchText: String!) {
  People: findPersonByNameOrEmail(searchText: $searchText) {
    edges {
      node {
        id
        email
        firstName
        lastName
        fullName
      }
    }
  }
}
    `;

/**
 * __useFindPersonByNameOrEmailQuery__
 *
 * To run a query within a React component, call `useFindPersonByNameOrEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPersonByNameOrEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPersonByNameOrEmailQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFindPersonByNameOrEmailQuery(baseOptions: Apollo.QueryHookOptions<FindPersonByNameOrEmailQuery, FindPersonByNameOrEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPersonByNameOrEmailQuery, FindPersonByNameOrEmailQueryVariables>(FindPersonByNameOrEmailDocument, options);
      }
export function useFindPersonByNameOrEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPersonByNameOrEmailQuery, FindPersonByNameOrEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPersonByNameOrEmailQuery, FindPersonByNameOrEmailQueryVariables>(FindPersonByNameOrEmailDocument, options);
        }
export type FindPersonByNameOrEmailQueryHookResult = ReturnType<typeof useFindPersonByNameOrEmailQuery>;
export type FindPersonByNameOrEmailLazyQueryHookResult = ReturnType<typeof useFindPersonByNameOrEmailLazyQuery>;
export type FindPersonByNameOrEmailQueryResult = Apollo.QueryResult<FindPersonByNameOrEmailQuery, FindPersonByNameOrEmailQueryVariables>;
export const FindPersonByPayRefDocument = gql`
    query findPersonByPayRef($searchText: String!) {
  FoundPeople: findPersonByPaymentReference(searchText: $searchText) {
    edges {
      node {
        id
        email
        firstName
        lastName
        fullName
      }
    }
  }
}
    `;

/**
 * __useFindPersonByPayRefQuery__
 *
 * To run a query within a React component, call `useFindPersonByPayRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPersonByPayRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPersonByPayRefQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFindPersonByPayRefQuery(baseOptions: Apollo.QueryHookOptions<FindPersonByPayRefQuery, FindPersonByPayRefQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPersonByPayRefQuery, FindPersonByPayRefQueryVariables>(FindPersonByPayRefDocument, options);
      }
export function useFindPersonByPayRefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPersonByPayRefQuery, FindPersonByPayRefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPersonByPayRefQuery, FindPersonByPayRefQueryVariables>(FindPersonByPayRefDocument, options);
        }
export type FindPersonByPayRefQueryHookResult = ReturnType<typeof useFindPersonByPayRefQuery>;
export type FindPersonByPayRefLazyQueryHookResult = ReturnType<typeof useFindPersonByPayRefLazyQuery>;
export type FindPersonByPayRefQueryResult = Apollo.QueryResult<FindPersonByPayRefQuery, FindPersonByPayRefQueryVariables>;
export const GetAddressesDocument = gql`
    query getAddresses($personId: BigInt, $sessionToken: UUID) {
  Addresses: getAddressesByPersonOrTemporaryPerson(
    personId: $personId
    sessionToken: $sessionToken
  ) {
    edges {
      node {
        id
        personId
        addressType
        firstName
        lastName
        houseNumber
        addressLine1
        addressLine2
        city
        region
        postalCode
        countryCode
        coordinates
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetAddressesQuery__
 *
 * To run a query within a React component, call `useGetAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressesQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useGetAddressesQuery(baseOptions?: Apollo.QueryHookOptions<GetAddressesQuery, GetAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressesQuery, GetAddressesQueryVariables>(GetAddressesDocument, options);
      }
export function useGetAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressesQuery, GetAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressesQuery, GetAddressesQueryVariables>(GetAddressesDocument, options);
        }
export type GetAddressesQueryHookResult = ReturnType<typeof useGetAddressesQuery>;
export type GetAddressesLazyQueryHookResult = ReturnType<typeof useGetAddressesLazyQuery>;
export type GetAddressesQueryResult = Apollo.QueryResult<GetAddressesQuery, GetAddressesQueryVariables>;
export const GetEmailAddressesDocument = gql`
    query getEmailAddresses($personId: BigInt!) {
  Emails: emailAddressesByPersonId(personId: $personId) {
    edges {
      node {
        email
        personId
      }
    }
  }
}
    `;

/**
 * __useGetEmailAddressesQuery__
 *
 * To run a query within a React component, call `useGetEmailAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailAddressesQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetEmailAddressesQuery(baseOptions: Apollo.QueryHookOptions<GetEmailAddressesQuery, GetEmailAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailAddressesQuery, GetEmailAddressesQueryVariables>(GetEmailAddressesDocument, options);
      }
export function useGetEmailAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailAddressesQuery, GetEmailAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailAddressesQuery, GetEmailAddressesQueryVariables>(GetEmailAddressesDocument, options);
        }
export type GetEmailAddressesQueryHookResult = ReturnType<typeof useGetEmailAddressesQuery>;
export type GetEmailAddressesLazyQueryHookResult = ReturnType<typeof useGetEmailAddressesLazyQuery>;
export type GetEmailAddressesQueryResult = Apollo.QueryResult<GetEmailAddressesQuery, GetEmailAddressesQueryVariables>;
export const GetPersonDocument = gql`
    query getPerson {
  Person: currentPerson {
    id
    email
    fullName
    firstName
    lastName
    birthDate
    auth0UserId
  }
}
    `;

/**
 * __useGetPersonQuery__
 *
 * To run a query within a React component, call `useGetPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonQuery, GetPersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonQuery, GetPersonQueryVariables>(GetPersonDocument, options);
      }
export function useGetPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonQuery, GetPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonQuery, GetPersonQueryVariables>(GetPersonDocument, options);
        }
export type GetPersonQueryHookResult = ReturnType<typeof useGetPersonQuery>;
export type GetPersonLazyQueryHookResult = ReturnType<typeof useGetPersonLazyQuery>;
export type GetPersonQueryResult = Apollo.QueryResult<GetPersonQuery, GetPersonQueryVariables>;
export const GetPersonAllDataDocument = gql`
    query getPersonAllData($personId: BigInt!) {
  RequestedPerson: personById(id: $personId) {
    id
    firstName
    lastName
    fullName
    email
    birthDate
  }
  EmailAddresses: emailAddressesByPersonId(personId: $personId) {
    edges {
      node {
        email
        personId
      }
    }
  }
  Addresses: addressesByPersonId(personId: $personId) {
    edges {
      node {
        id
        personId
        firstName
        lastName
        houseNumber
        addressLine1
        addressLine2
        city
        region
        postalCode
        countryCode
        coordinates
      }
    }
  }
  Allocation: allocationByPersonId(personId: $personId) {
    personId
    allocation
    createdAt
    updatedAt
  }
  Pledges: getPledgesByPersonId(personId: $personId) {
    edges {
      node {
        id
        personId
        period {
          start {
            value
            inclusive
          }
          end {
            value
            inclusive
          }
        }
        pledgePercentage
        pledgeType
      }
    }
  }
  Payments: paymentsByPersonId(personId: $personId) {
    edges {
      node {
        id
        personId
        allocation
        recipient
        gateway
        gatewayData
        status
        statusData
        gatewayTransactionId
        amount
        net
        fee
        currencyCode
        chargeAmount
        chargeCurrencyCode
        createdAt
        reference
        giftAidClaim: giftAidClaimsByPaymentIdAndPersonId {
          edges {
            node {
              paymentId
              personId
              addressId
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
  RecurringPayments: recurringPaymentsByPersonId(personId: $personId) {
    edges {
      node {
        id
        personId
        period
        periodIndex
        allocation
        amount
        currencyCode
        recipient
        gateway
        gatewayData
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetPersonAllDataQuery__
 *
 * To run a query within a React component, call `useGetPersonAllDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonAllDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonAllDataQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetPersonAllDataQuery(baseOptions: Apollo.QueryHookOptions<GetPersonAllDataQuery, GetPersonAllDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonAllDataQuery, GetPersonAllDataQueryVariables>(GetPersonAllDataDocument, options);
      }
export function useGetPersonAllDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonAllDataQuery, GetPersonAllDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonAllDataQuery, GetPersonAllDataQueryVariables>(GetPersonAllDataDocument, options);
        }
export type GetPersonAllDataQueryHookResult = ReturnType<typeof useGetPersonAllDataQuery>;
export type GetPersonAllDataLazyQueryHookResult = ReturnType<typeof useGetPersonAllDataLazyQuery>;
export type GetPersonAllDataQueryResult = Apollo.QueryResult<GetPersonAllDataQuery, GetPersonAllDataQueryVariables>;
export const GetPersonByIdDocument = gql`
    query getPersonById($personId: BigInt!) {
  Person: personById(id: $personId) {
    id
    firstName
    lastName
    fullName
    email
    birthDate
    createdAt
    updatedAt
    auth0UserId
  }
}
    `;

/**
 * __useGetPersonByIdQuery__
 *
 * To run a query within a React component, call `useGetPersonByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonByIdQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetPersonByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPersonByIdQuery, GetPersonByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonByIdQuery, GetPersonByIdQueryVariables>(GetPersonByIdDocument, options);
      }
export function useGetPersonByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonByIdQuery, GetPersonByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonByIdQuery, GetPersonByIdQueryVariables>(GetPersonByIdDocument, options);
        }
export type GetPersonByIdQueryHookResult = ReturnType<typeof useGetPersonByIdQuery>;
export type GetPersonByIdLazyQueryHookResult = ReturnType<typeof useGetPersonByIdLazyQuery>;
export type GetPersonByIdQueryResult = Apollo.QueryResult<GetPersonByIdQuery, GetPersonByIdQueryVariables>;
export const CancelRecurringReportedDonationDocument = gql`
    mutation cancelRecurringReportedDonation($recurringReportedDonationId: BigInt!) {
  cancelRecurringReportedDonation(
    input: {recurringReportedDonationId: $recurringReportedDonationId}
  ) {
    RecurringReportedDonation: recurringReportedDonation {
      id
    }
  }
}
    `;
export type CancelRecurringReportedDonationMutationFn = Apollo.MutationFunction<CancelRecurringReportedDonationMutation, CancelRecurringReportedDonationMutationVariables>;

/**
 * __useCancelRecurringReportedDonationMutation__
 *
 * To run a mutation, you first call `useCancelRecurringReportedDonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRecurringReportedDonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRecurringReportedDonationMutation, { data, loading, error }] = useCancelRecurringReportedDonationMutation({
 *   variables: {
 *      recurringReportedDonationId: // value for 'recurringReportedDonationId'
 *   },
 * });
 */
export function useCancelRecurringReportedDonationMutation(baseOptions?: Apollo.MutationHookOptions<CancelRecurringReportedDonationMutation, CancelRecurringReportedDonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelRecurringReportedDonationMutation, CancelRecurringReportedDonationMutationVariables>(CancelRecurringReportedDonationDocument, options);
      }
export type CancelRecurringReportedDonationMutationHookResult = ReturnType<typeof useCancelRecurringReportedDonationMutation>;
export type CancelRecurringReportedDonationMutationResult = Apollo.MutationResult<CancelRecurringReportedDonationMutation>;
export type CancelRecurringReportedDonationMutationOptions = Apollo.BaseMutationOptions<CancelRecurringReportedDonationMutation, CancelRecurringReportedDonationMutationVariables>;
export const CreateIncomeDocument = gql`
    mutation createIncome($personId: BigInt!, $startDate: Date!, $endDate: Date!, $amount: BigFloat!, $currencyCode: String!, $employmentStatus: IncomeEmploymentStatus!, $donationsTaxDeductible: Boolean!) {
  createIncome(
    input: {personId: $personId, period: {start: {value: $startDate, inclusive: true}, end: {value: $endDate, inclusive: true}}, amount: $amount, currencyCode: $currencyCode, employmentStatus: $employmentStatus, donationsTaxDeductible: $donationsTaxDeductible}
  ) {
    income {
      id
      personId
      period {
        start {
          value
          inclusive
        }
        end {
          value
          inclusive
        }
      }
      currencyCode
      employmentStatus
      donationsTaxDeductible
    }
  }
}
    `;
export type CreateIncomeMutationFn = Apollo.MutationFunction<CreateIncomeMutation, CreateIncomeMutationVariables>;

/**
 * __useCreateIncomeMutation__
 *
 * To run a mutation, you first call `useCreateIncomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncomeMutation, { data, loading, error }] = useCreateIncomeMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      amount: // value for 'amount'
 *      currencyCode: // value for 'currencyCode'
 *      employmentStatus: // value for 'employmentStatus'
 *      donationsTaxDeductible: // value for 'donationsTaxDeductible'
 *   },
 * });
 */
export function useCreateIncomeMutation(baseOptions?: Apollo.MutationHookOptions<CreateIncomeMutation, CreateIncomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIncomeMutation, CreateIncomeMutationVariables>(CreateIncomeDocument, options);
      }
export type CreateIncomeMutationHookResult = ReturnType<typeof useCreateIncomeMutation>;
export type CreateIncomeMutationResult = Apollo.MutationResult<CreateIncomeMutation>;
export type CreateIncomeMutationOptions = Apollo.BaseMutationOptions<CreateIncomeMutation, CreateIncomeMutationVariables>;
export const CreateRecurringReportedDonationDocument = gql`
    mutation createRecurringReportedDonation($personId: BigInt!, $organizationId: BigInt!, $amount: BigFloat!, $currencyCode: String!, $startDate: Date!, $recurrenceInterval: IntervalInput!) {
  RecurringReportedDonation: createRecurringReportedDonation(
    input: {personId: $personId, organizationId: $organizationId, amount: $amount, currencyCode: $currencyCode, startDate: $startDate, recurrenceInterval: $recurrenceInterval}
  ) {
    recurringReportedDonation {
      id
      personId
      organizationId
      amount
      currencyCode
      startDate
      recurrenceInterval {
        years
        months
        days
        hours
        minutes
        seconds
      }
      nextDate
      status
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateRecurringReportedDonationMutationFn = Apollo.MutationFunction<CreateRecurringReportedDonationMutation, CreateRecurringReportedDonationMutationVariables>;

/**
 * __useCreateRecurringReportedDonationMutation__
 *
 * To run a mutation, you first call `useCreateRecurringReportedDonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringReportedDonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringReportedDonationMutation, { data, loading, error }] = useCreateRecurringReportedDonationMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      organizationId: // value for 'organizationId'
 *      amount: // value for 'amount'
 *      currencyCode: // value for 'currencyCode'
 *      startDate: // value for 'startDate'
 *      recurrenceInterval: // value for 'recurrenceInterval'
 *   },
 * });
 */
export function useCreateRecurringReportedDonationMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecurringReportedDonationMutation, CreateRecurringReportedDonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecurringReportedDonationMutation, CreateRecurringReportedDonationMutationVariables>(CreateRecurringReportedDonationDocument, options);
      }
export type CreateRecurringReportedDonationMutationHookResult = ReturnType<typeof useCreateRecurringReportedDonationMutation>;
export type CreateRecurringReportedDonationMutationResult = Apollo.MutationResult<CreateRecurringReportedDonationMutation>;
export type CreateRecurringReportedDonationMutationOptions = Apollo.BaseMutationOptions<CreateRecurringReportedDonationMutation, CreateRecurringReportedDonationMutationVariables>;
export const CreateReportedDonationDocument = gql`
    mutation createReportedDonation($personId: BigInt!, $donationDate: Date!, $amount: BigFloat!, $currencyCode: String!, $organizationId: BigInt!, $pledgeId: BigInt, $incomeId: BigInt) {
  createReportedDonationByPersonId(
    input: {personId: $personId, donationDate: $donationDate, amount: $amount, currencyCode: $currencyCode, organizationId: $organizationId, pledgeId: $pledgeId, incomeId: $incomeId}
  ) {
    reportedDonation {
      id
      personId
      donationDate
      amount
      currencyCode
      organizationId
    }
  }
}
    `;
export type CreateReportedDonationMutationFn = Apollo.MutationFunction<CreateReportedDonationMutation, CreateReportedDonationMutationVariables>;

/**
 * __useCreateReportedDonationMutation__
 *
 * To run a mutation, you first call `useCreateReportedDonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportedDonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportedDonationMutation, { data, loading, error }] = useCreateReportedDonationMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      donationDate: // value for 'donationDate'
 *      amount: // value for 'amount'
 *      currencyCode: // value for 'currencyCode'
 *      organizationId: // value for 'organizationId'
 *      pledgeId: // value for 'pledgeId'
 *      incomeId: // value for 'incomeId'
 *   },
 * });
 */
export function useCreateReportedDonationMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportedDonationMutation, CreateReportedDonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportedDonationMutation, CreateReportedDonationMutationVariables>(CreateReportedDonationDocument, options);
      }
export type CreateReportedDonationMutationHookResult = ReturnType<typeof useCreateReportedDonationMutation>;
export type CreateReportedDonationMutationResult = Apollo.MutationResult<CreateReportedDonationMutation>;
export type CreateReportedDonationMutationOptions = Apollo.BaseMutationOptions<CreateReportedDonationMutation, CreateReportedDonationMutationVariables>;
export const DeleteIncomeDocument = gql`
    mutation deleteIncome($id: BigInt!) {
  deleteIncome(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type DeleteIncomeMutationFn = Apollo.MutationFunction<DeleteIncomeMutation, DeleteIncomeMutationVariables>;

/**
 * __useDeleteIncomeMutation__
 *
 * To run a mutation, you first call `useDeleteIncomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIncomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIncomeMutation, { data, loading, error }] = useDeleteIncomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIncomeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIncomeMutation, DeleteIncomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIncomeMutation, DeleteIncomeMutationVariables>(DeleteIncomeDocument, options);
      }
export type DeleteIncomeMutationHookResult = ReturnType<typeof useDeleteIncomeMutation>;
export type DeleteIncomeMutationResult = Apollo.MutationResult<DeleteIncomeMutation>;
export type DeleteIncomeMutationOptions = Apollo.BaseMutationOptions<DeleteIncomeMutation, DeleteIncomeMutationVariables>;
export const DeleteReportedDonationDocument = gql`
    mutation deleteReportedDonation($reportedDonationId: BigInt!) {
  deleteReportedDonation(input: {id: $reportedDonationId}) {
    clientMutationId
  }
}
    `;
export type DeleteReportedDonationMutationFn = Apollo.MutationFunction<DeleteReportedDonationMutation, DeleteReportedDonationMutationVariables>;

/**
 * __useDeleteReportedDonationMutation__
 *
 * To run a mutation, you first call `useDeleteReportedDonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportedDonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportedDonationMutation, { data, loading, error }] = useDeleteReportedDonationMutation({
 *   variables: {
 *      reportedDonationId: // value for 'reportedDonationId'
 *   },
 * });
 */
export function useDeleteReportedDonationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportedDonationMutation, DeleteReportedDonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportedDonationMutation, DeleteReportedDonationMutationVariables>(DeleteReportedDonationDocument, options);
      }
export type DeleteReportedDonationMutationHookResult = ReturnType<typeof useDeleteReportedDonationMutation>;
export type DeleteReportedDonationMutationResult = Apollo.MutationResult<DeleteReportedDonationMutation>;
export type DeleteReportedDonationMutationOptions = Apollo.BaseMutationOptions<DeleteReportedDonationMutation, DeleteReportedDonationMutationVariables>;
export const SignPledgeDocument = gql`
    mutation signPledge($personId: BigInt!, $startDate: Date!, $endDate: Date!, $pledgePercentage: BigFloat!, $pledgeType: PledgeType!, $motivation: String, $locale: String, $metadata: JSON!, $amount: BigFloat!, $currencyCode: String!, $employmentStatus: IncomeEmploymentStatus!, $firstName: String, $lastName: String, $birthDate: Date) {
  signPledge(
    input: {personId: $personId, pledgePeriod: {start: {value: $startDate, inclusive: true}, end: {value: $endDate, inclusive: true}}, pledgePercentage: $pledgePercentage, pledgeType: $pledgeType, motivation: $motivation, locale: $locale, metadata: $metadata, incomeAmount: $amount, incomeCurrencyCode: $currencyCode, incomeEmploymentStatus: $employmentStatus, personFirstName: $firstName, personLastName: $lastName, personBirthDate: $birthDate}
  ) {
    pledge {
      id
      personId
      pledgePercentage
      motivation
      locale
      metadata
      period {
        start {
          value
          inclusive
        }
        end {
          value
          inclusive
        }
      }
    }
  }
}
    `;
export type SignPledgeMutationFn = Apollo.MutationFunction<SignPledgeMutation, SignPledgeMutationVariables>;

/**
 * __useSignPledgeMutation__
 *
 * To run a mutation, you first call `useSignPledgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignPledgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signPledgeMutation, { data, loading, error }] = useSignPledgeMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      pledgePercentage: // value for 'pledgePercentage'
 *      pledgeType: // value for 'pledgeType'
 *      motivation: // value for 'motivation'
 *      locale: // value for 'locale'
 *      metadata: // value for 'metadata'
 *      amount: // value for 'amount'
 *      currencyCode: // value for 'currencyCode'
 *      employmentStatus: // value for 'employmentStatus'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      birthDate: // value for 'birthDate'
 *   },
 * });
 */
export function useSignPledgeMutation(baseOptions?: Apollo.MutationHookOptions<SignPledgeMutation, SignPledgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignPledgeMutation, SignPledgeMutationVariables>(SignPledgeDocument, options);
      }
export type SignPledgeMutationHookResult = ReturnType<typeof useSignPledgeMutation>;
export type SignPledgeMutationResult = Apollo.MutationResult<SignPledgeMutation>;
export type SignPledgeMutationOptions = Apollo.BaseMutationOptions<SignPledgeMutation, SignPledgeMutationVariables>;
export const UpdateIncomeDocument = gql`
    mutation updateIncome($id: BigInt!, $startDate: Date!, $endDate: Date!, $amount: BigFloat!, $currencyCode: String!, $employmentStatus: IncomeEmploymentStatus!, $donationsTaxDeductible: Boolean!) {
  updateIncome(
    input: {id: $id, period: {start: {value: $startDate, inclusive: true}, end: {value: $endDate, inclusive: true}}, amount: $amount, currencyCode: $currencyCode, employmentStatus: $employmentStatus, donationsTaxDeductible: $donationsTaxDeductible}
  ) {
    income {
      id
      personId
      period {
        start {
          value
          inclusive
        }
        end {
          value
          inclusive
        }
      }
      currencyCode
      employmentStatus
      donationsTaxDeductible
    }
  }
}
    `;
export type UpdateIncomeMutationFn = Apollo.MutationFunction<UpdateIncomeMutation, UpdateIncomeMutationVariables>;

/**
 * __useUpdateIncomeMutation__
 *
 * To run a mutation, you first call `useUpdateIncomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIncomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIncomeMutation, { data, loading, error }] = useUpdateIncomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      amount: // value for 'amount'
 *      currencyCode: // value for 'currencyCode'
 *      employmentStatus: // value for 'employmentStatus'
 *      donationsTaxDeductible: // value for 'donationsTaxDeductible'
 *   },
 * });
 */
export function useUpdateIncomeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIncomeMutation, UpdateIncomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIncomeMutation, UpdateIncomeMutationVariables>(UpdateIncomeDocument, options);
      }
export type UpdateIncomeMutationHookResult = ReturnType<typeof useUpdateIncomeMutation>;
export type UpdateIncomeMutationResult = Apollo.MutationResult<UpdateIncomeMutation>;
export type UpdateIncomeMutationOptions = Apollo.BaseMutationOptions<UpdateIncomeMutation, UpdateIncomeMutationVariables>;
export const UpdateReportedPaymentDocument = gql`
    mutation updateReportedPayment($id: BigInt!, $personId: BigInt!, $pledgeId: BigInt, $incomeId: BigInt) {
  updateReportedPayment(
    input: {id: $id, personId: $personId, pledgeId: $pledgeId, incomeId: $incomeId}
  ) {
    payment {
      id
    }
  }
}
    `;
export type UpdateReportedPaymentMutationFn = Apollo.MutationFunction<UpdateReportedPaymentMutation, UpdateReportedPaymentMutationVariables>;

/**
 * __useUpdateReportedPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateReportedPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportedPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportedPaymentMutation, { data, loading, error }] = useUpdateReportedPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      personId: // value for 'personId'
 *      pledgeId: // value for 'pledgeId'
 *      incomeId: // value for 'incomeId'
 *   },
 * });
 */
export function useUpdateReportedPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportedPaymentMutation, UpdateReportedPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportedPaymentMutation, UpdateReportedPaymentMutationVariables>(UpdateReportedPaymentDocument, options);
      }
export type UpdateReportedPaymentMutationHookResult = ReturnType<typeof useUpdateReportedPaymentMutation>;
export type UpdateReportedPaymentMutationResult = Apollo.MutationResult<UpdateReportedPaymentMutation>;
export type UpdateReportedPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateReportedPaymentMutation, UpdateReportedPaymentMutationVariables>;
export const UpdatePledgeDocument = gql`
    mutation updatePledge($id: BigInt!, $metadata: JSON!) {
  updatePledge(input: {id: $id, metadata: $metadata}) {
    pledge {
      id
      metadata
    }
  }
}
    `;
export type UpdatePledgeMutationFn = Apollo.MutationFunction<UpdatePledgeMutation, UpdatePledgeMutationVariables>;

/**
 * __useUpdatePledgeMutation__
 *
 * To run a mutation, you first call `useUpdatePledgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePledgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePledgeMutation, { data, loading, error }] = useUpdatePledgeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useUpdatePledgeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePledgeMutation, UpdatePledgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePledgeMutation, UpdatePledgeMutationVariables>(UpdatePledgeDocument, options);
      }
export type UpdatePledgeMutationHookResult = ReturnType<typeof useUpdatePledgeMutation>;
export type UpdatePledgeMutationResult = Apollo.MutationResult<UpdatePledgeMutation>;
export type UpdatePledgeMutationOptions = Apollo.BaseMutationOptions<UpdatePledgeMutation, UpdatePledgeMutationVariables>;
export const UpdateReportedDonationDocument = gql`
    mutation updateReportedDonation($id: BigInt!, $personId: BigInt!, $donationDate: Date!, $amount: BigFloat!, $currencyCode: String!, $organizationId: BigInt!, $pledgeId: BigInt, $incomeId: BigInt) {
  updateReportedDonation(
    input: {id: $id, personId: $personId, donationDate: $donationDate, amount: $amount, currencyCode: $currencyCode, organizationId: $organizationId, pledgeId: $pledgeId, incomeId: $incomeId}
  ) {
    reportedDonation {
      id
      personId
      donationDate
      amount
      currencyCode
      organizationId
    }
  }
}
    `;
export type UpdateReportedDonationMutationFn = Apollo.MutationFunction<UpdateReportedDonationMutation, UpdateReportedDonationMutationVariables>;

/**
 * __useUpdateReportedDonationMutation__
 *
 * To run a mutation, you first call `useUpdateReportedDonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportedDonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportedDonationMutation, { data, loading, error }] = useUpdateReportedDonationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      personId: // value for 'personId'
 *      donationDate: // value for 'donationDate'
 *      amount: // value for 'amount'
 *      currencyCode: // value for 'currencyCode'
 *      organizationId: // value for 'organizationId'
 *      pledgeId: // value for 'pledgeId'
 *      incomeId: // value for 'incomeId'
 *   },
 * });
 */
export function useUpdateReportedDonationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportedDonationMutation, UpdateReportedDonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportedDonationMutation, UpdateReportedDonationMutationVariables>(UpdateReportedDonationDocument, options);
      }
export type UpdateReportedDonationMutationHookResult = ReturnType<typeof useUpdateReportedDonationMutation>;
export type UpdateReportedDonationMutationResult = Apollo.MutationResult<UpdateReportedDonationMutation>;
export type UpdateReportedDonationMutationOptions = Apollo.BaseMutationOptions<UpdateReportedDonationMutation, UpdateReportedDonationMutationVariables>;
export const AllPledgesManagersDocument = gql`
    query allPledgesManagers {
  PledgesManagers: allPledgesManagers {
    edges {
      node {
        personId
      }
    }
  }
}
    `;

/**
 * __useAllPledgesManagersQuery__
 *
 * To run a query within a React component, call `useAllPledgesManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPledgesManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPledgesManagersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPledgesManagersQuery(baseOptions?: Apollo.QueryHookOptions<AllPledgesManagersQuery, AllPledgesManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPledgesManagersQuery, AllPledgesManagersQueryVariables>(AllPledgesManagersDocument, options);
      }
export function useAllPledgesManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPledgesManagersQuery, AllPledgesManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPledgesManagersQuery, AllPledgesManagersQueryVariables>(AllPledgesManagersDocument, options);
        }
export type AllPledgesManagersQueryHookResult = ReturnType<typeof useAllPledgesManagersQuery>;
export type AllPledgesManagersLazyQueryHookResult = ReturnType<typeof useAllPledgesManagersLazyQuery>;
export type AllPledgesManagersQueryResult = Apollo.QueryResult<AllPledgesManagersQuery, AllPledgesManagersQueryVariables>;
export const GetCompletionPaymentsByPersonIdDocument = gql`
    query getCompletionPaymentsByPersonId($personId: BigInt!) {
  CompletionPayments: allCompletionPayments(
    condition: {personId: $personId}
    orderBy: [DONATION_DATE_DESC, AMOUNT_DESC]
  ) {
    edges {
      node {
        objectId
        objectType
        reportedDonationId
        organizationId
        paymentId
        personId
        pledgeId
        incomeId
        amount
        currencyCode
        amountNormalized
        allocation
        donationDate
        externalOrganization: externalOrganizationByOrganizationId {
          id
          name
        }
        liability: liabilityByPledgeIdAndIncomeId {
          pledgeIncomePeriod {
            start {
              value
              inclusive
            }
            end {
              value
              inclusive
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompletionPaymentsByPersonIdQuery__
 *
 * To run a query within a React component, call `useGetCompletionPaymentsByPersonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletionPaymentsByPersonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletionPaymentsByPersonIdQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetCompletionPaymentsByPersonIdQuery(baseOptions: Apollo.QueryHookOptions<GetCompletionPaymentsByPersonIdQuery, GetCompletionPaymentsByPersonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletionPaymentsByPersonIdQuery, GetCompletionPaymentsByPersonIdQueryVariables>(GetCompletionPaymentsByPersonIdDocument, options);
      }
export function useGetCompletionPaymentsByPersonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletionPaymentsByPersonIdQuery, GetCompletionPaymentsByPersonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletionPaymentsByPersonIdQuery, GetCompletionPaymentsByPersonIdQueryVariables>(GetCompletionPaymentsByPersonIdDocument, options);
        }
export type GetCompletionPaymentsByPersonIdQueryHookResult = ReturnType<typeof useGetCompletionPaymentsByPersonIdQuery>;
export type GetCompletionPaymentsByPersonIdLazyQueryHookResult = ReturnType<typeof useGetCompletionPaymentsByPersonIdLazyQuery>;
export type GetCompletionPaymentsByPersonIdQueryResult = Apollo.QueryResult<GetCompletionPaymentsByPersonIdQuery, GetCompletionPaymentsByPersonIdQueryVariables>;
export const GetIncomesByPersonIdDocument = gql`
    query getIncomesByPersonId($personId: BigInt!) {
  Incomes: getIncomesByPersonId(personId: $personId) {
    edges {
      node {
        id
        personId
        period {
          start {
            value
            inclusive
          }
          end {
            value
            inclusive
          }
        }
        amount
        currencyCode
        employmentStatus
        donationsTaxDeductible
        liabilities: liabilitiesByIncomeId {
          edges {
            node {
              nodeId
              pledgeId
              incomeId
              personId
              pledgeIncomePeriod {
                start {
                  value
                  inclusive
                }
                end {
                  value
                  inclusive
                }
              }
              currencyCode
              liabilityAmount
              liabilityNormalized
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetIncomesByPersonIdQuery__
 *
 * To run a query within a React component, call `useGetIncomesByPersonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncomesByPersonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncomesByPersonIdQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetIncomesByPersonIdQuery(baseOptions: Apollo.QueryHookOptions<GetIncomesByPersonIdQuery, GetIncomesByPersonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncomesByPersonIdQuery, GetIncomesByPersonIdQueryVariables>(GetIncomesByPersonIdDocument, options);
      }
export function useGetIncomesByPersonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncomesByPersonIdQuery, GetIncomesByPersonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncomesByPersonIdQuery, GetIncomesByPersonIdQueryVariables>(GetIncomesByPersonIdDocument, options);
        }
export type GetIncomesByPersonIdQueryHookResult = ReturnType<typeof useGetIncomesByPersonIdQuery>;
export type GetIncomesByPersonIdLazyQueryHookResult = ReturnType<typeof useGetIncomesByPersonIdLazyQuery>;
export type GetIncomesByPersonIdQueryResult = Apollo.QueryResult<GetIncomesByPersonIdQuery, GetIncomesByPersonIdQueryVariables>;
export const GetLiabilitiesByPersonIdDocument = gql`
    query getLiabilitiesByPersonId($personId: BigInt!) {
  Liabilities: allLiabilities(condition: {personId: $personId}) {
    edges {
      node {
        personId
        pledgeId
        incomeId
        pledgeIncomePeriod {
          start {
            value
            inclusive
          }
          end {
            value
            inclusive
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetLiabilitiesByPersonIdQuery__
 *
 * To run a query within a React component, call `useGetLiabilitiesByPersonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiabilitiesByPersonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiabilitiesByPersonIdQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetLiabilitiesByPersonIdQuery(baseOptions: Apollo.QueryHookOptions<GetLiabilitiesByPersonIdQuery, GetLiabilitiesByPersonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiabilitiesByPersonIdQuery, GetLiabilitiesByPersonIdQueryVariables>(GetLiabilitiesByPersonIdDocument, options);
      }
export function useGetLiabilitiesByPersonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiabilitiesByPersonIdQuery, GetLiabilitiesByPersonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiabilitiesByPersonIdQuery, GetLiabilitiesByPersonIdQueryVariables>(GetLiabilitiesByPersonIdDocument, options);
        }
export type GetLiabilitiesByPersonIdQueryHookResult = ReturnType<typeof useGetLiabilitiesByPersonIdQuery>;
export type GetLiabilitiesByPersonIdLazyQueryHookResult = ReturnType<typeof useGetLiabilitiesByPersonIdLazyQuery>;
export type GetLiabilitiesByPersonIdQueryResult = Apollo.QueryResult<GetLiabilitiesByPersonIdQuery, GetLiabilitiesByPersonIdQueryVariables>;
export const GetLiabilityCompletionsDocument = gql`
    query getLiabilityCompletions($pledgeId: BigInt!) {
  LiabilityCompletions: getLiabilityCompletionByPledge(pledgeId: $pledgeId) {
    edges {
      node {
        personId
        pledgeId
        incomeId
        currencyCode
        period {
          start {
            value
            inclusive
          }
          end {
            value
            inclusive
          }
        }
        liabilityAmount
        completionAmount
        completionAmountNormalized
        completionPercentage
      }
    }
  }
}
    `;

/**
 * __useGetLiabilityCompletionsQuery__
 *
 * To run a query within a React component, call `useGetLiabilityCompletionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiabilityCompletionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiabilityCompletionsQuery({
 *   variables: {
 *      pledgeId: // value for 'pledgeId'
 *   },
 * });
 */
export function useGetLiabilityCompletionsQuery(baseOptions: Apollo.QueryHookOptions<GetLiabilityCompletionsQuery, GetLiabilityCompletionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiabilityCompletionsQuery, GetLiabilityCompletionsQueryVariables>(GetLiabilityCompletionsDocument, options);
      }
export function useGetLiabilityCompletionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiabilityCompletionsQuery, GetLiabilityCompletionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiabilityCompletionsQuery, GetLiabilityCompletionsQueryVariables>(GetLiabilityCompletionsDocument, options);
        }
export type GetLiabilityCompletionsQueryHookResult = ReturnType<typeof useGetLiabilityCompletionsQuery>;
export type GetLiabilityCompletionsLazyQueryHookResult = ReturnType<typeof useGetLiabilityCompletionsLazyQuery>;
export type GetLiabilityCompletionsQueryResult = Apollo.QueryResult<GetLiabilityCompletionsQuery, GetLiabilityCompletionsQueryVariables>;
export const GetLiabilityTotalCompletionsDocument = gql`
    query getLiabilityTotalCompletions($pledgeId: BigInt!) {
  LiabilityTotalCompletions: getLiabilityTotalCompletion(pledgeId: $pledgeId) {
    edges {
      node {
        pledgeId
        currencyCode
        currencySortOrder
        liabilityAmount
        liabilityAmountNormalized
        completionAmount
        completionAmountNormalized
        completionPercentage
      }
    }
  }
}
    `;

/**
 * __useGetLiabilityTotalCompletionsQuery__
 *
 * To run a query within a React component, call `useGetLiabilityTotalCompletionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiabilityTotalCompletionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiabilityTotalCompletionsQuery({
 *   variables: {
 *      pledgeId: // value for 'pledgeId'
 *   },
 * });
 */
export function useGetLiabilityTotalCompletionsQuery(baseOptions: Apollo.QueryHookOptions<GetLiabilityTotalCompletionsQuery, GetLiabilityTotalCompletionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiabilityTotalCompletionsQuery, GetLiabilityTotalCompletionsQueryVariables>(GetLiabilityTotalCompletionsDocument, options);
      }
export function useGetLiabilityTotalCompletionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiabilityTotalCompletionsQuery, GetLiabilityTotalCompletionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiabilityTotalCompletionsQuery, GetLiabilityTotalCompletionsQueryVariables>(GetLiabilityTotalCompletionsDocument, options);
        }
export type GetLiabilityTotalCompletionsQueryHookResult = ReturnType<typeof useGetLiabilityTotalCompletionsQuery>;
export type GetLiabilityTotalCompletionsLazyQueryHookResult = ReturnType<typeof useGetLiabilityTotalCompletionsLazyQuery>;
export type GetLiabilityTotalCompletionsQueryResult = Apollo.QueryResult<GetLiabilityTotalCompletionsQuery, GetLiabilityTotalCompletionsQueryVariables>;
export const GetPledgeDocument = gql`
    query getPledge($id: BigInt!) {
  Pledge: pledgeById(id: $id) {
    id
    personId
    period {
      start {
        value
        inclusive
      }
      end {
        value
        inclusive
      }
    }
    pledgePercentage
    pledgeType
    motivation
    locale
    metadata
  }
}
    `;

/**
 * __useGetPledgeQuery__
 *
 * To run a query within a React component, call `useGetPledgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPledgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPledgeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPledgeQuery(baseOptions: Apollo.QueryHookOptions<GetPledgeQuery, GetPledgeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPledgeQuery, GetPledgeQueryVariables>(GetPledgeDocument, options);
      }
export function useGetPledgeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPledgeQuery, GetPledgeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPledgeQuery, GetPledgeQueryVariables>(GetPledgeDocument, options);
        }
export type GetPledgeQueryHookResult = ReturnType<typeof useGetPledgeQuery>;
export type GetPledgeLazyQueryHookResult = ReturnType<typeof useGetPledgeLazyQuery>;
export type GetPledgeQueryResult = Apollo.QueryResult<GetPledgeQuery, GetPledgeQueryVariables>;
export const GetPledgeLiabilityThroughTodayDocument = gql`
    query getPledgeLiabilityThroughToday($pledgeId: BigInt!) {
  normalizedLiability: getPledgeLiabilityThroughToday(pledgeId: $pledgeId)
}
    `;

/**
 * __useGetPledgeLiabilityThroughTodayQuery__
 *
 * To run a query within a React component, call `useGetPledgeLiabilityThroughTodayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPledgeLiabilityThroughTodayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPledgeLiabilityThroughTodayQuery({
 *   variables: {
 *      pledgeId: // value for 'pledgeId'
 *   },
 * });
 */
export function useGetPledgeLiabilityThroughTodayQuery(baseOptions: Apollo.QueryHookOptions<GetPledgeLiabilityThroughTodayQuery, GetPledgeLiabilityThroughTodayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPledgeLiabilityThroughTodayQuery, GetPledgeLiabilityThroughTodayQueryVariables>(GetPledgeLiabilityThroughTodayDocument, options);
      }
export function useGetPledgeLiabilityThroughTodayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPledgeLiabilityThroughTodayQuery, GetPledgeLiabilityThroughTodayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPledgeLiabilityThroughTodayQuery, GetPledgeLiabilityThroughTodayQueryVariables>(GetPledgeLiabilityThroughTodayDocument, options);
        }
export type GetPledgeLiabilityThroughTodayQueryHookResult = ReturnType<typeof useGetPledgeLiabilityThroughTodayQuery>;
export type GetPledgeLiabilityThroughTodayLazyQueryHookResult = ReturnType<typeof useGetPledgeLiabilityThroughTodayLazyQuery>;
export type GetPledgeLiabilityThroughTodayQueryResult = Apollo.QueryResult<GetPledgeLiabilityThroughTodayQuery, GetPledgeLiabilityThroughTodayQueryVariables>;
export const GetPledgeRanksByPersonIdDocument = gql`
    query getPledgeRanksByPersonId($personId: BigInt!) {
  PledgeRanks: allPledgeRanks(
    orderBy: RANK_BY_PLEDGE_TYPE_DESC
    condition: {personId: $personId}
  ) {
    edges {
      node {
        createdAt
        pledgeType
        rankByPledgeType
        commencementDate
        personByPersonId {
          id
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useGetPledgeRanksByPersonIdQuery__
 *
 * To run a query within a React component, call `useGetPledgeRanksByPersonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPledgeRanksByPersonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPledgeRanksByPersonIdQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetPledgeRanksByPersonIdQuery(baseOptions: Apollo.QueryHookOptions<GetPledgeRanksByPersonIdQuery, GetPledgeRanksByPersonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPledgeRanksByPersonIdQuery, GetPledgeRanksByPersonIdQueryVariables>(GetPledgeRanksByPersonIdDocument, options);
      }
export function useGetPledgeRanksByPersonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPledgeRanksByPersonIdQuery, GetPledgeRanksByPersonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPledgeRanksByPersonIdQuery, GetPledgeRanksByPersonIdQueryVariables>(GetPledgeRanksByPersonIdDocument, options);
        }
export type GetPledgeRanksByPersonIdQueryHookResult = ReturnType<typeof useGetPledgeRanksByPersonIdQuery>;
export type GetPledgeRanksByPersonIdLazyQueryHookResult = ReturnType<typeof useGetPledgeRanksByPersonIdLazyQuery>;
export type GetPledgeRanksByPersonIdQueryResult = Apollo.QueryResult<GetPledgeRanksByPersonIdQuery, GetPledgeRanksByPersonIdQueryVariables>;
export const GetActivePledgedMemberPublicsDocument = gql`
    query getActivePledgedMemberPublics($pledgeType: PledgeType = GIVING_WHAT_WE_CAN, $first: Int = 10, $offset: Int = 0) {
  PledgedMembers: allPledgedMembersPublics(
    orderBy: RANK_BY_PLEDGE_TYPE_DESC
    first: $first
    offset: $offset
    condition: {pledgeType: $pledgeType, active: true}
  ) {
    edges {
      node {
        fullName
        anonymous
        pledgeType
        commencementDate
        rankByPledgeType
        active
        latestPledgePercentage
        latestPledgeEndDate
      }
    }
  }
}
    `;

/**
 * __useGetActivePledgedMemberPublicsQuery__
 *
 * To run a query within a React component, call `useGetActivePledgedMemberPublicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivePledgedMemberPublicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivePledgedMemberPublicsQuery({
 *   variables: {
 *      pledgeType: // value for 'pledgeType'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetActivePledgedMemberPublicsQuery(baseOptions?: Apollo.QueryHookOptions<GetActivePledgedMemberPublicsQuery, GetActivePledgedMemberPublicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivePledgedMemberPublicsQuery, GetActivePledgedMemberPublicsQueryVariables>(GetActivePledgedMemberPublicsDocument, options);
      }
export function useGetActivePledgedMemberPublicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivePledgedMemberPublicsQuery, GetActivePledgedMemberPublicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivePledgedMemberPublicsQuery, GetActivePledgedMemberPublicsQueryVariables>(GetActivePledgedMemberPublicsDocument, options);
        }
export type GetActivePledgedMemberPublicsQueryHookResult = ReturnType<typeof useGetActivePledgedMemberPublicsQuery>;
export type GetActivePledgedMemberPublicsLazyQueryHookResult = ReturnType<typeof useGetActivePledgedMemberPublicsLazyQuery>;
export type GetActivePledgedMemberPublicsQueryResult = Apollo.QueryResult<GetActivePledgedMemberPublicsQuery, GetActivePledgedMemberPublicsQueryVariables>;
export const GetPledgedMemberPublicsLatestRankDocument = gql`
    query getPledgedMemberPublicsLatestRank($pledgeType: PledgeType = GIVING_WHAT_WE_CAN) {
  PledgedMembers: allPledgedMembersPublicsList(
    orderBy: RANK_BY_PLEDGE_TYPE_DESC
    first: 1
    condition: {pledgeType: $pledgeType}
  ) {
    rankByPledgeType
  }
}
    `;

/**
 * __useGetPledgedMemberPublicsLatestRankQuery__
 *
 * To run a query within a React component, call `useGetPledgedMemberPublicsLatestRankQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPledgedMemberPublicsLatestRankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPledgedMemberPublicsLatestRankQuery({
 *   variables: {
 *      pledgeType: // value for 'pledgeType'
 *   },
 * });
 */
export function useGetPledgedMemberPublicsLatestRankQuery(baseOptions?: Apollo.QueryHookOptions<GetPledgedMemberPublicsLatestRankQuery, GetPledgedMemberPublicsLatestRankQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPledgedMemberPublicsLatestRankQuery, GetPledgedMemberPublicsLatestRankQueryVariables>(GetPledgedMemberPublicsLatestRankDocument, options);
      }
export function useGetPledgedMemberPublicsLatestRankLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPledgedMemberPublicsLatestRankQuery, GetPledgedMemberPublicsLatestRankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPledgedMemberPublicsLatestRankQuery, GetPledgedMemberPublicsLatestRankQueryVariables>(GetPledgedMemberPublicsLatestRankDocument, options);
        }
export type GetPledgedMemberPublicsLatestRankQueryHookResult = ReturnType<typeof useGetPledgedMemberPublicsLatestRankQuery>;
export type GetPledgedMemberPublicsLatestRankLazyQueryHookResult = ReturnType<typeof useGetPledgedMemberPublicsLatestRankLazyQuery>;
export type GetPledgedMemberPublicsLatestRankQueryResult = Apollo.QueryResult<GetPledgedMemberPublicsLatestRankQuery, GetPledgedMemberPublicsLatestRankQueryVariables>;
export const GetPledgesByPersonIdDocument = gql`
    query getPledgesByPersonId($personId: BigInt!) {
  Pledges: getPledgesByPersonId(personId: $personId) {
    edges {
      node {
        id
        personId
        period {
          start {
            value
            inclusive
          }
          end {
            value
            inclusive
          }
        }
        pledgePercentage
        pledgeType
        motivation
        liabilities: liabilitiesByPledgeId {
          edges {
            node {
              nodeId
              pledgeId
              incomeId
              personId
              currencyCode
              liabilityAmount
              liabilityNormalized
              createdAt
              updatedAt
            }
          }
        }
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetPledgesByPersonIdQuery__
 *
 * To run a query within a React component, call `useGetPledgesByPersonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPledgesByPersonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPledgesByPersonIdQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetPledgesByPersonIdQuery(baseOptions: Apollo.QueryHookOptions<GetPledgesByPersonIdQuery, GetPledgesByPersonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPledgesByPersonIdQuery, GetPledgesByPersonIdQueryVariables>(GetPledgesByPersonIdDocument, options);
      }
export function useGetPledgesByPersonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPledgesByPersonIdQuery, GetPledgesByPersonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPledgesByPersonIdQuery, GetPledgesByPersonIdQueryVariables>(GetPledgesByPersonIdDocument, options);
        }
export type GetPledgesByPersonIdQueryHookResult = ReturnType<typeof useGetPledgesByPersonIdQuery>;
export type GetPledgesByPersonIdLazyQueryHookResult = ReturnType<typeof useGetPledgesByPersonIdLazyQuery>;
export type GetPledgesByPersonIdQueryResult = Apollo.QueryResult<GetPledgesByPersonIdQuery, GetPledgesByPersonIdQueryVariables>;
export const GetRecurringReportedDonationDocument = gql`
    query getRecurringReportedDonation($recurringReportedDonationId: BigInt!) {
  RecurringReportedDonation: recurringReportedDonationById(
    id: $recurringReportedDonationId
  ) {
    ...RecurringReportedDonation
  }
}
    ${RecurringReportedDonationFragmentDoc}`;

/**
 * __useGetRecurringReportedDonationQuery__
 *
 * To run a query within a React component, call `useGetRecurringReportedDonationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringReportedDonationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringReportedDonationQuery({
 *   variables: {
 *      recurringReportedDonationId: // value for 'recurringReportedDonationId'
 *   },
 * });
 */
export function useGetRecurringReportedDonationQuery(baseOptions: Apollo.QueryHookOptions<GetRecurringReportedDonationQuery, GetRecurringReportedDonationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurringReportedDonationQuery, GetRecurringReportedDonationQueryVariables>(GetRecurringReportedDonationDocument, options);
      }
export function useGetRecurringReportedDonationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurringReportedDonationQuery, GetRecurringReportedDonationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurringReportedDonationQuery, GetRecurringReportedDonationQueryVariables>(GetRecurringReportedDonationDocument, options);
        }
export type GetRecurringReportedDonationQueryHookResult = ReturnType<typeof useGetRecurringReportedDonationQuery>;
export type GetRecurringReportedDonationLazyQueryHookResult = ReturnType<typeof useGetRecurringReportedDonationLazyQuery>;
export type GetRecurringReportedDonationQueryResult = Apollo.QueryResult<GetRecurringReportedDonationQuery, GetRecurringReportedDonationQueryVariables>;
export const GetRecurringReportedDonationsByPersonIdDocument = gql`
    query getRecurringReportedDonationsByPersonId($personId: BigInt!) {
  RecurringReportedDonations: getRecurringReportedDonationsByPersonId(
    personId: $personId
  ) {
    edges {
      node {
        id
        personId
        organizationId
        amount
        currencyCode
        startDate
        nextDate
        status
        createdAt
        updatedAt
        externalOrganization: externalOrganizationByOrganizationId {
          id
          name
          organizationSlug
          url
        }
        recurrenceInterval {
          years
          months
          days
          hours
          minutes
          seconds
        }
      }
    }
  }
}
    `;

/**
 * __useGetRecurringReportedDonationsByPersonIdQuery__
 *
 * To run a query within a React component, call `useGetRecurringReportedDonationsByPersonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringReportedDonationsByPersonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringReportedDonationsByPersonIdQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetRecurringReportedDonationsByPersonIdQuery(baseOptions: Apollo.QueryHookOptions<GetRecurringReportedDonationsByPersonIdQuery, GetRecurringReportedDonationsByPersonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurringReportedDonationsByPersonIdQuery, GetRecurringReportedDonationsByPersonIdQueryVariables>(GetRecurringReportedDonationsByPersonIdDocument, options);
      }
export function useGetRecurringReportedDonationsByPersonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurringReportedDonationsByPersonIdQuery, GetRecurringReportedDonationsByPersonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurringReportedDonationsByPersonIdQuery, GetRecurringReportedDonationsByPersonIdQueryVariables>(GetRecurringReportedDonationsByPersonIdDocument, options);
        }
export type GetRecurringReportedDonationsByPersonIdQueryHookResult = ReturnType<typeof useGetRecurringReportedDonationsByPersonIdQuery>;
export type GetRecurringReportedDonationsByPersonIdLazyQueryHookResult = ReturnType<typeof useGetRecurringReportedDonationsByPersonIdLazyQuery>;
export type GetRecurringReportedDonationsByPersonIdQueryResult = Apollo.QueryResult<GetRecurringReportedDonationsByPersonIdQuery, GetRecurringReportedDonationsByPersonIdQueryVariables>;
export const GetReportedDonationDocument = gql`
    query getReportedDonation($reportedDonationId: BigInt!) {
  ReportedDonation: reportedDonationById(id: $reportedDonationId) {
    ...ReportedDonation
  }
}
    ${ReportedDonationFragmentDoc}`;

/**
 * __useGetReportedDonationQuery__
 *
 * To run a query within a React component, call `useGetReportedDonationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportedDonationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportedDonationQuery({
 *   variables: {
 *      reportedDonationId: // value for 'reportedDonationId'
 *   },
 * });
 */
export function useGetReportedDonationQuery(baseOptions: Apollo.QueryHookOptions<GetReportedDonationQuery, GetReportedDonationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportedDonationQuery, GetReportedDonationQueryVariables>(GetReportedDonationDocument, options);
      }
export function useGetReportedDonationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportedDonationQuery, GetReportedDonationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportedDonationQuery, GetReportedDonationQueryVariables>(GetReportedDonationDocument, options);
        }
export type GetReportedDonationQueryHookResult = ReturnType<typeof useGetReportedDonationQuery>;
export type GetReportedDonationLazyQueryHookResult = ReturnType<typeof useGetReportedDonationLazyQuery>;
export type GetReportedDonationQueryResult = Apollo.QueryResult<GetReportedDonationQuery, GetReportedDonationQueryVariables>;
export const GetReportedDonationsByPersonIdDocument = gql`
    query getReportedDonationsByPersonId($personId: BigInt!) {
  ReportedDonations: reportedDonationsByPersonId(personId: $personId) {
    edges {
      node {
        id
        personId
        amount
        amountNormalized
        currencyCode
        donationDate
        createdAt
        updatedAt
        externalOrganization: externalOrganizationByOrganizationId {
          id
          name
          organizationSlug
        }
      }
    }
  }
}
    `;

/**
 * __useGetReportedDonationsByPersonIdQuery__
 *
 * To run a query within a React component, call `useGetReportedDonationsByPersonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportedDonationsByPersonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportedDonationsByPersonIdQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetReportedDonationsByPersonIdQuery(baseOptions: Apollo.QueryHookOptions<GetReportedDonationsByPersonIdQuery, GetReportedDonationsByPersonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportedDonationsByPersonIdQuery, GetReportedDonationsByPersonIdQueryVariables>(GetReportedDonationsByPersonIdDocument, options);
      }
export function useGetReportedDonationsByPersonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportedDonationsByPersonIdQuery, GetReportedDonationsByPersonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportedDonationsByPersonIdQuery, GetReportedDonationsByPersonIdQueryVariables>(GetReportedDonationsByPersonIdDocument, options);
        }
export type GetReportedDonationsByPersonIdQueryHookResult = ReturnType<typeof useGetReportedDonationsByPersonIdQuery>;
export type GetReportedDonationsByPersonIdLazyQueryHookResult = ReturnType<typeof useGetReportedDonationsByPersonIdLazyQuery>;
export type GetReportedDonationsByPersonIdQueryResult = Apollo.QueryResult<GetReportedDonationsByPersonIdQuery, GetReportedDonationsByPersonIdQueryVariables>;
export const CreatePollOptionVoteDocument = gql`
    mutation createPollOptionVote($personId: BigInt!, $pollOptionId: BigInt!, $context: String!) {
  createPollOptionVote(
    input: {personId: $personId, pollOptionId: $pollOptionId, context: $context}
  ) {
    pollOptionVote {
      personId
      pollOptionId
      context
    }
  }
}
    `;
export type CreatePollOptionVoteMutationFn = Apollo.MutationFunction<CreatePollOptionVoteMutation, CreatePollOptionVoteMutationVariables>;

/**
 * __useCreatePollOptionVoteMutation__
 *
 * To run a mutation, you first call `useCreatePollOptionVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePollOptionVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPollOptionVoteMutation, { data, loading, error }] = useCreatePollOptionVoteMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      pollOptionId: // value for 'pollOptionId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useCreatePollOptionVoteMutation(baseOptions?: Apollo.MutationHookOptions<CreatePollOptionVoteMutation, CreatePollOptionVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePollOptionVoteMutation, CreatePollOptionVoteMutationVariables>(CreatePollOptionVoteDocument, options);
      }
export type CreatePollOptionVoteMutationHookResult = ReturnType<typeof useCreatePollOptionVoteMutation>;
export type CreatePollOptionVoteMutationResult = Apollo.MutationResult<CreatePollOptionVoteMutation>;
export type CreatePollOptionVoteMutationOptions = Apollo.BaseMutationOptions<CreatePollOptionVoteMutation, CreatePollOptionVoteMutationVariables>;
export const GetPollByPollIdDocument = gql`
    query getPollByPollId($pollId: BigInt!) {
  Poll: pollPublicById(id: $pollId) {
    id
    voteMechanism
    questionOrdering
    question
    pollOptionPublicsByPollIdList {
      id
      pollId
      label
      voteCount
      pollOptionVotesByPollOptionIdList {
        personId
        pollOptionId
        context
      }
    }
  }
}
    `;

/**
 * __useGetPollByPollIdQuery__
 *
 * To run a query within a React component, call `useGetPollByPollIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPollByPollIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPollByPollIdQuery({
 *   variables: {
 *      pollId: // value for 'pollId'
 *   },
 * });
 */
export function useGetPollByPollIdQuery(baseOptions: Apollo.QueryHookOptions<GetPollByPollIdQuery, GetPollByPollIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPollByPollIdQuery, GetPollByPollIdQueryVariables>(GetPollByPollIdDocument, options);
      }
export function useGetPollByPollIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPollByPollIdQuery, GetPollByPollIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPollByPollIdQuery, GetPollByPollIdQueryVariables>(GetPollByPollIdDocument, options);
        }
export type GetPollByPollIdQueryHookResult = ReturnType<typeof useGetPollByPollIdQuery>;
export type GetPollByPollIdLazyQueryHookResult = ReturnType<typeof useGetPollByPollIdLazyQuery>;
export type GetPollByPollIdQueryResult = Apollo.QueryResult<GetPollByPollIdQuery, GetPollByPollIdQueryVariables>;
export const AllCountriesDocument = gql`
    query allCountries {
  Countries: allCountries(orderBy: NAME_ASC) {
    edges {
      node {
        name
        isoAlpha2
        isoAlpha3
      }
    }
  }
}
    `;

/**
 * __useAllCountriesQuery__
 *
 * To run a query within a React component, call `useAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCountriesQuery(baseOptions?: Apollo.QueryHookOptions<AllCountriesQuery, AllCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCountriesQuery, AllCountriesQueryVariables>(AllCountriesDocument, options);
      }
export function useAllCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCountriesQuery, AllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCountriesQuery, AllCountriesQueryVariables>(AllCountriesDocument, options);
        }
export type AllCountriesQueryHookResult = ReturnType<typeof useAllCountriesQuery>;
export type AllCountriesLazyQueryHookResult = ReturnType<typeof useAllCountriesLazyQuery>;
export type AllCountriesQueryResult = Apollo.QueryResult<AllCountriesQuery, AllCountriesQueryVariables>;
export const AllCountriesWithCurrenciesDocument = gql`
    query allCountriesWithCurrencies {
  Countries: allCountries(orderBy: NAME_ASC) {
    edges {
      node {
        name
        isoAlpha2
        isoAlpha3
        currencies: currencyByCountriesByCountryCodeList(orderBy: PRECEDENCE_ASC) {
          currencyCode
        }
      }
    }
  }
}
    `;

/**
 * __useAllCountriesWithCurrenciesQuery__
 *
 * To run a query within a React component, call `useAllCountriesWithCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCountriesWithCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCountriesWithCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCountriesWithCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<AllCountriesWithCurrenciesQuery, AllCountriesWithCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCountriesWithCurrenciesQuery, AllCountriesWithCurrenciesQueryVariables>(AllCountriesWithCurrenciesDocument, options);
      }
export function useAllCountriesWithCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCountriesWithCurrenciesQuery, AllCountriesWithCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCountriesWithCurrenciesQuery, AllCountriesWithCurrenciesQueryVariables>(AllCountriesWithCurrenciesDocument, options);
        }
export type AllCountriesWithCurrenciesQueryHookResult = ReturnType<typeof useAllCountriesWithCurrenciesQuery>;
export type AllCountriesWithCurrenciesLazyQueryHookResult = ReturnType<typeof useAllCountriesWithCurrenciesLazyQuery>;
export type AllCountriesWithCurrenciesQueryResult = Apollo.QueryResult<AllCountriesWithCurrenciesQuery, AllCountriesWithCurrenciesQueryVariables>;
export const AllCurrenciesDocument = gql`
    query allCurrencies {
  Currencies: allCurrencies {
    edges {
      node {
        name
        code
        decimals
        symbol
        currencyType
      }
    }
  }
}
    `;

/**
 * __useAllCurrenciesQuery__
 *
 * To run a query within a React component, call `useAllCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<AllCurrenciesQuery, AllCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCurrenciesQuery, AllCurrenciesQueryVariables>(AllCurrenciesDocument, options);
      }
export function useAllCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCurrenciesQuery, AllCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCurrenciesQuery, AllCurrenciesQueryVariables>(AllCurrenciesDocument, options);
        }
export type AllCurrenciesQueryHookResult = ReturnType<typeof useAllCurrenciesQuery>;
export type AllCurrenciesLazyQueryHookResult = ReturnType<typeof useAllCurrenciesLazyQuery>;
export type AllCurrenciesQueryResult = Apollo.QueryResult<AllCurrenciesQuery, AllCurrenciesQueryVariables>;
export const AllMembersDocument = gql`
    query allMembers {
  Pledges: allPledgedMembersPublicsList(orderBy: RANK_BY_PLEDGE_TYPE_DESC) {
    pledgeType
    active
    rankByPledgeType
    fullName
    commencementDate
  }
}
    `;

/**
 * __useAllMembersQuery__
 *
 * To run a query within a React component, call `useAllMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllMembersQuery(baseOptions?: Apollo.QueryHookOptions<AllMembersQuery, AllMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllMembersQuery, AllMembersQueryVariables>(AllMembersDocument, options);
      }
export function useAllMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMembersQuery, AllMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllMembersQuery, AllMembersQueryVariables>(AllMembersDocument, options);
        }
export type AllMembersQueryHookResult = ReturnType<typeof useAllMembersQuery>;
export type AllMembersLazyQueryHookResult = ReturnType<typeof useAllMembersLazyQuery>;
export type AllMembersQueryResult = Apollo.QueryResult<AllMembersQuery, AllMembersQueryVariables>;
export const ClosestExchangeRateDocument = gql`
    query closestExchangeRate($currencyCode: String!, $date: Date!) {
  ExchangeRate: closestExchangeRate(currencyCode: $currencyCode, date: $date) {
    currencyCode
    date
    rate
  }
}
    `;

/**
 * __useClosestExchangeRateQuery__
 *
 * To run a query within a React component, call `useClosestExchangeRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useClosestExchangeRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClosestExchangeRateQuery({
 *   variables: {
 *      currencyCode: // value for 'currencyCode'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useClosestExchangeRateQuery(baseOptions: Apollo.QueryHookOptions<ClosestExchangeRateQuery, ClosestExchangeRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClosestExchangeRateQuery, ClosestExchangeRateQueryVariables>(ClosestExchangeRateDocument, options);
      }
export function useClosestExchangeRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClosestExchangeRateQuery, ClosestExchangeRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClosestExchangeRateQuery, ClosestExchangeRateQueryVariables>(ClosestExchangeRateDocument, options);
        }
export type ClosestExchangeRateQueryHookResult = ReturnType<typeof useClosestExchangeRateQuery>;
export type ClosestExchangeRateLazyQueryHookResult = ReturnType<typeof useClosestExchangeRateLazyQuery>;
export type ClosestExchangeRateQueryResult = Apollo.QueryResult<ClosestExchangeRateQuery, ClosestExchangeRateQueryVariables>;
export const GetCurrencyDocument = gql`
    query getCurrency($code: String!) {
  Currency: currencyByCode(code: $code) {
    name
    code
    decimals
    symbol
    currencyType
  }
}
    `;

/**
 * __useGetCurrencyQuery__
 *
 * To run a query within a React component, call `useGetCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetCurrencyQuery(baseOptions: Apollo.QueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyQuery, GetCurrencyQueryVariables>(GetCurrencyDocument, options);
      }
export function useGetCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyQuery, GetCurrencyQueryVariables>(GetCurrencyDocument, options);
        }
export type GetCurrencyQueryHookResult = ReturnType<typeof useGetCurrencyQuery>;
export type GetCurrencyLazyQueryHookResult = ReturnType<typeof useGetCurrencyLazyQuery>;
export type GetCurrencyQueryResult = Apollo.QueryResult<GetCurrencyQuery, GetCurrencyQueryVariables>;
export const PaymentCurrenciesDocument = gql`
    query paymentCurrencies {
  USD: currencyByCode(code: "USD") {
    ...currencyFields
  }
  GBP: currencyByCode(code: "GBP") {
    ...currencyFields
  }
}
    ${CurrencyFieldsFragmentDoc}`;

/**
 * __usePaymentCurrenciesQuery__
 *
 * To run a query within a React component, call `usePaymentCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<PaymentCurrenciesQuery, PaymentCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentCurrenciesQuery, PaymentCurrenciesQueryVariables>(PaymentCurrenciesDocument, options);
      }
export function usePaymentCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentCurrenciesQuery, PaymentCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentCurrenciesQuery, PaymentCurrenciesQueryVariables>(PaymentCurrenciesDocument, options);
        }
export type PaymentCurrenciesQueryHookResult = ReturnType<typeof usePaymentCurrenciesQuery>;
export type PaymentCurrenciesLazyQueryHookResult = ReturnType<typeof usePaymentCurrenciesLazyQuery>;
export type PaymentCurrenciesQueryResult = Apollo.QueryResult<PaymentCurrenciesQuery, PaymentCurrenciesQueryVariables>;
export const PaymentExchangeRatesDocument = gql`
    query paymentExchangeRates($date: Date!) {
  GBP: closestExchangeRate(currencyCode: "GBP", date: $date) {
    ...exchangeRateFields
  }
  BTC: closestExchangeRate(currencyCode: "BTC", date: $date) {
    ...exchangeRateFields
  }
  ETH: closestExchangeRate(currencyCode: "ETH", date: $date) {
    ...exchangeRateFields
  }
  LTC: closestExchangeRate(currencyCode: "LTC", date: $date) {
    ...exchangeRateFields
  }
}
    ${ExchangeRateFieldsFragmentDoc}`;

/**
 * __usePaymentExchangeRatesQuery__
 *
 * To run a query within a React component, call `usePaymentExchangeRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentExchangeRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentExchangeRatesQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function usePaymentExchangeRatesQuery(baseOptions: Apollo.QueryHookOptions<PaymentExchangeRatesQuery, PaymentExchangeRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentExchangeRatesQuery, PaymentExchangeRatesQueryVariables>(PaymentExchangeRatesDocument, options);
      }
export function usePaymentExchangeRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentExchangeRatesQuery, PaymentExchangeRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentExchangeRatesQuery, PaymentExchangeRatesQueryVariables>(PaymentExchangeRatesDocument, options);
        }
export type PaymentExchangeRatesQueryHookResult = ReturnType<typeof usePaymentExchangeRatesQuery>;
export type PaymentExchangeRatesLazyQueryHookResult = ReturnType<typeof usePaymentExchangeRatesLazyQuery>;
export type PaymentExchangeRatesQueryResult = Apollo.QueryResult<PaymentExchangeRatesQuery, PaymentExchangeRatesQueryVariables>;
export const GetStatsDocument = gql`
    query getStats {
  allGlobalStatsList {
    gwwcPledgesTotal
    activeTryGivingPledgesTotal
    tryGivingCompletedTotal
    pledgersCountriesTotal
    pledgesDonationsTotal
    projectedDonationsTotal
  }
}
    `;

/**
 * __useGetStatsQuery__
 *
 * To run a query within a React component, call `useGetStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetStatsQuery, GetStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatsQuery, GetStatsQueryVariables>(GetStatsDocument, options);
      }
export function useGetStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatsQuery, GetStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatsQuery, GetStatsQueryVariables>(GetStatsDocument, options);
        }
export type GetStatsQueryHookResult = ReturnType<typeof useGetStatsQuery>;
export type GetStatsLazyQueryHookResult = ReturnType<typeof useGetStatsLazyQuery>;
export type GetStatsQueryResult = Apollo.QueryResult<GetStatsQuery, GetStatsQueryVariables>;
export const GetPaymentStatsAggregateDocument = gql`
    query getPaymentStatsAggregate {
  PaymentStats: getPaymentStatsAggregate {
    totalDonations
    numDonations
    numDonors
    totalDonationsLastYear
    numDonationsLastYear
    numDonorsLastYear
  }
}
    `;

/**
 * __useGetPaymentStatsAggregateQuery__
 *
 * To run a query within a React component, call `useGetPaymentStatsAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentStatsAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentStatsAggregateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentStatsAggregateQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentStatsAggregateQuery, GetPaymentStatsAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentStatsAggregateQuery, GetPaymentStatsAggregateQueryVariables>(GetPaymentStatsAggregateDocument, options);
      }
export function useGetPaymentStatsAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentStatsAggregateQuery, GetPaymentStatsAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentStatsAggregateQuery, GetPaymentStatsAggregateQueryVariables>(GetPaymentStatsAggregateDocument, options);
        }
export type GetPaymentStatsAggregateQueryHookResult = ReturnType<typeof useGetPaymentStatsAggregateQuery>;
export type GetPaymentStatsAggregateLazyQueryHookResult = ReturnType<typeof useGetPaymentStatsAggregateLazyQuery>;
export type GetPaymentStatsAggregateQueryResult = Apollo.QueryResult<GetPaymentStatsAggregateQuery, GetPaymentStatsAggregateQueryVariables>;
export const GetXeroBalanceSheetByOrganizationDocument = gql`
    query getXeroBalanceSheetByOrganization($reference: String!, $nearestReportDate: Date) {
  XeroBalanceSheet: getBalanceSheetMonthlyTotalByReference(
    reference: $reference
    nearestReportDate: $nearestReportDate
  ) {
    edges {
      node {
        reportDate
        reference
        amount
      }
    }
  }
}
    `;

/**
 * __useGetXeroBalanceSheetByOrganizationQuery__
 *
 * To run a query within a React component, call `useGetXeroBalanceSheetByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetXeroBalanceSheetByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetXeroBalanceSheetByOrganizationQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      nearestReportDate: // value for 'nearestReportDate'
 *   },
 * });
 */
export function useGetXeroBalanceSheetByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetXeroBalanceSheetByOrganizationQuery, GetXeroBalanceSheetByOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetXeroBalanceSheetByOrganizationQuery, GetXeroBalanceSheetByOrganizationQueryVariables>(GetXeroBalanceSheetByOrganizationDocument, options);
      }
export function useGetXeroBalanceSheetByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetXeroBalanceSheetByOrganizationQuery, GetXeroBalanceSheetByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetXeroBalanceSheetByOrganizationQuery, GetXeroBalanceSheetByOrganizationQueryVariables>(GetXeroBalanceSheetByOrganizationDocument, options);
        }
export type GetXeroBalanceSheetByOrganizationQueryHookResult = ReturnType<typeof useGetXeroBalanceSheetByOrganizationQuery>;
export type GetXeroBalanceSheetByOrganizationLazyQueryHookResult = ReturnType<typeof useGetXeroBalanceSheetByOrganizationLazyQuery>;
export type GetXeroBalanceSheetByOrganizationQueryResult = Apollo.QueryResult<GetXeroBalanceSheetByOrganizationQuery, GetXeroBalanceSheetByOrganizationQueryVariables>;
export const GetXeroBalanceSheetReportMonthlyTotalDocument = gql`
    query getXeroBalanceSheetReportMonthlyTotal($nearestReportDate: Date) {
  XeroBalanceSheets: getBalanceSheetReportMonthlyTotal(
    nearestReportDate: $nearestReportDate
  ) {
    edges {
      node {
        reportDate
        reference
        amount
      }
    }
  }
}
    `;

/**
 * __useGetXeroBalanceSheetReportMonthlyTotalQuery__
 *
 * To run a query within a React component, call `useGetXeroBalanceSheetReportMonthlyTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetXeroBalanceSheetReportMonthlyTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetXeroBalanceSheetReportMonthlyTotalQuery({
 *   variables: {
 *      nearestReportDate: // value for 'nearestReportDate'
 *   },
 * });
 */
export function useGetXeroBalanceSheetReportMonthlyTotalQuery(baseOptions?: Apollo.QueryHookOptions<GetXeroBalanceSheetReportMonthlyTotalQuery, GetXeroBalanceSheetReportMonthlyTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetXeroBalanceSheetReportMonthlyTotalQuery, GetXeroBalanceSheetReportMonthlyTotalQueryVariables>(GetXeroBalanceSheetReportMonthlyTotalDocument, options);
      }
export function useGetXeroBalanceSheetReportMonthlyTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetXeroBalanceSheetReportMonthlyTotalQuery, GetXeroBalanceSheetReportMonthlyTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetXeroBalanceSheetReportMonthlyTotalQuery, GetXeroBalanceSheetReportMonthlyTotalQueryVariables>(GetXeroBalanceSheetReportMonthlyTotalDocument, options);
        }
export type GetXeroBalanceSheetReportMonthlyTotalQueryHookResult = ReturnType<typeof useGetXeroBalanceSheetReportMonthlyTotalQuery>;
export type GetXeroBalanceSheetReportMonthlyTotalLazyQueryHookResult = ReturnType<typeof useGetXeroBalanceSheetReportMonthlyTotalLazyQuery>;
export type GetXeroBalanceSheetReportMonthlyTotalQueryResult = Apollo.QueryResult<GetXeroBalanceSheetReportMonthlyTotalQuery, GetXeroBalanceSheetReportMonthlyTotalQueryVariables>;
export const UpdateSettingsContactPreferenceDocument = gql`
    mutation updateSettingsContactPreference($personId: BigInt!, $currentAddressId: BigInt) {
  updateContactPreferenceByPersonId(
    input: {personId: $personId, currentAddressId: $currentAddressId}
  ) {
    contactPreference {
      personId
      currentAddressId
    }
  }
}
    `;
export type UpdateSettingsContactPreferenceMutationFn = Apollo.MutationFunction<UpdateSettingsContactPreferenceMutation, UpdateSettingsContactPreferenceMutationVariables>;

/**
 * __useUpdateSettingsContactPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsContactPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsContactPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsContactPreferenceMutation, { data, loading, error }] = useUpdateSettingsContactPreferenceMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      currentAddressId: // value for 'currentAddressId'
 *   },
 * });
 */
export function useUpdateSettingsContactPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingsContactPreferenceMutation, UpdateSettingsContactPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingsContactPreferenceMutation, UpdateSettingsContactPreferenceMutationVariables>(UpdateSettingsContactPreferenceDocument, options);
      }
export type UpdateSettingsContactPreferenceMutationHookResult = ReturnType<typeof useUpdateSettingsContactPreferenceMutation>;
export type UpdateSettingsContactPreferenceMutationResult = Apollo.MutationResult<UpdateSettingsContactPreferenceMutation>;
export type UpdateSettingsContactPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateSettingsContactPreferenceMutation, UpdateSettingsContactPreferenceMutationVariables>;
export const GetSettingsDocument = gql`
    query getSettings($personId: BigInt!) {
  ContactPreference: contactPreferenceByPersonId(personId: $personId) {
    currentAddressId
  }
}
    `;

/**
 * __useGetSettingsQuery__
 *
 * To run a query within a React component, call `useGetSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
      }
export function useGetSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
        }
export type GetSettingsQueryHookResult = ReturnType<typeof useGetSettingsQuery>;
export type GetSettingsLazyQueryHookResult = ReturnType<typeof useGetSettingsLazyQuery>;
export type GetSettingsQueryResult = Apollo.QueryResult<GetSettingsQuery, GetSettingsQueryVariables>;
export const UpsertGivingWhatWeCanSurveyDocument = gql`
    mutation upsertGivingWhatWeCanSurvey($personId: BigInt!, $counterfactualDonationPercentage: Float, $wherePlanningToGive: [String], $wherePlanningToGiveNotes: String, $referrer: [String], $referrerNotes: String, $gwwcDonationInfluence: String, $otherComments: String) {
  upsertGivingWhatWeCanSurvey(
    input: {personId: $personId, counterfactualDonationPercentage: $counterfactualDonationPercentage, wherePlanningToGive: $wherePlanningToGive, wherePlanningToGiveNotes: $wherePlanningToGiveNotes, referrer: $referrer, referrerNotes: $referrerNotes, gwwcDonationInfluence: $gwwcDonationInfluence, otherComments: $otherComments}
  ) {
    givingWhatWeCanSurvey {
      ...GWWCSurvey
    }
  }
}
    ${GwwcSurveyFragmentDoc}`;
export type UpsertGivingWhatWeCanSurveyMutationFn = Apollo.MutationFunction<UpsertGivingWhatWeCanSurveyMutation, UpsertGivingWhatWeCanSurveyMutationVariables>;

/**
 * __useUpsertGivingWhatWeCanSurveyMutation__
 *
 * To run a mutation, you first call `useUpsertGivingWhatWeCanSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertGivingWhatWeCanSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertGivingWhatWeCanSurveyMutation, { data, loading, error }] = useUpsertGivingWhatWeCanSurveyMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      counterfactualDonationPercentage: // value for 'counterfactualDonationPercentage'
 *      wherePlanningToGive: // value for 'wherePlanningToGive'
 *      wherePlanningToGiveNotes: // value for 'wherePlanningToGiveNotes'
 *      referrer: // value for 'referrer'
 *      referrerNotes: // value for 'referrerNotes'
 *      gwwcDonationInfluence: // value for 'gwwcDonationInfluence'
 *      otherComments: // value for 'otherComments'
 *   },
 * });
 */
export function useUpsertGivingWhatWeCanSurveyMutation(baseOptions?: Apollo.MutationHookOptions<UpsertGivingWhatWeCanSurveyMutation, UpsertGivingWhatWeCanSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertGivingWhatWeCanSurveyMutation, UpsertGivingWhatWeCanSurveyMutationVariables>(UpsertGivingWhatWeCanSurveyDocument, options);
      }
export type UpsertGivingWhatWeCanSurveyMutationHookResult = ReturnType<typeof useUpsertGivingWhatWeCanSurveyMutation>;
export type UpsertGivingWhatWeCanSurveyMutationResult = Apollo.MutationResult<UpsertGivingWhatWeCanSurveyMutation>;
export type UpsertGivingWhatWeCanSurveyMutationOptions = Apollo.BaseMutationOptions<UpsertGivingWhatWeCanSurveyMutation, UpsertGivingWhatWeCanSurveyMutationVariables>;
export const AllOrganizationCategoriesDocument = gql`
    query allOrganizationCategories {
  OrganizationCategories: allOrganizationCategories(orderBy: SORT_ORDER_ASC) {
    edges {
      node {
        slug
        description
      }
    }
  }
}
    `;

/**
 * __useAllOrganizationCategoriesQuery__
 *
 * To run a query within a React component, call `useAllOrganizationCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOrganizationCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrganizationCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllOrganizationCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AllOrganizationCategoriesQuery, AllOrganizationCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllOrganizationCategoriesQuery, AllOrganizationCategoriesQueryVariables>(AllOrganizationCategoriesDocument, options);
      }
export function useAllOrganizationCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllOrganizationCategoriesQuery, AllOrganizationCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllOrganizationCategoriesQuery, AllOrganizationCategoriesQueryVariables>(AllOrganizationCategoriesDocument, options);
        }
export type AllOrganizationCategoriesQueryHookResult = ReturnType<typeof useAllOrganizationCategoriesQuery>;
export type AllOrganizationCategoriesLazyQueryHookResult = ReturnType<typeof useAllOrganizationCategoriesLazyQuery>;
export type AllOrganizationCategoriesQueryResult = Apollo.QueryResult<AllOrganizationCategoriesQuery, AllOrganizationCategoriesQueryVariables>;
export const AllReferralSourcesDocument = gql`
    query allReferralSources {
  ReferralSources: allReferralSources(orderBy: SORT_ORDER_ASC) {
    edges {
      node {
        slug
        description
      }
    }
  }
}
    `;

/**
 * __useAllReferralSourcesQuery__
 *
 * To run a query within a React component, call `useAllReferralSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReferralSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReferralSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllReferralSourcesQuery(baseOptions?: Apollo.QueryHookOptions<AllReferralSourcesQuery, AllReferralSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllReferralSourcesQuery, AllReferralSourcesQueryVariables>(AllReferralSourcesDocument, options);
      }
export function useAllReferralSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllReferralSourcesQuery, AllReferralSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllReferralSourcesQuery, AllReferralSourcesQueryVariables>(AllReferralSourcesDocument, options);
        }
export type AllReferralSourcesQueryHookResult = ReturnType<typeof useAllReferralSourcesQuery>;
export type AllReferralSourcesLazyQueryHookResult = ReturnType<typeof useAllReferralSourcesLazyQuery>;
export type AllReferralSourcesQueryResult = Apollo.QueryResult<AllReferralSourcesQuery, AllReferralSourcesQueryVariables>;
export const GivingWhatWeCanSurveyByPersonIdDocument = gql`
    query givingWhatWeCanSurveyByPersonId($personId: BigInt!) {
  GivingWhatWeCanSurvey: givingWhatWeCanSurveyByPersonId(personId: $personId) {
    ...GWWCSurvey
  }
}
    ${GwwcSurveyFragmentDoc}`;

/**
 * __useGivingWhatWeCanSurveyByPersonIdQuery__
 *
 * To run a query within a React component, call `useGivingWhatWeCanSurveyByPersonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGivingWhatWeCanSurveyByPersonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGivingWhatWeCanSurveyByPersonIdQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGivingWhatWeCanSurveyByPersonIdQuery(baseOptions: Apollo.QueryHookOptions<GivingWhatWeCanSurveyByPersonIdQuery, GivingWhatWeCanSurveyByPersonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GivingWhatWeCanSurveyByPersonIdQuery, GivingWhatWeCanSurveyByPersonIdQueryVariables>(GivingWhatWeCanSurveyByPersonIdDocument, options);
      }
export function useGivingWhatWeCanSurveyByPersonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GivingWhatWeCanSurveyByPersonIdQuery, GivingWhatWeCanSurveyByPersonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GivingWhatWeCanSurveyByPersonIdQuery, GivingWhatWeCanSurveyByPersonIdQueryVariables>(GivingWhatWeCanSurveyByPersonIdDocument, options);
        }
export type GivingWhatWeCanSurveyByPersonIdQueryHookResult = ReturnType<typeof useGivingWhatWeCanSurveyByPersonIdQuery>;
export type GivingWhatWeCanSurveyByPersonIdLazyQueryHookResult = ReturnType<typeof useGivingWhatWeCanSurveyByPersonIdLazyQuery>;
export type GivingWhatWeCanSurveyByPersonIdQueryResult = Apollo.QueryResult<GivingWhatWeCanSurveyByPersonIdQuery, GivingWhatWeCanSurveyByPersonIdQueryVariables>;